export default {
	"110000": {
		id: 110000,
		area_name: "北京",
		area_code: "Beijing",
		area_parent_id: 0,
		child: {
			"110100": {
				id: 110100,
				area_name: "北京市",
				area_code: "Beijing",
				area_parent_id: 110000,
				child: {
					"110101": {
						id: 110101,
						area_name: "东城区",
						area_code: "Dongcheng",
						area_parent_id: 110100
					},
					"110102": {
						id: 110102,
						area_name: "西城区",
						area_code: "Xicheng",
						area_parent_id: 110100
					},
					"110105": {
						id: 110105,
						area_name: "朝阳区",
						area_code: "Chaoyang",
						area_parent_id: 110100
					},
					"110106": {
						id: 110106,
						area_name: "丰台区",
						area_code: "Fengtai",
						area_parent_id: 110100
					},
					"110107": {
						id: 110107,
						area_name: "石景山区",
						area_code: "Shijingshan",
						area_parent_id: 110100
					},
					"110108": {
						id: 110108,
						area_name: "海淀区",
						area_code: "Haidian",
						area_parent_id: 110100
					},
					"110109": {
						id: 110109,
						area_name: "门头沟区",
						area_code: "Mentougou",
						area_parent_id: 110100
					},
					"110111": {
						id: 110111,
						area_name: "房山区",
						area_code: "Fangshan",
						area_parent_id: 110100
					},
					"110112": {
						id: 110112,
						area_name: "通州区",
						area_code: "Tongzhou",
						area_parent_id: 110100
					},
					"110113": {
						id: 110113,
						area_name: "顺义区",
						area_code: "Shunyi",
						area_parent_id: 110100
					},
					"110114": {
						id: 110114,
						area_name: "昌平区",
						area_code: "Changping",
						area_parent_id: 110100
					},
					"110115": {
						id: 110115,
						area_name: "大兴区",
						area_code: "Daxing",
						area_parent_id: 110100
					},
					"110116": {
						id: 110116,
						area_name: "怀柔区",
						area_code: "Huairou",
						area_parent_id: 110100
					},
					"110117": {
						id: 110117,
						area_name: "平谷区",
						area_code: "Pinggu",
						area_parent_id: 110100
					},
					"110228": {
						id: 110228,
						area_name: "密云县",
						area_code: "Miyun",
						area_parent_id: 110100
					},
					"110229": {
						id: 110229,
						area_name: "延庆县",
						area_code: "Yanqing",
						area_parent_id: 110100
					}
				}
			}
		}
	},
	"120000": {
		id: 120000,
		area_name: "天津",
		area_code: "Tianjin",
		area_parent_id: 0,
		child: {
			"120100": {
				id: 120100,
				area_name: "天津市",
				area_code: "Tianjin",
				area_parent_id: 120000,
				child: {
					"120101": {
						id: 120101,
						area_name: "和平区",
						area_code: "Heping",
						area_parent_id: 120100
					},
					"120102": {
						id: 120102,
						area_name: "河东区",
						area_code: "Hedong",
						area_parent_id: 120100
					},
					"120103": {
						id: 120103,
						area_name: "河西区",
						area_code: "Hexi",
						area_parent_id: 120100
					},
					"120104": {
						id: 120104,
						area_name: "南开区",
						area_code: "Nankai",
						area_parent_id: 120100
					},
					"120105": {
						id: 120105,
						area_name: "河北区",
						area_code: "Hebei",
						area_parent_id: 120100
					},
					"120106": {
						id: 120106,
						area_name: "红桥区",
						area_code: "Hongqiao",
						area_parent_id: 120100
					},
					"120110": {
						id: 120110,
						area_name: "东丽区",
						area_code: "Dongli",
						area_parent_id: 120100
					},
					"120111": {
						id: 120111,
						area_name: "西青区",
						area_code: "Xiqing",
						area_parent_id: 120100
					},
					"120112": {
						id: 120112,
						area_name: "津南区",
						area_code: "Jinnan",
						area_parent_id: 120100
					},
					"120113": {
						id: 120113,
						area_name: "北辰区",
						area_code: "Beichen",
						area_parent_id: 120100
					},
					"120114": {
						id: 120114,
						area_name: "武清区",
						area_code: "Wuqing",
						area_parent_id: 120100
					},
					"120115": {
						id: 120115,
						area_name: "宝坻区",
						area_code: "Baodi",
						area_parent_id: 120100
					},
					"120116": {
						id: 120116,
						area_name: "滨海新区",
						area_code: "Binhaixinqu",
						area_parent_id: 120100
					},
					"120221": {
						id: 120221,
						area_name: "宁河县",
						area_code: "Ninghe",
						area_parent_id: 120100
					},
					"120223": {
						id: 120223,
						area_name: "静海县",
						area_code: "Jinghai",
						area_parent_id: 120100
					},
					"120225": {
						id: 120225,
						area_name: "蓟县",
						area_code: "Jixian",
						area_parent_id: 120100
					}
				}
			}
		}
	},
	"130000": {
		id: 130000,
		area_name: "河北省",
		area_code: "Hebei",
		area_parent_id: 0,
		child: {
			"130100": {
				id: 130100,
				area_name: "石家庄市",
				area_code: "Shijiazhuang",
				area_parent_id: 130000,
				child: {
					"130102": {
						id: 130102,
						area_name: "长安区",
						area_code: "Chang'an",
						area_parent_id: 130100
					},
					"130104": {
						id: 130104,
						area_name: "桥西区",
						area_code: "Qiaoxi",
						area_parent_id: 130100
					},
					"130105": {
						id: 130105,
						area_name: "新华区",
						area_code: "Xinhua",
						area_parent_id: 130100
					},
					"130107": {
						id: 130107,
						area_name: "井陉矿区",
						area_code: "Jingxingkuangqu",
						area_parent_id: 130100
					},
					"130108": {
						id: 130108,
						area_name: "裕华区",
						area_code: "Yuhua",
						area_parent_id: 130100
					},
					"130109": {
						id: 130109,
						area_name: "藁城区",
						area_code: "Gaocheng",
						area_parent_id: 130100
					},
					"130110": {
						id: 130110,
						area_name: "鹿泉区",
						area_code: "Luquan",
						area_parent_id: 130100
					},
					"130111": {
						id: 130111,
						area_name: "栾城区",
						area_code: "Luancheng",
						area_parent_id: 130100
					},
					"130121": {
						id: 130121,
						area_name: "井陉县",
						area_code: "Jingxing",
						area_parent_id: 130100
					},
					"130123": {
						id: 130123,
						area_name: "正定县",
						area_code: "Zhengding",
						area_parent_id: 130100
					},
					"130125": {
						id: 130125,
						area_name: "行唐县",
						area_code: "Xingtang",
						area_parent_id: 130100
					},
					"130126": {
						id: 130126,
						area_name: "灵寿县",
						area_code: "Lingshou",
						area_parent_id: 130100
					},
					"130127": {
						id: 130127,
						area_name: "高邑县",
						area_code: "Gaoyi",
						area_parent_id: 130100
					},
					"130128": {
						id: 130128,
						area_name: "深泽县",
						area_code: "Shenze",
						area_parent_id: 130100
					},
					"130129": {
						id: 130129,
						area_name: "赞皇县",
						area_code: "Zanhuang",
						area_parent_id: 130100
					},
					"130130": {
						id: 130130,
						area_name: "无极县",
						area_code: "Wuji",
						area_parent_id: 130100
					},
					"130131": {
						id: 130131,
						area_name: "平山县",
						area_code: "Pingshan",
						area_parent_id: 130100
					},
					"130132": {
						id: 130132,
						area_name: "元氏县",
						area_code: "Yuanshi",
						area_parent_id: 130100
					},
					"130133": {
						id: 130133,
						area_name: "赵县",
						area_code: "Zhaoxian",
						area_parent_id: 130100
					},
					"130181": {
						id: 130181,
						area_name: "辛集市",
						area_code: "Xinji",
						area_parent_id: 130100
					},
					"130183": {
						id: 130183,
						area_name: "晋州市",
						area_code: "Jinzhou",
						area_parent_id: 130100
					},
					"130184": {
						id: 130184,
						area_name: "新乐市",
						area_code: "Xinle",
						area_parent_id: 130100
					}
				}
			},
			"130200": {
				id: 130200,
				area_name: "唐山市",
				area_code: "Tangshan",
				area_parent_id: 130000,
				child: {
					"130202": {
						id: 130202,
						area_name: "路南区",
						area_code: "Lunan",
						area_parent_id: 130200
					},
					"130203": {
						id: 130203,
						area_name: "路北区",
						area_code: "Lubei",
						area_parent_id: 130200
					},
					"130204": {
						id: 130204,
						area_name: "古冶区",
						area_code: "Guye",
						area_parent_id: 130200
					},
					"130205": {
						id: 130205,
						area_name: "开平区",
						area_code: "Kaiping",
						area_parent_id: 130200
					},
					"130207": {
						id: 130207,
						area_name: "丰南区",
						area_code: "Fengnan",
						area_parent_id: 130200
					},
					"130208": {
						id: 130208,
						area_name: "丰润区",
						area_code: "Fengrun",
						area_parent_id: 130200
					},
					"130209": {
						id: 130209,
						area_name: "曹妃甸区",
						area_code: "Caofeidian",
						area_parent_id: 130200
					},
					"130223": {
						id: 130223,
						area_name: "滦县",
						area_code: "Luanxian",
						area_parent_id: 130200
					},
					"130224": {
						id: 130224,
						area_name: "滦南县",
						area_code: "Luannan",
						area_parent_id: 130200
					},
					"130225": {
						id: 130225,
						area_name: "乐亭县",
						area_code: "Laoting",
						area_parent_id: 130200
					},
					"130227": {
						id: 130227,
						area_name: "迁西县",
						area_code: "Qianxi",
						area_parent_id: 130200
					},
					"130229": {
						id: 130229,
						area_name: "玉田县",
						area_code: "Yutian",
						area_parent_id: 130200
					},
					"130281": {
						id: 130281,
						area_name: "遵化市",
						area_code: "Zunhua",
						area_parent_id: 130200
					},
					"130283": {
						id: 130283,
						area_name: "迁安市",
						area_code: "Qian'an",
						area_parent_id: 130200
					}
				}
			},
			"130300": {
				id: 130300,
				area_name: "秦皇岛市",
				area_code: "Qinhuangdao",
				area_parent_id: 130000,
				child: {
					"130302": {
						id: 130302,
						area_name: "海港区",
						area_code: "Haigang",
						area_parent_id: 130300
					},
					"130303": {
						id: 130303,
						area_name: "山海关区",
						area_code: "Shanhaiguan",
						area_parent_id: 130300
					},
					"130304": {
						id: 130304,
						area_name: "北戴河区",
						area_code: "Beidaihe",
						area_parent_id: 130300
					},
					"130321": {
						id: 130321,
						area_name: "青龙满族自治县",
						area_code: "Qinglong",
						area_parent_id: 130300
					},
					"130322": {
						id: 130322,
						area_name: "昌黎县",
						area_code: "Changli",
						area_parent_id: 130300
					},
					"130323": {
						id: 130323,
						area_name: "抚宁县",
						area_code: "Funing",
						area_parent_id: 130300
					},
					"130324": {
						id: 130324,
						area_name: "卢龙县",
						area_code: "Lulong",
						area_parent_id: 130300
					}
				}
			},
			"130400": {
				id: 130400,
				area_name: "邯郸市",
				area_code: "Handan",
				area_parent_id: 130000,
				child: {
					"130402": {
						id: 130402,
						area_name: "邯山区",
						area_code: "Hanshan",
						area_parent_id: 130400
					},
					"130403": {
						id: 130403,
						area_name: "丛台区",
						area_code: "Congtai",
						area_parent_id: 130400
					},
					"130404": {
						id: 130404,
						area_name: "复兴区",
						area_code: "Fuxing",
						area_parent_id: 130400
					},
					"130406": {
						id: 130406,
						area_name: "峰峰矿区",
						area_code: "Fengfengkuangqu",
						area_parent_id: 130400
					},
					"130421": {
						id: 130421,
						area_name: "邯郸县",
						area_code: "Handan",
						area_parent_id: 130400
					},
					"130423": {
						id: 130423,
						area_name: "临漳县",
						area_code: "Linzhang",
						area_parent_id: 130400
					},
					"130424": {
						id: 130424,
						area_name: "成安县",
						area_code: "Cheng'an",
						area_parent_id: 130400
					},
					"130425": {
						id: 130425,
						area_name: "大名县",
						area_code: "Daming",
						area_parent_id: 130400
					},
					"130426": {
						id: 130426,
						area_name: "涉县",
						area_code: "Shexian",
						area_parent_id: 130400
					},
					"130427": {
						id: 130427,
						area_name: "磁县",
						area_code: "Cixian",
						area_parent_id: 130400
					},
					"130428": {
						id: 130428,
						area_name: "肥乡县",
						area_code: "Feixiang",
						area_parent_id: 130400
					},
					"130429": {
						id: 130429,
						area_name: "永年县",
						area_code: "Yongnian",
						area_parent_id: 130400
					},
					"130430": {
						id: 130430,
						area_name: "邱县",
						area_code: "Qiuxian",
						area_parent_id: 130400
					},
					"130431": {
						id: 130431,
						area_name: "鸡泽县",
						area_code: "Jize",
						area_parent_id: 130400
					},
					"130432": {
						id: 130432,
						area_name: "广平县",
						area_code: "Guangping",
						area_parent_id: 130400
					},
					"130433": {
						id: 130433,
						area_name: "馆陶县",
						area_code: "Guantao",
						area_parent_id: 130400
					},
					"130434": {
						id: 130434,
						area_name: "魏县",
						area_code: "Weixian",
						area_parent_id: 130400
					},
					"130435": {
						id: 130435,
						area_name: "曲周县",
						area_code: "Quzhou",
						area_parent_id: 130400
					},
					"130481": {
						id: 130481,
						area_name: "武安市",
						area_code: "Wu'an",
						area_parent_id: 130400
					}
				}
			},
			"130500": {
				id: 130500,
				area_name: "邢台市",
				area_code: "Xingtai",
				area_parent_id: 130000,
				child: {
					"130502": {
						id: 130502,
						area_name: "桥东区",
						area_code: "Qiaodong",
						area_parent_id: 130500
					},
					"130503": {
						id: 130503,
						area_name: "桥西区",
						area_code: "Qiaoxi",
						area_parent_id: 130500
					},
					"130521": {
						id: 130521,
						area_name: "邢台县",
						area_code: "Xingtai",
						area_parent_id: 130500
					},
					"130522": {
						id: 130522,
						area_name: "临城县",
						area_code: "Lincheng",
						area_parent_id: 130500
					},
					"130523": {
						id: 130523,
						area_name: "内丘县",
						area_code: "Neiqiu",
						area_parent_id: 130500
					},
					"130524": {
						id: 130524,
						area_name: "柏乡县",
						area_code: "Baixiang",
						area_parent_id: 130500
					},
					"130525": {
						id: 130525,
						area_name: "隆尧县",
						area_code: "Longyao",
						area_parent_id: 130500
					},
					"130526": {
						id: 130526,
						area_name: "任县",
						area_code: "Renxian",
						area_parent_id: 130500
					},
					"130527": {
						id: 130527,
						area_name: "南和县",
						area_code: "Nanhe",
						area_parent_id: 130500
					},
					"130528": {
						id: 130528,
						area_name: "宁晋县",
						area_code: "Ningjin",
						area_parent_id: 130500
					},
					"130529": {
						id: 130529,
						area_name: "巨鹿县",
						area_code: "Julu",
						area_parent_id: 130500
					},
					"130530": {
						id: 130530,
						area_name: "新河县",
						area_code: "Xinhe",
						area_parent_id: 130500
					},
					"130531": {
						id: 130531,
						area_name: "广宗县",
						area_code: "Guangzong",
						area_parent_id: 130500
					},
					"130532": {
						id: 130532,
						area_name: "平乡县",
						area_code: "Pingxiang",
						area_parent_id: 130500
					},
					"130533": {
						id: 130533,
						area_name: "威县",
						area_code: "Weixian",
						area_parent_id: 130500
					},
					"130534": {
						id: 130534,
						area_name: "清河县",
						area_code: "Qinghe",
						area_parent_id: 130500
					},
					"130535": {
						id: 130535,
						area_name: "临西县",
						area_code: "Linxi",
						area_parent_id: 130500
					},
					"130581": {
						id: 130581,
						area_name: "南宫市",
						area_code: "Nangong",
						area_parent_id: 130500
					},
					"130582": {
						id: 130582,
						area_name: "沙河市",
						area_code: "Shahe",
						area_parent_id: 130500
					}
				}
			},
			"130600": {
				id: 130600,
				area_name: "保定市",
				area_code: "Baoding",
				area_parent_id: 130000,
				child: {
					"130602": {
						id: 130602,
						area_name: "新市区",
						area_code: "Xinshi",
						area_parent_id: 130600
					},
					"130603": {
						id: 130603,
						area_name: "北市区",
						area_code: "Beishi",
						area_parent_id: 130600
					},
					"130604": {
						id: 130604,
						area_name: "南市区",
						area_code: "Nanshi",
						area_parent_id: 130600
					},
					"130621": {
						id: 130621,
						area_name: "满城县",
						area_code: "Mancheng",
						area_parent_id: 130600
					},
					"130622": {
						id: 130622,
						area_name: "清苑县",
						area_code: "Qingyuan",
						area_parent_id: 130600
					},
					"130623": {
						id: 130623,
						area_name: "涞水县",
						area_code: "Laishui",
						area_parent_id: 130600
					},
					"130624": {
						id: 130624,
						area_name: "阜平县",
						area_code: "Fuping",
						area_parent_id: 130600
					},
					"130625": {
						id: 130625,
						area_name: "徐水县",
						area_code: "Xushui",
						area_parent_id: 130600
					},
					"130626": {
						id: 130626,
						area_name: "定兴县",
						area_code: "Dingxing",
						area_parent_id: 130600
					},
					"130627": {
						id: 130627,
						area_name: "唐县",
						area_code: "Tangxian",
						area_parent_id: 130600
					},
					"130628": {
						id: 130628,
						area_name: "高阳县",
						area_code: "Gaoyang",
						area_parent_id: 130600
					},
					"130629": {
						id: 130629,
						area_name: "容城县",
						area_code: "Rongcheng",
						area_parent_id: 130600
					},
					"130630": {
						id: 130630,
						area_name: "涞源县",
						area_code: "Laiyuan",
						area_parent_id: 130600
					},
					"130631": {
						id: 130631,
						area_name: "望都县",
						area_code: "Wangdu",
						area_parent_id: 130600
					},
					"130632": {
						id: 130632,
						area_name: "安新县",
						area_code: "Anxin",
						area_parent_id: 130600
					},
					"130633": {
						id: 130633,
						area_name: "易县",
						area_code: "Yixian",
						area_parent_id: 130600
					},
					"130634": {
						id: 130634,
						area_name: "曲阳县",
						area_code: "Quyang",
						area_parent_id: 130600
					},
					"130635": {
						id: 130635,
						area_name: "蠡县",
						area_code: "Lixian",
						area_parent_id: 130600
					},
					"130636": {
						id: 130636,
						area_name: "顺平县",
						area_code: "Shunping",
						area_parent_id: 130600
					},
					"130637": {
						id: 130637,
						area_name: "博野县",
						area_code: "Boye",
						area_parent_id: 130600
					},
					"130638": {
						id: 130638,
						area_name: "雄县",
						area_code: "Xiongxian",
						area_parent_id: 130600
					},
					"130681": {
						id: 130681,
						area_name: "涿州市",
						area_code: "Zhuozhou",
						area_parent_id: 130600
					},
					"130682": {
						id: 130682,
						area_name: "定州市",
						area_code: "Dingzhou",
						area_parent_id: 130600
					},
					"130683": {
						id: 130683,
						area_name: "安国市",
						area_code: "Anguo",
						area_parent_id: 130600
					},
					"130684": {
						id: 130684,
						area_name: "高碑店市",
						area_code: "Gaobeidian",
						area_parent_id: 130600
					}
				}
			},
			"130700": {
				id: 130700,
				area_name: "张家口市",
				area_code: "Zhangjiakou",
				area_parent_id: 130000,
				child: {
					"130702": {
						id: 130702,
						area_name: "桥东区",
						area_code: "Qiaodong",
						area_parent_id: 130700
					},
					"130703": {
						id: 130703,
						area_name: "桥西区",
						area_code: "Qiaoxi",
						area_parent_id: 130700
					},
					"130705": {
						id: 130705,
						area_name: "宣化区",
						area_code: "Xuanhua",
						area_parent_id: 130700
					},
					"130706": {
						id: 130706,
						area_name: "下花园区",
						area_code: "Xiahuayuan",
						area_parent_id: 130700
					},
					"130721": {
						id: 130721,
						area_name: "宣化县",
						area_code: "Xuanhua",
						area_parent_id: 130700
					},
					"130722": {
						id: 130722,
						area_name: "张北县",
						area_code: "Zhangbei",
						area_parent_id: 130700
					},
					"130723": {
						id: 130723,
						area_name: "康保县",
						area_code: "Kangbao",
						area_parent_id: 130700
					},
					"130724": {
						id: 130724,
						area_name: "沽源县",
						area_code: "Guyuan",
						area_parent_id: 130700
					},
					"130725": {
						id: 130725,
						area_name: "尚义县",
						area_code: "Shangyi",
						area_parent_id: 130700
					},
					"130726": {
						id: 130726,
						area_name: "蔚县",
						area_code: "Yuxian",
						area_parent_id: 130700
					},
					"130727": {
						id: 130727,
						area_name: "阳原县",
						area_code: "Yangyuan",
						area_parent_id: 130700
					},
					"130728": {
						id: 130728,
						area_name: "怀安县",
						area_code: "Huai'an",
						area_parent_id: 130700
					},
					"130729": {
						id: 130729,
						area_name: "万全县",
						area_code: "Wanquan",
						area_parent_id: 130700
					},
					"130730": {
						id: 130730,
						area_name: "怀来县",
						area_code: "Huailai",
						area_parent_id: 130700
					},
					"130731": {
						id: 130731,
						area_name: "涿鹿县",
						area_code: "Zhuolu",
						area_parent_id: 130700
					},
					"130732": {
						id: 130732,
						area_name: "赤城县",
						area_code: "Chicheng",
						area_parent_id: 130700
					},
					"130733": {
						id: 130733,
						area_name: "崇礼县",
						area_code: "Chongli",
						area_parent_id: 130700
					}
				}
			},
			"130800": {
				id: 130800,
				area_name: "承德市",
				area_code: "Chengde",
				area_parent_id: 130000,
				child: {
					"130802": {
						id: 130802,
						area_name: "双桥区",
						area_code: "Shuangqiao",
						area_parent_id: 130800
					},
					"130803": {
						id: 130803,
						area_name: "双滦区",
						area_code: "Shuangluan",
						area_parent_id: 130800
					},
					"130804": {
						id: 130804,
						area_name: "鹰手营子矿区",
						area_code: "Yingshouyingzikuangqu",
						area_parent_id: 130800
					},
					"130821": {
						id: 130821,
						area_name: "承德县",
						area_code: "Chengde",
						area_parent_id: 130800
					},
					"130822": {
						id: 130822,
						area_name: "兴隆县",
						area_code: "Xinglong",
						area_parent_id: 130800
					},
					"130823": {
						id: 130823,
						area_name: "平泉县",
						area_code: "Pingquan",
						area_parent_id: 130800
					},
					"130824": {
						id: 130824,
						area_name: "滦平县",
						area_code: "Luanping",
						area_parent_id: 130800
					},
					"130825": {
						id: 130825,
						area_name: "隆化县",
						area_code: "Longhua",
						area_parent_id: 130800
					},
					"130826": {
						id: 130826,
						area_name: "丰宁满族自治县",
						area_code: "Fengning",
						area_parent_id: 130800
					},
					"130827": {
						id: 130827,
						area_name: "宽城满族自治县",
						area_code: "Kuancheng",
						area_parent_id: 130800
					},
					"130828": {
						id: 130828,
						area_name: "围场满族蒙古族自治县",
						area_code: "Weichang",
						area_parent_id: 130800
					}
				}
			},
			"130900": {
				id: 130900,
				area_name: "沧州市",
				area_code: "Cangzhou",
				area_parent_id: 130000,
				child: {
					"130902": {
						id: 130902,
						area_name: "新华区",
						area_code: "Xinhua",
						area_parent_id: 130900
					},
					"130903": {
						id: 130903,
						area_name: "运河区",
						area_code: "Yunhe",
						area_parent_id: 130900
					},
					"130921": {
						id: 130921,
						area_name: "沧县",
						area_code: "Cangxian",
						area_parent_id: 130900
					},
					"130922": {
						id: 130922,
						area_name: "青县",
						area_code: "Qingxian",
						area_parent_id: 130900
					},
					"130923": {
						id: 130923,
						area_name: "东光县",
						area_code: "Dongguang",
						area_parent_id: 130900
					},
					"130924": {
						id: 130924,
						area_name: "海兴县",
						area_code: "Haixing",
						area_parent_id: 130900
					},
					"130925": {
						id: 130925,
						area_name: "盐山县",
						area_code: "Yanshan",
						area_parent_id: 130900
					},
					"130926": {
						id: 130926,
						area_name: "肃宁县",
						area_code: "Suning",
						area_parent_id: 130900
					},
					"130927": {
						id: 130927,
						area_name: "南皮县",
						area_code: "Nanpi",
						area_parent_id: 130900
					},
					"130928": {
						id: 130928,
						area_name: "吴桥县",
						area_code: "Wuqiao",
						area_parent_id: 130900
					},
					"130929": {
						id: 130929,
						area_name: "献县",
						area_code: "Xianxian",
						area_parent_id: 130900
					},
					"130930": {
						id: 130930,
						area_name: "孟村回族自治县",
						area_code: "Mengcun",
						area_parent_id: 130900
					},
					"130981": {
						id: 130981,
						area_name: "泊头市",
						area_code: "Botou",
						area_parent_id: 130900
					},
					"130982": {
						id: 130982,
						area_name: "任丘市",
						area_code: "Renqiu",
						area_parent_id: 130900
					},
					"130983": {
						id: 130983,
						area_name: "黄骅市",
						area_code: "Huanghua",
						area_parent_id: 130900
					},
					"130984": {
						id: 130984,
						area_name: "河间市",
						area_code: "Hejian",
						area_parent_id: 130900
					}
				}
			},
			"131000": {
				id: 131000,
				area_name: "廊坊市",
				area_code: "Langfang",
				area_parent_id: 130000,
				child: {
					"131002": {
						id: 131002,
						area_name: "安次区",
						area_code: "Anci",
						area_parent_id: 131000
					},
					"131003": {
						id: 131003,
						area_name: "广阳区",
						area_code: "Guangyang",
						area_parent_id: 131000
					},
					"131022": {
						id: 131022,
						area_name: "固安县",
						area_code: "Gu'an",
						area_parent_id: 131000
					},
					"131023": {
						id: 131023,
						area_name: "永清县",
						area_code: "Yongqing",
						area_parent_id: 131000
					},
					"131024": {
						id: 131024,
						area_name: "香河县",
						area_code: "Xianghe",
						area_parent_id: 131000
					},
					"131025": {
						id: 131025,
						area_name: "大城县",
						area_code: "Daicheng",
						area_parent_id: 131000
					},
					"131026": {
						id: 131026,
						area_name: "文安县",
						area_code: "Wen'an",
						area_parent_id: 131000
					},
					"131028": {
						id: 131028,
						area_name: "大厂回族自治县",
						area_code: "Dachang",
						area_parent_id: 131000
					},
					"131081": {
						id: 131081,
						area_name: "霸州市",
						area_code: "Bazhou",
						area_parent_id: 131000
					},
					"131082": {
						id: 131082,
						area_name: "三河市",
						area_code: "Sanhe",
						area_parent_id: 131000
					}
				}
			},
			"131100": {
				id: 131100,
				area_name: "衡水市",
				area_code: "Hengshui",
				area_parent_id: 130000,
				child: {
					"131102": {
						id: 131102,
						area_name: "桃城区",
						area_code: "Taocheng",
						area_parent_id: 131100
					},
					"131121": {
						id: 131121,
						area_name: "枣强县",
						area_code: "Zaoqiang",
						area_parent_id: 131100
					},
					"131122": {
						id: 131122,
						area_name: "武邑县",
						area_code: "Wuyi",
						area_parent_id: 131100
					},
					"131123": {
						id: 131123,
						area_name: "武强县",
						area_code: "Wuqiang",
						area_parent_id: 131100
					},
					"131124": {
						id: 131124,
						area_name: "饶阳县",
						area_code: "Raoyang",
						area_parent_id: 131100
					},
					"131125": {
						id: 131125,
						area_name: "安平县",
						area_code: "Anping",
						area_parent_id: 131100
					},
					"131126": {
						id: 131126,
						area_name: "故城县",
						area_code: "Gucheng",
						area_parent_id: 131100
					},
					"131127": {
						id: 131127,
						area_name: "景县",
						area_code: "Jingxian",
						area_parent_id: 131100
					},
					"131128": {
						id: 131128,
						area_name: "阜城县",
						area_code: "Fucheng",
						area_parent_id: 131100
					},
					"131181": {
						id: 131181,
						area_name: "冀州市",
						area_code: "Jizhou",
						area_parent_id: 131100
					},
					"131182": {
						id: 131182,
						area_name: "深州市",
						area_code: "Shenzhou",
						area_parent_id: 131100
					}
				}
			}
		}
	},
	"140000": {
		id: 140000,
		area_name: "山西省",
		area_code: "Shanxi",
		area_parent_id: 0,
		child: {
			"140100": {
				id: 140100,
				area_name: "太原市",
				area_code: "Taiyuan",
				area_parent_id: 140000,
				child: {
					"140105": {
						id: 140105,
						area_name: "小店区",
						area_code: "Xiaodian",
						area_parent_id: 140100
					},
					"140106": {
						id: 140106,
						area_name: "迎泽区",
						area_code: "Yingze",
						area_parent_id: 140100
					},
					"140107": {
						id: 140107,
						area_name: "杏花岭区",
						area_code: "Xinghualing",
						area_parent_id: 140100
					},
					"140108": {
						id: 140108,
						area_name: "尖草坪区",
						area_code: "Jiancaoping",
						area_parent_id: 140100
					},
					"140109": {
						id: 140109,
						area_name: "万柏林区",
						area_code: "Wanbailin",
						area_parent_id: 140100
					},
					"140110": {
						id: 140110,
						area_name: "晋源区",
						area_code: "Jinyuan",
						area_parent_id: 140100
					},
					"140121": {
						id: 140121,
						area_name: "清徐县",
						area_code: "Qingxu",
						area_parent_id: 140100
					},
					"140122": {
						id: 140122,
						area_name: "阳曲县",
						area_code: "Yangqu",
						area_parent_id: 140100
					},
					"140123": {
						id: 140123,
						area_name: "娄烦县",
						area_code: "Loufan",
						area_parent_id: 140100
					},
					"140181": {
						id: 140181,
						area_name: "古交市",
						area_code: "Gujiao",
						area_parent_id: 140100
					}
				}
			},
			"140200": {
				id: 140200,
				area_name: "大同市",
				area_code: "Datong",
				area_parent_id: 140000,
				child: {
					"140202": {
						id: 140202,
						area_name: "城区",
						area_code: "Chengqu",
						area_parent_id: 140200
					},
					"140203": {
						id: 140203,
						area_name: "矿区",
						area_code: "Kuangqu",
						area_parent_id: 140200
					},
					"140211": {
						id: 140211,
						area_name: "南郊区",
						area_code: "Nanjiao",
						area_parent_id: 140200
					},
					"140212": {
						id: 140212,
						area_name: "新荣区",
						area_code: "Xinrong",
						area_parent_id: 140200
					},
					"140221": {
						id: 140221,
						area_name: "阳高县",
						area_code: "Yanggao",
						area_parent_id: 140200
					},
					"140222": {
						id: 140222,
						area_name: "天镇县",
						area_code: "Tianzhen",
						area_parent_id: 140200
					},
					"140223": {
						id: 140223,
						area_name: "广灵县",
						area_code: "Guangling",
						area_parent_id: 140200
					},
					"140224": {
						id: 140224,
						area_name: "灵丘县",
						area_code: "Lingqiu",
						area_parent_id: 140200
					},
					"140225": {
						id: 140225,
						area_name: "浑源县",
						area_code: "Hunyuan",
						area_parent_id: 140200
					},
					"140226": {
						id: 140226,
						area_name: "左云县",
						area_code: "Zuoyun",
						area_parent_id: 140200
					},
					"140227": {
						id: 140227,
						area_name: "大同县",
						area_code: "Datong",
						area_parent_id: 140200
					}
				}
			},
			"140300": {
				id: 140300,
				area_name: "阳泉市",
				area_code: "Yangquan",
				area_parent_id: 140000,
				child: {
					"140302": {
						id: 140302,
						area_name: "城区",
						area_code: "Chengqu",
						area_parent_id: 140300
					},
					"140303": {
						id: 140303,
						area_name: "矿区",
						area_code: "Kuangqu",
						area_parent_id: 140300
					},
					"140311": {
						id: 140311,
						area_name: "郊区",
						area_code: "Jiaoqu",
						area_parent_id: 140300
					},
					"140321": {
						id: 140321,
						area_name: "平定县",
						area_code: "Pingding",
						area_parent_id: 140300
					},
					"140322": {
						id: 140322,
						area_name: "盂县",
						area_code: "Yuxian",
						area_parent_id: 140300
					}
				}
			},
			"140400": {
				id: 140400,
				area_name: "长治市",
				area_code: "Changzhi",
				area_parent_id: 140000,
				child: {
					"140402": {
						id: 140402,
						area_name: "城区",
						area_code: "Chengqu",
						area_parent_id: 140400
					},
					"140411": {
						id: 140411,
						area_name: "郊区",
						area_code: "Jiaoqu",
						area_parent_id: 140400
					},
					"140421": {
						id: 140421,
						area_name: "长治县",
						area_code: "Changzhi",
						area_parent_id: 140400
					},
					"140423": {
						id: 140423,
						area_name: "襄垣县",
						area_code: "Xiangyuan",
						area_parent_id: 140400
					},
					"140424": {
						id: 140424,
						area_name: "屯留县",
						area_code: "Tunliu",
						area_parent_id: 140400
					},
					"140425": {
						id: 140425,
						area_name: "平顺县",
						area_code: "Pingshun",
						area_parent_id: 140400
					},
					"140426": {
						id: 140426,
						area_name: "黎城县",
						area_code: "Licheng",
						area_parent_id: 140400
					},
					"140427": {
						id: 140427,
						area_name: "壶关县",
						area_code: "Huguan",
						area_parent_id: 140400
					},
					"140428": {
						id: 140428,
						area_name: "长子县",
						area_code: "Zhangzi",
						area_parent_id: 140400
					},
					"140429": {
						id: 140429,
						area_name: "武乡县",
						area_code: "Wuxiang",
						area_parent_id: 140400
					},
					"140430": {
						id: 140430,
						area_name: "沁县",
						area_code: "Qinxian",
						area_parent_id: 140400
					},
					"140431": {
						id: 140431,
						area_name: "沁源县",
						area_code: "Qinyuan",
						area_parent_id: 140400
					},
					"140481": {
						id: 140481,
						area_name: "潞城市",
						area_code: "Lucheng",
						area_parent_id: 140400
					}
				}
			},
			"140500": {
				id: 140500,
				area_name: "晋城市",
				area_code: "Jincheng",
				area_parent_id: 140000,
				child: {
					"140502": {
						id: 140502,
						area_name: "城区",
						area_code: "Chengqu",
						area_parent_id: 140500
					},
					"140521": {
						id: 140521,
						area_name: "沁水县",
						area_code: "Qinshui",
						area_parent_id: 140500
					},
					"140522": {
						id: 140522,
						area_name: "阳城县",
						area_code: "Yangcheng",
						area_parent_id: 140500
					},
					"140524": {
						id: 140524,
						area_name: "陵川县",
						area_code: "Lingchuan",
						area_parent_id: 140500
					},
					"140525": {
						id: 140525,
						area_name: "泽州县",
						area_code: "Zezhou",
						area_parent_id: 140500
					},
					"140581": {
						id: 140581,
						area_name: "高平市",
						area_code: "Gaoping",
						area_parent_id: 140500
					}
				}
			},
			"140600": {
				id: 140600,
				area_name: "朔州市",
				area_code: "Shuozhou",
				area_parent_id: 140000,
				child: {
					"140602": {
						id: 140602,
						area_name: "朔城区",
						area_code: "Shuocheng",
						area_parent_id: 140600
					},
					"140603": {
						id: 140603,
						area_name: "平鲁区",
						area_code: "Pinglu",
						area_parent_id: 140600
					},
					"140621": {
						id: 140621,
						area_name: "山阴县",
						area_code: "Shanyin",
						area_parent_id: 140600
					},
					"140622": {
						id: 140622,
						area_name: "应县",
						area_code: "Yingxian",
						area_parent_id: 140600
					},
					"140623": {
						id: 140623,
						area_name: "右玉县",
						area_code: "Youyu",
						area_parent_id: 140600
					},
					"140624": {
						id: 140624,
						area_name: "怀仁县",
						area_code: "Huairen",
						area_parent_id: 140600
					}
				}
			},
			"140700": {
				id: 140700,
				area_name: "晋中市",
				area_code: "Jinzhong",
				area_parent_id: 140000,
				child: {
					"140702": {
						id: 140702,
						area_name: "榆次区",
						area_code: "Yuci",
						area_parent_id: 140700
					},
					"140721": {
						id: 140721,
						area_name: "榆社县",
						area_code: "Yushe",
						area_parent_id: 140700
					},
					"140722": {
						id: 140722,
						area_name: "左权县",
						area_code: "Zuoquan",
						area_parent_id: 140700
					},
					"140723": {
						id: 140723,
						area_name: "和顺县",
						area_code: "Heshun",
						area_parent_id: 140700
					},
					"140724": {
						id: 140724,
						area_name: "昔阳县",
						area_code: "Xiyang",
						area_parent_id: 140700
					},
					"140725": {
						id: 140725,
						area_name: "寿阳县",
						area_code: "Shouyang",
						area_parent_id: 140700
					},
					"140726": {
						id: 140726,
						area_name: "太谷县",
						area_code: "Taigu",
						area_parent_id: 140700
					},
					"140727": {
						id: 140727,
						area_name: "祁县",
						area_code: "Qixian",
						area_parent_id: 140700
					},
					"140728": {
						id: 140728,
						area_name: "平遥县",
						area_code: "Pingyao",
						area_parent_id: 140700
					},
					"140729": {
						id: 140729,
						area_name: "灵石县",
						area_code: "Lingshi",
						area_parent_id: 140700
					},
					"140781": {
						id: 140781,
						area_name: "介休市",
						area_code: "Jiexiu",
						area_parent_id: 140700
					}
				}
			},
			"140800": {
				id: 140800,
				area_name: "运城市",
				area_code: "Yuncheng",
				area_parent_id: 140000,
				child: {
					"140802": {
						id: 140802,
						area_name: "盐湖区",
						area_code: "Yanhu",
						area_parent_id: 140800
					},
					"140821": {
						id: 140821,
						area_name: "临猗县",
						area_code: "Linyi",
						area_parent_id: 140800
					},
					"140822": {
						id: 140822,
						area_name: "万荣县",
						area_code: "Wanrong",
						area_parent_id: 140800
					},
					"140823": {
						id: 140823,
						area_name: "闻喜县",
						area_code: "Wenxi",
						area_parent_id: 140800
					},
					"140824": {
						id: 140824,
						area_name: "稷山县",
						area_code: "Jishan",
						area_parent_id: 140800
					},
					"140825": {
						id: 140825,
						area_name: "新绛县",
						area_code: "Xinjiang",
						area_parent_id: 140800
					},
					"140826": {
						id: 140826,
						area_name: "绛县",
						area_code: "Jiangxian",
						area_parent_id: 140800
					},
					"140827": {
						id: 140827,
						area_name: "垣曲县",
						area_code: "Yuanqu",
						area_parent_id: 140800
					},
					"140828": {
						id: 140828,
						area_name: "夏县",
						area_code: "Xiaxian",
						area_parent_id: 140800
					},
					"140829": {
						id: 140829,
						area_name: "平陆县",
						area_code: "Pinglu",
						area_parent_id: 140800
					},
					"140830": {
						id: 140830,
						area_name: "芮城县",
						area_code: "Ruicheng",
						area_parent_id: 140800
					},
					"140881": {
						id: 140881,
						area_name: "永济市",
						area_code: "Yongji",
						area_parent_id: 140800
					},
					"140882": {
						id: 140882,
						area_name: "河津市",
						area_code: "Hejin",
						area_parent_id: 140800
					}
				}
			},
			"140900": {
				id: 140900,
				area_name: "忻州市",
				area_code: "Xinzhou",
				area_parent_id: 140000,
				child: {
					"140902": {
						id: 140902,
						area_name: "忻府区",
						area_code: "Xinfu",
						area_parent_id: 140900
					},
					"140921": {
						id: 140921,
						area_name: "定襄县",
						area_code: "Dingxiang",
						area_parent_id: 140900
					},
					"140922": {
						id: 140922,
						area_name: "五台县",
						area_code: "Wutai",
						area_parent_id: 140900
					},
					"140923": {
						id: 140923,
						area_name: "代县",
						area_code: "Daixian",
						area_parent_id: 140900
					},
					"140924": {
						id: 140924,
						area_name: "繁峙县",
						area_code: "Fanshi",
						area_parent_id: 140900
					},
					"140925": {
						id: 140925,
						area_name: "宁武县",
						area_code: "Ningwu",
						area_parent_id: 140900
					},
					"140926": {
						id: 140926,
						area_name: "静乐县",
						area_code: "Jingle",
						area_parent_id: 140900
					},
					"140927": {
						id: 140927,
						area_name: "神池县",
						area_code: "Shenchi",
						area_parent_id: 140900
					},
					"140928": {
						id: 140928,
						area_name: "五寨县",
						area_code: "Wuzhai",
						area_parent_id: 140900
					},
					"140929": {
						id: 140929,
						area_name: "岢岚县",
						area_code: "Kelan",
						area_parent_id: 140900
					},
					"140930": {
						id: 140930,
						area_name: "河曲县",
						area_code: "Hequ",
						area_parent_id: 140900
					},
					"140931": {
						id: 140931,
						area_name: "保德县",
						area_code: "Baode",
						area_parent_id: 140900
					},
					"140932": {
						id: 140932,
						area_name: "偏关县",
						area_code: "Pianguan",
						area_parent_id: 140900
					},
					"140981": {
						id: 140981,
						area_name: "原平市",
						area_code: "Yuanping",
						area_parent_id: 140900
					}
				}
			},
			"141000": {
				id: 141000,
				area_name: "临汾市",
				area_code: "Linfen",
				area_parent_id: 140000,
				child: {
					"141002": {
						id: 141002,
						area_name: "尧都区",
						area_code: "Yaodu",
						area_parent_id: 141000
					},
					"141021": {
						id: 141021,
						area_name: "曲沃县",
						area_code: "Quwo",
						area_parent_id: 141000
					},
					"141022": {
						id: 141022,
						area_name: "翼城县",
						area_code: "Yicheng",
						area_parent_id: 141000
					},
					"141023": {
						id: 141023,
						area_name: "襄汾县",
						area_code: "Xiangfen",
						area_parent_id: 141000
					},
					"141024": {
						id: 141024,
						area_name: "洪洞县",
						area_code: "Hongtong",
						area_parent_id: 141000
					},
					"141025": {
						id: 141025,
						area_name: "古县",
						area_code: "Guxian",
						area_parent_id: 141000
					},
					"141026": {
						id: 141026,
						area_name: "安泽县",
						area_code: "Anze",
						area_parent_id: 141000
					},
					"141027": {
						id: 141027,
						area_name: "浮山县",
						area_code: "Fushan",
						area_parent_id: 141000
					},
					"141028": {
						id: 141028,
						area_name: "吉县",
						area_code: "Jixian",
						area_parent_id: 141000
					},
					"141029": {
						id: 141029,
						area_name: "乡宁县",
						area_code: "Xiangning",
						area_parent_id: 141000
					},
					"141030": {
						id: 141030,
						area_name: "大宁县",
						area_code: "Daning",
						area_parent_id: 141000
					},
					"141031": {
						id: 141031,
						area_name: "隰县",
						area_code: "Xixian",
						area_parent_id: 141000
					},
					"141032": {
						id: 141032,
						area_name: "永和县",
						area_code: "Yonghe",
						area_parent_id: 141000
					},
					"141033": {
						id: 141033,
						area_name: "蒲县",
						area_code: "Puxian",
						area_parent_id: 141000
					},
					"141034": {
						id: 141034,
						area_name: "汾西县",
						area_code: "Fenxi",
						area_parent_id: 141000
					},
					"141081": {
						id: 141081,
						area_name: "侯马市",
						area_code: "Houma",
						area_parent_id: 141000
					},
					"141082": {
						id: 141082,
						area_name: "霍州市",
						area_code: "Huozhou",
						area_parent_id: 141000
					}
				}
			},
			"141100": {
				id: 141100,
				area_name: "吕梁市",
				area_code: "Lvliang",
				area_parent_id: 140000,
				child: {
					"141102": {
						id: 141102,
						area_name: "离石区",
						area_code: "Lishi",
						area_parent_id: 141100
					},
					"141121": {
						id: 141121,
						area_name: "文水县",
						area_code: "Wenshui",
						area_parent_id: 141100
					},
					"141122": {
						id: 141122,
						area_name: "交城县",
						area_code: "Jiaocheng",
						area_parent_id: 141100
					},
					"141123": {
						id: 141123,
						area_name: "兴县",
						area_code: "Xingxian",
						area_parent_id: 141100
					},
					"141124": {
						id: 141124,
						area_name: "临县",
						area_code: "Linxian",
						area_parent_id: 141100
					},
					"141125": {
						id: 141125,
						area_name: "柳林县",
						area_code: "Liulin",
						area_parent_id: 141100
					},
					"141126": {
						id: 141126,
						area_name: "石楼县",
						area_code: "Shilou",
						area_parent_id: 141100
					},
					"141127": {
						id: 141127,
						area_name: "岚县",
						area_code: "Lanxian",
						area_parent_id: 141100
					},
					"141128": {
						id: 141128,
						area_name: "方山县",
						area_code: "Fangshan",
						area_parent_id: 141100
					},
					"141129": {
						id: 141129,
						area_name: "中阳县",
						area_code: "Zhongyang",
						area_parent_id: 141100
					},
					"141130": {
						id: 141130,
						area_name: "交口县",
						area_code: "Jiaokou",
						area_parent_id: 141100
					},
					"141181": {
						id: 141181,
						area_name: "孝义市",
						area_code: "Xiaoyi",
						area_parent_id: 141100
					},
					"141182": {
						id: 141182,
						area_name: "汾阳市",
						area_code: "Fenyang",
						area_parent_id: 141100
					}
				}
			}
		}
	},
	"150000": {
		id: 150000,
		area_name: "内蒙古自治区",
		area_code: "Inner Mongolia",
		area_parent_id: 0,
		child: {
			"150100": {
				id: 150100,
				area_name: "呼和浩特市",
				area_code: "Hohhot",
				area_parent_id: 150000,
				child: {
					"150102": {
						id: 150102,
						area_name: "新城区",
						area_code: "Xincheng",
						area_parent_id: 150100
					},
					"150103": {
						id: 150103,
						area_name: "回民区",
						area_code: "Huimin",
						area_parent_id: 150100
					},
					"150104": {
						id: 150104,
						area_name: "玉泉区",
						area_code: "Yuquan",
						area_parent_id: 150100
					},
					"150105": {
						id: 150105,
						area_name: "赛罕区",
						area_code: "Saihan",
						area_parent_id: 150100
					},
					"150121": {
						id: 150121,
						area_name: "土默特左旗",
						area_code: "Tumotezuoqi",
						area_parent_id: 150100
					},
					"150122": {
						id: 150122,
						area_name: "托克托县",
						area_code: "Tuoketuo",
						area_parent_id: 150100
					},
					"150123": {
						id: 150123,
						area_name: "和林格尔县",
						area_code: "Helingeer",
						area_parent_id: 150100
					},
					"150124": {
						id: 150124,
						area_name: "清水河县",
						area_code: "Qingshuihe",
						area_parent_id: 150100
					},
					"150125": {
						id: 150125,
						area_name: "武川县",
						area_code: "Wuchuan",
						area_parent_id: 150100
					}
				}
			},
			"150200": {
				id: 150200,
				area_name: "包头市",
				area_code: "Baotou",
				area_parent_id: 150000,
				child: {
					"150202": {
						id: 150202,
						area_name: "东河区",
						area_code: "Donghe",
						area_parent_id: 150200
					},
					"150203": {
						id: 150203,
						area_name: "昆都仑区",
						area_code: "Kundulun",
						area_parent_id: 150200
					},
					"150204": {
						id: 150204,
						area_name: "青山区",
						area_code: "Qingshan",
						area_parent_id: 150200
					},
					"150205": {
						id: 150205,
						area_name: "石拐区",
						area_code: "Shiguai",
						area_parent_id: 150200
					},
					"150206": {
						id: 150206,
						area_name: "白云鄂博矿区",
						area_code: "Baiyunebokuangqu",
						area_parent_id: 150200
					},
					"150207": {
						id: 150207,
						area_name: "九原区",
						area_code: "Jiuyuan",
						area_parent_id: 150200
					},
					"150221": {
						id: 150221,
						area_name: "土默特右旗",
						area_code: "Tumoteyouqi",
						area_parent_id: 150200
					},
					"150222": {
						id: 150222,
						area_name: "固阳县",
						area_code: "Guyang",
						area_parent_id: 150200
					},
					"150223": {
						id: 150223,
						area_name: "达尔罕茂明安联合旗",
						area_code: "Damaoqi",
						area_parent_id: 150200
					}
				}
			},
			"150300": {
				id: 150300,
				area_name: "乌海市",
				area_code: "Wuhai",
				area_parent_id: 150000,
				child: {
					"150302": {
						id: 150302,
						area_name: "海勃湾区",
						area_code: "Haibowan",
						area_parent_id: 150300
					},
					"150303": {
						id: 150303,
						area_name: "海南区",
						area_code: "Hainan",
						area_parent_id: 150300
					},
					"150304": {
						id: 150304,
						area_name: "乌达区",
						area_code: "Wuda",
						area_parent_id: 150300
					}
				}
			},
			"150400": {
				id: 150400,
				area_name: "赤峰市",
				area_code: "Chifeng",
				area_parent_id: 150000,
				child: {
					"150402": {
						id: 150402,
						area_name: "红山区",
						area_code: "Hongshan",
						area_parent_id: 150400
					},
					"150403": {
						id: 150403,
						area_name: "元宝山区",
						area_code: "Yuanbaoshan",
						area_parent_id: 150400
					},
					"150404": {
						id: 150404,
						area_name: "松山区",
						area_code: "Songshan",
						area_parent_id: 150400
					},
					"150421": {
						id: 150421,
						area_name: "阿鲁科尔沁旗",
						area_code: "Alukeerqinqi",
						area_parent_id: 150400
					},
					"150422": {
						id: 150422,
						area_name: "巴林左旗",
						area_code: "Balinzuoqi",
						area_parent_id: 150400
					},
					"150423": {
						id: 150423,
						area_name: "巴林右旗",
						area_code: "Balinyouqi",
						area_parent_id: 150400
					},
					"150424": {
						id: 150424,
						area_name: "林西县",
						area_code: "Linxi",
						area_parent_id: 150400
					},
					"150425": {
						id: 150425,
						area_name: "克什克腾旗",
						area_code: "Keshiketengqi",
						area_parent_id: 150400
					},
					"150426": {
						id: 150426,
						area_name: "翁牛特旗",
						area_code: "Wengniuteqi",
						area_parent_id: 150400
					},
					"150428": {
						id: 150428,
						area_name: "喀喇沁旗",
						area_code: "Kalaqinqi",
						area_parent_id: 150400
					},
					"150429": {
						id: 150429,
						area_name: "宁城县",
						area_code: "Ningcheng",
						area_parent_id: 150400
					},
					"150430": {
						id: 150430,
						area_name: "敖汉旗",
						area_code: "Aohanqi",
						area_parent_id: 150400
					}
				}
			},
			"150500": {
				id: 150500,
				area_name: "通辽市",
				area_code: "Tongliao",
				area_parent_id: 150000,
				child: {
					"150502": {
						id: 150502,
						area_name: "科尔沁区",
						area_code: "Keerqin",
						area_parent_id: 150500
					},
					"150521": {
						id: 150521,
						area_name: "科尔沁左翼中旗",
						area_code: "Keerqinzuoyizhongqi",
						area_parent_id: 150500
					},
					"150522": {
						id: 150522,
						area_name: "科尔沁左翼后旗",
						area_code: "Keerqinzuoyihouqi",
						area_parent_id: 150500
					},
					"150523": {
						id: 150523,
						area_name: "开鲁县",
						area_code: "Kailu",
						area_parent_id: 150500
					},
					"150524": {
						id: 150524,
						area_name: "库伦旗",
						area_code: "Kulunqi",
						area_parent_id: 150500
					},
					"150525": {
						id: 150525,
						area_name: "奈曼旗",
						area_code: "Naimanqi",
						area_parent_id: 150500
					},
					"150526": {
						id: 150526,
						area_name: "扎鲁特旗",
						area_code: "Zhaluteqi",
						area_parent_id: 150500
					},
					"150581": {
						id: 150581,
						area_name: "霍林郭勒市",
						area_code: "Huolinguole",
						area_parent_id: 150500
					}
				}
			},
			"150600": {
				id: 150600,
				area_name: "鄂尔多斯市",
				area_code: "Ordos",
				area_parent_id: 150000,
				child: {
					"150602": {
						id: 150602,
						area_name: "东胜区",
						area_code: "Dongsheng",
						area_parent_id: 150600
					},
					"150621": {
						id: 150621,
						area_name: "达拉特旗",
						area_code: "Dalateqi",
						area_parent_id: 150600
					},
					"150622": {
						id: 150622,
						area_name: "准格尔旗",
						area_code: "Zhungeerqi",
						area_parent_id: 150600
					},
					"150623": {
						id: 150623,
						area_name: "鄂托克前旗",
						area_code: "Etuokeqianqi",
						area_parent_id: 150600
					},
					"150624": {
						id: 150624,
						area_name: "鄂托克旗",
						area_code: "Etuokeqi",
						area_parent_id: 150600
					},
					"150625": {
						id: 150625,
						area_name: "杭锦旗",
						area_code: "Hangjinqi",
						area_parent_id: 150600
					},
					"150626": {
						id: 150626,
						area_name: "乌审旗",
						area_code: "Wushenqi",
						area_parent_id: 150600
					},
					"150627": {
						id: 150627,
						area_name: "伊金霍洛旗",
						area_code: "Yijinhuoluoqi",
						area_parent_id: 150600
					}
				}
			},
			"150700": {
				id: 150700,
				area_name: "呼伦贝尔市",
				area_code: "Hulunber",
				area_parent_id: 150000,
				child: {
					"150702": {
						id: 150702,
						area_name: "海拉尔区",
						area_code: "Hailaer",
						area_parent_id: 150700
					},
					"150703": {
						id: 150703,
						area_name: "扎赉诺尔区",
						area_code: "Zhalainuoer",
						area_parent_id: 150700
					},
					"150721": {
						id: 150721,
						area_name: "阿荣旗",
						area_code: "Arongqi",
						area_parent_id: 150700
					},
					"150722": {
						id: 150722,
						area_name: "莫力达瓦达斡尔族自治旗",
						area_code: "Moqi",
						area_parent_id: 150700
					},
					"150723": {
						id: 150723,
						area_name: "鄂伦春自治旗",
						area_code: "Elunchun",
						area_parent_id: 150700
					},
					"150724": {
						id: 150724,
						area_name: "鄂温克族自治旗",
						area_code: "Ewen",
						area_parent_id: 150700
					},
					"150725": {
						id: 150725,
						area_name: "陈巴尔虎旗",
						area_code: "Chenbaerhuqi",
						area_parent_id: 150700
					},
					"150726": {
						id: 150726,
						area_name: "新巴尔虎左旗",
						area_code: "Xinbaerhuzuoqi",
						area_parent_id: 150700
					},
					"150727": {
						id: 150727,
						area_name: "新巴尔虎右旗",
						area_code: "Xinbaerhuyouqi",
						area_parent_id: 150700
					},
					"150781": {
						id: 150781,
						area_name: "满洲里市",
						area_code: "Manzhouli",
						area_parent_id: 150700
					},
					"150782": {
						id: 150782,
						area_name: "牙克石市",
						area_code: "Yakeshi",
						area_parent_id: 150700
					},
					"150783": {
						id: 150783,
						area_name: "扎兰屯市",
						area_code: "Zhalantun",
						area_parent_id: 150700
					},
					"150784": {
						id: 150784,
						area_name: "额尔古纳市",
						area_code: "Eerguna",
						area_parent_id: 150700
					},
					"150785": {
						id: 150785,
						area_name: "根河市",
						area_code: "Genhe",
						area_parent_id: 150700
					}
				}
			},
			"150800": {
				id: 150800,
				area_name: "巴彦淖尔市",
				area_code: "Bayan Nur",
				area_parent_id: 150000,
				child: {
					"150802": {
						id: 150802,
						area_name: "临河区",
						area_code: "Linhe",
						area_parent_id: 150800
					},
					"150821": {
						id: 150821,
						area_name: "五原县",
						area_code: "Wuyuan",
						area_parent_id: 150800
					},
					"150822": {
						id: 150822,
						area_name: "磴口县",
						area_code: "Dengkou",
						area_parent_id: 150800
					},
					"150823": {
						id: 150823,
						area_name: "乌拉特前旗",
						area_code: "Wulateqianqi",
						area_parent_id: 150800
					},
					"150824": {
						id: 150824,
						area_name: "乌拉特中旗",
						area_code: "Wulatezhongqi",
						area_parent_id: 150800
					},
					"150825": {
						id: 150825,
						area_name: "乌拉特后旗",
						area_code: "Wulatehouqi",
						area_parent_id: 150800
					},
					"150826": {
						id: 150826,
						area_name: "杭锦后旗",
						area_code: "Hangjinhouqi",
						area_parent_id: 150800
					}
				}
			},
			"150900": {
				id: 150900,
				area_name: "乌兰察布市",
				area_code: "Ulanqab",
				area_parent_id: 150000,
				child: {
					"150902": {
						id: 150902,
						area_name: "集宁区",
						area_code: "Jining",
						area_parent_id: 150900
					},
					"150921": {
						id: 150921,
						area_name: "卓资县",
						area_code: "Zhuozi",
						area_parent_id: 150900
					},
					"150922": {
						id: 150922,
						area_name: "化德县",
						area_code: "Huade",
						area_parent_id: 150900
					},
					"150923": {
						id: 150923,
						area_name: "商都县",
						area_code: "Shangdu",
						area_parent_id: 150900
					},
					"150924": {
						id: 150924,
						area_name: "兴和县",
						area_code: "Xinghe",
						area_parent_id: 150900
					},
					"150925": {
						id: 150925,
						area_name: "凉城县",
						area_code: "Liangcheng",
						area_parent_id: 150900
					},
					"150926": {
						id: 150926,
						area_name: "察哈尔右翼前旗",
						area_code: "Chayouqianqi",
						area_parent_id: 150900
					},
					"150927": {
						id: 150927,
						area_name: "察哈尔右翼中旗",
						area_code: "Chayouzhongqi",
						area_parent_id: 150900
					},
					"150928": {
						id: 150928,
						area_name: "察哈尔右翼后旗",
						area_code: "Chayouhouqi",
						area_parent_id: 150900
					},
					"150929": {
						id: 150929,
						area_name: "四子王旗",
						area_code: "Siziwangqi",
						area_parent_id: 150900
					},
					"150981": {
						id: 150981,
						area_name: "丰镇市",
						area_code: "Fengzhen",
						area_parent_id: 150900
					}
				}
			},
			"152200": {
				id: 152200,
				area_name: "兴安盟",
				area_code: "Hinggan",
				area_parent_id: 150000,
				child: {
					"152201": {
						id: 152201,
						area_name: "乌兰浩特市",
						area_code: "Wulanhaote",
						area_parent_id: 152200
					},
					"152202": {
						id: 152202,
						area_name: "阿尔山市",
						area_code: "Aershan",
						area_parent_id: 152200
					},
					"152221": {
						id: 152221,
						area_name: "科尔沁右翼前旗",
						area_code: "Keyouqianqi",
						area_parent_id: 152200
					},
					"152222": {
						id: 152222,
						area_name: "科尔沁右翼中旗",
						area_code: "Keyouzhongqi",
						area_parent_id: 152200
					},
					"152223": {
						id: 152223,
						area_name: "扎赉特旗",
						area_code: "Zhalaiteqi",
						area_parent_id: 152200
					},
					"152224": {
						id: 152224,
						area_name: "突泉县",
						area_code: "Tuquan",
						area_parent_id: 152200
					}
				}
			},
			"152500": {
				id: 152500,
				area_name: "锡林郭勒盟",
				area_code: "Xilin Gol",
				area_parent_id: 150000,
				child: {
					"152501": {
						id: 152501,
						area_name: "二连浩特市",
						area_code: "Erlianhaote",
						area_parent_id: 152500
					},
					"152502": {
						id: 152502,
						area_name: "锡林浩特市",
						area_code: "Xilinhaote",
						area_parent_id: 152500
					},
					"152522": {
						id: 152522,
						area_name: "阿巴嘎旗",
						area_code: "Abagaqi",
						area_parent_id: 152500
					},
					"152523": {
						id: 152523,
						area_name: "苏尼特左旗",
						area_code: "Sunitezuoqi",
						area_parent_id: 152500
					},
					"152524": {
						id: 152524,
						area_name: "苏尼特右旗",
						area_code: "Suniteyouqi",
						area_parent_id: 152500
					},
					"152525": {
						id: 152525,
						area_name: "东乌珠穆沁旗",
						area_code: "Dongwuqi",
						area_parent_id: 152500
					},
					"152526": {
						id: 152526,
						area_name: "西乌珠穆沁旗",
						area_code: "Xiwuqi",
						area_parent_id: 152500
					},
					"152527": {
						id: 152527,
						area_name: "太仆寺旗",
						area_code: "Taipusiqi",
						area_parent_id: 152500
					},
					"152528": {
						id: 152528,
						area_name: "镶黄旗",
						area_code: "Xianghuangqi",
						area_parent_id: 152500
					},
					"152529": {
						id: 152529,
						area_name: "正镶白旗",
						area_code: "Zhengxiangbaiqi",
						area_parent_id: 152500
					},
					"152530": {
						id: 152530,
						area_name: "正蓝旗",
						area_code: "Zhenglanqi",
						area_parent_id: 152500
					},
					"152531": {
						id: 152531,
						area_name: "多伦县",
						area_code: "Duolun",
						area_parent_id: 152500
					}
				}
			},
			"152900": {
				id: 152900,
				area_name: "阿拉善盟",
				area_code: "Alxa",
				area_parent_id: 150000,
				child: {
					"152921": {
						id: 152921,
						area_name: "阿拉善左旗",
						area_code: "Alashanzuoqi",
						area_parent_id: 152900
					},
					"152922": {
						id: 152922,
						area_name: "阿拉善右旗",
						area_code: "Alashanyouqi",
						area_parent_id: 152900
					},
					"152923": {
						id: 152923,
						area_name: "额济纳旗",
						area_code: "Ejinaqi",
						area_parent_id: 152900
					}
				}
			}
		}
	},
	"210000": {
		id: 210000,
		area_name: "辽宁省",
		area_code: "Liaoning",
		area_parent_id: 0,
		child: {
			"210100": {
				id: 210100,
				area_name: "沈阳市",
				area_code: "Shenyang",
				area_parent_id: 210000,
				child: {
					"210102": {
						id: 210102,
						area_name: "和平区",
						area_code: "Heping",
						area_parent_id: 210100
					},
					"210103": {
						id: 210103,
						area_name: "沈河区",
						area_code: "Shenhe",
						area_parent_id: 210100
					},
					"210104": {
						id: 210104,
						area_name: "大东区",
						area_code: "Dadong",
						area_parent_id: 210100
					},
					"210105": {
						id: 210105,
						area_name: "皇姑区",
						area_code: "Huanggu",
						area_parent_id: 210100
					},
					"210106": {
						id: 210106,
						area_name: "铁西区",
						area_code: "Tiexi",
						area_parent_id: 210100
					},
					"210111": {
						id: 210111,
						area_name: "苏家屯区",
						area_code: "Sujiatun",
						area_parent_id: 210100
					},
					"210112": {
						id: 210112,
						area_name: "浑南区",
						area_code: "Hunnan",
						area_parent_id: 210100
					},
					"210113": {
						id: 210113,
						area_name: "沈北新区",
						area_code: "Shenbeixinqu",
						area_parent_id: 210100
					},
					"210114": {
						id: 210114,
						area_name: "于洪区",
						area_code: "Yuhong",
						area_parent_id: 210100
					},
					"210122": {
						id: 210122,
						area_name: "辽中县",
						area_code: "Liaozhong",
						area_parent_id: 210100
					},
					"210123": {
						id: 210123,
						area_name: "康平县",
						area_code: "Kangping",
						area_parent_id: 210100
					},
					"210124": {
						id: 210124,
						area_name: "法库县",
						area_code: "Faku",
						area_parent_id: 210100
					},
					"210181": {
						id: 210181,
						area_name: "新民市",
						area_code: "Xinmin",
						area_parent_id: 210100
					}
				}
			},
			"210200": {
				id: 210200,
				area_name: "大连市",
				area_code: "Dalian",
				area_parent_id: 210000,
				child: {
					"210202": {
						id: 210202,
						area_name: "中山区",
						area_code: "Zhongshan",
						area_parent_id: 210200
					},
					"210203": {
						id: 210203,
						area_name: "西岗区",
						area_code: "Xigang",
						area_parent_id: 210200
					},
					"210204": {
						id: 210204,
						area_name: "沙河口区",
						area_code: "Shahekou",
						area_parent_id: 210200
					},
					"210211": {
						id: 210211,
						area_name: "甘井子区",
						area_code: "Ganjingzi",
						area_parent_id: 210200
					},
					"210212": {
						id: 210212,
						area_name: "旅顺口区",
						area_code: "Lvshunkou",
						area_parent_id: 210200
					},
					"210213": {
						id: 210213,
						area_name: "金州区",
						area_code: "Jinzhou",
						area_parent_id: 210200
					},
					"210224": {
						id: 210224,
						area_name: "长海县",
						area_code: "Changhai",
						area_parent_id: 210200
					},
					"210281": {
						id: 210281,
						area_name: "瓦房店市",
						area_code: "Wafangdian",
						area_parent_id: 210200
					},
					"210282": {
						id: 210282,
						area_name: "普兰店市",
						area_code: "Pulandian",
						area_parent_id: 210200
					},
					"210283": {
						id: 210283,
						area_name: "庄河市",
						area_code: "Zhuanghe",
						area_parent_id: 210200
					}
				}
			},
			"210300": {
				id: 210300,
				area_name: "鞍山市",
				area_code: "Anshan",
				area_parent_id: 210000,
				child: {
					"210302": {
						id: 210302,
						area_name: "铁东区",
						area_code: "Tiedong",
						area_parent_id: 210300
					},
					"210303": {
						id: 210303,
						area_name: "铁西区",
						area_code: "Tiexi",
						area_parent_id: 210300
					},
					"210304": {
						id: 210304,
						area_name: "立山区",
						area_code: "Lishan",
						area_parent_id: 210300
					},
					"210311": {
						id: 210311,
						area_name: "千山区",
						area_code: "Qianshan",
						area_parent_id: 210300
					},
					"210321": {
						id: 210321,
						area_name: "台安县",
						area_code: "Tai'an",
						area_parent_id: 210300
					},
					"210323": {
						id: 210323,
						area_name: "岫岩满族自治县",
						area_code: "Xiuyan",
						area_parent_id: 210300
					},
					"210381": {
						id: 210381,
						area_name: "海城市",
						area_code: "Haicheng",
						area_parent_id: 210300
					}
				}
			},
			"210400": {
				id: 210400,
				area_name: "抚顺市",
				area_code: "Fushun",
				area_parent_id: 210000,
				child: {
					"210402": {
						id: 210402,
						area_name: "新抚区",
						area_code: "Xinfu",
						area_parent_id: 210400
					},
					"210403": {
						id: 210403,
						area_name: "东洲区",
						area_code: "Dongzhou",
						area_parent_id: 210400
					},
					"210404": {
						id: 210404,
						area_name: "望花区",
						area_code: "Wanghua",
						area_parent_id: 210400
					},
					"210411": {
						id: 210411,
						area_name: "顺城区",
						area_code: "Shuncheng",
						area_parent_id: 210400
					},
					"210421": {
						id: 210421,
						area_name: "抚顺县",
						area_code: "Fushun",
						area_parent_id: 210400
					},
					"210422": {
						id: 210422,
						area_name: "新宾满族自治县",
						area_code: "Xinbin",
						area_parent_id: 210400
					},
					"210423": {
						id: 210423,
						area_name: "清原满族自治县",
						area_code: "Qingyuan",
						area_parent_id: 210400
					}
				}
			},
			"210500": {
				id: 210500,
				area_name: "本溪市",
				area_code: "Benxi",
				area_parent_id: 210000,
				child: {
					"210502": {
						id: 210502,
						area_name: "平山区",
						area_code: "Pingshan",
						area_parent_id: 210500
					},
					"210503": {
						id: 210503,
						area_name: "溪湖区",
						area_code: "Xihu",
						area_parent_id: 210500
					},
					"210504": {
						id: 210504,
						area_name: "明山区",
						area_code: "Mingshan",
						area_parent_id: 210500
					},
					"210505": {
						id: 210505,
						area_name: "南芬区",
						area_code: "Nanfen",
						area_parent_id: 210500
					},
					"210521": {
						id: 210521,
						area_name: "本溪满族自治县",
						area_code: "Benxi",
						area_parent_id: 210500
					},
					"210522": {
						id: 210522,
						area_name: "桓仁满族自治县",
						area_code: "Huanren",
						area_parent_id: 210500
					}
				}
			},
			"210600": {
				id: 210600,
				area_name: "丹东市",
				area_code: "Dandong",
				area_parent_id: 210000,
				child: {
					"210602": {
						id: 210602,
						area_name: "元宝区",
						area_code: "Yuanbao",
						area_parent_id: 210600
					},
					"210603": {
						id: 210603,
						area_name: "振兴区",
						area_code: "Zhenxing",
						area_parent_id: 210600
					},
					"210604": {
						id: 210604,
						area_name: "振安区",
						area_code: "Zhen'an",
						area_parent_id: 210600
					},
					"210624": {
						id: 210624,
						area_name: "宽甸满族自治县",
						area_code: "Kuandian",
						area_parent_id: 210600
					},
					"210681": {
						id: 210681,
						area_name: "东港市",
						area_code: "Donggang",
						area_parent_id: 210600
					},
					"210682": {
						id: 210682,
						area_name: "凤城市",
						area_code: "Fengcheng",
						area_parent_id: 210600
					}
				}
			},
			"210700": {
				id: 210700,
				area_name: "锦州市",
				area_code: "Jinzhou",
				area_parent_id: 210000,
				child: {
					"210702": {
						id: 210702,
						area_name: "古塔区",
						area_code: "Guta",
						area_parent_id: 210700
					},
					"210703": {
						id: 210703,
						area_name: "凌河区",
						area_code: "Linghe",
						area_parent_id: 210700
					},
					"210711": {
						id: 210711,
						area_name: "太和区",
						area_code: "Taihe",
						area_parent_id: 210700
					},
					"210726": {
						id: 210726,
						area_name: "黑山县",
						area_code: "Heishan",
						area_parent_id: 210700
					},
					"210727": {
						id: 210727,
						area_name: "义县",
						area_code: "Yixian",
						area_parent_id: 210700
					},
					"210781": {
						id: 210781,
						area_name: "凌海市",
						area_code: "Linghai",
						area_parent_id: 210700
					},
					"210782": {
						id: 210782,
						area_name: "北镇市",
						area_code: "Beizhen",
						area_parent_id: 210700
					}
				}
			},
			"210800": {
				id: 210800,
				area_name: "营口市",
				area_code: "Yingkou",
				area_parent_id: 210000,
				child: {
					"210802": {
						id: 210802,
						area_name: "站前区",
						area_code: "Zhanqian",
						area_parent_id: 210800
					},
					"210803": {
						id: 210803,
						area_name: "西市区",
						area_code: "Xishi",
						area_parent_id: 210800
					},
					"210804": {
						id: 210804,
						area_name: "鲅鱼圈区",
						area_code: "Bayuquan",
						area_parent_id: 210800
					},
					"210811": {
						id: 210811,
						area_name: "老边区",
						area_code: "Laobian",
						area_parent_id: 210800
					},
					"210881": {
						id: 210881,
						area_name: "盖州市",
						area_code: "Gaizhou",
						area_parent_id: 210800
					},
					"210882": {
						id: 210882,
						area_name: "大石桥市",
						area_code: "Dashiqiao",
						area_parent_id: 210800
					}
				}
			},
			"210900": {
				id: 210900,
				area_name: "阜新市",
				area_code: "Fuxin",
				area_parent_id: 210000,
				child: {
					"210902": {
						id: 210902,
						area_name: "海州区",
						area_code: "Haizhou",
						area_parent_id: 210900
					},
					"210903": {
						id: 210903,
						area_name: "新邱区",
						area_code: "Xinqiu",
						area_parent_id: 210900
					},
					"210904": {
						id: 210904,
						area_name: "太平区",
						area_code: "Taiping",
						area_parent_id: 210900
					},
					"210905": {
						id: 210905,
						area_name: "清河门区",
						area_code: "Qinghemen",
						area_parent_id: 210900
					},
					"210911": {
						id: 210911,
						area_name: "细河区",
						area_code: "Xihe",
						area_parent_id: 210900
					},
					"210921": {
						id: 210921,
						area_name: "阜新蒙古族自治县",
						area_code: "Fuxin",
						area_parent_id: 210900
					},
					"210922": {
						id: 210922,
						area_name: "彰武县",
						area_code: "Zhangwu",
						area_parent_id: 210900
					}
				}
			},
			"211000": {
				id: 211000,
				area_name: "辽阳市",
				area_code: "Liaoyang",
				area_parent_id: 210000,
				child: {
					"211002": {
						id: 211002,
						area_name: "白塔区",
						area_code: "Baita",
						area_parent_id: 211000
					},
					"211003": {
						id: 211003,
						area_name: "文圣区",
						area_code: "Wensheng",
						area_parent_id: 211000
					},
					"211004": {
						id: 211004,
						area_name: "宏伟区",
						area_code: "Hongwei",
						area_parent_id: 211000
					},
					"211005": {
						id: 211005,
						area_name: "弓长岭区",
						area_code: "Gongchangling",
						area_parent_id: 211000
					},
					"211011": {
						id: 211011,
						area_name: "太子河区",
						area_code: "Taizihe",
						area_parent_id: 211000
					},
					"211021": {
						id: 211021,
						area_name: "辽阳县",
						area_code: "Liaoyang",
						area_parent_id: 211000
					},
					"211081": {
						id: 211081,
						area_name: "灯塔市",
						area_code: "Dengta",
						area_parent_id: 211000
					}
				}
			},
			"211100": {
				id: 211100,
				area_name: "盘锦市",
				area_code: "Panjin",
				area_parent_id: 210000,
				child: {
					"211102": {
						id: 211102,
						area_name: "双台子区",
						area_code: "Shuangtaizi",
						area_parent_id: 211100
					},
					"211103": {
						id: 211103,
						area_name: "兴隆台区",
						area_code: "Xinglongtai",
						area_parent_id: 211100
					},
					"211121": {
						id: 211121,
						area_name: "大洼县",
						area_code: "Dawa",
						area_parent_id: 211100
					},
					"211122": {
						id: 211122,
						area_name: "盘山县",
						area_code: "Panshan",
						area_parent_id: 211100
					}
				}
			},
			"211200": {
				id: 211200,
				area_name: "铁岭市",
				area_code: "Tieling",
				area_parent_id: 210000,
				child: {
					"211202": {
						id: 211202,
						area_name: "银州区",
						area_code: "Yinzhou",
						area_parent_id: 211200
					},
					"211204": {
						id: 211204,
						area_name: "清河区",
						area_code: "Qinghe",
						area_parent_id: 211200
					},
					"211221": {
						id: 211221,
						area_name: "铁岭县",
						area_code: "Tieling",
						area_parent_id: 211200
					},
					"211223": {
						id: 211223,
						area_name: "西丰县",
						area_code: "Xifeng",
						area_parent_id: 211200
					},
					"211224": {
						id: 211224,
						area_name: "昌图县",
						area_code: "Changtu",
						area_parent_id: 211200
					},
					"211281": {
						id: 211281,
						area_name: "调兵山市",
						area_code: "Diaobingshan",
						area_parent_id: 211200
					},
					"211282": {
						id: 211282,
						area_name: "开原市",
						area_code: "Kaiyuan",
						area_parent_id: 211200
					}
				}
			},
			"211300": {
				id: 211300,
				area_name: "朝阳市",
				area_code: "Chaoyang",
				area_parent_id: 210000,
				child: {
					"211302": {
						id: 211302,
						area_name: "双塔区",
						area_code: "Shuangta",
						area_parent_id: 211300
					},
					"211303": {
						id: 211303,
						area_name: "龙城区",
						area_code: "Longcheng",
						area_parent_id: 211300
					},
					"211321": {
						id: 211321,
						area_name: "朝阳县",
						area_code: "Chaoyang",
						area_parent_id: 211300
					},
					"211322": {
						id: 211322,
						area_name: "建平县",
						area_code: "Jianping",
						area_parent_id: 211300
					},
					"211324": {
						id: 211324,
						area_name: "喀喇沁左翼蒙古族自治县",
						area_code: "Kalaqinzuoyi",
						area_parent_id: 211300
					},
					"211381": {
						id: 211381,
						area_name: "北票市",
						area_code: "Beipiao",
						area_parent_id: 211300
					},
					"211382": {
						id: 211382,
						area_name: "凌源市",
						area_code: "Lingyuan",
						area_parent_id: 211300
					}
				}
			},
			"211400": {
				id: 211400,
				area_name: "葫芦岛市",
				area_code: "Huludao",
				area_parent_id: 210000,
				child: {
					"211402": {
						id: 211402,
						area_name: "连山区",
						area_code: "Lianshan",
						area_parent_id: 211400
					},
					"211403": {
						id: 211403,
						area_name: "龙港区",
						area_code: "Longgang",
						area_parent_id: 211400
					},
					"211404": {
						id: 211404,
						area_name: "南票区",
						area_code: "Nanpiao",
						area_parent_id: 211400
					},
					"211421": {
						id: 211421,
						area_name: "绥中县",
						area_code: "Suizhong",
						area_parent_id: 211400
					},
					"211422": {
						id: 211422,
						area_name: "建昌县",
						area_code: "Jianchang",
						area_parent_id: 211400
					},
					"211481": {
						id: 211481,
						area_name: "兴城市",
						area_code: "Xingcheng",
						area_parent_id: 211400
					}
				}
			},
			"211500": {
				id: 211500,
				area_name: "金普新区",
				area_code: "Jinpuxinqu",
				area_parent_id: 210000,
				child: {
					"211501": {
						id: 211501,
						area_name: "金州新区",
						area_code: "Jinzhouxinqu",
						area_parent_id: 211500
					},
					"211502": {
						id: 211502,
						area_name: "普湾新区",
						area_code: "Puwanxinqu",
						area_parent_id: 211500
					},
					"211503": {
						id: 211503,
						area_name: "保税区",
						area_code: "Baoshuiqu",
						area_parent_id: 211500
					}
				}
			}
		}
	},
	"220000": {
		id: 220000,
		area_name: "吉林省",
		area_code: "Jilin",
		area_parent_id: 0,
		child: {
			"220100": {
				id: 220100,
				area_name: "长春市",
				area_code: "Changchun",
				area_parent_id: 220000,
				child: {
					"220102": {
						id: 220102,
						area_name: "南关区",
						area_code: "Nanguan",
						area_parent_id: 220100
					},
					"220103": {
						id: 220103,
						area_name: "宽城区",
						area_code: "Kuancheng",
						area_parent_id: 220100
					},
					"220104": {
						id: 220104,
						area_name: "朝阳区",
						area_code: "Chaoyang",
						area_parent_id: 220100
					},
					"220105": {
						id: 220105,
						area_name: "二道区",
						area_code: "Erdao",
						area_parent_id: 220100
					},
					"220106": {
						id: 220106,
						area_name: "绿园区",
						area_code: "Lvyuan",
						area_parent_id: 220100
					},
					"220112": {
						id: 220112,
						area_name: "双阳区",
						area_code: "Shuangyang",
						area_parent_id: 220100
					},
					"220113": {
						id: 220113,
						area_name: "九台区",
						area_code: "Jiutai",
						area_parent_id: 220100
					},
					"220122": {
						id: 220122,
						area_name: "农安县",
						area_code: "Nong'an",
						area_parent_id: 220100
					},
					"220182": {
						id: 220182,
						area_name: "榆树市",
						area_code: "Yushu",
						area_parent_id: 220100
					},
					"220183": {
						id: 220183,
						area_name: "德惠市",
						area_code: "Dehui",
						area_parent_id: 220100
					}
				}
			},
			"220200": {
				id: 220200,
				area_name: "吉林市",
				area_code: "Jilin",
				area_parent_id: 220000,
				child: {
					"220202": {
						id: 220202,
						area_name: "昌邑区",
						area_code: "Changyi",
						area_parent_id: 220200
					},
					"220203": {
						id: 220203,
						area_name: "龙潭区",
						area_code: "Longtan",
						area_parent_id: 220200
					},
					"220204": {
						id: 220204,
						area_name: "船营区",
						area_code: "Chuanying",
						area_parent_id: 220200
					},
					"220211": {
						id: 220211,
						area_name: "丰满区",
						area_code: "Fengman",
						area_parent_id: 220200
					},
					"220221": {
						id: 220221,
						area_name: "永吉县",
						area_code: "Yongji",
						area_parent_id: 220200
					},
					"220281": {
						id: 220281,
						area_name: "蛟河市",
						area_code: "Jiaohe",
						area_parent_id: 220200
					},
					"220282": {
						id: 220282,
						area_name: "桦甸市",
						area_code: "Huadian",
						area_parent_id: 220200
					},
					"220283": {
						id: 220283,
						area_name: "舒兰市",
						area_code: "Shulan",
						area_parent_id: 220200
					},
					"220284": {
						id: 220284,
						area_name: "磐石市",
						area_code: "Panshi",
						area_parent_id: 220200
					}
				}
			},
			"220300": {
				id: 220300,
				area_name: "四平市",
				area_code: "Siping",
				area_parent_id: 220000,
				child: {
					"220302": {
						id: 220302,
						area_name: "铁西区",
						area_code: "Tiexi",
						area_parent_id: 220300
					},
					"220303": {
						id: 220303,
						area_name: "铁东区",
						area_code: "Tiedong",
						area_parent_id: 220300
					},
					"220322": {
						id: 220322,
						area_name: "梨树县",
						area_code: "Lishu",
						area_parent_id: 220300
					},
					"220323": {
						id: 220323,
						area_name: "伊通满族自治县",
						area_code: "Yitong",
						area_parent_id: 220300
					},
					"220381": {
						id: 220381,
						area_name: "公主岭市",
						area_code: "Gongzhuling",
						area_parent_id: 220300
					},
					"220382": {
						id: 220382,
						area_name: "双辽市",
						area_code: "Shuangliao",
						area_parent_id: 220300
					}
				}
			},
			"220400": {
				id: 220400,
				area_name: "辽源市",
				area_code: "Liaoyuan",
				area_parent_id: 220000,
				child: {
					"220402": {
						id: 220402,
						area_name: "龙山区",
						area_code: "Longshan",
						area_parent_id: 220400
					},
					"220403": {
						id: 220403,
						area_name: "西安区",
						area_code: "Xi'an",
						area_parent_id: 220400
					},
					"220421": {
						id: 220421,
						area_name: "东丰县",
						area_code: "Dongfeng",
						area_parent_id: 220400
					},
					"220422": {
						id: 220422,
						area_name: "东辽县",
						area_code: "Dongliao",
						area_parent_id: 220400
					}
				}
			},
			"220500": {
				id: 220500,
				area_name: "通化市",
				area_code: "Tonghua",
				area_parent_id: 220000,
				child: {
					"220502": {
						id: 220502,
						area_name: "东昌区",
						area_code: "Dongchang",
						area_parent_id: 220500
					},
					"220503": {
						id: 220503,
						area_name: "二道江区",
						area_code: "Erdaojiang",
						area_parent_id: 220500
					},
					"220521": {
						id: 220521,
						area_name: "通化县",
						area_code: "Tonghua",
						area_parent_id: 220500
					},
					"220523": {
						id: 220523,
						area_name: "辉南县",
						area_code: "Huinan",
						area_parent_id: 220500
					},
					"220524": {
						id: 220524,
						area_name: "柳河县",
						area_code: "Liuhe",
						area_parent_id: 220500
					},
					"220581": {
						id: 220581,
						area_name: "梅河口市",
						area_code: "Meihekou",
						area_parent_id: 220500
					},
					"220582": {
						id: 220582,
						area_name: "集安市",
						area_code: "Ji'an",
						area_parent_id: 220500
					}
				}
			},
			"220600": {
				id: 220600,
				area_name: "白山市",
				area_code: "Baishan",
				area_parent_id: 220000,
				child: {
					"220602": {
						id: 220602,
						area_name: "浑江区",
						area_code: "Hunjiang",
						area_parent_id: 220600
					},
					"220605": {
						id: 220605,
						area_name: "江源区",
						area_code: "Jiangyuan",
						area_parent_id: 220600
					},
					"220621": {
						id: 220621,
						area_name: "抚松县",
						area_code: "Fusong",
						area_parent_id: 220600
					},
					"220622": {
						id: 220622,
						area_name: "靖宇县",
						area_code: "Jingyu",
						area_parent_id: 220600
					},
					"220623": {
						id: 220623,
						area_name: "长白朝鲜族自治县",
						area_code: "Changbai",
						area_parent_id: 220600
					},
					"220681": {
						id: 220681,
						area_name: "临江市",
						area_code: "Linjiang",
						area_parent_id: 220600
					}
				}
			},
			"220700": {
				id: 220700,
				area_name: "松原市",
				area_code: "Songyuan",
				area_parent_id: 220000,
				child: {
					"220702": {
						id: 220702,
						area_name: "宁江区",
						area_code: "Ningjiang",
						area_parent_id: 220700
					},
					"220721": {
						id: 220721,
						area_name: "前郭尔罗斯蒙古族自治县",
						area_code: "Qianguoerluosi",
						area_parent_id: 220700
					},
					"220722": {
						id: 220722,
						area_name: "长岭县",
						area_code: "Changling",
						area_parent_id: 220700
					},
					"220723": {
						id: 220723,
						area_name: "乾安县",
						area_code: "Qian'an",
						area_parent_id: 220700
					},
					"220781": {
						id: 220781,
						area_name: "扶余市",
						area_code: "Fuyu",
						area_parent_id: 220700
					}
				}
			},
			"220800": {
				id: 220800,
				area_name: "白城市",
				area_code: "Baicheng",
				area_parent_id: 220000,
				child: {
					"220802": {
						id: 220802,
						area_name: "洮北区",
						area_code: "Taobei",
						area_parent_id: 220800
					},
					"220821": {
						id: 220821,
						area_name: "镇赉县",
						area_code: "Zhenlai",
						area_parent_id: 220800
					},
					"220822": {
						id: 220822,
						area_name: "通榆县",
						area_code: "Tongyu",
						area_parent_id: 220800
					},
					"220881": {
						id: 220881,
						area_name: "洮南市",
						area_code: "Taonan",
						area_parent_id: 220800
					},
					"220882": {
						id: 220882,
						area_name: "大安市",
						area_code: "Da'an",
						area_parent_id: 220800
					}
				}
			},
			"222400": {
				id: 222400,
				area_name: "延边朝鲜族自治州",
				area_code: "Yanbian",
				area_parent_id: 220000,
				child: {
					"222401": {
						id: 222401,
						area_name: "延吉市",
						area_code: "Yanji",
						area_parent_id: 222400
					},
					"222402": {
						id: 222402,
						area_name: "图们市",
						area_code: "Tumen",
						area_parent_id: 222400
					},
					"222403": {
						id: 222403,
						area_name: "敦化市",
						area_code: "Dunhua",
						area_parent_id: 222400
					},
					"222404": {
						id: 222404,
						area_name: "珲春市",
						area_code: "Hunchun",
						area_parent_id: 222400
					},
					"222405": {
						id: 222405,
						area_name: "龙井市",
						area_code: "Longjing",
						area_parent_id: 222400
					},
					"222406": {
						id: 222406,
						area_name: "和龙市",
						area_code: "Helong",
						area_parent_id: 222400
					},
					"222424": {
						id: 222424,
						area_name: "汪清县",
						area_code: "Wangqing",
						area_parent_id: 222400
					},
					"222426": {
						id: 222426,
						area_name: "安图县",
						area_code: "Antu",
						area_parent_id: 222400
					}
				}
			}
		}
	},
	"230000": {
		id: 230000,
		area_name: "黑龙江省",
		area_code: "Heilongjiang",
		area_parent_id: 0,
		child: {
			"230100": {
				id: 230100,
				area_name: "哈尔滨市",
				area_code: "Harbin",
				area_parent_id: 230000,
				child: {
					"230102": {
						id: 230102,
						area_name: "道里区",
						area_code: "Daoli",
						area_parent_id: 230100
					},
					"230103": {
						id: 230103,
						area_name: "南岗区",
						area_code: "Nangang",
						area_parent_id: 230100
					},
					"230104": {
						id: 230104,
						area_name: "道外区",
						area_code: "Daowai",
						area_parent_id: 230100
					},
					"230108": {
						id: 230108,
						area_name: "平房区",
						area_code: "Pingfang",
						area_parent_id: 230100
					},
					"230109": {
						id: 230109,
						area_name: "松北区",
						area_code: "Songbei",
						area_parent_id: 230100
					},
					"230110": {
						id: 230110,
						area_name: "香坊区",
						area_code: "Xiangfang",
						area_parent_id: 230100
					},
					"230111": {
						id: 230111,
						area_name: "呼兰区",
						area_code: "Hulan",
						area_parent_id: 230100
					},
					"230112": {
						id: 230112,
						area_name: "阿城区",
						area_code: "A'cheng",
						area_parent_id: 230100
					},
					"230113": {
						id: 230113,
						area_name: "双城区",
						area_code: "Shuangcheng",
						area_parent_id: 230100
					},
					"230123": {
						id: 230123,
						area_name: "依兰县",
						area_code: "Yilan",
						area_parent_id: 230100
					},
					"230124": {
						id: 230124,
						area_name: "方正县",
						area_code: "Fangzheng",
						area_parent_id: 230100
					},
					"230125": {
						id: 230125,
						area_name: "宾县",
						area_code: "Binxian",
						area_parent_id: 230100
					},
					"230126": {
						id: 230126,
						area_name: "巴彦县",
						area_code: "Bayan",
						area_parent_id: 230100
					},
					"230127": {
						id: 230127,
						area_name: "木兰县",
						area_code: "Mulan",
						area_parent_id: 230100
					},
					"230128": {
						id: 230128,
						area_name: "通河县",
						area_code: "Tonghe",
						area_parent_id: 230100
					},
					"230129": {
						id: 230129,
						area_name: "延寿县",
						area_code: "Yanshou",
						area_parent_id: 230100
					},
					"230183": {
						id: 230183,
						area_name: "尚志市",
						area_code: "Shangzhi",
						area_parent_id: 230100
					},
					"230184": {
						id: 230184,
						area_name: "五常市",
						area_code: "Wuchang",
						area_parent_id: 230100
					}
				}
			},
			"230200": {
				id: 230200,
				area_name: "齐齐哈尔市",
				area_code: "Qiqihar",
				area_parent_id: 230000,
				child: {
					"230202": {
						id: 230202,
						area_name: "龙沙区",
						area_code: "Longsha",
						area_parent_id: 230200
					},
					"230203": {
						id: 230203,
						area_name: "建华区",
						area_code: "Jianhua",
						area_parent_id: 230200
					},
					"230204": {
						id: 230204,
						area_name: "铁锋区",
						area_code: "Tiefeng",
						area_parent_id: 230200
					},
					"230205": {
						id: 230205,
						area_name: "昂昂溪区",
						area_code: "Angangxi",
						area_parent_id: 230200
					},
					"230206": {
						id: 230206,
						area_name: "富拉尔基区",
						area_code: "Fulaerji",
						area_parent_id: 230200
					},
					"230207": {
						id: 230207,
						area_name: "碾子山区",
						area_code: "Nianzishan",
						area_parent_id: 230200
					},
					"230208": {
						id: 230208,
						area_name: "梅里斯达斡尔族区",
						area_code: "Meilisi",
						area_parent_id: 230200
					},
					"230221": {
						id: 230221,
						area_name: "龙江县",
						area_code: "Longjiang",
						area_parent_id: 230200
					},
					"230223": {
						id: 230223,
						area_name: "依安县",
						area_code: "Yi'an",
						area_parent_id: 230200
					},
					"230224": {
						id: 230224,
						area_name: "泰来县",
						area_code: "Tailai",
						area_parent_id: 230200
					},
					"230225": {
						id: 230225,
						area_name: "甘南县",
						area_code: "Gannan",
						area_parent_id: 230200
					},
					"230227": {
						id: 230227,
						area_name: "富裕县",
						area_code: "Fuyu",
						area_parent_id: 230200
					},
					"230229": {
						id: 230229,
						area_name: "克山县",
						area_code: "Keshan",
						area_parent_id: 230200
					},
					"230230": {
						id: 230230,
						area_name: "克东县",
						area_code: "Kedong",
						area_parent_id: 230200
					},
					"230231": {
						id: 230231,
						area_name: "拜泉县",
						area_code: "Baiquan",
						area_parent_id: 230200
					},
					"230281": {
						id: 230281,
						area_name: "讷河市",
						area_code: "Nehe",
						area_parent_id: 230200
					}
				}
			},
			"230300": {
				id: 230300,
				area_name: "鸡西市",
				area_code: "Jixi",
				area_parent_id: 230000,
				child: {
					"230302": {
						id: 230302,
						area_name: "鸡冠区",
						area_code: "Jiguan",
						area_parent_id: 230300
					},
					"230303": {
						id: 230303,
						area_name: "恒山区",
						area_code: "Hengshan",
						area_parent_id: 230300
					},
					"230304": {
						id: 230304,
						area_name: "滴道区",
						area_code: "Didao",
						area_parent_id: 230300
					},
					"230305": {
						id: 230305,
						area_name: "梨树区",
						area_code: "Lishu",
						area_parent_id: 230300
					},
					"230306": {
						id: 230306,
						area_name: "城子河区",
						area_code: "Chengzihe",
						area_parent_id: 230300
					},
					"230307": {
						id: 230307,
						area_name: "麻山区",
						area_code: "Mashan",
						area_parent_id: 230300
					},
					"230321": {
						id: 230321,
						area_name: "鸡东县",
						area_code: "Jidong",
						area_parent_id: 230300
					},
					"230381": {
						id: 230381,
						area_name: "虎林市",
						area_code: "Hulin",
						area_parent_id: 230300
					},
					"230382": {
						id: 230382,
						area_name: "密山市",
						area_code: "Mishan",
						area_parent_id: 230300
					}
				}
			},
			"230400": {
				id: 230400,
				area_name: "鹤岗市",
				area_code: "Hegang",
				area_parent_id: 230000,
				child: {
					"230402": {
						id: 230402,
						area_name: "向阳区",
						area_code: "Xiangyang",
						area_parent_id: 230400
					},
					"230403": {
						id: 230403,
						area_name: "工农区",
						area_code: "Gongnong",
						area_parent_id: 230400
					},
					"230404": {
						id: 230404,
						area_name: "南山区",
						area_code: "Nanshan",
						area_parent_id: 230400
					},
					"230405": {
						id: 230405,
						area_name: "兴安区",
						area_code: "Xing'an",
						area_parent_id: 230400
					},
					"230406": {
						id: 230406,
						area_name: "东山区",
						area_code: "Dongshan",
						area_parent_id: 230400
					},
					"230407": {
						id: 230407,
						area_name: "兴山区",
						area_code: "Xingshan",
						area_parent_id: 230400
					},
					"230421": {
						id: 230421,
						area_name: "萝北县",
						area_code: "Luobei",
						area_parent_id: 230400
					},
					"230422": {
						id: 230422,
						area_name: "绥滨县",
						area_code: "Suibin",
						area_parent_id: 230400
					}
				}
			},
			"230500": {
				id: 230500,
				area_name: "双鸭山市",
				area_code: "Shuangyashan",
				area_parent_id: 230000,
				child: {
					"230502": {
						id: 230502,
						area_name: "尖山区",
						area_code: "Jianshan",
						area_parent_id: 230500
					},
					"230503": {
						id: 230503,
						area_name: "岭东区",
						area_code: "Lingdong",
						area_parent_id: 230500
					},
					"230505": {
						id: 230505,
						area_name: "四方台区",
						area_code: "Sifangtai",
						area_parent_id: 230500
					},
					"230506": {
						id: 230506,
						area_name: "宝山区",
						area_code: "Baoshan",
						area_parent_id: 230500
					},
					"230521": {
						id: 230521,
						area_name: "集贤县",
						area_code: "Jixian",
						area_parent_id: 230500
					},
					"230522": {
						id: 230522,
						area_name: "友谊县",
						area_code: "Youyi",
						area_parent_id: 230500
					},
					"230523": {
						id: 230523,
						area_name: "宝清县",
						area_code: "Baoqing",
						area_parent_id: 230500
					},
					"230524": {
						id: 230524,
						area_name: "饶河县",
						area_code: "Raohe",
						area_parent_id: 230500
					}
				}
			},
			"230600": {
				id: 230600,
				area_name: "大庆市",
				area_code: "Daqing",
				area_parent_id: 230000,
				child: {
					"230602": {
						id: 230602,
						area_name: "萨尔图区",
						area_code: "Saertu",
						area_parent_id: 230600
					},
					"230603": {
						id: 230603,
						area_name: "龙凤区",
						area_code: "Longfeng",
						area_parent_id: 230600
					},
					"230604": {
						id: 230604,
						area_name: "让胡路区",
						area_code: "Ranghulu",
						area_parent_id: 230600
					},
					"230605": {
						id: 230605,
						area_name: "红岗区",
						area_code: "Honggang",
						area_parent_id: 230600
					},
					"230606": {
						id: 230606,
						area_name: "大同区",
						area_code: "Datong",
						area_parent_id: 230600
					},
					"230621": {
						id: 230621,
						area_name: "肇州县",
						area_code: "Zhaozhou",
						area_parent_id: 230600
					},
					"230622": {
						id: 230622,
						area_name: "肇源县",
						area_code: "Zhaoyuan",
						area_parent_id: 230600
					},
					"230623": {
						id: 230623,
						area_name: "林甸县",
						area_code: "Lindian",
						area_parent_id: 230600
					},
					"230624": {
						id: 230624,
						area_name: "杜尔伯特蒙古族自治县",
						area_code: "Duerbote",
						area_parent_id: 230600
					}
				}
			},
			"230700": {
				id: 230700,
				area_name: "伊春市",
				area_code: "Yichun",
				area_parent_id: 230000,
				child: {
					"230702": {
						id: 230702,
						area_name: "伊春区",
						area_code: "Yichun",
						area_parent_id: 230700
					},
					"230703": {
						id: 230703,
						area_name: "南岔区",
						area_code: "Nancha",
						area_parent_id: 230700
					},
					"230704": {
						id: 230704,
						area_name: "友好区",
						area_code: "Youhao",
						area_parent_id: 230700
					},
					"230705": {
						id: 230705,
						area_name: "西林区",
						area_code: "Xilin",
						area_parent_id: 230700
					},
					"230706": {
						id: 230706,
						area_name: "翠峦区",
						area_code: "Cuiluan",
						area_parent_id: 230700
					},
					"230707": {
						id: 230707,
						area_name: "新青区",
						area_code: "Xinqing",
						area_parent_id: 230700
					},
					"230708": {
						id: 230708,
						area_name: "美溪区",
						area_code: "Meixi",
						area_parent_id: 230700
					},
					"230709": {
						id: 230709,
						area_name: "金山屯区",
						area_code: "Jinshantun",
						area_parent_id: 230700
					},
					"230710": {
						id: 230710,
						area_name: "五营区",
						area_code: "Wuying",
						area_parent_id: 230700
					},
					"230711": {
						id: 230711,
						area_name: "乌马河区",
						area_code: "Wumahe",
						area_parent_id: 230700
					},
					"230712": {
						id: 230712,
						area_name: "汤旺河区",
						area_code: "Tangwanghe",
						area_parent_id: 230700
					},
					"230713": {
						id: 230713,
						area_name: "带岭区",
						area_code: "Dailing",
						area_parent_id: 230700
					},
					"230714": {
						id: 230714,
						area_name: "乌伊岭区",
						area_code: "Wuyiling",
						area_parent_id: 230700
					},
					"230715": {
						id: 230715,
						area_name: "红星区",
						area_code: "Hongxing",
						area_parent_id: 230700
					},
					"230716": {
						id: 230716,
						area_name: "上甘岭区",
						area_code: "Shangganling",
						area_parent_id: 230700
					},
					"230722": {
						id: 230722,
						area_name: "嘉荫县",
						area_code: "Jiayin",
						area_parent_id: 230700
					},
					"230781": {
						id: 230781,
						area_name: "铁力市",
						area_code: "Tieli",
						area_parent_id: 230700
					}
				}
			},
			"230800": {
				id: 230800,
				area_name: "佳木斯市",
				area_code: "Jiamusi",
				area_parent_id: 230000,
				child: {
					"230803": {
						id: 230803,
						area_name: "向阳区",
						area_code: "Xiangyang",
						area_parent_id: 230800
					},
					"230804": {
						id: 230804,
						area_name: "前进区",
						area_code: "Qianjin",
						area_parent_id: 230800
					},
					"230805": {
						id: 230805,
						area_name: "东风区",
						area_code: "Dongfeng",
						area_parent_id: 230800
					},
					"230811": {
						id: 230811,
						area_name: "郊区",
						area_code: "Jiaoqu",
						area_parent_id: 230800
					},
					"230822": {
						id: 230822,
						area_name: "桦南县",
						area_code: "Huanan",
						area_parent_id: 230800
					},
					"230826": {
						id: 230826,
						area_name: "桦川县",
						area_code: "Huachuan",
						area_parent_id: 230800
					},
					"230828": {
						id: 230828,
						area_name: "汤原县",
						area_code: "Tangyuan",
						area_parent_id: 230800
					},
					"230833": {
						id: 230833,
						area_name: "抚远县",
						area_code: "Fuyuan",
						area_parent_id: 230800
					},
					"230881": {
						id: 230881,
						area_name: "同江市",
						area_code: "Tongjiang",
						area_parent_id: 230800
					},
					"230882": {
						id: 230882,
						area_name: "富锦市",
						area_code: "Fujin",
						area_parent_id: 230800
					}
				}
			},
			"230900": {
				id: 230900,
				area_name: "七台河市",
				area_code: "Qitaihe",
				area_parent_id: 230000,
				child: {
					"230902": {
						id: 230902,
						area_name: "新兴区",
						area_code: "Xinxing",
						area_parent_id: 230900
					},
					"230903": {
						id: 230903,
						area_name: "桃山区",
						area_code: "Taoshan",
						area_parent_id: 230900
					},
					"230904": {
						id: 230904,
						area_name: "茄子河区",
						area_code: "Qiezihe",
						area_parent_id: 230900
					},
					"230921": {
						id: 230921,
						area_name: "勃利县",
						area_code: "Boli",
						area_parent_id: 230900
					}
				}
			},
			"231000": {
				id: 231000,
				area_name: "牡丹江市",
				area_code: "Mudanjiang",
				area_parent_id: 230000,
				child: {
					"231002": {
						id: 231002,
						area_name: "东安区",
						area_code: "Dong'an",
						area_parent_id: 231000
					},
					"231003": {
						id: 231003,
						area_name: "阳明区",
						area_code: "Yangming",
						area_parent_id: 231000
					},
					"231004": {
						id: 231004,
						area_name: "爱民区",
						area_code: "Aimin",
						area_parent_id: 231000
					},
					"231005": {
						id: 231005,
						area_name: "西安区",
						area_code: "Xi'an",
						area_parent_id: 231000
					},
					"231024": {
						id: 231024,
						area_name: "东宁县",
						area_code: "Dongning",
						area_parent_id: 231000
					},
					"231025": {
						id: 231025,
						area_name: "林口县",
						area_code: "Linkou",
						area_parent_id: 231000
					},
					"231081": {
						id: 231081,
						area_name: "绥芬河市",
						area_code: "Suifenhe",
						area_parent_id: 231000
					},
					"231083": {
						id: 231083,
						area_name: "海林市",
						area_code: "Hailin",
						area_parent_id: 231000
					},
					"231084": {
						id: 231084,
						area_name: "宁安市",
						area_code: "Ning'an",
						area_parent_id: 231000
					},
					"231085": {
						id: 231085,
						area_name: "穆棱市",
						area_code: "Muling",
						area_parent_id: 231000
					}
				}
			},
			"231100": {
				id: 231100,
				area_name: "黑河市",
				area_code: "Heihe",
				area_parent_id: 230000,
				child: {
					"231102": {
						id: 231102,
						area_name: "爱辉区",
						area_code: "Aihui",
						area_parent_id: 231100
					},
					"231121": {
						id: 231121,
						area_name: "嫩江县",
						area_code: "Nenjiang",
						area_parent_id: 231100
					},
					"231123": {
						id: 231123,
						area_name: "逊克县",
						area_code: "Xunke",
						area_parent_id: 231100
					},
					"231124": {
						id: 231124,
						area_name: "孙吴县",
						area_code: "Sunwu",
						area_parent_id: 231100
					},
					"231181": {
						id: 231181,
						area_name: "北安市",
						area_code: "Bei'an",
						area_parent_id: 231100
					},
					"231182": {
						id: 231182,
						area_name: "五大连池市",
						area_code: "Wudalianchi",
						area_parent_id: 231100
					}
				}
			},
			"231200": {
				id: 231200,
				area_name: "绥化市",
				area_code: "Suihua",
				area_parent_id: 230000,
				child: {
					"231202": {
						id: 231202,
						area_name: "北林区",
						area_code: "Beilin",
						area_parent_id: 231200
					},
					"231221": {
						id: 231221,
						area_name: "望奎县",
						area_code: "Wangkui",
						area_parent_id: 231200
					},
					"231222": {
						id: 231222,
						area_name: "兰西县",
						area_code: "Lanxi",
						area_parent_id: 231200
					},
					"231223": {
						id: 231223,
						area_name: "青冈县",
						area_code: "Qinggang",
						area_parent_id: 231200
					},
					"231224": {
						id: 231224,
						area_name: "庆安县",
						area_code: "Qing'an",
						area_parent_id: 231200
					},
					"231225": {
						id: 231225,
						area_name: "明水县",
						area_code: "Mingshui",
						area_parent_id: 231200
					},
					"231226": {
						id: 231226,
						area_name: "绥棱县",
						area_code: "Suileng",
						area_parent_id: 231200
					},
					"231281": {
						id: 231281,
						area_name: "安达市",
						area_code: "Anda",
						area_parent_id: 231200
					},
					"231282": {
						id: 231282,
						area_name: "肇东市",
						area_code: "Zhaodong",
						area_parent_id: 231200
					},
					"231283": {
						id: 231283,
						area_name: "海伦市",
						area_code: "Hailun",
						area_parent_id: 231200
					}
				}
			},
			"232700": {
				id: 232700,
				area_name: "大兴安岭地区",
				area_code: "DaXingAnLing",
				area_parent_id: 230000,
				child: {
					"232701": {
						id: 232701,
						area_name: "加格达奇区",
						area_code: "Jiagedaqi",
						area_parent_id: 232700
					},
					"232702": {
						id: 232702,
						area_name: "新林区",
						area_code: "Xinlin",
						area_parent_id: 232700
					},
					"232703": {
						id: 232703,
						area_name: "松岭区",
						area_code: "Songling",
						area_parent_id: 232700
					},
					"232704": {
						id: 232704,
						area_name: "呼中区",
						area_code: "Huzhong",
						area_parent_id: 232700
					},
					"232721": {
						id: 232721,
						area_name: "呼玛县",
						area_code: "Huma",
						area_parent_id: 232700
					},
					"232722": {
						id: 232722,
						area_name: "塔河县",
						area_code: "Tahe",
						area_parent_id: 232700
					},
					"232723": {
						id: 232723,
						area_name: "漠河县",
						area_code: "Mohe",
						area_parent_id: 232700
					}
				}
			}
		}
	},
	"310000": {
		id: 310000,
		area_name: "上海",
		area_code: "Shanghai",
		area_parent_id: 0,
		child: {
			"310100": {
				id: 310100,
				area_name: "上海市",
				area_code: "Shanghai",
				area_parent_id: 310000,
				child: {
					"310101": {
						id: 310101,
						area_name: "黄浦区",
						area_code: "Huangpu",
						area_parent_id: 310100
					},
					"310104": {
						id: 310104,
						area_name: "徐汇区",
						area_code: "Xuhui",
						area_parent_id: 310100
					},
					"310105": {
						id: 310105,
						area_name: "长宁区",
						area_code: "Changning",
						area_parent_id: 310100
					},
					"310106": {
						id: 310106,
						area_name: "静安区",
						area_code: "Jing'an",
						area_parent_id: 310100
					},
					"310107": {
						id: 310107,
						area_name: "普陀区",
						area_code: "Putuo",
						area_parent_id: 310100
					},
					"310108": {
						id: 310108,
						area_name: "闸北区",
						area_code: "Zhabei",
						area_parent_id: 310100
					},
					"310109": {
						id: 310109,
						area_name: "虹口区",
						area_code: "Hongkou",
						area_parent_id: 310100
					},
					"310110": {
						id: 310110,
						area_name: "杨浦区",
						area_code: "Yangpu",
						area_parent_id: 310100
					},
					"310112": {
						id: 310112,
						area_name: "闵行区",
						area_code: "Minhang",
						area_parent_id: 310100
					},
					"310113": {
						id: 310113,
						area_name: "宝山区",
						area_code: "Baoshan",
						area_parent_id: 310100
					},
					"310114": {
						id: 310114,
						area_name: "嘉定区",
						area_code: "Jiading",
						area_parent_id: 310100
					},
					"310115": {
						id: 310115,
						area_name: "浦东新区",
						area_code: "Pudong",
						area_parent_id: 310100
					},
					"310116": {
						id: 310116,
						area_name: "金山区",
						area_code: "Jinshan",
						area_parent_id: 310100
					},
					"310117": {
						id: 310117,
						area_name: "松江区",
						area_code: "Songjiang",
						area_parent_id: 310100
					},
					"310118": {
						id: 310118,
						area_name: "青浦区",
						area_code: "Qingpu",
						area_parent_id: 310100
					},
					"310120": {
						id: 310120,
						area_name: "奉贤区",
						area_code: "Fengxian",
						area_parent_id: 310100
					},
					"310230": {
						id: 310230,
						area_name: "崇明县",
						area_code: "Chongming",
						area_parent_id: 310100
					}
				}
			}
		}
	},
	"320000": {
		id: 320000,
		area_name: "江苏省",
		area_code: "Jiangsu",
		area_parent_id: 0,
		child: {
			"320100": {
				id: 320100,
				area_name: "南京市",
				area_code: "Nanjing",
				area_parent_id: 320000,
				child: {
					"320102": {
						id: 320102,
						area_name: "玄武区",
						area_code: "Xuanwu",
						area_parent_id: 320100
					},
					"320104": {
						id: 320104,
						area_name: "秦淮区",
						area_code: "Qinhuai",
						area_parent_id: 320100
					},
					"320105": {
						id: 320105,
						area_name: "建邺区",
						area_code: "Jianye",
						area_parent_id: 320100
					},
					"320106": {
						id: 320106,
						area_name: "鼓楼区",
						area_code: "Gulou",
						area_parent_id: 320100
					},
					"320111": {
						id: 320111,
						area_name: "浦口区",
						area_code: "Pukou",
						area_parent_id: 320100
					},
					"320113": {
						id: 320113,
						area_name: "栖霞区",
						area_code: "Qixia",
						area_parent_id: 320100
					},
					"320114": {
						id: 320114,
						area_name: "雨花台区",
						area_code: "Yuhuatai",
						area_parent_id: 320100
					},
					"320115": {
						id: 320115,
						area_name: "江宁区",
						area_code: "Jiangning",
						area_parent_id: 320100
					},
					"320116": {
						id: 320116,
						area_name: "六合区",
						area_code: "Luhe",
						area_parent_id: 320100
					},
					"320117": {
						id: 320117,
						area_name: "溧水区",
						area_code: "Lishui",
						area_parent_id: 320100
					},
					"320118": {
						id: 320118,
						area_name: "高淳区",
						area_code: "Gaochun",
						area_parent_id: 320100
					}
				}
			},
			"320200": {
				id: 320200,
				area_name: "无锡市",
				area_code: "Wuxi",
				area_parent_id: 320000,
				child: {
					"320202": {
						id: 320202,
						area_name: "崇安区",
						area_code: "Chong'an",
						area_parent_id: 320200
					},
					"320203": {
						id: 320203,
						area_name: "南长区",
						area_code: "Nanchang",
						area_parent_id: 320200
					},
					"320204": {
						id: 320204,
						area_name: "北塘区",
						area_code: "Beitang",
						area_parent_id: 320200
					},
					"320205": {
						id: 320205,
						area_name: "锡山区",
						area_code: "Xishan",
						area_parent_id: 320200
					},
					"320206": {
						id: 320206,
						area_name: "惠山区",
						area_code: "Huishan",
						area_parent_id: 320200
					},
					"320211": {
						id: 320211,
						area_name: "滨湖区",
						area_code: "Binhu",
						area_parent_id: 320200
					},
					"320281": {
						id: 320281,
						area_name: "江阴市",
						area_code: "Jiangyin",
						area_parent_id: 320200
					},
					"320282": {
						id: 320282,
						area_name: "宜兴市",
						area_code: "Yixing",
						area_parent_id: 320200
					}
				}
			},
			"320300": {
				id: 320300,
				area_name: "徐州市",
				area_code: "Xuzhou",
				area_parent_id: 320000,
				child: {
					"320302": {
						id: 320302,
						area_name: "鼓楼区",
						area_code: "Gulou",
						area_parent_id: 320300
					},
					"320303": {
						id: 320303,
						area_name: "云龙区",
						area_code: "Yunlong",
						area_parent_id: 320300
					},
					"320305": {
						id: 320305,
						area_name: "贾汪区",
						area_code: "Jiawang",
						area_parent_id: 320300
					},
					"320311": {
						id: 320311,
						area_name: "泉山区",
						area_code: "Quanshan",
						area_parent_id: 320300
					},
					"320312": {
						id: 320312,
						area_name: "铜山区",
						area_code: "Tongshan",
						area_parent_id: 320300
					},
					"320321": {
						id: 320321,
						area_name: "丰县",
						area_code: "Fengxian",
						area_parent_id: 320300
					},
					"320322": {
						id: 320322,
						area_name: "沛县",
						area_code: "Peixian",
						area_parent_id: 320300
					},
					"320324": {
						id: 320324,
						area_name: "睢宁县",
						area_code: "Suining",
						area_parent_id: 320300
					},
					"320381": {
						id: 320381,
						area_name: "新沂市",
						area_code: "Xinyi",
						area_parent_id: 320300
					},
					"320382": {
						id: 320382,
						area_name: "邳州市",
						area_code: "Pizhou",
						area_parent_id: 320300
					}
				}
			},
			"320400": {
				id: 320400,
				area_name: "常州市",
				area_code: "Changzhou",
				area_parent_id: 320000,
				child: {
					"320402": {
						id: 320402,
						area_name: "天宁区",
						area_code: "Tianning",
						area_parent_id: 320400
					},
					"320404": {
						id: 320404,
						area_name: "钟楼区",
						area_code: "Zhonglou",
						area_parent_id: 320400
					},
					"320405": {
						id: 320405,
						area_name: "戚墅堰区",
						area_code: "Qishuyan",
						area_parent_id: 320400
					},
					"320411": {
						id: 320411,
						area_name: "新北区",
						area_code: "Xinbei",
						area_parent_id: 320400
					},
					"320412": {
						id: 320412,
						area_name: "武进区",
						area_code: "Wujin",
						area_parent_id: 320400
					},
					"320481": {
						id: 320481,
						area_name: "溧阳市",
						area_code: "Liyang",
						area_parent_id: 320400
					},
					"320482": {
						id: 320482,
						area_name: "金坛市",
						area_code: "Jintan",
						area_parent_id: 320400
					}
				}
			},
			"320500": {
				id: 320500,
				area_name: "苏州市",
				area_code: "Suzhou",
				area_parent_id: 320000,
				child: {
					"320505": {
						id: 320505,
						area_name: "虎丘区",
						area_code: "Huqiu",
						area_parent_id: 320500
					},
					"320506": {
						id: 320506,
						area_name: "吴中区",
						area_code: "Wuzhong",
						area_parent_id: 320500
					},
					"320507": {
						id: 320507,
						area_name: "相城区",
						area_code: "Xiangcheng",
						area_parent_id: 320500
					},
					"320508": {
						id: 320508,
						area_name: "姑苏区",
						area_code: "Gusu",
						area_parent_id: 320500
					},
					"320509": {
						id: 320509,
						area_name: "吴江区",
						area_code: "Wujiang",
						area_parent_id: 320500
					},
					"320581": {
						id: 320581,
						area_name: "常熟市",
						area_code: "Changshu",
						area_parent_id: 320500
					},
					"320582": {
						id: 320582,
						area_name: "张家港市",
						area_code: "Zhangjiagang",
						area_parent_id: 320500
					},
					"320583": {
						id: 320583,
						area_name: "昆山市",
						area_code: "Kunshan",
						area_parent_id: 320500
					},
					"320585": {
						id: 320585,
						area_name: "太仓市",
						area_code: "Taicang",
						area_parent_id: 320500
					}
				}
			},
			"320600": {
				id: 320600,
				area_name: "南通市",
				area_code: "Nantong",
				area_parent_id: 320000,
				child: {
					"320602": {
						id: 320602,
						area_name: "崇川区",
						area_code: "Chongchuan",
						area_parent_id: 320600
					},
					"320611": {
						id: 320611,
						area_name: "港闸区",
						area_code: "Gangzha",
						area_parent_id: 320600
					},
					"320612": {
						id: 320612,
						area_name: "通州区",
						area_code: "Tongzhou",
						area_parent_id: 320600
					},
					"320621": {
						id: 320621,
						area_name: "海安县",
						area_code: "Hai'an",
						area_parent_id: 320600
					},
					"320623": {
						id: 320623,
						area_name: "如东县",
						area_code: "Rudong",
						area_parent_id: 320600
					},
					"320681": {
						id: 320681,
						area_name: "启东市",
						area_code: "Qidong",
						area_parent_id: 320600
					},
					"320682": {
						id: 320682,
						area_name: "如皋市",
						area_code: "Rugao",
						area_parent_id: 320600
					},
					"320684": {
						id: 320684,
						area_name: "海门市",
						area_code: "Haimen",
						area_parent_id: 320600
					}
				}
			},
			"320700": {
				id: 320700,
				area_name: "连云港市",
				area_code: "Lianyungang",
				area_parent_id: 320000,
				child: {
					"320703": {
						id: 320703,
						area_name: "连云区",
						area_code: "Lianyun",
						area_parent_id: 320700
					},
					"320706": {
						id: 320706,
						area_name: "海州区",
						area_code: "Haizhou",
						area_parent_id: 320700
					},
					"320707": {
						id: 320707,
						area_name: "赣榆区",
						area_code: "Ganyu",
						area_parent_id: 320700
					},
					"320722": {
						id: 320722,
						area_name: "东海县",
						area_code: "Donghai",
						area_parent_id: 320700
					},
					"320723": {
						id: 320723,
						area_name: "灌云县",
						area_code: "Guanyun",
						area_parent_id: 320700
					},
					"320724": {
						id: 320724,
						area_name: "灌南县",
						area_code: "Guannan",
						area_parent_id: 320700
					}
				}
			},
			"320800": {
				id: 320800,
				area_name: "淮安市",
				area_code: "Huai'an",
				area_parent_id: 320000,
				child: {
					"320802": {
						id: 320802,
						area_name: "清河区",
						area_code: "Qinghe",
						area_parent_id: 320800
					},
					"320803": {
						id: 320803,
						area_name: "淮安区",
						area_code: "Huai'an",
						area_parent_id: 320800
					},
					"320804": {
						id: 320804,
						area_name: "淮阴区",
						area_code: "Huaiyin",
						area_parent_id: 320800
					},
					"320811": {
						id: 320811,
						area_name: "清浦区",
						area_code: "Qingpu",
						area_parent_id: 320800
					},
					"320826": {
						id: 320826,
						area_name: "涟水县",
						area_code: "Lianshui",
						area_parent_id: 320800
					},
					"320829": {
						id: 320829,
						area_name: "洪泽县",
						area_code: "Hongze",
						area_parent_id: 320800
					},
					"320830": {
						id: 320830,
						area_name: "盱眙县",
						area_code: "Xuyi",
						area_parent_id: 320800
					},
					"320831": {
						id: 320831,
						area_name: "金湖县",
						area_code: "Jinhu",
						area_parent_id: 320800
					}
				}
			},
			"320900": {
				id: 320900,
				area_name: "盐城市",
				area_code: "Yancheng",
				area_parent_id: 320000,
				child: {
					"320902": {
						id: 320902,
						area_name: "亭湖区",
						area_code: "Tinghu",
						area_parent_id: 320900
					},
					"320903": {
						id: 320903,
						area_name: "盐都区",
						area_code: "Yandu",
						area_parent_id: 320900
					},
					"320921": {
						id: 320921,
						area_name: "响水县",
						area_code: "Xiangshui",
						area_parent_id: 320900
					},
					"320922": {
						id: 320922,
						area_name: "滨海县",
						area_code: "Binhai",
						area_parent_id: 320900
					},
					"320923": {
						id: 320923,
						area_name: "阜宁县",
						area_code: "Funing",
						area_parent_id: 320900
					},
					"320924": {
						id: 320924,
						area_name: "射阳县",
						area_code: "Sheyang",
						area_parent_id: 320900
					},
					"320925": {
						id: 320925,
						area_name: "建湖县",
						area_code: "Jianhu",
						area_parent_id: 320900
					},
					"320981": {
						id: 320981,
						area_name: "东台市",
						area_code: "Dongtai",
						area_parent_id: 320900
					},
					"320982": {
						id: 320982,
						area_name: "大丰市",
						area_code: "Dafeng",
						area_parent_id: 320900
					}
				}
			},
			"321000": {
				id: 321000,
				area_name: "扬州市",
				area_code: "Yangzhou",
				area_parent_id: 320000,
				child: {
					"321002": {
						id: 321002,
						area_name: "广陵区",
						area_code: "Guangling",
						area_parent_id: 321000
					},
					"321003": {
						id: 321003,
						area_name: "邗江区",
						area_code: "Hanjiang",
						area_parent_id: 321000
					},
					"321012": {
						id: 321012,
						area_name: "江都区",
						area_code: "Jiangdu",
						area_parent_id: 321000
					},
					"321023": {
						id: 321023,
						area_name: "宝应县",
						area_code: "Baoying",
						area_parent_id: 321000
					},
					"321081": {
						id: 321081,
						area_name: "仪征市",
						area_code: "Yizheng",
						area_parent_id: 321000
					},
					"321084": {
						id: 321084,
						area_name: "高邮市",
						area_code: "Gaoyou",
						area_parent_id: 321000
					}
				}
			},
			"321100": {
				id: 321100,
				area_name: "镇江市",
				area_code: "Zhenjiang",
				area_parent_id: 320000,
				child: {
					"321102": {
						id: 321102,
						area_name: "京口区",
						area_code: "Jingkou",
						area_parent_id: 321100
					},
					"321111": {
						id: 321111,
						area_name: "润州区",
						area_code: "Runzhou",
						area_parent_id: 321100
					},
					"321112": {
						id: 321112,
						area_name: "丹徒区",
						area_code: "Dantu",
						area_parent_id: 321100
					},
					"321181": {
						id: 321181,
						area_name: "丹阳市",
						area_code: "Danyang",
						area_parent_id: 321100
					},
					"321182": {
						id: 321182,
						area_name: "扬中市",
						area_code: "Yangzhong",
						area_parent_id: 321100
					},
					"321183": {
						id: 321183,
						area_name: "句容市",
						area_code: "Jurong",
						area_parent_id: 321100
					}
				}
			},
			"321200": {
				id: 321200,
				area_name: "泰州市",
				area_code: "Taizhou",
				area_parent_id: 320000,
				child: {
					"321202": {
						id: 321202,
						area_name: "海陵区",
						area_code: "Hailing",
						area_parent_id: 321200
					},
					"321203": {
						id: 321203,
						area_name: "高港区",
						area_code: "Gaogang",
						area_parent_id: 321200
					},
					"321204": {
						id: 321204,
						area_name: "姜堰区",
						area_code: "Jiangyan",
						area_parent_id: 321200
					},
					"321281": {
						id: 321281,
						area_name: "兴化市",
						area_code: "Xinghua",
						area_parent_id: 321200
					},
					"321282": {
						id: 321282,
						area_name: "靖江市",
						area_code: "Jingjiang",
						area_parent_id: 321200
					},
					"321283": {
						id: 321283,
						area_name: "泰兴市",
						area_code: "Taixing",
						area_parent_id: 321200
					}
				}
			},
			"321300": {
				id: 321300,
				area_name: "宿迁市",
				area_code: "Suqian",
				area_parent_id: 320000,
				child: {
					"321302": {
						id: 321302,
						area_name: "宿城区",
						area_code: "Sucheng",
						area_parent_id: 321300
					},
					"321311": {
						id: 321311,
						area_name: "宿豫区",
						area_code: "Suyu",
						area_parent_id: 321300
					},
					"321322": {
						id: 321322,
						area_name: "沭阳县",
						area_code: "Shuyang",
						area_parent_id: 321300
					},
					"321323": {
						id: 321323,
						area_name: "泗阳县",
						area_code: "Siyang",
						area_parent_id: 321300
					},
					"321324": {
						id: 321324,
						area_name: "泗洪县",
						area_code: "Sihong",
						area_parent_id: 321300
					}
				}
			}
		}
	},
	"330000": {
		id: 330000,
		area_name: "浙江省",
		area_code: "Zhejiang",
		area_parent_id: 0,
		child: {
			"330100": {
				id: 330100,
				area_name: "杭州市",
				area_code: "Hangzhou",
				area_parent_id: 330000,
				child: {
					"330102": {
						id: 330102,
						area_name: "上城区",
						area_code: "Shangcheng",
						area_parent_id: 330100
					},
					"330103": {
						id: 330103,
						area_name: "下城区",
						area_code: "Xiacheng",
						area_parent_id: 330100
					},
					"330104": {
						id: 330104,
						area_name: "江干区",
						area_code: "Jianggan",
						area_parent_id: 330100
					},
					"330105": {
						id: 330105,
						area_name: "拱墅区",
						area_code: "Gongshu",
						area_parent_id: 330100
					},
					"330106": {
						id: 330106,
						area_name: "西湖区",
						area_code: "Xihu",
						area_parent_id: 330100
					},
					"330108": {
						id: 330108,
						area_name: "滨江区",
						area_code: "Binjiang",
						area_parent_id: 330100
					},
					"330109": {
						id: 330109,
						area_name: "萧山区",
						area_code: "Xiaoshan",
						area_parent_id: 330100
					},
					"330110": {
						id: 330110,
						area_name: "余杭区",
						area_code: "Yuhang",
						area_parent_id: 330100
					},
					"330122": {
						id: 330122,
						area_name: "桐庐县",
						area_code: "Tonglu",
						area_parent_id: 330100
					},
					"330127": {
						id: 330127,
						area_name: "淳安县",
						area_code: "Chun'an",
						area_parent_id: 330100
					},
					"330182": {
						id: 330182,
						area_name: "建德市",
						area_code: "Jiande",
						area_parent_id: 330100
					},
					"330183": {
						id: 330183,
						area_name: "富阳区",
						area_code: "Fuyang",
						area_parent_id: 330100
					},
					"330185": {
						id: 330185,
						area_name: "临安市",
						area_code: "Lin'an",
						area_parent_id: 330100
					}
				}
			},
			"330200": {
				id: 330200,
				area_name: "宁波市",
				area_code: "Ningbo",
				area_parent_id: 330000,
				child: {
					"330203": {
						id: 330203,
						area_name: "海曙区",
						area_code: "Haishu",
						area_parent_id: 330200
					},
					"330204": {
						id: 330204,
						area_name: "江东区",
						area_code: "Jiangdong",
						area_parent_id: 330200
					},
					"330205": {
						id: 330205,
						area_name: "江北区",
						area_code: "Jiangbei",
						area_parent_id: 330200
					},
					"330206": {
						id: 330206,
						area_name: "北仑区",
						area_code: "Beilun",
						area_parent_id: 330200
					},
					"330211": {
						id: 330211,
						area_name: "镇海区",
						area_code: "Zhenhai",
						area_parent_id: 330200
					},
					"330212": {
						id: 330212,
						area_name: "鄞州区",
						area_code: "Yinzhou",
						area_parent_id: 330200
					},
					"330225": {
						id: 330225,
						area_name: "象山县",
						area_code: "Xiangshan",
						area_parent_id: 330200
					},
					"330226": {
						id: 330226,
						area_name: "宁海县",
						area_code: "Ninghai",
						area_parent_id: 330200
					},
					"330281": {
						id: 330281,
						area_name: "余姚市",
						area_code: "Yuyao",
						area_parent_id: 330200
					},
					"330282": {
						id: 330282,
						area_name: "慈溪市",
						area_code: "Cixi",
						area_parent_id: 330200
					},
					"330283": {
						id: 330283,
						area_name: "奉化市",
						area_code: "Fenghua",
						area_parent_id: 330200
					}
				}
			},
			"330300": {
				id: 330300,
				area_name: "温州市",
				area_code: "Wenzhou",
				area_parent_id: 330000,
				child: {
					"330302": {
						id: 330302,
						area_name: "鹿城区",
						area_code: "Lucheng",
						area_parent_id: 330300
					},
					"330303": {
						id: 330303,
						area_name: "龙湾区",
						area_code: "Longwan",
						area_parent_id: 330300
					},
					"330304": {
						id: 330304,
						area_name: "瓯海区",
						area_code: "Ouhai",
						area_parent_id: 330300
					},
					"330322": {
						id: 330322,
						area_name: "洞头县",
						area_code: "Dongtou",
						area_parent_id: 330300
					},
					"330324": {
						id: 330324,
						area_name: "永嘉县",
						area_code: "Yongjia",
						area_parent_id: 330300
					},
					"330326": {
						id: 330326,
						area_name: "平阳县",
						area_code: "Pingyang",
						area_parent_id: 330300
					},
					"330327": {
						id: 330327,
						area_name: "苍南县",
						area_code: "Cangnan",
						area_parent_id: 330300
					},
					"330328": {
						id: 330328,
						area_name: "文成县",
						area_code: "Wencheng",
						area_parent_id: 330300
					},
					"330329": {
						id: 330329,
						area_name: "泰顺县",
						area_code: "Taishun",
						area_parent_id: 330300
					},
					"330381": {
						id: 330381,
						area_name: "瑞安市",
						area_code: "Rui'an",
						area_parent_id: 330300
					},
					"330382": {
						id: 330382,
						area_name: "乐清市",
						area_code: "Yueqing",
						area_parent_id: 330300
					}
				}
			},
			"330400": {
				id: 330400,
				area_name: "嘉兴市",
				area_code: "Jiaxing",
				area_parent_id: 330000,
				child: {
					"330402": {
						id: 330402,
						area_name: "南湖区",
						area_code: "Nanhu",
						area_parent_id: 330400
					},
					"330411": {
						id: 330411,
						area_name: "秀洲区",
						area_code: "Xiuzhou",
						area_parent_id: 330400
					},
					"330421": {
						id: 330421,
						area_name: "嘉善县",
						area_code: "Jiashan",
						area_parent_id: 330400
					},
					"330424": {
						id: 330424,
						area_name: "海盐县",
						area_code: "Haiyan",
						area_parent_id: 330400
					},
					"330481": {
						id: 330481,
						area_name: "海宁市",
						area_code: "Haining",
						area_parent_id: 330400
					},
					"330482": {
						id: 330482,
						area_name: "平湖市",
						area_code: "Pinghu",
						area_parent_id: 330400
					},
					"330483": {
						id: 330483,
						area_name: "桐乡市",
						area_code: "Tongxiang",
						area_parent_id: 330400
					}
				}
			},
			"330500": {
				id: 330500,
				area_name: "湖州市",
				area_code: "Huzhou",
				area_parent_id: 330000,
				child: {
					"330502": {
						id: 330502,
						area_name: "吴兴区",
						area_code: "Wuxing",
						area_parent_id: 330500
					},
					"330503": {
						id: 330503,
						area_name: "南浔区",
						area_code: "Nanxun",
						area_parent_id: 330500
					},
					"330521": {
						id: 330521,
						area_name: "德清县",
						area_code: "Deqing",
						area_parent_id: 330500
					},
					"330522": {
						id: 330522,
						area_name: "长兴县",
						area_code: "Changxing",
						area_parent_id: 330500
					},
					"330523": {
						id: 330523,
						area_name: "安吉县",
						area_code: "Anji",
						area_parent_id: 330500
					}
				}
			},
			"330600": {
				id: 330600,
				area_name: "绍兴市",
				area_code: "Shaoxing",
				area_parent_id: 330000,
				child: {
					"330602": {
						id: 330602,
						area_name: "越城区",
						area_code: "Yuecheng",
						area_parent_id: 330600
					},
					"330603": {
						id: 330603,
						area_name: "柯桥区",
						area_code: "Keqiao ",
						area_parent_id: 330600
					},
					"330604": {
						id: 330604,
						area_name: "上虞区",
						area_code: "Shangyu",
						area_parent_id: 330600
					},
					"330624": {
						id: 330624,
						area_name: "新昌县",
						area_code: "Xinchang",
						area_parent_id: 330600
					},
					"330681": {
						id: 330681,
						area_name: "诸暨市",
						area_code: "Zhuji",
						area_parent_id: 330600
					},
					"330683": {
						id: 330683,
						area_name: "嵊州市",
						area_code: "Shengzhou",
						area_parent_id: 330600
					}
				}
			},
			"330700": {
				id: 330700,
				area_name: "金华市",
				area_code: "Jinhua",
				area_parent_id: 330000,
				child: {
					"330702": {
						id: 330702,
						area_name: "婺城区",
						area_code: "Wucheng",
						area_parent_id: 330700
					},
					"330703": {
						id: 330703,
						area_name: "金东区",
						area_code: "Jindong",
						area_parent_id: 330700
					},
					"330723": {
						id: 330723,
						area_name: "武义县",
						area_code: "Wuyi",
						area_parent_id: 330700
					},
					"330726": {
						id: 330726,
						area_name: "浦江县",
						area_code: "Pujiang",
						area_parent_id: 330700
					},
					"330727": {
						id: 330727,
						area_name: "磐安县",
						area_code: "Pan'an",
						area_parent_id: 330700
					},
					"330781": {
						id: 330781,
						area_name: "兰溪市",
						area_code: "Lanxi",
						area_parent_id: 330700
					},
					"330782": {
						id: 330782,
						area_name: "义乌市",
						area_code: "Yiwu",
						area_parent_id: 330700
					},
					"330783": {
						id: 330783,
						area_name: "东阳市",
						area_code: "Dongyang",
						area_parent_id: 330700
					},
					"330784": {
						id: 330784,
						area_name: "永康市",
						area_code: "Yongkang",
						area_parent_id: 330700
					}
				}
			},
			"330800": {
				id: 330800,
				area_name: "衢州市",
				area_code: "Quzhou",
				area_parent_id: 330000,
				child: {
					"330802": {
						id: 330802,
						area_name: "柯城区",
						area_code: "Kecheng",
						area_parent_id: 330800
					},
					"330803": {
						id: 330803,
						area_name: "衢江区",
						area_code: "Qujiang",
						area_parent_id: 330800
					},
					"330822": {
						id: 330822,
						area_name: "常山县",
						area_code: "Changshan",
						area_parent_id: 330800
					},
					"330824": {
						id: 330824,
						area_name: "开化县",
						area_code: "Kaihua",
						area_parent_id: 330800
					},
					"330825": {
						id: 330825,
						area_name: "龙游县",
						area_code: "Longyou",
						area_parent_id: 330800
					},
					"330881": {
						id: 330881,
						area_name: "江山市",
						area_code: "Jiangshan",
						area_parent_id: 330800
					}
				}
			},
			"330900": {
				id: 330900,
				area_name: "舟山市",
				area_code: "Zhoushan",
				area_parent_id: 330000,
				child: {
					"330902": {
						id: 330902,
						area_name: "定海区",
						area_code: "Dinghai",
						area_parent_id: 330900
					},
					"330903": {
						id: 330903,
						area_name: "普陀区",
						area_code: "Putuo",
						area_parent_id: 330900
					},
					"330921": {
						id: 330921,
						area_name: "岱山县",
						area_code: "Daishan",
						area_parent_id: 330900
					},
					"330922": {
						id: 330922,
						area_name: "嵊泗县",
						area_code: "Shengsi",
						area_parent_id: 330900
					}
				}
			},
			"331000": {
				id: 331000,
				area_name: "台州市",
				area_code: "Taizhou",
				area_parent_id: 330000,
				child: {
					"331002": {
						id: 331002,
						area_name: "椒江区",
						area_code: "Jiaojiang",
						area_parent_id: 331000
					},
					"331003": {
						id: 331003,
						area_name: "黄岩区",
						area_code: "Huangyan",
						area_parent_id: 331000
					},
					"331004": {
						id: 331004,
						area_name: "路桥区",
						area_code: "Luqiao",
						area_parent_id: 331000
					},
					"331021": {
						id: 331021,
						area_name: "玉环县",
						area_code: "Yuhuan",
						area_parent_id: 331000
					},
					"331022": {
						id: 331022,
						area_name: "三门县",
						area_code: "Sanmen",
						area_parent_id: 331000
					},
					"331023": {
						id: 331023,
						area_name: "天台县",
						area_code: "Tiantai",
						area_parent_id: 331000
					},
					"331024": {
						id: 331024,
						area_name: "仙居县",
						area_code: "Xianju",
						area_parent_id: 331000
					},
					"331081": {
						id: 331081,
						area_name: "温岭市",
						area_code: "Wenling",
						area_parent_id: 331000
					},
					"331082": {
						id: 331082,
						area_name: "临海市",
						area_code: "Linhai",
						area_parent_id: 331000
					}
				}
			},
			"331100": {
				id: 331100,
				area_name: "丽水市",
				area_code: "Lishui",
				area_parent_id: 330000,
				child: {
					"331102": {
						id: 331102,
						area_name: "莲都区",
						area_code: "Liandu",
						area_parent_id: 331100
					},
					"331121": {
						id: 331121,
						area_name: "青田县",
						area_code: "Qingtian",
						area_parent_id: 331100
					},
					"331122": {
						id: 331122,
						area_name: "缙云县",
						area_code: "Jinyun",
						area_parent_id: 331100
					},
					"331123": {
						id: 331123,
						area_name: "遂昌县",
						area_code: "Suichang",
						area_parent_id: 331100
					},
					"331124": {
						id: 331124,
						area_name: "松阳县",
						area_code: "Songyang",
						area_parent_id: 331100
					},
					"331125": {
						id: 331125,
						area_name: "云和县",
						area_code: "Yunhe",
						area_parent_id: 331100
					},
					"331126": {
						id: 331126,
						area_name: "庆元县",
						area_code: "Qingyuan",
						area_parent_id: 331100
					},
					"331127": {
						id: 331127,
						area_name: "景宁畲族自治县",
						area_code: "Jingning",
						area_parent_id: 331100
					},
					"331181": {
						id: 331181,
						area_name: "龙泉市",
						area_code: "Longquan",
						area_parent_id: 331100
					}
				}
			},
			"331200": {
				id: 331200,
				area_name: "舟山群岛新区",
				area_code: "Zhoushan",
				area_parent_id: 330000,
				child: {
					"331201": {
						id: 331201,
						area_name: "金塘岛",
						area_code: "Jintang",
						area_parent_id: 331200
					},
					"331202": {
						id: 331202,
						area_name: "六横岛",
						area_code: "Liuheng",
						area_parent_id: 331200
					},
					"331203": {
						id: 331203,
						area_name: "衢山岛",
						area_code: "Qushan",
						area_parent_id: 331200
					},
					"331204": {
						id: 331204,
						area_name: "舟山本岛西北部",
						area_code: "Zhoushan",
						area_parent_id: 331200
					},
					"331205": {
						id: 331205,
						area_name: "岱山岛西南部",
						area_code: "Daishan",
						area_parent_id: 331200
					},
					"331206": {
						id: 331206,
						area_name: "泗礁岛",
						area_code: "Sijiao",
						area_parent_id: 331200
					},
					"331207": {
						id: 331207,
						area_name: "朱家尖岛",
						area_code: "Zhujiajian",
						area_parent_id: 331200
					},
					"331208": {
						id: 331208,
						area_name: "洋山岛",
						area_code: "Yangshan",
						area_parent_id: 331200
					},
					"331209": {
						id: 331209,
						area_name: "长涂岛",
						area_code: "Changtu",
						area_parent_id: 331200
					},
					"331210": {
						id: 331210,
						area_name: "虾峙岛",
						area_code: "Xiazhi",
						area_parent_id: 331200
					}
				}
			}
		}
	},
	"340000": {
		id: 340000,
		area_name: "安徽省",
		area_code: "Anhui",
		area_parent_id: 0,
		child: {
			"340100": {
				id: 340100,
				area_name: "合肥市",
				area_code: "Hefei",
				area_parent_id: 340000,
				child: {
					"340102": {
						id: 340102,
						area_name: "瑶海区",
						area_code: "Yaohai",
						area_parent_id: 340100
					},
					"340103": {
						id: 340103,
						area_name: "庐阳区",
						area_code: "Luyang",
						area_parent_id: 340100
					},
					"340104": {
						id: 340104,
						area_name: "蜀山区",
						area_code: "Shushan",
						area_parent_id: 340100
					},
					"340111": {
						id: 340111,
						area_name: "包河区",
						area_code: "Baohe",
						area_parent_id: 340100
					},
					"340121": {
						id: 340121,
						area_name: "长丰县",
						area_code: "Changfeng",
						area_parent_id: 340100
					},
					"340122": {
						id: 340122,
						area_name: "肥东县",
						area_code: "Feidong",
						area_parent_id: 340100
					},
					"340123": {
						id: 340123,
						area_name: "肥西县",
						area_code: "Feixi",
						area_parent_id: 340100
					},
					"340124": {
						id: 340124,
						area_name: "庐江县",
						area_code: "Lujiang",
						area_parent_id: 340100
					},
					"340181": {
						id: 340181,
						area_name: "巢湖市",
						area_code: "Chaohu",
						area_parent_id: 340100
					}
				}
			},
			"340200": {
				id: 340200,
				area_name: "芜湖市",
				area_code: "Wuhu",
				area_parent_id: 340000,
				child: {
					"340202": {
						id: 340202,
						area_name: "镜湖区",
						area_code: "Jinghu",
						area_parent_id: 340200
					},
					"340203": {
						id: 340203,
						area_name: "弋江区",
						area_code: "Yijiang",
						area_parent_id: 340200
					},
					"340207": {
						id: 340207,
						area_name: "鸠江区",
						area_code: "Jiujiang",
						area_parent_id: 340200
					},
					"340208": {
						id: 340208,
						area_name: "三山区",
						area_code: "Sanshan",
						area_parent_id: 340200
					},
					"340221": {
						id: 340221,
						area_name: "芜湖县",
						area_code: "Wuhu",
						area_parent_id: 340200
					},
					"340222": {
						id: 340222,
						area_name: "繁昌县",
						area_code: "Fanchang",
						area_parent_id: 340200
					},
					"340223": {
						id: 340223,
						area_name: "南陵县",
						area_code: "Nanling",
						area_parent_id: 340200
					},
					"340225": {
						id: 340225,
						area_name: "无为县",
						area_code: "Wuwei",
						area_parent_id: 340200
					}
				}
			},
			"340300": {
				id: 340300,
				area_name: "蚌埠市",
				area_code: "Bengbu",
				area_parent_id: 340000,
				child: {
					"340302": {
						id: 340302,
						area_name: "龙子湖区",
						area_code: "Longzihu",
						area_parent_id: 340300
					},
					"340303": {
						id: 340303,
						area_name: "蚌山区",
						area_code: "Bengshan",
						area_parent_id: 340300
					},
					"340304": {
						id: 340304,
						area_name: "禹会区",
						area_code: "Yuhui",
						area_parent_id: 340300
					},
					"340311": {
						id: 340311,
						area_name: "淮上区",
						area_code: "Huaishang",
						area_parent_id: 340300
					},
					"340321": {
						id: 340321,
						area_name: "怀远县",
						area_code: "Huaiyuan",
						area_parent_id: 340300
					},
					"340322": {
						id: 340322,
						area_name: "五河县",
						area_code: "Wuhe",
						area_parent_id: 340300
					},
					"340323": {
						id: 340323,
						area_name: "固镇县",
						area_code: "Guzhen",
						area_parent_id: 340300
					}
				}
			},
			"340400": {
				id: 340400,
				area_name: "淮南市",
				area_code: "Huainan",
				area_parent_id: 340000,
				child: {
					"340402": {
						id: 340402,
						area_name: "大通区",
						area_code: "Datong",
						area_parent_id: 340400
					},
					"340403": {
						id: 340403,
						area_name: "田家庵区",
						area_code: "Tianjiaan",
						area_parent_id: 340400
					},
					"340404": {
						id: 340404,
						area_name: "谢家集区",
						area_code: "Xiejiaji",
						area_parent_id: 340400
					},
					"340405": {
						id: 340405,
						area_name: "八公山区",
						area_code: "Bagongshan",
						area_parent_id: 340400
					},
					"340406": {
						id: 340406,
						area_name: "潘集区",
						area_code: "Panji",
						area_parent_id: 340400
					},
					"340421": {
						id: 340421,
						area_name: "凤台县",
						area_code: "Fengtai",
						area_parent_id: 340400
					}
				}
			},
			"340500": {
				id: 340500,
				area_name: "马鞍山市",
				area_code: "Ma'anshan",
				area_parent_id: 340000,
				child: {
					"340503": {
						id: 340503,
						area_name: "花山区",
						area_code: "Huashan",
						area_parent_id: 340500
					},
					"340504": {
						id: 340504,
						area_name: "雨山区",
						area_code: "Yushan",
						area_parent_id: 340500
					},
					"340506": {
						id: 340506,
						area_name: "博望区",
						area_code: "Bowang",
						area_parent_id: 340500
					},
					"340521": {
						id: 340521,
						area_name: "当涂县",
						area_code: "Dangtu",
						area_parent_id: 340500
					},
					"340522": {
						id: 340522,
						area_name: "含山县",
						area_code: "Hanshan ",
						area_parent_id: 340500
					},
					"340523": {
						id: 340523,
						area_name: "和县",
						area_code: "Hexian",
						area_parent_id: 340500
					}
				}
			},
			"340600": {
				id: 340600,
				area_name: "淮北市",
				area_code: "Huaibei",
				area_parent_id: 340000,
				child: {
					"340602": {
						id: 340602,
						area_name: "杜集区",
						area_code: "Duji",
						area_parent_id: 340600
					},
					"340603": {
						id: 340603,
						area_name: "相山区",
						area_code: "Xiangshan",
						area_parent_id: 340600
					},
					"340604": {
						id: 340604,
						area_name: "烈山区",
						area_code: "Lieshan",
						area_parent_id: 340600
					},
					"340621": {
						id: 340621,
						area_name: "濉溪县",
						area_code: "Suixi",
						area_parent_id: 340600
					}
				}
			},
			"340700": {
				id: 340700,
				area_name: "铜陵市",
				area_code: "Tongling",
				area_parent_id: 340000,
				child: {
					"340702": {
						id: 340702,
						area_name: "铜官山区",
						area_code: "Tongguanshan",
						area_parent_id: 340700
					},
					"340703": {
						id: 340703,
						area_name: "狮子山区",
						area_code: "Shizishan",
						area_parent_id: 340700
					},
					"340711": {
						id: 340711,
						area_name: "郊区",
						area_code: "Jiaoqu",
						area_parent_id: 340700
					},
					"340721": {
						id: 340721,
						area_name: "铜陵县",
						area_code: "Tongling",
						area_parent_id: 340700
					}
				}
			},
			"340800": {
				id: 340800,
				area_name: "安庆市",
				area_code: "Anqing",
				area_parent_id: 340000,
				child: {
					"340802": {
						id: 340802,
						area_name: "迎江区",
						area_code: "Yingjiang",
						area_parent_id: 340800
					},
					"340803": {
						id: 340803,
						area_name: "大观区",
						area_code: "Daguan",
						area_parent_id: 340800
					},
					"340811": {
						id: 340811,
						area_name: "宜秀区",
						area_code: "Yixiu",
						area_parent_id: 340800
					},
					"340822": {
						id: 340822,
						area_name: "怀宁县",
						area_code: "Huaining",
						area_parent_id: 340800
					},
					"340823": {
						id: 340823,
						area_name: "枞阳县",
						area_code: "Zongyang",
						area_parent_id: 340800
					},
					"340824": {
						id: 340824,
						area_name: "潜山县",
						area_code: "Qianshan",
						area_parent_id: 340800
					},
					"340825": {
						id: 340825,
						area_name: "太湖县",
						area_code: "Taihu",
						area_parent_id: 340800
					},
					"340826": {
						id: 340826,
						area_name: "宿松县",
						area_code: "Susong",
						area_parent_id: 340800
					},
					"340827": {
						id: 340827,
						area_name: "望江县",
						area_code: "Wangjiang",
						area_parent_id: 340800
					},
					"340828": {
						id: 340828,
						area_name: "岳西县",
						area_code: "Yuexi",
						area_parent_id: 340800
					},
					"340881": {
						id: 340881,
						area_name: "桐城市",
						area_code: "Tongcheng",
						area_parent_id: 340800
					}
				}
			},
			"341000": {
				id: 341000,
				area_name: "黄山市",
				area_code: "Huangshan",
				area_parent_id: 340000,
				child: {
					"341002": {
						id: 341002,
						area_name: "屯溪区",
						area_code: "Tunxi",
						area_parent_id: 341000
					},
					"341003": {
						id: 341003,
						area_name: "黄山区",
						area_code: "Huangshan",
						area_parent_id: 341000
					},
					"341004": {
						id: 341004,
						area_name: "徽州区",
						area_code: "Huizhou",
						area_parent_id: 341000
					},
					"341021": {
						id: 341021,
						area_name: "歙县",
						area_code: "Shexian",
						area_parent_id: 341000
					},
					"341022": {
						id: 341022,
						area_name: "休宁县",
						area_code: "Xiuning",
						area_parent_id: 341000
					},
					"341023": {
						id: 341023,
						area_name: "黟县",
						area_code: "Yixian",
						area_parent_id: 341000
					},
					"341024": {
						id: 341024,
						area_name: "祁门县",
						area_code: "Qimen",
						area_parent_id: 341000
					}
				}
			},
			"341100": {
				id: 341100,
				area_name: "滁州市",
				area_code: "Chuzhou",
				area_parent_id: 340000,
				child: {
					"341102": {
						id: 341102,
						area_name: "琅琊区",
						area_code: "Langya",
						area_parent_id: 341100
					},
					"341103": {
						id: 341103,
						area_name: "南谯区",
						area_code: "Nanqiao",
						area_parent_id: 341100
					},
					"341122": {
						id: 341122,
						area_name: "来安县",
						area_code: "Lai'an",
						area_parent_id: 341100
					},
					"341124": {
						id: 341124,
						area_name: "全椒县",
						area_code: "Quanjiao",
						area_parent_id: 341100
					},
					"341125": {
						id: 341125,
						area_name: "定远县",
						area_code: "Dingyuan",
						area_parent_id: 341100
					},
					"341126": {
						id: 341126,
						area_name: "凤阳县",
						area_code: "Fengyang",
						area_parent_id: 341100
					},
					"341181": {
						id: 341181,
						area_name: "天长市",
						area_code: "Tianchang",
						area_parent_id: 341100
					},
					"341182": {
						id: 341182,
						area_name: "明光市",
						area_code: "Mingguang",
						area_parent_id: 341100
					}
				}
			},
			"341200": {
				id: 341200,
				area_name: "阜阳市",
				area_code: "Fuyang",
				area_parent_id: 340000,
				child: {
					"341202": {
						id: 341202,
						area_name: "颍州区",
						area_code: "Yingzhou",
						area_parent_id: 341200
					},
					"341203": {
						id: 341203,
						area_name: "颍东区",
						area_code: "Yingdong",
						area_parent_id: 341200
					},
					"341204": {
						id: 341204,
						area_name: "颍泉区",
						area_code: "Yingquan",
						area_parent_id: 341200
					},
					"341221": {
						id: 341221,
						area_name: "临泉县",
						area_code: "Linquan",
						area_parent_id: 341200
					},
					"341222": {
						id: 341222,
						area_name: "太和县",
						area_code: "Taihe",
						area_parent_id: 341200
					},
					"341225": {
						id: 341225,
						area_name: "阜南县",
						area_code: "Funan",
						area_parent_id: 341200
					},
					"341226": {
						id: 341226,
						area_name: "颍上县",
						area_code: "Yingshang",
						area_parent_id: 341200
					},
					"341282": {
						id: 341282,
						area_name: "界首市",
						area_code: "Jieshou",
						area_parent_id: 341200
					}
				}
			},
			"341300": {
				id: 341300,
				area_name: "宿州市",
				area_code: "Suzhou",
				area_parent_id: 340000,
				child: {
					"341302": {
						id: 341302,
						area_name: "埇桥区",
						area_code: "Yongqiao",
						area_parent_id: 341300
					},
					"341321": {
						id: 341321,
						area_name: "砀山县",
						area_code: "Dangshan",
						area_parent_id: 341300
					},
					"341322": {
						id: 341322,
						area_name: "萧县",
						area_code: "Xiaoxian",
						area_parent_id: 341300
					},
					"341323": {
						id: 341323,
						area_name: "灵璧县",
						area_code: "Lingbi",
						area_parent_id: 341300
					},
					"341324": {
						id: 341324,
						area_name: "泗县",
						area_code: "Sixian",
						area_parent_id: 341300
					}
				}
			},
			"341500": {
				id: 341500,
				area_name: "六安市",
				area_code: "Lu'an",
				area_parent_id: 340000,
				child: {
					"341502": {
						id: 341502,
						area_name: "金安区",
						area_code: "Jin'an",
						area_parent_id: 341500
					},
					"341503": {
						id: 341503,
						area_name: "裕安区",
						area_code: "Yu'an",
						area_parent_id: 341500
					},
					"341521": {
						id: 341521,
						area_name: "寿县",
						area_code: "Shouxian",
						area_parent_id: 341500
					},
					"341522": {
						id: 341522,
						area_name: "霍邱县",
						area_code: "Huoqiu",
						area_parent_id: 341500
					},
					"341523": {
						id: 341523,
						area_name: "舒城县",
						area_code: "Shucheng",
						area_parent_id: 341500
					},
					"341524": {
						id: 341524,
						area_name: "金寨县",
						area_code: "Jinzhai",
						area_parent_id: 341500
					},
					"341525": {
						id: 341525,
						area_name: "霍山县",
						area_code: "Huoshan",
						area_parent_id: 341500
					}
				}
			},
			"341600": {
				id: 341600,
				area_name: "亳州市",
				area_code: "Bozhou",
				area_parent_id: 340000,
				child: {
					"341602": {
						id: 341602,
						area_name: "谯城区",
						area_code: "Qiaocheng",
						area_parent_id: 341600
					},
					"341621": {
						id: 341621,
						area_name: "涡阳县",
						area_code: "Guoyang",
						area_parent_id: 341600
					},
					"341622": {
						id: 341622,
						area_name: "蒙城县",
						area_code: "Mengcheng",
						area_parent_id: 341600
					},
					"341623": {
						id: 341623,
						area_name: "利辛县",
						area_code: "Lixin",
						area_parent_id: 341600
					}
				}
			},
			"341700": {
				id: 341700,
				area_name: "池州市",
				area_code: "Chizhou",
				area_parent_id: 340000,
				child: {
					"341702": {
						id: 341702,
						area_name: "贵池区",
						area_code: "Guichi",
						area_parent_id: 341700
					},
					"341721": {
						id: 341721,
						area_name: "东至县",
						area_code: "Dongzhi",
						area_parent_id: 341700
					},
					"341722": {
						id: 341722,
						area_name: "石台县",
						area_code: "Shitai",
						area_parent_id: 341700
					},
					"341723": {
						id: 341723,
						area_name: "青阳县",
						area_code: "Qingyang",
						area_parent_id: 341700
					}
				}
			},
			"341800": {
				id: 341800,
				area_name: "宣城市",
				area_code: "Xuancheng",
				area_parent_id: 340000,
				child: {
					"341802": {
						id: 341802,
						area_name: "宣州区",
						area_code: "Xuanzhou",
						area_parent_id: 341800
					},
					"341821": {
						id: 341821,
						area_name: "郎溪县",
						area_code: "Langxi",
						area_parent_id: 341800
					},
					"341822": {
						id: 341822,
						area_name: "广德县",
						area_code: "Guangde",
						area_parent_id: 341800
					},
					"341823": {
						id: 341823,
						area_name: "泾县",
						area_code: "Jingxian",
						area_parent_id: 341800
					},
					"341824": {
						id: 341824,
						area_name: "绩溪县",
						area_code: "Jixi",
						area_parent_id: 341800
					},
					"341825": {
						id: 341825,
						area_name: "旌德县",
						area_code: "Jingde",
						area_parent_id: 341800
					},
					"341881": {
						id: 341881,
						area_name: "宁国市",
						area_code: "Ningguo",
						area_parent_id: 341800
					}
				}
			}
		}
	},
	"350000": {
		id: 350000,
		area_name: "福建省",
		area_code: "Fujian",
		area_parent_id: 0,
		child: {
			"350100": {
				id: 350100,
				area_name: "福州市",
				area_code: "Fuzhou",
				area_parent_id: 350000,
				child: {
					"350102": {
						id: 350102,
						area_name: "鼓楼区",
						area_code: "Gulou",
						area_parent_id: 350100
					},
					"350103": {
						id: 350103,
						area_name: "台江区",
						area_code: "Taijiang",
						area_parent_id: 350100
					},
					"350104": {
						id: 350104,
						area_name: "仓山区",
						area_code: "Cangshan",
						area_parent_id: 350100
					},
					"350105": {
						id: 350105,
						area_name: "马尾区",
						area_code: "Mawei",
						area_parent_id: 350100
					},
					"350111": {
						id: 350111,
						area_name: "晋安区",
						area_code: "Jin'an",
						area_parent_id: 350100
					},
					"350121": {
						id: 350121,
						area_name: "闽侯县",
						area_code: "Minhou",
						area_parent_id: 350100
					},
					"350122": {
						id: 350122,
						area_name: "连江县",
						area_code: "Lianjiang",
						area_parent_id: 350100
					},
					"350123": {
						id: 350123,
						area_name: "罗源县",
						area_code: "Luoyuan",
						area_parent_id: 350100
					},
					"350124": {
						id: 350124,
						area_name: "闽清县",
						area_code: "Minqing",
						area_parent_id: 350100
					},
					"350125": {
						id: 350125,
						area_name: "永泰县",
						area_code: "Yongtai",
						area_parent_id: 350100
					},
					"350128": {
						id: 350128,
						area_name: "平潭县",
						area_code: "Pingtan",
						area_parent_id: 350100
					},
					"350181": {
						id: 350181,
						area_name: "福清市",
						area_code: "Fuqing",
						area_parent_id: 350100
					},
					"350182": {
						id: 350182,
						area_name: "长乐市",
						area_code: "Changle",
						area_parent_id: 350100
					}
				}
			},
			"350200": {
				id: 350200,
				area_name: "厦门市",
				area_code: "Xiamen",
				area_parent_id: 350000,
				child: {
					"350203": {
						id: 350203,
						area_name: "思明区",
						area_code: "Siming",
						area_parent_id: 350200
					},
					"350205": {
						id: 350205,
						area_name: "海沧区",
						area_code: "Haicang",
						area_parent_id: 350200
					},
					"350206": {
						id: 350206,
						area_name: "湖里区",
						area_code: "Huli",
						area_parent_id: 350200
					},
					"350211": {
						id: 350211,
						area_name: "集美区",
						area_code: "Jimei",
						area_parent_id: 350200
					},
					"350212": {
						id: 350212,
						area_name: "同安区",
						area_code: "Tong'an",
						area_parent_id: 350200
					},
					"350213": {
						id: 350213,
						area_name: "翔安区",
						area_code: "Xiang'an",
						area_parent_id: 350200
					}
				}
			},
			"350300": {
				id: 350300,
				area_name: "莆田市",
				area_code: "Putian",
				area_parent_id: 350000,
				child: {
					"350302": {
						id: 350302,
						area_name: "城厢区",
						area_code: "Chengxiang",
						area_parent_id: 350300
					},
					"350303": {
						id: 350303,
						area_name: "涵江区",
						area_code: "Hanjiang",
						area_parent_id: 350300
					},
					"350304": {
						id: 350304,
						area_name: "荔城区",
						area_code: "Licheng",
						area_parent_id: 350300
					},
					"350305": {
						id: 350305,
						area_name: "秀屿区",
						area_code: "Xiuyu",
						area_parent_id: 350300
					},
					"350322": {
						id: 350322,
						area_name: "仙游县",
						area_code: "Xianyou",
						area_parent_id: 350300
					}
				}
			},
			"350400": {
				id: 350400,
				area_name: "三明市",
				area_code: "Sanming",
				area_parent_id: 350000,
				child: {
					"350402": {
						id: 350402,
						area_name: "梅列区",
						area_code: "Meilie",
						area_parent_id: 350400
					},
					"350403": {
						id: 350403,
						area_name: "三元区",
						area_code: "Sanyuan",
						area_parent_id: 350400
					},
					"350421": {
						id: 350421,
						area_name: "明溪县",
						area_code: "Mingxi",
						area_parent_id: 350400
					},
					"350423": {
						id: 350423,
						area_name: "清流县",
						area_code: "Qingliu",
						area_parent_id: 350400
					},
					"350424": {
						id: 350424,
						area_name: "宁化县",
						area_code: "Ninghua",
						area_parent_id: 350400
					},
					"350425": {
						id: 350425,
						area_name: "大田县",
						area_code: "Datian",
						area_parent_id: 350400
					},
					"350426": {
						id: 350426,
						area_name: "尤溪县",
						area_code: "Youxi",
						area_parent_id: 350400
					},
					"350427": {
						id: 350427,
						area_name: "沙县",
						area_code: "Shaxian",
						area_parent_id: 350400
					},
					"350428": {
						id: 350428,
						area_name: "将乐县",
						area_code: "Jiangle",
						area_parent_id: 350400
					},
					"350429": {
						id: 350429,
						area_name: "泰宁县",
						area_code: "Taining",
						area_parent_id: 350400
					},
					"350430": {
						id: 350430,
						area_name: "建宁县",
						area_code: "Jianning",
						area_parent_id: 350400
					},
					"350481": {
						id: 350481,
						area_name: "永安市",
						area_code: "Yong'an",
						area_parent_id: 350400
					}
				}
			},
			"350500": {
				id: 350500,
				area_name: "泉州市",
				area_code: "Quanzhou",
				area_parent_id: 350000,
				child: {
					"350502": {
						id: 350502,
						area_name: "鲤城区",
						area_code: "Licheng",
						area_parent_id: 350500
					},
					"350503": {
						id: 350503,
						area_name: "丰泽区",
						area_code: "Fengze",
						area_parent_id: 350500
					},
					"350504": {
						id: 350504,
						area_name: "洛江区",
						area_code: "Luojiang",
						area_parent_id: 350500
					},
					"350505": {
						id: 350505,
						area_name: "泉港区",
						area_code: "Quangang",
						area_parent_id: 350500
					},
					"350521": {
						id: 350521,
						area_name: "惠安县",
						area_code: "Hui'an",
						area_parent_id: 350500
					},
					"350524": {
						id: 350524,
						area_name: "安溪县",
						area_code: "Anxi",
						area_parent_id: 350500
					},
					"350525": {
						id: 350525,
						area_name: "永春县",
						area_code: "Yongchun",
						area_parent_id: 350500
					},
					"350526": {
						id: 350526,
						area_name: "德化县",
						area_code: "Dehua",
						area_parent_id: 350500
					},
					"350527": {
						id: 350527,
						area_name: "金门县",
						area_code: "Jinmen",
						area_parent_id: 350500
					},
					"350581": {
						id: 350581,
						area_name: "石狮市",
						area_code: "Shishi",
						area_parent_id: 350500
					},
					"350582": {
						id: 350582,
						area_name: "晋江市",
						area_code: "Jinjiang",
						area_parent_id: 350500
					},
					"350583": {
						id: 350583,
						area_name: "南安市",
						area_code: "Nan'an",
						area_parent_id: 350500
					}
				}
			},
			"350600": {
				id: 350600,
				area_name: "漳州市",
				area_code: "Zhangzhou",
				area_parent_id: 350000,
				child: {
					"350602": {
						id: 350602,
						area_name: "芗城区",
						area_code: "Xiangcheng",
						area_parent_id: 350600
					},
					"350603": {
						id: 350603,
						area_name: "龙文区",
						area_code: "Longwen",
						area_parent_id: 350600
					},
					"350622": {
						id: 350622,
						area_name: "云霄县",
						area_code: "Yunxiao",
						area_parent_id: 350600
					},
					"350623": {
						id: 350623,
						area_name: "漳浦县",
						area_code: "Zhangpu",
						area_parent_id: 350600
					},
					"350624": {
						id: 350624,
						area_name: "诏安县",
						area_code: "Zhao'an",
						area_parent_id: 350600
					},
					"350625": {
						id: 350625,
						area_name: "长泰县",
						area_code: "Changtai",
						area_parent_id: 350600
					},
					"350626": {
						id: 350626,
						area_name: "东山县",
						area_code: "Dongshan",
						area_parent_id: 350600
					},
					"350627": {
						id: 350627,
						area_name: "南靖县",
						area_code: "Nanjing",
						area_parent_id: 350600
					},
					"350628": {
						id: 350628,
						area_name: "平和县",
						area_code: "Pinghe",
						area_parent_id: 350600
					},
					"350629": {
						id: 350629,
						area_name: "华安县",
						area_code: "Hua'an",
						area_parent_id: 350600
					},
					"350681": {
						id: 350681,
						area_name: "龙海市",
						area_code: "Longhai",
						area_parent_id: 350600
					}
				}
			},
			"350700": {
				id: 350700,
				area_name: "南平市",
				area_code: "Nanping",
				area_parent_id: 350000,
				child: {
					"350702": {
						id: 350702,
						area_name: "延平区",
						area_code: "Yanping",
						area_parent_id: 350700
					},
					"350703": {
						id: 350703,
						area_name: "建阳区",
						area_code: "Jianyang",
						area_parent_id: 350700
					},
					"350721": {
						id: 350721,
						area_name: "顺昌县",
						area_code: "Shunchang",
						area_parent_id: 350700
					},
					"350722": {
						id: 350722,
						area_name: "浦城县",
						area_code: "Pucheng",
						area_parent_id: 350700
					},
					"350723": {
						id: 350723,
						area_name: "光泽县",
						area_code: "Guangze",
						area_parent_id: 350700
					},
					"350724": {
						id: 350724,
						area_name: "松溪县",
						area_code: "Songxi",
						area_parent_id: 350700
					},
					"350725": {
						id: 350725,
						area_name: "政和县",
						area_code: "Zhenghe",
						area_parent_id: 350700
					},
					"350781": {
						id: 350781,
						area_name: "邵武市",
						area_code: "Shaowu",
						area_parent_id: 350700
					},
					"350782": {
						id: 350782,
						area_name: "武夷山市",
						area_code: "Wuyishan",
						area_parent_id: 350700
					},
					"350783": {
						id: 350783,
						area_name: "建瓯市",
						area_code: "Jianou",
						area_parent_id: 350700
					}
				}
			},
			"350800": {
				id: 350800,
				area_name: "龙岩市",
				area_code: "Longyan",
				area_parent_id: 350000,
				child: {
					"350802": {
						id: 350802,
						area_name: "新罗区",
						area_code: "Xinluo",
						area_parent_id: 350800
					},
					"350821": {
						id: 350821,
						area_name: "长汀县",
						area_code: "Changting",
						area_parent_id: 350800
					},
					"350822": {
						id: 350822,
						area_name: "永定区",
						area_code: "Yongding",
						area_parent_id: 350800
					},
					"350823": {
						id: 350823,
						area_name: "上杭县",
						area_code: "Shanghang",
						area_parent_id: 350800
					},
					"350824": {
						id: 350824,
						area_name: "武平县",
						area_code: "Wuping",
						area_parent_id: 350800
					},
					"350825": {
						id: 350825,
						area_name: "连城县",
						area_code: "Liancheng",
						area_parent_id: 350800
					},
					"350881": {
						id: 350881,
						area_name: "漳平市",
						area_code: "Zhangping",
						area_parent_id: 350800
					}
				}
			},
			"350900": {
				id: 350900,
				area_name: "宁德市",
				area_code: "Ningde",
				area_parent_id: 350000,
				child: {
					"350902": {
						id: 350902,
						area_name: "蕉城区",
						area_code: "Jiaocheng",
						area_parent_id: 350900
					},
					"350921": {
						id: 350921,
						area_name: "霞浦县",
						area_code: "Xiapu",
						area_parent_id: 350900
					},
					"350922": {
						id: 350922,
						area_name: "古田县",
						area_code: "Gutian",
						area_parent_id: 350900
					},
					"350923": {
						id: 350923,
						area_name: "屏南县",
						area_code: "Pingnan",
						area_parent_id: 350900
					},
					"350924": {
						id: 350924,
						area_name: "寿宁县",
						area_code: "Shouning",
						area_parent_id: 350900
					},
					"350925": {
						id: 350925,
						area_name: "周宁县",
						area_code: "Zhouning",
						area_parent_id: 350900
					},
					"350926": {
						id: 350926,
						area_name: "柘荣县",
						area_code: "Zherong",
						area_parent_id: 350900
					},
					"350981": {
						id: 350981,
						area_name: "福安市",
						area_code: "Fu'an",
						area_parent_id: 350900
					},
					"350982": {
						id: 350982,
						area_name: "福鼎市",
						area_code: "Fuding",
						area_parent_id: 350900
					}
				}
			}
		}
	},
	"360000": {
		id: 360000,
		area_name: "江西省",
		area_code: "Jiangxi",
		area_parent_id: 0,
		child: {
			"360100": {
				id: 360100,
				area_name: "南昌市",
				area_code: "Nanchang",
				area_parent_id: 360000,
				child: {
					"360102": {
						id: 360102,
						area_name: "东湖区",
						area_code: "Donghu",
						area_parent_id: 360100
					},
					"360103": {
						id: 360103,
						area_name: "西湖区",
						area_code: "Xihu",
						area_parent_id: 360100
					},
					"360104": {
						id: 360104,
						area_name: "青云谱区",
						area_code: "Qingyunpu",
						area_parent_id: 360100
					},
					"360105": {
						id: 360105,
						area_name: "湾里区",
						area_code: "Wanli",
						area_parent_id: 360100
					},
					"360111": {
						id: 360111,
						area_name: "青山湖区",
						area_code: "Qingshanhu",
						area_parent_id: 360100
					},
					"360121": {
						id: 360121,
						area_name: "南昌县",
						area_code: "Nanchang",
						area_parent_id: 360100
					},
					"360122": {
						id: 360122,
						area_name: "新建县",
						area_code: "Xinjian",
						area_parent_id: 360100
					},
					"360123": {
						id: 360123,
						area_name: "安义县",
						area_code: "Anyi",
						area_parent_id: 360100
					},
					"360124": {
						id: 360124,
						area_name: "进贤县",
						area_code: "Jinxian",
						area_parent_id: 360100
					}
				}
			},
			"360200": {
				id: 360200,
				area_name: "景德镇市",
				area_code: "Jingdezhen",
				area_parent_id: 360000,
				child: {
					"360202": {
						id: 360202,
						area_name: "昌江区",
						area_code: "Changjiang",
						area_parent_id: 360200
					},
					"360203": {
						id: 360203,
						area_name: "珠山区",
						area_code: "Zhushan",
						area_parent_id: 360200
					},
					"360222": {
						id: 360222,
						area_name: "浮梁县",
						area_code: "Fuliang",
						area_parent_id: 360200
					},
					"360281": {
						id: 360281,
						area_name: "乐平市",
						area_code: "Leping",
						area_parent_id: 360200
					}
				}
			},
			"360300": {
				id: 360300,
				area_name: "萍乡市",
				area_code: "Pingxiang",
				area_parent_id: 360000,
				child: {
					"360302": {
						id: 360302,
						area_name: "安源区",
						area_code: "Anyuan",
						area_parent_id: 360300
					},
					"360313": {
						id: 360313,
						area_name: "湘东区",
						area_code: "Xiangdong",
						area_parent_id: 360300
					},
					"360321": {
						id: 360321,
						area_name: "莲花县",
						area_code: "Lianhua",
						area_parent_id: 360300
					},
					"360322": {
						id: 360322,
						area_name: "上栗县",
						area_code: "Shangli",
						area_parent_id: 360300
					},
					"360323": {
						id: 360323,
						area_name: "芦溪县",
						area_code: "Luxi",
						area_parent_id: 360300
					}
				}
			},
			"360400": {
				id: 360400,
				area_name: "九江市",
				area_code: "Jiujiang",
				area_parent_id: 360000,
				child: {
					"360402": {
						id: 360402,
						area_name: "庐山区",
						area_code: "Lushan",
						area_parent_id: 360400
					},
					"360403": {
						id: 360403,
						area_name: "浔阳区",
						area_code: "Xunyang",
						area_parent_id: 360400
					},
					"360421": {
						id: 360421,
						area_name: "九江县",
						area_code: "Jiujiang",
						area_parent_id: 360400
					},
					"360423": {
						id: 360423,
						area_name: "武宁县",
						area_code: "Wuning",
						area_parent_id: 360400
					},
					"360424": {
						id: 360424,
						area_name: "修水县",
						area_code: "Xiushui",
						area_parent_id: 360400
					},
					"360425": {
						id: 360425,
						area_name: "永修县",
						area_code: "Yongxiu",
						area_parent_id: 360400
					},
					"360426": {
						id: 360426,
						area_name: "德安县",
						area_code: "De'an",
						area_parent_id: 360400
					},
					"360427": {
						id: 360427,
						area_name: "星子县",
						area_code: "Xingzi",
						area_parent_id: 360400
					},
					"360428": {
						id: 360428,
						area_name: "都昌县",
						area_code: "Duchang",
						area_parent_id: 360400
					},
					"360429": {
						id: 360429,
						area_name: "湖口县",
						area_code: "Hukou",
						area_parent_id: 360400
					},
					"360430": {
						id: 360430,
						area_name: "彭泽县",
						area_code: "Pengze",
						area_parent_id: 360400
					},
					"360481": {
						id: 360481,
						area_name: "瑞昌市",
						area_code: "Ruichang",
						area_parent_id: 360400
					},
					"360482": {
						id: 360482,
						area_name: "共青城市",
						area_code: "Gongqingcheng",
						area_parent_id: 360400
					}
				}
			},
			"360500": {
				id: 360500,
				area_name: "新余市",
				area_code: "Xinyu",
				area_parent_id: 360000,
				child: {
					"360502": {
						id: 360502,
						area_name: "渝水区",
						area_code: "Yushui",
						area_parent_id: 360500
					},
					"360521": {
						id: 360521,
						area_name: "分宜县",
						area_code: "Fenyi",
						area_parent_id: 360500
					}
				}
			},
			"360600": {
				id: 360600,
				area_name: "鹰潭市",
				area_code: "Yingtan",
				area_parent_id: 360000,
				child: {
					"360602": {
						id: 360602,
						area_name: "月湖区",
						area_code: "Yuehu",
						area_parent_id: 360600
					},
					"360622": {
						id: 360622,
						area_name: "余江县",
						area_code: "Yujiang",
						area_parent_id: 360600
					},
					"360681": {
						id: 360681,
						area_name: "贵溪市",
						area_code: "Guixi",
						area_parent_id: 360600
					}
				}
			},
			"360700": {
				id: 360700,
				area_name: "赣州市",
				area_code: "Ganzhou",
				area_parent_id: 360000,
				child: {
					"360702": {
						id: 360702,
						area_name: "章贡区",
						area_code: "Zhanggong",
						area_parent_id: 360700
					},
					"360703": {
						id: 360703,
						area_name: "南康区",
						area_code: "Nankang",
						area_parent_id: 360700
					},
					"360721": {
						id: 360721,
						area_name: "赣县",
						area_code: "Ganxian",
						area_parent_id: 360700
					},
					"360722": {
						id: 360722,
						area_name: "信丰县",
						area_code: "Xinfeng",
						area_parent_id: 360700
					},
					"360723": {
						id: 360723,
						area_name: "大余县",
						area_code: "Dayu",
						area_parent_id: 360700
					},
					"360724": {
						id: 360724,
						area_name: "上犹县",
						area_code: "Shangyou",
						area_parent_id: 360700
					},
					"360725": {
						id: 360725,
						area_name: "崇义县",
						area_code: "Chongyi",
						area_parent_id: 360700
					},
					"360726": {
						id: 360726,
						area_name: "安远县",
						area_code: "Anyuan",
						area_parent_id: 360700
					},
					"360727": {
						id: 360727,
						area_name: "龙南县",
						area_code: "Longnan",
						area_parent_id: 360700
					},
					"360728": {
						id: 360728,
						area_name: "定南县",
						area_code: "Dingnan",
						area_parent_id: 360700
					},
					"360729": {
						id: 360729,
						area_name: "全南县",
						area_code: "Quannan",
						area_parent_id: 360700
					},
					"360730": {
						id: 360730,
						area_name: "宁都县",
						area_code: "Ningdu",
						area_parent_id: 360700
					},
					"360731": {
						id: 360731,
						area_name: "于都县",
						area_code: "Yudu",
						area_parent_id: 360700
					},
					"360732": {
						id: 360732,
						area_name: "兴国县",
						area_code: "Xingguo",
						area_parent_id: 360700
					},
					"360733": {
						id: 360733,
						area_name: "会昌县",
						area_code: "Huichang",
						area_parent_id: 360700
					},
					"360734": {
						id: 360734,
						area_name: "寻乌县",
						area_code: "Xunwu",
						area_parent_id: 360700
					},
					"360735": {
						id: 360735,
						area_name: "石城县",
						area_code: "Shicheng",
						area_parent_id: 360700
					},
					"360781": {
						id: 360781,
						area_name: "瑞金市",
						area_code: "Ruijin",
						area_parent_id: 360700
					}
				}
			},
			"360800": {
				id: 360800,
				area_name: "吉安市",
				area_code: "Ji'an",
				area_parent_id: 360000,
				child: {
					"360802": {
						id: 360802,
						area_name: "吉州区",
						area_code: "Jizhou",
						area_parent_id: 360800
					},
					"360803": {
						id: 360803,
						area_name: "青原区",
						area_code: "Qingyuan",
						area_parent_id: 360800
					},
					"360821": {
						id: 360821,
						area_name: "吉安县",
						area_code: "Ji'an",
						area_parent_id: 360800
					},
					"360822": {
						id: 360822,
						area_name: "吉水县",
						area_code: "Jishui",
						area_parent_id: 360800
					},
					"360823": {
						id: 360823,
						area_name: "峡江县",
						area_code: "Xiajiang",
						area_parent_id: 360800
					},
					"360824": {
						id: 360824,
						area_name: "新干县",
						area_code: "Xingan",
						area_parent_id: 360800
					},
					"360825": {
						id: 360825,
						area_name: "永丰县",
						area_code: "Yongfeng",
						area_parent_id: 360800
					},
					"360826": {
						id: 360826,
						area_name: "泰和县",
						area_code: "Taihe",
						area_parent_id: 360800
					},
					"360827": {
						id: 360827,
						area_name: "遂川县",
						area_code: "Suichuan",
						area_parent_id: 360800
					},
					"360828": {
						id: 360828,
						area_name: "万安县",
						area_code: "Wan'an",
						area_parent_id: 360800
					},
					"360829": {
						id: 360829,
						area_name: "安福县",
						area_code: "Anfu",
						area_parent_id: 360800
					},
					"360830": {
						id: 360830,
						area_name: "永新县",
						area_code: "Yongxin",
						area_parent_id: 360800
					},
					"360881": {
						id: 360881,
						area_name: "井冈山市",
						area_code: "Jinggangshan",
						area_parent_id: 360800
					}
				}
			},
			"360900": {
				id: 360900,
				area_name: "宜春市",
				area_code: "Yichun",
				area_parent_id: 360000,
				child: {
					"360902": {
						id: 360902,
						area_name: "袁州区",
						area_code: "Yuanzhou",
						area_parent_id: 360900
					},
					"360921": {
						id: 360921,
						area_name: "奉新县",
						area_code: "Fengxin",
						area_parent_id: 360900
					},
					"360922": {
						id: 360922,
						area_name: "万载县",
						area_code: "Wanzai",
						area_parent_id: 360900
					},
					"360923": {
						id: 360923,
						area_name: "上高县",
						area_code: "Shanggao",
						area_parent_id: 360900
					},
					"360924": {
						id: 360924,
						area_name: "宜丰县",
						area_code: "Yifeng",
						area_parent_id: 360900
					},
					"360925": {
						id: 360925,
						area_name: "靖安县",
						area_code: "Jing'an",
						area_parent_id: 360900
					},
					"360926": {
						id: 360926,
						area_name: "铜鼓县",
						area_code: "Tonggu",
						area_parent_id: 360900
					},
					"360981": {
						id: 360981,
						area_name: "丰城市",
						area_code: "Fengcheng",
						area_parent_id: 360900
					},
					"360982": {
						id: 360982,
						area_name: "樟树市",
						area_code: "Zhangshu",
						area_parent_id: 360900
					},
					"360983": {
						id: 360983,
						area_name: "高安市",
						area_code: "Gao'an",
						area_parent_id: 360900
					}
				}
			},
			"361000": {
				id: 361000,
				area_name: "抚州市",
				area_code: "Fuzhou",
				area_parent_id: 360000,
				child: {
					"361002": {
						id: 361002,
						area_name: "临川区",
						area_code: "Linchuan",
						area_parent_id: 361000
					},
					"361021": {
						id: 361021,
						area_name: "南城县",
						area_code: "Nancheng",
						area_parent_id: 361000
					},
					"361022": {
						id: 361022,
						area_name: "黎川县",
						area_code: "Lichuan",
						area_parent_id: 361000
					},
					"361023": {
						id: 361023,
						area_name: "南丰县",
						area_code: "Nanfeng",
						area_parent_id: 361000
					},
					"361024": {
						id: 361024,
						area_name: "崇仁县",
						area_code: "Chongren",
						area_parent_id: 361000
					},
					"361025": {
						id: 361025,
						area_name: "乐安县",
						area_code: "Le'an",
						area_parent_id: 361000
					},
					"361026": {
						id: 361026,
						area_name: "宜黄县",
						area_code: "Yihuang",
						area_parent_id: 361000
					},
					"361027": {
						id: 361027,
						area_name: "金溪县",
						area_code: "Jinxi",
						area_parent_id: 361000
					},
					"361028": {
						id: 361028,
						area_name: "资溪县",
						area_code: "Zixi",
						area_parent_id: 361000
					},
					"361029": {
						id: 361029,
						area_name: "东乡县",
						area_code: "Dongxiang",
						area_parent_id: 361000
					},
					"361030": {
						id: 361030,
						area_name: "广昌县",
						area_code: "Guangchang",
						area_parent_id: 361000
					}
				}
			},
			"361100": {
				id: 361100,
				area_name: "上饶市",
				area_code: "Shangrao",
				area_parent_id: 360000,
				child: {
					"361102": {
						id: 361102,
						area_name: "信州区",
						area_code: "Xinzhou",
						area_parent_id: 361100
					},
					"361121": {
						id: 361121,
						area_name: "上饶县",
						area_code: "Shangrao",
						area_parent_id: 361100
					},
					"361122": {
						id: 361122,
						area_name: "广丰县",
						area_code: "Guangfeng",
						area_parent_id: 361100
					},
					"361123": {
						id: 361123,
						area_name: "玉山县",
						area_code: "Yushan",
						area_parent_id: 361100
					},
					"361124": {
						id: 361124,
						area_name: "铅山县",
						area_code: "Yanshan",
						area_parent_id: 361100
					},
					"361125": {
						id: 361125,
						area_name: "横峰县",
						area_code: "Hengfeng",
						area_parent_id: 361100
					},
					"361126": {
						id: 361126,
						area_name: "弋阳县",
						area_code: "Yiyang",
						area_parent_id: 361100
					},
					"361127": {
						id: 361127,
						area_name: "余干县",
						area_code: "Yugan",
						area_parent_id: 361100
					},
					"361128": {
						id: 361128,
						area_name: "鄱阳县",
						area_code: "Poyang",
						area_parent_id: 361100
					},
					"361129": {
						id: 361129,
						area_name: "万年县",
						area_code: "Wannian",
						area_parent_id: 361100
					},
					"361130": {
						id: 361130,
						area_name: "婺源县",
						area_code: "Wuyuan",
						area_parent_id: 361100
					},
					"361181": {
						id: 361181,
						area_name: "德兴市",
						area_code: "Dexing",
						area_parent_id: 361100
					}
				}
			}
		}
	},
	"370000": {
		id: 370000,
		area_name: "山东省",
		area_code: "Shandong",
		area_parent_id: 0,
		child: {
			"370100": {
				id: 370100,
				area_name: "济南市",
				area_code: "Jinan",
				area_parent_id: 370000,
				child: {
					"370102": {
						id: 370102,
						area_name: "历下区",
						area_code: "Lixia",
						area_parent_id: 370100
					},
					"370103": {
						id: 370103,
						area_name: "市中区",
						area_code: "Shizhongqu",
						area_parent_id: 370100
					},
					"370104": {
						id: 370104,
						area_name: "槐荫区",
						area_code: "Huaiyin",
						area_parent_id: 370100
					},
					"370105": {
						id: 370105,
						area_name: "天桥区",
						area_code: "Tianqiao",
						area_parent_id: 370100
					},
					"370112": {
						id: 370112,
						area_name: "历城区",
						area_code: "Licheng",
						area_parent_id: 370100
					},
					"370113": {
						id: 370113,
						area_name: "长清区",
						area_code: "Changqing",
						area_parent_id: 370100
					},
					"370124": {
						id: 370124,
						area_name: "平阴县",
						area_code: "Pingyin",
						area_parent_id: 370100
					},
					"370125": {
						id: 370125,
						area_name: "济阳县",
						area_code: "Jiyang",
						area_parent_id: 370100
					},
					"370126": {
						id: 370126,
						area_name: "商河县",
						area_code: "Shanghe",
						area_parent_id: 370100
					},
					"370181": {
						id: 370181,
						area_name: "章丘市",
						area_code: "Zhangqiu",
						area_parent_id: 370100
					}
				}
			},
			"370200": {
				id: 370200,
				area_name: "青岛市",
				area_code: "Qingdao",
				area_parent_id: 370000,
				child: {
					"370202": {
						id: 370202,
						area_name: "市南区",
						area_code: "Shinan",
						area_parent_id: 370200
					},
					"370203": {
						id: 370203,
						area_name: "市北区",
						area_code: "Shibei",
						area_parent_id: 370200
					},
					"370211": {
						id: 370211,
						area_name: "黄岛区",
						area_code: "Huangdao",
						area_parent_id: 370200
					},
					"370212": {
						id: 370212,
						area_name: "崂山区",
						area_code: "Laoshan",
						area_parent_id: 370200
					},
					"370213": {
						id: 370213,
						area_name: "李沧区",
						area_code: "Licang",
						area_parent_id: 370200
					},
					"370214": {
						id: 370214,
						area_name: "城阳区",
						area_code: "Chengyang",
						area_parent_id: 370200
					},
					"370281": {
						id: 370281,
						area_name: "胶州市",
						area_code: "Jiaozhou",
						area_parent_id: 370200
					},
					"370282": {
						id: 370282,
						area_name: "即墨市",
						area_code: "Jimo",
						area_parent_id: 370200
					},
					"370283": {
						id: 370283,
						area_name: "平度市",
						area_code: "Pingdu",
						area_parent_id: 370200
					},
					"370285": {
						id: 370285,
						area_name: "莱西市",
						area_code: "Laixi",
						area_parent_id: 370200
					},
					"370286": {
						id: 370286,
						area_name: "西海岸新区",
						area_code: "Xihai'an",
						area_parent_id: 370200
					}
				}
			},
			"370300": {
				id: 370300,
				area_name: "淄博市",
				area_code: "Zibo",
				area_parent_id: 370000,
				child: {
					"370302": {
						id: 370302,
						area_name: "淄川区",
						area_code: "Zichuan",
						area_parent_id: 370300
					},
					"370303": {
						id: 370303,
						area_name: "张店区",
						area_code: "Zhangdian",
						area_parent_id: 370300
					},
					"370304": {
						id: 370304,
						area_name: "博山区",
						area_code: "Boshan",
						area_parent_id: 370300
					},
					"370305": {
						id: 370305,
						area_name: "临淄区",
						area_code: "Linzi",
						area_parent_id: 370300
					},
					"370306": {
						id: 370306,
						area_name: "周村区",
						area_code: "Zhoucun",
						area_parent_id: 370300
					},
					"370321": {
						id: 370321,
						area_name: "桓台县",
						area_code: "Huantai",
						area_parent_id: 370300
					},
					"370322": {
						id: 370322,
						area_name: "高青县",
						area_code: "Gaoqing",
						area_parent_id: 370300
					},
					"370323": {
						id: 370323,
						area_name: "沂源县",
						area_code: "Yiyuan",
						area_parent_id: 370300
					}
				}
			},
			"370400": {
				id: 370400,
				area_name: "枣庄市",
				area_code: "Zaozhuang",
				area_parent_id: 370000,
				child: {
					"370402": {
						id: 370402,
						area_name: "市中区",
						area_code: "Shizhongqu",
						area_parent_id: 370400
					},
					"370403": {
						id: 370403,
						area_name: "薛城区",
						area_code: "Xuecheng",
						area_parent_id: 370400
					},
					"370404": {
						id: 370404,
						area_name: "峄城区",
						area_code: "Yicheng",
						area_parent_id: 370400
					},
					"370405": {
						id: 370405,
						area_name: "台儿庄区",
						area_code: "Taierzhuang",
						area_parent_id: 370400
					},
					"370406": {
						id: 370406,
						area_name: "山亭区",
						area_code: "Shanting",
						area_parent_id: 370400
					},
					"370481": {
						id: 370481,
						area_name: "滕州市",
						area_code: "Tengzhou",
						area_parent_id: 370400
					}
				}
			},
			"370500": {
				id: 370500,
				area_name: "东营市",
				area_code: "Dongying",
				area_parent_id: 370000,
				child: {
					"370502": {
						id: 370502,
						area_name: "东营区",
						area_code: "Dongying",
						area_parent_id: 370500
					},
					"370503": {
						id: 370503,
						area_name: "河口区",
						area_code: "Hekou",
						area_parent_id: 370500
					},
					"370521": {
						id: 370521,
						area_name: "垦利县",
						area_code: "Kenli",
						area_parent_id: 370500
					},
					"370522": {
						id: 370522,
						area_name: "利津县",
						area_code: "Lijin",
						area_parent_id: 370500
					},
					"370523": {
						id: 370523,
						area_name: "广饶县",
						area_code: "Guangrao",
						area_parent_id: 370500
					}
				}
			},
			"370600": {
				id: 370600,
				area_name: "烟台市",
				area_code: "Yantai",
				area_parent_id: 370000,
				child: {
					"370602": {
						id: 370602,
						area_name: "芝罘区",
						area_code: "Zhifu",
						area_parent_id: 370600
					},
					"370611": {
						id: 370611,
						area_name: "福山区",
						area_code: "Fushan",
						area_parent_id: 370600
					},
					"370612": {
						id: 370612,
						area_name: "牟平区",
						area_code: "Muping",
						area_parent_id: 370600
					},
					"370613": {
						id: 370613,
						area_name: "莱山区",
						area_code: "Laishan",
						area_parent_id: 370600
					},
					"370634": {
						id: 370634,
						area_name: "长岛县",
						area_code: "Changdao",
						area_parent_id: 370600
					},
					"370681": {
						id: 370681,
						area_name: "龙口市",
						area_code: "Longkou",
						area_parent_id: 370600
					},
					"370682": {
						id: 370682,
						area_name: "莱阳市",
						area_code: "Laiyang",
						area_parent_id: 370600
					},
					"370683": {
						id: 370683,
						area_name: "莱州市",
						area_code: "Laizhou",
						area_parent_id: 370600
					},
					"370684": {
						id: 370684,
						area_name: "蓬莱市",
						area_code: "Penglai",
						area_parent_id: 370600
					},
					"370685": {
						id: 370685,
						area_name: "招远市",
						area_code: "Zhaoyuan",
						area_parent_id: 370600
					},
					"370686": {
						id: 370686,
						area_name: "栖霞市",
						area_code: "Qixia",
						area_parent_id: 370600
					},
					"370687": {
						id: 370687,
						area_name: "海阳市",
						area_code: "Haiyang",
						area_parent_id: 370600
					}
				}
			},
			"370700": {
				id: 370700,
				area_name: "潍坊市",
				area_code: "Weifang",
				area_parent_id: 370000,
				child: {
					"370702": {
						id: 370702,
						area_name: "潍城区",
						area_code: "Weicheng",
						area_parent_id: 370700
					},
					"370703": {
						id: 370703,
						area_name: "寒亭区",
						area_code: "Hanting",
						area_parent_id: 370700
					},
					"370704": {
						id: 370704,
						area_name: "坊子区",
						area_code: "Fangzi",
						area_parent_id: 370700
					},
					"370705": {
						id: 370705,
						area_name: "奎文区",
						area_code: "Kuiwen",
						area_parent_id: 370700
					},
					"370724": {
						id: 370724,
						area_name: "临朐县",
						area_code: "Linqu",
						area_parent_id: 370700
					},
					"370725": {
						id: 370725,
						area_name: "昌乐县",
						area_code: "Changle",
						area_parent_id: 370700
					},
					"370781": {
						id: 370781,
						area_name: "青州市",
						area_code: "Qingzhou",
						area_parent_id: 370700
					},
					"370782": {
						id: 370782,
						area_name: "诸城市",
						area_code: "Zhucheng",
						area_parent_id: 370700
					},
					"370783": {
						id: 370783,
						area_name: "寿光市",
						area_code: "Shouguang",
						area_parent_id: 370700
					},
					"370784": {
						id: 370784,
						area_name: "安丘市",
						area_code: "Anqiu",
						area_parent_id: 370700
					},
					"370785": {
						id: 370785,
						area_name: "高密市",
						area_code: "Gaomi",
						area_parent_id: 370700
					},
					"370786": {
						id: 370786,
						area_name: "昌邑市",
						area_code: "Changyi",
						area_parent_id: 370700
					}
				}
			},
			"370800": {
				id: 370800,
				area_name: "济宁市",
				area_code: "Jining",
				area_parent_id: 370000,
				child: {
					"370811": {
						id: 370811,
						area_name: "任城区",
						area_code: "Rencheng",
						area_parent_id: 370800
					},
					"370812": {
						id: 370812,
						area_name: "兖州区",
						area_code: "Yanzhou ",
						area_parent_id: 370800
					},
					"370826": {
						id: 370826,
						area_name: "微山县",
						area_code: "Weishan",
						area_parent_id: 370800
					},
					"370827": {
						id: 370827,
						area_name: "鱼台县",
						area_code: "Yutai",
						area_parent_id: 370800
					},
					"370828": {
						id: 370828,
						area_name: "金乡县",
						area_code: "Jinxiang",
						area_parent_id: 370800
					},
					"370829": {
						id: 370829,
						area_name: "嘉祥县",
						area_code: "Jiaxiang",
						area_parent_id: 370800
					},
					"370830": {
						id: 370830,
						area_name: "汶上县",
						area_code: "Wenshang",
						area_parent_id: 370800
					},
					"370831": {
						id: 370831,
						area_name: "泗水县",
						area_code: "Sishui",
						area_parent_id: 370800
					},
					"370832": {
						id: 370832,
						area_name: "梁山县",
						area_code: "Liangshan",
						area_parent_id: 370800
					},
					"370881": {
						id: 370881,
						area_name: "曲阜市",
						area_code: "Qufu",
						area_parent_id: 370800
					},
					"370883": {
						id: 370883,
						area_name: "邹城市",
						area_code: "Zoucheng",
						area_parent_id: 370800
					}
				}
			},
			"370900": {
				id: 370900,
				area_name: "泰安市",
				area_code: "Tai'an",
				area_parent_id: 370000,
				child: {
					"370902": {
						id: 370902,
						area_name: "泰山区",
						area_code: "Taishan",
						area_parent_id: 370900
					},
					"370911": {
						id: 370911,
						area_name: "岱岳区",
						area_code: "Daiyue",
						area_parent_id: 370900
					},
					"370921": {
						id: 370921,
						area_name: "宁阳县",
						area_code: "Ningyang",
						area_parent_id: 370900
					},
					"370923": {
						id: 370923,
						area_name: "东平县",
						area_code: "Dongping",
						area_parent_id: 370900
					},
					"370982": {
						id: 370982,
						area_name: "新泰市",
						area_code: "Xintai",
						area_parent_id: 370900
					},
					"370983": {
						id: 370983,
						area_name: "肥城市",
						area_code: "Feicheng",
						area_parent_id: 370900
					}
				}
			},
			"371000": {
				id: 371000,
				area_name: "威海市",
				area_code: "Weihai",
				area_parent_id: 370000,
				child: {
					"371002": {
						id: 371002,
						area_name: "环翠区",
						area_code: "Huancui",
						area_parent_id: 371000
					},
					"371003": {
						id: 371003,
						area_name: "文登区",
						area_code: "Wendeng",
						area_parent_id: 371000
					},
					"371082": {
						id: 371082,
						area_name: "荣成市",
						area_code: "Rongcheng",
						area_parent_id: 371000
					},
					"371083": {
						id: 371083,
						area_name: "乳山市",
						area_code: "Rushan",
						area_parent_id: 371000
					}
				}
			},
			"371100": {
				id: 371100,
				area_name: "日照市",
				area_code: "Rizhao",
				area_parent_id: 370000,
				child: {
					"371102": {
						id: 371102,
						area_name: "东港区",
						area_code: "Donggang",
						area_parent_id: 371100
					},
					"371103": {
						id: 371103,
						area_name: "岚山区",
						area_code: "Lanshan",
						area_parent_id: 371100
					},
					"371121": {
						id: 371121,
						area_name: "五莲县",
						area_code: "Wulian",
						area_parent_id: 371100
					},
					"371122": {
						id: 371122,
						area_name: "莒县",
						area_code: "Juxian",
						area_parent_id: 371100
					}
				}
			},
			"371200": {
				id: 371200,
				area_name: "莱芜市",
				area_code: "Laiwu",
				area_parent_id: 370000,
				child: {
					"371202": {
						id: 371202,
						area_name: "莱城区",
						area_code: "Laicheng",
						area_parent_id: 371200
					},
					"371203": {
						id: 371203,
						area_name: "钢城区",
						area_code: "Gangcheng",
						area_parent_id: 371200
					}
				}
			},
			"371300": {
				id: 371300,
				area_name: "临沂市",
				area_code: "Linyi",
				area_parent_id: 370000,
				child: {
					"371302": {
						id: 371302,
						area_name: "兰山区",
						area_code: "Lanshan",
						area_parent_id: 371300
					},
					"371311": {
						id: 371311,
						area_name: "罗庄区",
						area_code: "Luozhuang",
						area_parent_id: 371300
					},
					"371312": {
						id: 371312,
						area_name: "河东区",
						area_code: "Hedong",
						area_parent_id: 371300
					},
					"371321": {
						id: 371321,
						area_name: "沂南县",
						area_code: "Yinan",
						area_parent_id: 371300
					},
					"371322": {
						id: 371322,
						area_name: "郯城县",
						area_code: "Tancheng",
						area_parent_id: 371300
					},
					"371323": {
						id: 371323,
						area_name: "沂水县",
						area_code: "Yishui",
						area_parent_id: 371300
					},
					"371324": {
						id: 371324,
						area_name: "兰陵县",
						area_code: "Lanling",
						area_parent_id: 371300
					},
					"371325": {
						id: 371325,
						area_name: "费县",
						area_code: "Feixian",
						area_parent_id: 371300
					},
					"371326": {
						id: 371326,
						area_name: "平邑县",
						area_code: "Pingyi",
						area_parent_id: 371300
					},
					"371327": {
						id: 371327,
						area_name: "莒南县",
						area_code: "Junan",
						area_parent_id: 371300
					},
					"371328": {
						id: 371328,
						area_name: "蒙阴县",
						area_code: "Mengyin",
						area_parent_id: 371300
					},
					"371329": {
						id: 371329,
						area_name: "临沭县",
						area_code: "Linshu",
						area_parent_id: 371300
					}
				}
			},
			"371400": {
				id: 371400,
				area_name: "德州市",
				area_code: "Dezhou",
				area_parent_id: 370000,
				child: {
					"371402": {
						id: 371402,
						area_name: "德城区",
						area_code: "Decheng",
						area_parent_id: 371400
					},
					"371403": {
						id: 371403,
						area_name: "陵城区",
						area_code: "Lingcheng",
						area_parent_id: 371400
					},
					"371422": {
						id: 371422,
						area_name: "宁津县",
						area_code: "Ningjin",
						area_parent_id: 371400
					},
					"371423": {
						id: 371423,
						area_name: "庆云县",
						area_code: "Qingyun",
						area_parent_id: 371400
					},
					"371424": {
						id: 371424,
						area_name: "临邑县",
						area_code: "Linyi",
						area_parent_id: 371400
					},
					"371425": {
						id: 371425,
						area_name: "齐河县",
						area_code: "Qihe",
						area_parent_id: 371400
					},
					"371426": {
						id: 371426,
						area_name: "平原县",
						area_code: "Pingyuan",
						area_parent_id: 371400
					},
					"371427": {
						id: 371427,
						area_name: "夏津县",
						area_code: "Xiajin",
						area_parent_id: 371400
					},
					"371428": {
						id: 371428,
						area_name: "武城县",
						area_code: "Wucheng",
						area_parent_id: 371400
					},
					"371481": {
						id: 371481,
						area_name: "乐陵市",
						area_code: "Leling",
						area_parent_id: 371400
					},
					"371482": {
						id: 371482,
						area_name: "禹城市",
						area_code: "Yucheng",
						area_parent_id: 371400
					}
				}
			},
			"371500": {
				id: 371500,
				area_name: "聊城市",
				area_code: "Liaocheng",
				area_parent_id: 370000,
				child: {
					"371502": {
						id: 371502,
						area_name: "东昌府区",
						area_code: "Dongchangfu",
						area_parent_id: 371500
					},
					"371521": {
						id: 371521,
						area_name: "阳谷县",
						area_code: "Yanggu",
						area_parent_id: 371500
					},
					"371522": {
						id: 371522,
						area_name: "莘县",
						area_code: "Shenxian",
						area_parent_id: 371500
					},
					"371523": {
						id: 371523,
						area_name: "茌平县",
						area_code: "Chiping",
						area_parent_id: 371500
					},
					"371524": {
						id: 371524,
						area_name: "东阿县",
						area_code: "Dong'e",
						area_parent_id: 371500
					},
					"371525": {
						id: 371525,
						area_name: "冠县",
						area_code: "Guanxian",
						area_parent_id: 371500
					},
					"371526": {
						id: 371526,
						area_name: "高唐县",
						area_code: "Gaotang",
						area_parent_id: 371500
					},
					"371581": {
						id: 371581,
						area_name: "临清市",
						area_code: "Linqing",
						area_parent_id: 371500
					}
				}
			},
			"371600": {
				id: 371600,
				area_name: "滨州市",
				area_code: "Binzhou",
				area_parent_id: 370000,
				child: {
					"371602": {
						id: 371602,
						area_name: "滨城区",
						area_code: "Bincheng",
						area_parent_id: 371600
					},
					"371603": {
						id: 371603,
						area_name: "沾化区",
						area_code: "Zhanhua",
						area_parent_id: 371600
					},
					"371621": {
						id: 371621,
						area_name: "惠民县",
						area_code: "Huimin",
						area_parent_id: 371600
					},
					"371622": {
						id: 371622,
						area_name: "阳信县",
						area_code: "Yangxin",
						area_parent_id: 371600
					},
					"371623": {
						id: 371623,
						area_name: "无棣县",
						area_code: "Wudi",
						area_parent_id: 371600
					},
					"371625": {
						id: 371625,
						area_name: "博兴县",
						area_code: "Boxing",
						area_parent_id: 371600
					},
					"371626": {
						id: 371626,
						area_name: "邹平县",
						area_code: "Zouping",
						area_parent_id: 371600
					},
					"371627": {
						id: 371627,
						area_name: "北海新区",
						area_code: "Beihaixinqu",
						area_parent_id: 371600
					}
				}
			},
			"371700": {
				id: 371700,
				area_name: "菏泽市",
				area_code: "Heze",
				area_parent_id: 370000,
				child: {
					"371702": {
						id: 371702,
						area_name: "牡丹区",
						area_code: "Mudan",
						area_parent_id: 371700
					},
					"371721": {
						id: 371721,
						area_name: "曹县",
						area_code: "Caoxian",
						area_parent_id: 371700
					},
					"371722": {
						id: 371722,
						area_name: "单县",
						area_code: "Shanxian",
						area_parent_id: 371700
					},
					"371723": {
						id: 371723,
						area_name: "成武县",
						area_code: "Chengwu",
						area_parent_id: 371700
					},
					"371724": {
						id: 371724,
						area_name: "巨野县",
						area_code: "Juye",
						area_parent_id: 371700
					},
					"371725": {
						id: 371725,
						area_name: "郓城县",
						area_code: "Yuncheng",
						area_parent_id: 371700
					},
					"371726": {
						id: 371726,
						area_name: "鄄城县",
						area_code: "Juancheng",
						area_parent_id: 371700
					},
					"371727": {
						id: 371727,
						area_name: "定陶县",
						area_code: "Dingtao",
						area_parent_id: 371700
					},
					"371728": {
						id: 371728,
						area_name: "东明县",
						area_code: "Dongming",
						area_parent_id: 371700
					}
				}
			}
		}
	},
	"410000": {
		id: 410000,
		area_name: "河南省",
		area_code: "Henan",
		area_parent_id: 0,
		child: {
			"410100": {
				id: 410100,
				area_name: "郑州市",
				area_code: "Zhengzhou",
				area_parent_id: 410000,
				child: {
					"410102": {
						id: 410102,
						area_name: "中原区",
						area_code: "Zhongyuan",
						area_parent_id: 410100
					},
					"410103": {
						id: 410103,
						area_name: "二七区",
						area_code: "Erqi",
						area_parent_id: 410100
					},
					"410104": {
						id: 410104,
						area_name: "管城回族区",
						area_code: "Guancheng",
						area_parent_id: 410100
					},
					"410105": {
						id: 410105,
						area_name: "金水区",
						area_code: "Jinshui",
						area_parent_id: 410100
					},
					"410106": {
						id: 410106,
						area_name: "上街区",
						area_code: "Shangjie",
						area_parent_id: 410100
					},
					"410108": {
						id: 410108,
						area_name: "惠济区",
						area_code: "Huiji",
						area_parent_id: 410100
					},
					"410122": {
						id: 410122,
						area_name: "中牟县",
						area_code: "Zhongmu",
						area_parent_id: 410100
					},
					"410181": {
						id: 410181,
						area_name: "巩义市",
						area_code: "Gongyi",
						area_parent_id: 410100
					},
					"410182": {
						id: 410182,
						area_name: "荥阳市",
						area_code: "Xingyang",
						area_parent_id: 410100
					},
					"410183": {
						id: 410183,
						area_name: "新密市",
						area_code: "Xinmi",
						area_parent_id: 410100
					},
					"410184": {
						id: 410184,
						area_name: "新郑市",
						area_code: "Xinzheng",
						area_parent_id: 410100
					},
					"410185": {
						id: 410185,
						area_name: "登封市",
						area_code: "Dengfeng",
						area_parent_id: 410100
					}
				}
			},
			"410200": {
				id: 410200,
				area_name: "开封市",
				area_code: "Kaifeng",
				area_parent_id: 410000,
				child: {
					"410202": {
						id: 410202,
						area_name: "龙亭区",
						area_code: "Longting",
						area_parent_id: 410200
					},
					"410203": {
						id: 410203,
						area_name: "顺河回族区",
						area_code: "Shunhe",
						area_parent_id: 410200
					},
					"410204": {
						id: 410204,
						area_name: "鼓楼区",
						area_code: "Gulou",
						area_parent_id: 410200
					},
					"410205": {
						id: 410205,
						area_name: "禹王台区",
						area_code: "Yuwangtai",
						area_parent_id: 410200
					},
					"410212": {
						id: 410212,
						area_name: "祥符区",
						area_code: "Xiangfu",
						area_parent_id: 410200
					},
					"410221": {
						id: 410221,
						area_name: "杞县",
						area_code: "Qixian",
						area_parent_id: 410200
					},
					"410222": {
						id: 410222,
						area_name: "通许县",
						area_code: "Tongxu",
						area_parent_id: 410200
					},
					"410223": {
						id: 410223,
						area_name: "尉氏县",
						area_code: "Weishi",
						area_parent_id: 410200
					},
					"410225": {
						id: 410225,
						area_name: "兰考县",
						area_code: "Lankao",
						area_parent_id: 410200
					}
				}
			},
			"410300": {
				id: 410300,
				area_name: "洛阳市",
				area_code: "Luoyang",
				area_parent_id: 410000,
				child: {
					"410302": {
						id: 410302,
						area_name: "老城区",
						area_code: "Laocheng",
						area_parent_id: 410300
					},
					"410303": {
						id: 410303,
						area_name: "西工区",
						area_code: "Xigong",
						area_parent_id: 410300
					},
					"410304": {
						id: 410304,
						area_name: "瀍河回族区",
						area_code: "Chanhe",
						area_parent_id: 410300
					},
					"410305": {
						id: 410305,
						area_name: "涧西区",
						area_code: "Jianxi",
						area_parent_id: 410300
					},
					"410306": {
						id: 410306,
						area_name: "吉利区",
						area_code: "Jili",
						area_parent_id: 410300
					},
					"410311": {
						id: 410311,
						area_name: "洛龙区",
						area_code: "Luolong",
						area_parent_id: 410300
					},
					"410322": {
						id: 410322,
						area_name: "孟津县",
						area_code: "Mengjin",
						area_parent_id: 410300
					},
					"410323": {
						id: 410323,
						area_name: "新安县",
						area_code: "Xin'an",
						area_parent_id: 410300
					},
					"410324": {
						id: 410324,
						area_name: "栾川县",
						area_code: "Luanchuan",
						area_parent_id: 410300
					},
					"410325": {
						id: 410325,
						area_name: "嵩县",
						area_code: "Songxian",
						area_parent_id: 410300
					},
					"410326": {
						id: 410326,
						area_name: "汝阳县",
						area_code: "Ruyang",
						area_parent_id: 410300
					},
					"410327": {
						id: 410327,
						area_name: "宜阳县",
						area_code: "Yiyang",
						area_parent_id: 410300
					},
					"410328": {
						id: 410328,
						area_name: "洛宁县",
						area_code: "Luoning",
						area_parent_id: 410300
					},
					"410329": {
						id: 410329,
						area_name: "伊川县",
						area_code: "Yichuan",
						area_parent_id: 410300
					},
					"410381": {
						id: 410381,
						area_name: "偃师市",
						area_code: "Yanshi",
						area_parent_id: 410300
					}
				}
			},
			"410400": {
				id: 410400,
				area_name: "平顶山市",
				area_code: "Pingdingshan",
				area_parent_id: 410000,
				child: {
					"410402": {
						id: 410402,
						area_name: "新华区",
						area_code: "Xinhua",
						area_parent_id: 410400
					},
					"410403": {
						id: 410403,
						area_name: "卫东区",
						area_code: "Weidong",
						area_parent_id: 410400
					},
					"410404": {
						id: 410404,
						area_name: "石龙区",
						area_code: "Shilong",
						area_parent_id: 410400
					},
					"410411": {
						id: 410411,
						area_name: "湛河区",
						area_code: "Zhanhe",
						area_parent_id: 410400
					},
					"410421": {
						id: 410421,
						area_name: "宝丰县",
						area_code: "Baofeng",
						area_parent_id: 410400
					},
					"410422": {
						id: 410422,
						area_name: "叶县",
						area_code: "Yexian",
						area_parent_id: 410400
					},
					"410423": {
						id: 410423,
						area_name: "鲁山县",
						area_code: "Lushan",
						area_parent_id: 410400
					},
					"410425": {
						id: 410425,
						area_name: "郏县",
						area_code: "Jiaxian",
						area_parent_id: 410400
					},
					"410481": {
						id: 410481,
						area_name: "舞钢市",
						area_code: "Wugang",
						area_parent_id: 410400
					},
					"410482": {
						id: 410482,
						area_name: "汝州市",
						area_code: "Ruzhou",
						area_parent_id: 410400
					}
				}
			},
			"410500": {
				id: 410500,
				area_name: "安阳市",
				area_code: "Anyang",
				area_parent_id: 410000,
				child: {
					"410502": {
						id: 410502,
						area_name: "文峰区",
						area_code: "Wenfeng",
						area_parent_id: 410500
					},
					"410503": {
						id: 410503,
						area_name: "北关区",
						area_code: "Beiguan",
						area_parent_id: 410500
					},
					"410505": {
						id: 410505,
						area_name: "殷都区",
						area_code: "Yindu",
						area_parent_id: 410500
					},
					"410506": {
						id: 410506,
						area_name: "龙安区",
						area_code: "Long'an",
						area_parent_id: 410500
					},
					"410522": {
						id: 410522,
						area_name: "安阳县",
						area_code: "Anyang",
						area_parent_id: 410500
					},
					"410523": {
						id: 410523,
						area_name: "汤阴县",
						area_code: "Tangyin",
						area_parent_id: 410500
					},
					"410526": {
						id: 410526,
						area_name: "滑县",
						area_code: "Huaxian",
						area_parent_id: 410500
					},
					"410527": {
						id: 410527,
						area_name: "内黄县",
						area_code: "Neihuang",
						area_parent_id: 410500
					},
					"410581": {
						id: 410581,
						area_name: "林州市",
						area_code: "Linzhou",
						area_parent_id: 410500
					}
				}
			},
			"410600": {
				id: 410600,
				area_name: "鹤壁市",
				area_code: "Hebi",
				area_parent_id: 410000,
				child: {
					"410602": {
						id: 410602,
						area_name: "鹤山区",
						area_code: "Heshan",
						area_parent_id: 410600
					},
					"410603": {
						id: 410603,
						area_name: "山城区",
						area_code: "Shancheng",
						area_parent_id: 410600
					},
					"410611": {
						id: 410611,
						area_name: "淇滨区",
						area_code: "Qibin",
						area_parent_id: 410600
					},
					"410621": {
						id: 410621,
						area_name: "浚县",
						area_code: "Xunxian",
						area_parent_id: 410600
					},
					"410622": {
						id: 410622,
						area_name: "淇县",
						area_code: "Qixian",
						area_parent_id: 410600
					}
				}
			},
			"410700": {
				id: 410700,
				area_name: "新乡市",
				area_code: "Xinxiang",
				area_parent_id: 410000,
				child: {
					"410702": {
						id: 410702,
						area_name: "红旗区",
						area_code: "Hongqi",
						area_parent_id: 410700
					},
					"410703": {
						id: 410703,
						area_name: "卫滨区",
						area_code: "Weibin",
						area_parent_id: 410700
					},
					"410704": {
						id: 410704,
						area_name: "凤泉区",
						area_code: "Fengquan",
						area_parent_id: 410700
					},
					"410711": {
						id: 410711,
						area_name: "牧野区",
						area_code: "Muye",
						area_parent_id: 410700
					},
					"410721": {
						id: 410721,
						area_name: "新乡县",
						area_code: "Xinxiang",
						area_parent_id: 410700
					},
					"410724": {
						id: 410724,
						area_name: "获嘉县",
						area_code: "Huojia",
						area_parent_id: 410700
					},
					"410725": {
						id: 410725,
						area_name: "原阳县",
						area_code: "Yuanyang",
						area_parent_id: 410700
					},
					"410726": {
						id: 410726,
						area_name: "延津县",
						area_code: "Yanjin",
						area_parent_id: 410700
					},
					"410727": {
						id: 410727,
						area_name: "封丘县",
						area_code: "Fengqiu",
						area_parent_id: 410700
					},
					"410728": {
						id: 410728,
						area_name: "长垣县",
						area_code: "Changyuan",
						area_parent_id: 410700
					},
					"410781": {
						id: 410781,
						area_name: "卫辉市",
						area_code: "Weihui",
						area_parent_id: 410700
					},
					"410782": {
						id: 410782,
						area_name: "辉县市",
						area_code: "Huixian",
						area_parent_id: 410700
					}
				}
			},
			"410800": {
				id: 410800,
				area_name: "焦作市",
				area_code: "Jiaozuo",
				area_parent_id: 410000,
				child: {
					"410802": {
						id: 410802,
						area_name: "解放区",
						area_code: "Jiefang",
						area_parent_id: 410800
					},
					"410803": {
						id: 410803,
						area_name: "中站区",
						area_code: "Zhongzhan",
						area_parent_id: 410800
					},
					"410804": {
						id: 410804,
						area_name: "马村区",
						area_code: "Macun",
						area_parent_id: 410800
					},
					"410811": {
						id: 410811,
						area_name: "山阳区",
						area_code: "Shanyang",
						area_parent_id: 410800
					},
					"410821": {
						id: 410821,
						area_name: "修武县",
						area_code: "Xiuwu",
						area_parent_id: 410800
					},
					"410822": {
						id: 410822,
						area_name: "博爱县",
						area_code: "Boai",
						area_parent_id: 410800
					},
					"410823": {
						id: 410823,
						area_name: "武陟县",
						area_code: "Wuzhi",
						area_parent_id: 410800
					},
					"410825": {
						id: 410825,
						area_name: "温县",
						area_code: "Wenxian",
						area_parent_id: 410800
					},
					"410882": {
						id: 410882,
						area_name: "沁阳市",
						area_code: "Qinyang",
						area_parent_id: 410800
					},
					"410883": {
						id: 410883,
						area_name: "孟州市",
						area_code: "Mengzhou",
						area_parent_id: 410800
					}
				}
			},
			"410900": {
				id: 410900,
				area_name: "濮阳市",
				area_code: "Puyang",
				area_parent_id: 410000,
				child: {
					"410902": {
						id: 410902,
						area_name: "华龙区",
						area_code: "Hualong",
						area_parent_id: 410900
					},
					"410922": {
						id: 410922,
						area_name: "清丰县",
						area_code: "Qingfeng",
						area_parent_id: 410900
					},
					"410923": {
						id: 410923,
						area_name: "南乐县",
						area_code: "Nanle",
						area_parent_id: 410900
					},
					"410926": {
						id: 410926,
						area_name: "范县",
						area_code: "Fanxian",
						area_parent_id: 410900
					},
					"410927": {
						id: 410927,
						area_name: "台前县",
						area_code: "Taiqian",
						area_parent_id: 410900
					},
					"410928": {
						id: 410928,
						area_name: "濮阳县",
						area_code: "Puyang",
						area_parent_id: 410900
					}
				}
			},
			"411000": {
				id: 411000,
				area_name: "许昌市",
				area_code: "Xuchang",
				area_parent_id: 410000,
				child: {
					"411002": {
						id: 411002,
						area_name: "魏都区",
						area_code: "Weidu",
						area_parent_id: 411000
					},
					"411023": {
						id: 411023,
						area_name: "许昌县",
						area_code: "Xuchang",
						area_parent_id: 411000
					},
					"411024": {
						id: 411024,
						area_name: "鄢陵县",
						area_code: "Yanling",
						area_parent_id: 411000
					},
					"411025": {
						id: 411025,
						area_name: "襄城县",
						area_code: "Xiangcheng",
						area_parent_id: 411000
					},
					"411081": {
						id: 411081,
						area_name: "禹州市",
						area_code: "Yuzhou",
						area_parent_id: 411000
					},
					"411082": {
						id: 411082,
						area_name: "长葛市",
						area_code: "Changge",
						area_parent_id: 411000
					}
				}
			},
			"411100": {
				id: 411100,
				area_name: "漯河市",
				area_code: "Luohe",
				area_parent_id: 410000,
				child: {
					"411102": {
						id: 411102,
						area_name: "源汇区",
						area_code: "Yuanhui",
						area_parent_id: 411100
					},
					"411103": {
						id: 411103,
						area_name: "郾城区",
						area_code: "Yancheng",
						area_parent_id: 411100
					},
					"411104": {
						id: 411104,
						area_name: "召陵区",
						area_code: "Zhaoling",
						area_parent_id: 411100
					},
					"411121": {
						id: 411121,
						area_name: "舞阳县",
						area_code: "Wuyang",
						area_parent_id: 411100
					},
					"411122": {
						id: 411122,
						area_name: "临颍县",
						area_code: "Linying",
						area_parent_id: 411100
					}
				}
			},
			"411200": {
				id: 411200,
				area_name: "三门峡市",
				area_code: "Sanmenxia",
				area_parent_id: 410000,
				child: {
					"411202": {
						id: 411202,
						area_name: "湖滨区",
						area_code: "Hubin",
						area_parent_id: 411200
					},
					"411221": {
						id: 411221,
						area_name: "渑池县",
						area_code: "Mianchi",
						area_parent_id: 411200
					},
					"411222": {
						id: 411222,
						area_name: "陕县",
						area_code: "Shanxian",
						area_parent_id: 411200
					},
					"411224": {
						id: 411224,
						area_name: "卢氏县",
						area_code: "Lushi",
						area_parent_id: 411200
					},
					"411281": {
						id: 411281,
						area_name: "义马市",
						area_code: "Yima",
						area_parent_id: 411200
					},
					"411282": {
						id: 411282,
						area_name: "灵宝市",
						area_code: "Lingbao",
						area_parent_id: 411200
					}
				}
			},
			"411300": {
				id: 411300,
				area_name: "南阳市",
				area_code: "Nanyang",
				area_parent_id: 410000,
				child: {
					"411302": {
						id: 411302,
						area_name: "宛城区",
						area_code: "Wancheng",
						area_parent_id: 411300
					},
					"411303": {
						id: 411303,
						area_name: "卧龙区",
						area_code: "Wolong",
						area_parent_id: 411300
					},
					"411321": {
						id: 411321,
						area_name: "南召县",
						area_code: "Nanzhao",
						area_parent_id: 411300
					},
					"411322": {
						id: 411322,
						area_name: "方城县",
						area_code: "Fangcheng",
						area_parent_id: 411300
					},
					"411323": {
						id: 411323,
						area_name: "西峡县",
						area_code: "Xixia",
						area_parent_id: 411300
					},
					"411324": {
						id: 411324,
						area_name: "镇平县",
						area_code: "Zhenping",
						area_parent_id: 411300
					},
					"411325": {
						id: 411325,
						area_name: "内乡县",
						area_code: "Neixiang",
						area_parent_id: 411300
					},
					"411326": {
						id: 411326,
						area_name: "淅川县",
						area_code: "Xichuan",
						area_parent_id: 411300
					},
					"411327": {
						id: 411327,
						area_name: "社旗县",
						area_code: "Sheqi",
						area_parent_id: 411300
					},
					"411328": {
						id: 411328,
						area_name: "唐河县",
						area_code: "Tanghe",
						area_parent_id: 411300
					},
					"411329": {
						id: 411329,
						area_name: "新野县",
						area_code: "Xinye",
						area_parent_id: 411300
					},
					"411330": {
						id: 411330,
						area_name: "桐柏县",
						area_code: "Tongbai",
						area_parent_id: 411300
					},
					"411381": {
						id: 411381,
						area_name: "邓州市",
						area_code: "Dengzhou",
						area_parent_id: 411300
					}
				}
			},
			"411400": {
				id: 411400,
				area_name: "商丘市",
				area_code: "Shangqiu",
				area_parent_id: 410000,
				child: {
					"411402": {
						id: 411402,
						area_name: "梁园区",
						area_code: "Liangyuan",
						area_parent_id: 411400
					},
					"411403": {
						id: 411403,
						area_name: "睢阳区",
						area_code: "Suiyang",
						area_parent_id: 411400
					},
					"411421": {
						id: 411421,
						area_name: "民权县",
						area_code: "Minquan",
						area_parent_id: 411400
					},
					"411422": {
						id: 411422,
						area_name: "睢县",
						area_code: "Suixian",
						area_parent_id: 411400
					},
					"411423": {
						id: 411423,
						area_name: "宁陵县",
						area_code: "Ningling",
						area_parent_id: 411400
					},
					"411424": {
						id: 411424,
						area_name: "柘城县",
						area_code: "Zhecheng",
						area_parent_id: 411400
					},
					"411425": {
						id: 411425,
						area_name: "虞城县",
						area_code: "Yucheng",
						area_parent_id: 411400
					},
					"411426": {
						id: 411426,
						area_name: "夏邑县",
						area_code: "Xiayi",
						area_parent_id: 411400
					},
					"411481": {
						id: 411481,
						area_name: "永城市",
						area_code: "Yongcheng",
						area_parent_id: 411400
					}
				}
			},
			"411500": {
				id: 411500,
				area_name: "信阳市",
				area_code: "Xinyang",
				area_parent_id: 410000,
				child: {
					"411502": {
						id: 411502,
						area_name: "浉河区",
						area_code: "Shihe",
						area_parent_id: 411500
					},
					"411503": {
						id: 411503,
						area_name: "平桥区",
						area_code: "Pingqiao",
						area_parent_id: 411500
					},
					"411521": {
						id: 411521,
						area_name: "罗山县",
						area_code: "Luoshan",
						area_parent_id: 411500
					},
					"411522": {
						id: 411522,
						area_name: "光山县",
						area_code: "Guangshan",
						area_parent_id: 411500
					},
					"411523": {
						id: 411523,
						area_name: "新县",
						area_code: "Xinxian",
						area_parent_id: 411500
					},
					"411524": {
						id: 411524,
						area_name: "商城县",
						area_code: "Shangcheng",
						area_parent_id: 411500
					},
					"411525": {
						id: 411525,
						area_name: "固始县",
						area_code: "Gushi",
						area_parent_id: 411500
					},
					"411526": {
						id: 411526,
						area_name: "潢川县",
						area_code: "Huangchuan",
						area_parent_id: 411500
					},
					"411527": {
						id: 411527,
						area_name: "淮滨县",
						area_code: "Huaibin",
						area_parent_id: 411500
					},
					"411528": {
						id: 411528,
						area_name: "息县",
						area_code: "Xixian",
						area_parent_id: 411500
					}
				}
			},
			"411600": {
				id: 411600,
				area_name: "周口市",
				area_code: "Zhoukou",
				area_parent_id: 410000,
				child: {
					"411602": {
						id: 411602,
						area_name: "川汇区",
						area_code: "Chuanhui",
						area_parent_id: 411600
					},
					"411621": {
						id: 411621,
						area_name: "扶沟县",
						area_code: "Fugou",
						area_parent_id: 411600
					},
					"411622": {
						id: 411622,
						area_name: "西华县",
						area_code: "Xihua",
						area_parent_id: 411600
					},
					"411623": {
						id: 411623,
						area_name: "商水县",
						area_code: "Shangshui",
						area_parent_id: 411600
					},
					"411624": {
						id: 411624,
						area_name: "沈丘县",
						area_code: "Shenqiu",
						area_parent_id: 411600
					},
					"411625": {
						id: 411625,
						area_name: "郸城县",
						area_code: "Dancheng",
						area_parent_id: 411600
					},
					"411626": {
						id: 411626,
						area_name: "淮阳县",
						area_code: "Huaiyang",
						area_parent_id: 411600
					},
					"411627": {
						id: 411627,
						area_name: "太康县",
						area_code: "Taikang",
						area_parent_id: 411600
					},
					"411628": {
						id: 411628,
						area_name: "鹿邑县",
						area_code: "Luyi",
						area_parent_id: 411600
					},
					"411681": {
						id: 411681,
						area_name: "项城市",
						area_code: "Xiangcheng",
						area_parent_id: 411600
					}
				}
			},
			"411700": {
				id: 411700,
				area_name: "驻马店市",
				area_code: "Zhumadian",
				area_parent_id: 410000,
				child: {
					"411702": {
						id: 411702,
						area_name: "驿城区",
						area_code: "Yicheng",
						area_parent_id: 411700
					},
					"411721": {
						id: 411721,
						area_name: "西平县",
						area_code: "Xiping",
						area_parent_id: 411700
					},
					"411722": {
						id: 411722,
						area_name: "上蔡县",
						area_code: "Shangcai",
						area_parent_id: 411700
					},
					"411723": {
						id: 411723,
						area_name: "平舆县",
						area_code: "Pingyu",
						area_parent_id: 411700
					},
					"411724": {
						id: 411724,
						area_name: "正阳县",
						area_code: "Zhengyang",
						area_parent_id: 411700
					},
					"411725": {
						id: 411725,
						area_name: "确山县",
						area_code: "Queshan",
						area_parent_id: 411700
					},
					"411726": {
						id: 411726,
						area_name: "泌阳县",
						area_code: "Biyang",
						area_parent_id: 411700
					},
					"411727": {
						id: 411727,
						area_name: "汝南县",
						area_code: "Runan",
						area_parent_id: 411700
					},
					"411728": {
						id: 411728,
						area_name: "遂平县",
						area_code: "Suiping",
						area_parent_id: 411700
					},
					"411729": {
						id: 411729,
						area_name: "新蔡县",
						area_code: "Xincai",
						area_parent_id: 411700
					}
				}
			},
			"419000": {
				id: 419000,
				area_name: "直辖县级",
				area_code: "",
				area_parent_id: 410000,
				child: {
					"419001": {
						id: 419001,
						area_name: "济源市",
						area_code: "Jiyuan",
						area_parent_id: 419000
					}
				}
			}
		}
	},
	"420000": {
		id: 420000,
		area_name: "湖北省",
		area_code: "Hubei",
		area_parent_id: 0,
		child: {
			"420100": {
				id: 420100,
				area_name: "武汉市",
				area_code: "Wuhan",
				area_parent_id: 420000,
				child: {
					"420102": {
						id: 420102,
						area_name: "江岸区",
						area_code: "Jiang'an",
						area_parent_id: 420100
					},
					"420103": {
						id: 420103,
						area_name: "江汉区",
						area_code: "Jianghan",
						area_parent_id: 420100
					},
					"420104": {
						id: 420104,
						area_name: "硚口区",
						area_code: "Qiaokou",
						area_parent_id: 420100
					},
					"420105": {
						id: 420105,
						area_name: "汉阳区",
						area_code: "Hanyang",
						area_parent_id: 420100
					},
					"420106": {
						id: 420106,
						area_name: "武昌区",
						area_code: "Wuchang",
						area_parent_id: 420100
					},
					"420107": {
						id: 420107,
						area_name: "青山区",
						area_code: "Qingshan",
						area_parent_id: 420100
					},
					"420111": {
						id: 420111,
						area_name: "洪山区",
						area_code: "Hongshan",
						area_parent_id: 420100
					},
					"420112": {
						id: 420112,
						area_name: "东西湖区",
						area_code: "Dongxihu",
						area_parent_id: 420100
					},
					"420113": {
						id: 420113,
						area_name: "汉南区",
						area_code: "Hannan",
						area_parent_id: 420100
					},
					"420114": {
						id: 420114,
						area_name: "蔡甸区",
						area_code: "Caidian",
						area_parent_id: 420100
					},
					"420115": {
						id: 420115,
						area_name: "江夏区",
						area_code: "Jiangxia",
						area_parent_id: 420100
					},
					"420116": {
						id: 420116,
						area_name: "黄陂区",
						area_code: "Huangpi",
						area_parent_id: 420100
					},
					"420117": {
						id: 420117,
						area_name: "新洲区",
						area_code: "Xinzhou",
						area_parent_id: 420100
					}
				}
			},
			"420200": {
				id: 420200,
				area_name: "黄石市",
				area_code: "Huangshi",
				area_parent_id: 420000,
				child: {
					"420202": {
						id: 420202,
						area_name: "黄石港区",
						area_code: "Huangshigang",
						area_parent_id: 420200
					},
					"420203": {
						id: 420203,
						area_name: "西塞山区",
						area_code: "Xisaishan",
						area_parent_id: 420200
					},
					"420204": {
						id: 420204,
						area_name: "下陆区",
						area_code: "Xialu",
						area_parent_id: 420200
					},
					"420205": {
						id: 420205,
						area_name: "铁山区",
						area_code: "Tieshan",
						area_parent_id: 420200
					},
					"420222": {
						id: 420222,
						area_name: "阳新县",
						area_code: "Yangxin",
						area_parent_id: 420200
					},
					"420281": {
						id: 420281,
						area_name: "大冶市",
						area_code: "Daye",
						area_parent_id: 420200
					}
				}
			},
			"420300": {
				id: 420300,
				area_name: "十堰市",
				area_code: "Shiyan",
				area_parent_id: 420000,
				child: {
					"420302": {
						id: 420302,
						area_name: "茅箭区",
						area_code: "Maojian",
						area_parent_id: 420300
					},
					"420303": {
						id: 420303,
						area_name: "张湾区",
						area_code: "Zhangwan",
						area_parent_id: 420300
					},
					"420304": {
						id: 420304,
						area_name: "郧阳区",
						area_code: "Yunyang",
						area_parent_id: 420300
					},
					"420322": {
						id: 420322,
						area_name: "郧西县",
						area_code: "Yunxi",
						area_parent_id: 420300
					},
					"420323": {
						id: 420323,
						area_name: "竹山县",
						area_code: "Zhushan",
						area_parent_id: 420300
					},
					"420324": {
						id: 420324,
						area_name: "竹溪县",
						area_code: "Zhuxi",
						area_parent_id: 420300
					},
					"420325": {
						id: 420325,
						area_name: "房县",
						area_code: "Fangxian",
						area_parent_id: 420300
					},
					"420381": {
						id: 420381,
						area_name: "丹江口市",
						area_code: "Danjiangkou",
						area_parent_id: 420300
					}
				}
			},
			"420500": {
				id: 420500,
				area_name: "宜昌市",
				area_code: "Yichang",
				area_parent_id: 420000,
				child: {
					"420502": {
						id: 420502,
						area_name: "西陵区",
						area_code: "Xiling",
						area_parent_id: 420500
					},
					"420503": {
						id: 420503,
						area_name: "伍家岗区",
						area_code: "Wujiagang",
						area_parent_id: 420500
					},
					"420504": {
						id: 420504,
						area_name: "点军区",
						area_code: "Dianjun",
						area_parent_id: 420500
					},
					"420505": {
						id: 420505,
						area_name: "猇亭区",
						area_code: "Xiaoting",
						area_parent_id: 420500
					},
					"420506": {
						id: 420506,
						area_name: "夷陵区",
						area_code: "Yiling",
						area_parent_id: 420500
					},
					"420525": {
						id: 420525,
						area_name: "远安县",
						area_code: "Yuan'an",
						area_parent_id: 420500
					},
					"420526": {
						id: 420526,
						area_name: "兴山县",
						area_code: "Xingshan",
						area_parent_id: 420500
					},
					"420527": {
						id: 420527,
						area_name: "秭归县",
						area_code: "Zigui",
						area_parent_id: 420500
					},
					"420528": {
						id: 420528,
						area_name: "长阳土家族自治县",
						area_code: "Changyang",
						area_parent_id: 420500
					},
					"420529": {
						id: 420529,
						area_name: "五峰土家族自治县",
						area_code: "Wufeng",
						area_parent_id: 420500
					},
					"420581": {
						id: 420581,
						area_name: "宜都市",
						area_code: "Yidu",
						area_parent_id: 420500
					},
					"420582": {
						id: 420582,
						area_name: "当阳市",
						area_code: "Dangyang",
						area_parent_id: 420500
					},
					"420583": {
						id: 420583,
						area_name: "枝江市",
						area_code: "Zhijiang",
						area_parent_id: 420500
					}
				}
			},
			"420600": {
				id: 420600,
				area_name: "襄阳市",
				area_code: "Xiangyang",
				area_parent_id: 420000,
				child: {
					"420602": {
						id: 420602,
						area_name: "襄城区",
						area_code: "Xiangcheng",
						area_parent_id: 420600
					},
					"420606": {
						id: 420606,
						area_name: "樊城区",
						area_code: "Fancheng",
						area_parent_id: 420600
					},
					"420607": {
						id: 420607,
						area_name: "襄州区",
						area_code: "Xiangzhou",
						area_parent_id: 420600
					},
					"420624": {
						id: 420624,
						area_name: "南漳县",
						area_code: "Nanzhang",
						area_parent_id: 420600
					},
					"420625": {
						id: 420625,
						area_name: "谷城县",
						area_code: "Gucheng",
						area_parent_id: 420600
					},
					"420626": {
						id: 420626,
						area_name: "保康县",
						area_code: "Baokang",
						area_parent_id: 420600
					},
					"420682": {
						id: 420682,
						area_name: "老河口市",
						area_code: "Laohekou",
						area_parent_id: 420600
					},
					"420683": {
						id: 420683,
						area_name: "枣阳市",
						area_code: "Zaoyang",
						area_parent_id: 420600
					},
					"420684": {
						id: 420684,
						area_name: "宜城市",
						area_code: "Yicheng",
						area_parent_id: 420600
					}
				}
			},
			"420700": {
				id: 420700,
				area_name: "鄂州市",
				area_code: "Ezhou",
				area_parent_id: 420000,
				child: {
					"420702": {
						id: 420702,
						area_name: "梁子湖区",
						area_code: "Liangzihu",
						area_parent_id: 420700
					},
					"420703": {
						id: 420703,
						area_name: "华容区",
						area_code: "Huarong",
						area_parent_id: 420700
					},
					"420704": {
						id: 420704,
						area_name: "鄂城区",
						area_code: "Echeng",
						area_parent_id: 420700
					}
				}
			},
			"420800": {
				id: 420800,
				area_name: "荆门市",
				area_code: "Jingmen",
				area_parent_id: 420000,
				child: {
					"420802": {
						id: 420802,
						area_name: "东宝区",
						area_code: "Dongbao",
						area_parent_id: 420800
					},
					"420804": {
						id: 420804,
						area_name: "掇刀区",
						area_code: "Duodao",
						area_parent_id: 420800
					},
					"420821": {
						id: 420821,
						area_name: "京山县",
						area_code: "Jingshan",
						area_parent_id: 420800
					},
					"420822": {
						id: 420822,
						area_name: "沙洋县",
						area_code: "Shayang",
						area_parent_id: 420800
					},
					"420881": {
						id: 420881,
						area_name: "钟祥市",
						area_code: "Zhongxiang",
						area_parent_id: 420800
					}
				}
			},
			"420900": {
				id: 420900,
				area_name: "孝感市",
				area_code: "Xiaogan",
				area_parent_id: 420000,
				child: {
					"420902": {
						id: 420902,
						area_name: "孝南区",
						area_code: "Xiaonan",
						area_parent_id: 420900
					},
					"420921": {
						id: 420921,
						area_name: "孝昌县",
						area_code: "Xiaochang",
						area_parent_id: 420900
					},
					"420922": {
						id: 420922,
						area_name: "大悟县",
						area_code: "Dawu",
						area_parent_id: 420900
					},
					"420923": {
						id: 420923,
						area_name: "云梦县",
						area_code: "Yunmeng",
						area_parent_id: 420900
					},
					"420981": {
						id: 420981,
						area_name: "应城市",
						area_code: "Yingcheng",
						area_parent_id: 420900
					},
					"420982": {
						id: 420982,
						area_name: "安陆市",
						area_code: "Anlu",
						area_parent_id: 420900
					},
					"420984": {
						id: 420984,
						area_name: "汉川市",
						area_code: "Hanchuan",
						area_parent_id: 420900
					}
				}
			},
			"421000": {
				id: 421000,
				area_name: "荆州市",
				area_code: "Jingzhou",
				area_parent_id: 420000,
				child: {
					"421002": {
						id: 421002,
						area_name: "沙市区",
						area_code: "Shashi",
						area_parent_id: 421000
					},
					"421003": {
						id: 421003,
						area_name: "荆州区",
						area_code: "Jingzhou",
						area_parent_id: 421000
					},
					"421022": {
						id: 421022,
						area_name: "公安县",
						area_code: "Gong'an",
						area_parent_id: 421000
					},
					"421023": {
						id: 421023,
						area_name: "监利县",
						area_code: "Jianli",
						area_parent_id: 421000
					},
					"421024": {
						id: 421024,
						area_name: "江陵县",
						area_code: "Jiangling",
						area_parent_id: 421000
					},
					"421081": {
						id: 421081,
						area_name: "石首市",
						area_code: "Shishou",
						area_parent_id: 421000
					},
					"421083": {
						id: 421083,
						area_name: "洪湖市",
						area_code: "Honghu",
						area_parent_id: 421000
					},
					"421087": {
						id: 421087,
						area_name: "松滋市",
						area_code: "Songzi",
						area_parent_id: 421000
					}
				}
			},
			"421100": {
				id: 421100,
				area_name: "黄冈市",
				area_code: "Huanggang",
				area_parent_id: 420000,
				child: {
					"421102": {
						id: 421102,
						area_name: "黄州区",
						area_code: "Huangzhou",
						area_parent_id: 421100
					},
					"421121": {
						id: 421121,
						area_name: "团风县",
						area_code: "Tuanfeng",
						area_parent_id: 421100
					},
					"421122": {
						id: 421122,
						area_name: "红安县",
						area_code: "Hong'an",
						area_parent_id: 421100
					},
					"421123": {
						id: 421123,
						area_name: "罗田县",
						area_code: "Luotian",
						area_parent_id: 421100
					},
					"421124": {
						id: 421124,
						area_name: "英山县",
						area_code: "Yingshan",
						area_parent_id: 421100
					},
					"421125": {
						id: 421125,
						area_name: "浠水县",
						area_code: "Xishui",
						area_parent_id: 421100
					},
					"421126": {
						id: 421126,
						area_name: "蕲春县",
						area_code: "Qichun",
						area_parent_id: 421100
					},
					"421127": {
						id: 421127,
						area_name: "黄梅县",
						area_code: "Huangmei",
						area_parent_id: 421100
					},
					"421181": {
						id: 421181,
						area_name: "麻城市",
						area_code: "Macheng",
						area_parent_id: 421100
					},
					"421182": {
						id: 421182,
						area_name: "武穴市",
						area_code: "Wuxue",
						area_parent_id: 421100
					}
				}
			},
			"421200": {
				id: 421200,
				area_name: "咸宁市",
				area_code: "Xianning",
				area_parent_id: 420000,
				child: {
					"421202": {
						id: 421202,
						area_name: "咸安区",
						area_code: "Xian'an",
						area_parent_id: 421200
					},
					"421221": {
						id: 421221,
						area_name: "嘉鱼县",
						area_code: "Jiayu",
						area_parent_id: 421200
					},
					"421222": {
						id: 421222,
						area_name: "通城县",
						area_code: "Tongcheng",
						area_parent_id: 421200
					},
					"421223": {
						id: 421223,
						area_name: "崇阳县",
						area_code: "Chongyang",
						area_parent_id: 421200
					},
					"421224": {
						id: 421224,
						area_name: "通山县",
						area_code: "Tongshan",
						area_parent_id: 421200
					},
					"421281": {
						id: 421281,
						area_name: "赤壁市",
						area_code: "Chibi",
						area_parent_id: 421200
					}
				}
			},
			"421300": {
				id: 421300,
				area_name: "随州市",
				area_code: "Suizhou",
				area_parent_id: 420000,
				child: {
					"421303": {
						id: 421303,
						area_name: "曾都区",
						area_code: "Zengdu",
						area_parent_id: 421300
					},
					"421321": {
						id: 421321,
						area_name: "随县",
						area_code: "Suixian",
						area_parent_id: 421300
					},
					"421381": {
						id: 421381,
						area_name: "广水市",
						area_code: "Guangshui",
						area_parent_id: 421300
					}
				}
			},
			"422800": {
				id: 422800,
				area_name: "恩施土家族苗族自治州",
				area_code: "Enshi",
				area_parent_id: 420000,
				child: {
					"422801": {
						id: 422801,
						area_name: "恩施市",
						area_code: "Enshi",
						area_parent_id: 422800
					},
					"422802": {
						id: 422802,
						area_name: "利川市",
						area_code: "Lichuan",
						area_parent_id: 422800
					},
					"422822": {
						id: 422822,
						area_name: "建始县",
						area_code: "Jianshi",
						area_parent_id: 422800
					},
					"422823": {
						id: 422823,
						area_name: "巴东县",
						area_code: "Badong",
						area_parent_id: 422800
					},
					"422825": {
						id: 422825,
						area_name: "宣恩县",
						area_code: "Xuanen",
						area_parent_id: 422800
					},
					"422826": {
						id: 422826,
						area_name: "咸丰县",
						area_code: "Xianfeng",
						area_parent_id: 422800
					},
					"422827": {
						id: 422827,
						area_name: "来凤县",
						area_code: "Laifeng",
						area_parent_id: 422800
					},
					"422828": {
						id: 422828,
						area_name: "鹤峰县",
						area_code: "Hefeng",
						area_parent_id: 422800
					}
				}
			},
			"429000": {
				id: 429000,
				area_name: "直辖县级",
				area_code: "",
				area_parent_id: 420000,
				child: {
					"429004": {
						id: 429004,
						area_name: "仙桃市",
						area_code: "Xiantao",
						area_parent_id: 429000
					},
					"429005": {
						id: 429005,
						area_name: "潜江市",
						area_code: "Qianjiang",
						area_parent_id: 429000
					},
					"429006": {
						id: 429006,
						area_name: "天门市",
						area_code: "Tianmen",
						area_parent_id: 429000
					},
					"429021": {
						id: 429021,
						area_name: "神农架林区",
						area_code: "Shennongjia",
						area_parent_id: 429000
					}
				}
			}
		}
	},
	"430000": {
		id: 430000,
		area_name: "湖南省",
		area_code: "Hunan",
		area_parent_id: 0,
		child: {
			"430100": {
				id: 430100,
				area_name: "长沙市",
				area_code: "Changsha",
				area_parent_id: 430000,
				child: {
					"430102": {
						id: 430102,
						area_name: "芙蓉区",
						area_code: "Furong",
						area_parent_id: 430100
					},
					"430103": {
						id: 430103,
						area_name: "天心区",
						area_code: "Tianxin",
						area_parent_id: 430100
					},
					"430104": {
						id: 430104,
						area_name: "岳麓区",
						area_code: "Yuelu",
						area_parent_id: 430100
					},
					"430105": {
						id: 430105,
						area_name: "开福区",
						area_code: "Kaifu",
						area_parent_id: 430100
					},
					"430111": {
						id: 430111,
						area_name: "雨花区",
						area_code: "Yuhua",
						area_parent_id: 430100
					},
					"430112": {
						id: 430112,
						area_name: "望城区",
						area_code: "Wangcheng",
						area_parent_id: 430100
					},
					"430121": {
						id: 430121,
						area_name: "长沙县",
						area_code: "Changsha",
						area_parent_id: 430100
					},
					"430124": {
						id: 430124,
						area_name: "宁乡县",
						area_code: "Ningxiang",
						area_parent_id: 430100
					},
					"430181": {
						id: 430181,
						area_name: "浏阳市",
						area_code: "Liuyang",
						area_parent_id: 430100
					}
				}
			},
			"430200": {
				id: 430200,
				area_name: "株洲市",
				area_code: "Zhuzhou",
				area_parent_id: 430000,
				child: {
					"430202": {
						id: 430202,
						area_name: "荷塘区",
						area_code: "Hetang",
						area_parent_id: 430200
					},
					"430203": {
						id: 430203,
						area_name: "芦淞区",
						area_code: "Lusong",
						area_parent_id: 430200
					},
					"430204": {
						id: 430204,
						area_name: "石峰区",
						area_code: "Shifeng",
						area_parent_id: 430200
					},
					"430211": {
						id: 430211,
						area_name: "天元区",
						area_code: "Tianyuan",
						area_parent_id: 430200
					},
					"430221": {
						id: 430221,
						area_name: "株洲县",
						area_code: "Zhuzhou",
						area_parent_id: 430200
					},
					"430223": {
						id: 430223,
						area_name: "攸县",
						area_code: "Youxian",
						area_parent_id: 430200
					},
					"430224": {
						id: 430224,
						area_name: "茶陵县",
						area_code: "Chaling",
						area_parent_id: 430200
					},
					"430225": {
						id: 430225,
						area_name: "炎陵县",
						area_code: "Yanling",
						area_parent_id: 430200
					},
					"430281": {
						id: 430281,
						area_name: "醴陵市",
						area_code: "Liling",
						area_parent_id: 430200
					}
				}
			},
			"430300": {
				id: 430300,
				area_name: "湘潭市",
				area_code: "Xiangtan",
				area_parent_id: 430000,
				child: {
					"430302": {
						id: 430302,
						area_name: "雨湖区",
						area_code: "Yuhu",
						area_parent_id: 430300
					},
					"430304": {
						id: 430304,
						area_name: "岳塘区",
						area_code: "Yuetang",
						area_parent_id: 430300
					},
					"430321": {
						id: 430321,
						area_name: "湘潭县",
						area_code: "Xiangtan",
						area_parent_id: 430300
					},
					"430381": {
						id: 430381,
						area_name: "湘乡市",
						area_code: "Xiangxiang",
						area_parent_id: 430300
					},
					"430382": {
						id: 430382,
						area_name: "韶山市",
						area_code: "Shaoshan",
						area_parent_id: 430300
					}
				}
			},
			"430400": {
				id: 430400,
				area_name: "衡阳市",
				area_code: "Hengyang",
				area_parent_id: 430000,
				child: {
					"430405": {
						id: 430405,
						area_name: "珠晖区",
						area_code: "Zhuhui",
						area_parent_id: 430400
					},
					"430406": {
						id: 430406,
						area_name: "雁峰区",
						area_code: "Yanfeng",
						area_parent_id: 430400
					},
					"430407": {
						id: 430407,
						area_name: "石鼓区",
						area_code: "Shigu",
						area_parent_id: 430400
					},
					"430408": {
						id: 430408,
						area_name: "蒸湘区",
						area_code: "Zhengxiang",
						area_parent_id: 430400
					},
					"430412": {
						id: 430412,
						area_name: "南岳区",
						area_code: "Nanyue",
						area_parent_id: 430400
					},
					"430421": {
						id: 430421,
						area_name: "衡阳县",
						area_code: "Hengyang",
						area_parent_id: 430400
					},
					"430422": {
						id: 430422,
						area_name: "衡南县",
						area_code: "Hengnan",
						area_parent_id: 430400
					},
					"430423": {
						id: 430423,
						area_name: "衡山县",
						area_code: "Hengshan",
						area_parent_id: 430400
					},
					"430424": {
						id: 430424,
						area_name: "衡东县",
						area_code: "Hengdong",
						area_parent_id: 430400
					},
					"430426": {
						id: 430426,
						area_name: "祁东县",
						area_code: "Qidong",
						area_parent_id: 430400
					},
					"430481": {
						id: 430481,
						area_name: "耒阳市",
						area_code: "Leiyang",
						area_parent_id: 430400
					},
					"430482": {
						id: 430482,
						area_name: "常宁市",
						area_code: "Changning",
						area_parent_id: 430400
					}
				}
			},
			"430500": {
				id: 430500,
				area_name: "邵阳市",
				area_code: "Shaoyang",
				area_parent_id: 430000,
				child: {
					"430502": {
						id: 430502,
						area_name: "双清区",
						area_code: "Shuangqing",
						area_parent_id: 430500
					},
					"430503": {
						id: 430503,
						area_name: "大祥区",
						area_code: "Daxiang",
						area_parent_id: 430500
					},
					"430511": {
						id: 430511,
						area_name: "北塔区",
						area_code: "Beita",
						area_parent_id: 430500
					},
					"430521": {
						id: 430521,
						area_name: "邵东县",
						area_code: "Shaodong",
						area_parent_id: 430500
					},
					"430522": {
						id: 430522,
						area_name: "新邵县",
						area_code: "Xinshao",
						area_parent_id: 430500
					},
					"430523": {
						id: 430523,
						area_name: "邵阳县",
						area_code: "Shaoyang",
						area_parent_id: 430500
					},
					"430524": {
						id: 430524,
						area_name: "隆回县",
						area_code: "Longhui",
						area_parent_id: 430500
					},
					"430525": {
						id: 430525,
						area_name: "洞口县",
						area_code: "Dongkou",
						area_parent_id: 430500
					},
					"430527": {
						id: 430527,
						area_name: "绥宁县",
						area_code: "Suining",
						area_parent_id: 430500
					},
					"430528": {
						id: 430528,
						area_name: "新宁县",
						area_code: "Xinning",
						area_parent_id: 430500
					},
					"430529": {
						id: 430529,
						area_name: "城步苗族自治县",
						area_code: "Chengbu",
						area_parent_id: 430500
					},
					"430581": {
						id: 430581,
						area_name: "武冈市",
						area_code: "Wugang",
						area_parent_id: 430500
					}
				}
			},
			"430600": {
				id: 430600,
				area_name: "岳阳市",
				area_code: "Yueyang",
				area_parent_id: 430000,
				child: {
					"430602": {
						id: 430602,
						area_name: "岳阳楼区",
						area_code: "Yueyanglou",
						area_parent_id: 430600
					},
					"430603": {
						id: 430603,
						area_name: "云溪区",
						area_code: "Yunxi",
						area_parent_id: 430600
					},
					"430611": {
						id: 430611,
						area_name: "君山区",
						area_code: "Junshan",
						area_parent_id: 430600
					},
					"430621": {
						id: 430621,
						area_name: "岳阳县",
						area_code: "Yueyang",
						area_parent_id: 430600
					},
					"430623": {
						id: 430623,
						area_name: "华容县",
						area_code: "Huarong",
						area_parent_id: 430600
					},
					"430624": {
						id: 430624,
						area_name: "湘阴县",
						area_code: "Xiangyin",
						area_parent_id: 430600
					},
					"430626": {
						id: 430626,
						area_name: "平江县",
						area_code: "Pingjiang",
						area_parent_id: 430600
					},
					"430681": {
						id: 430681,
						area_name: "汨罗市",
						area_code: "Miluo",
						area_parent_id: 430600
					},
					"430682": {
						id: 430682,
						area_name: "临湘市",
						area_code: "Linxiang",
						area_parent_id: 430600
					}
				}
			},
			"430700": {
				id: 430700,
				area_name: "常德市",
				area_code: "Changde",
				area_parent_id: 430000,
				child: {
					"430702": {
						id: 430702,
						area_name: "武陵区",
						area_code: "Wuling",
						area_parent_id: 430700
					},
					"430703": {
						id: 430703,
						area_name: "鼎城区",
						area_code: "Dingcheng",
						area_parent_id: 430700
					},
					"430721": {
						id: 430721,
						area_name: "安乡县",
						area_code: "Anxiang",
						area_parent_id: 430700
					},
					"430722": {
						id: 430722,
						area_name: "汉寿县",
						area_code: "Hanshou",
						area_parent_id: 430700
					},
					"430723": {
						id: 430723,
						area_name: "澧县",
						area_code: "Lixian",
						area_parent_id: 430700
					},
					"430724": {
						id: 430724,
						area_name: "临澧县",
						area_code: "Linli",
						area_parent_id: 430700
					},
					"430725": {
						id: 430725,
						area_name: "桃源县",
						area_code: "Taoyuan",
						area_parent_id: 430700
					},
					"430726": {
						id: 430726,
						area_name: "石门县",
						area_code: "Shimen",
						area_parent_id: 430700
					},
					"430781": {
						id: 430781,
						area_name: "津市市",
						area_code: "Jinshi",
						area_parent_id: 430700
					}
				}
			},
			"430800": {
				id: 430800,
				area_name: "张家界市",
				area_code: "Zhangjiajie",
				area_parent_id: 430000,
				child: {
					"430802": {
						id: 430802,
						area_name: "永定区",
						area_code: "Yongding",
						area_parent_id: 430800
					},
					"430811": {
						id: 430811,
						area_name: "武陵源区",
						area_code: "Wulingyuan",
						area_parent_id: 430800
					},
					"430821": {
						id: 430821,
						area_name: "慈利县",
						area_code: "Cili",
						area_parent_id: 430800
					},
					"430822": {
						id: 430822,
						area_name: "桑植县",
						area_code: "Sangzhi",
						area_parent_id: 430800
					}
				}
			},
			"430900": {
				id: 430900,
				area_name: "益阳市",
				area_code: "Yiyang",
				area_parent_id: 430000,
				child: {
					"430902": {
						id: 430902,
						area_name: "资阳区",
						area_code: "Ziyang",
						area_parent_id: 430900
					},
					"430903": {
						id: 430903,
						area_name: "赫山区",
						area_code: "Heshan",
						area_parent_id: 430900
					},
					"430921": {
						id: 430921,
						area_name: "南县",
						area_code: "Nanxian",
						area_parent_id: 430900
					},
					"430922": {
						id: 430922,
						area_name: "桃江县",
						area_code: "Taojiang",
						area_parent_id: 430900
					},
					"430923": {
						id: 430923,
						area_name: "安化县",
						area_code: "Anhua",
						area_parent_id: 430900
					},
					"430981": {
						id: 430981,
						area_name: "沅江市",
						area_code: "Yuanjiang",
						area_parent_id: 430900
					}
				}
			},
			"431000": {
				id: 431000,
				area_name: "郴州市",
				area_code: "Chenzhou",
				area_parent_id: 430000,
				child: {
					"431002": {
						id: 431002,
						area_name: "北湖区",
						area_code: "Beihu",
						area_parent_id: 431000
					},
					"431003": {
						id: 431003,
						area_name: "苏仙区",
						area_code: "Suxian",
						area_parent_id: 431000
					},
					"431021": {
						id: 431021,
						area_name: "桂阳县",
						area_code: "Guiyang",
						area_parent_id: 431000
					},
					"431022": {
						id: 431022,
						area_name: "宜章县",
						area_code: "Yizhang",
						area_parent_id: 431000
					},
					"431023": {
						id: 431023,
						area_name: "永兴县",
						area_code: "Yongxing",
						area_parent_id: 431000
					},
					"431024": {
						id: 431024,
						area_name: "嘉禾县",
						area_code: "Jiahe",
						area_parent_id: 431000
					},
					"431025": {
						id: 431025,
						area_name: "临武县",
						area_code: "Linwu",
						area_parent_id: 431000
					},
					"431026": {
						id: 431026,
						area_name: "汝城县",
						area_code: "Rucheng",
						area_parent_id: 431000
					},
					"431027": {
						id: 431027,
						area_name: "桂东县",
						area_code: "Guidong",
						area_parent_id: 431000
					},
					"431028": {
						id: 431028,
						area_name: "安仁县",
						area_code: "Anren",
						area_parent_id: 431000
					},
					"431081": {
						id: 431081,
						area_name: "资兴市",
						area_code: "Zixing",
						area_parent_id: 431000
					}
				}
			},
			"431100": {
				id: 431100,
				area_name: "永州市",
				area_code: "Yongzhou",
				area_parent_id: 430000,
				child: {
					"431102": {
						id: 431102,
						area_name: "零陵区",
						area_code: "Lingling",
						area_parent_id: 431100
					},
					"431103": {
						id: 431103,
						area_name: "冷水滩区",
						area_code: "Lengshuitan",
						area_parent_id: 431100
					},
					"431121": {
						id: 431121,
						area_name: "祁阳县",
						area_code: "Qiyang",
						area_parent_id: 431100
					},
					"431122": {
						id: 431122,
						area_name: "东安县",
						area_code: "Dong'an",
						area_parent_id: 431100
					},
					"431123": {
						id: 431123,
						area_name: "双牌县",
						area_code: "Shuangpai",
						area_parent_id: 431100
					},
					"431124": {
						id: 431124,
						area_name: "道县",
						area_code: "Daoxian",
						area_parent_id: 431100
					},
					"431125": {
						id: 431125,
						area_name: "江永县",
						area_code: "Jiangyong",
						area_parent_id: 431100
					},
					"431126": {
						id: 431126,
						area_name: "宁远县",
						area_code: "Ningyuan",
						area_parent_id: 431100
					},
					"431127": {
						id: 431127,
						area_name: "蓝山县",
						area_code: "Lanshan",
						area_parent_id: 431100
					},
					"431128": {
						id: 431128,
						area_name: "新田县",
						area_code: "Xintian",
						area_parent_id: 431100
					},
					"431129": {
						id: 431129,
						area_name: "江华瑶族自治县",
						area_code: "Jianghua",
						area_parent_id: 431100
					}
				}
			},
			"431200": {
				id: 431200,
				area_name: "怀化市",
				area_code: "Huaihua",
				area_parent_id: 430000,
				child: {
					"431202": {
						id: 431202,
						area_name: "鹤城区",
						area_code: "Hecheng",
						area_parent_id: 431200
					},
					"431221": {
						id: 431221,
						area_name: "中方县",
						area_code: "Zhongfang",
						area_parent_id: 431200
					},
					"431222": {
						id: 431222,
						area_name: "沅陵县",
						area_code: "Yuanling",
						area_parent_id: 431200
					},
					"431223": {
						id: 431223,
						area_name: "辰溪县",
						area_code: "Chenxi",
						area_parent_id: 431200
					},
					"431224": {
						id: 431224,
						area_name: "溆浦县",
						area_code: "Xupu",
						area_parent_id: 431200
					},
					"431225": {
						id: 431225,
						area_name: "会同县",
						area_code: "Huitong",
						area_parent_id: 431200
					},
					"431226": {
						id: 431226,
						area_name: "麻阳苗族自治县",
						area_code: "Mayang",
						area_parent_id: 431200
					},
					"431227": {
						id: 431227,
						area_name: "新晃侗族自治县",
						area_code: "Xinhuang",
						area_parent_id: 431200
					},
					"431228": {
						id: 431228,
						area_name: "芷江侗族自治县",
						area_code: "Zhijiang",
						area_parent_id: 431200
					},
					"431229": {
						id: 431229,
						area_name: "靖州苗族侗族自治县",
						area_code: "Jingzhou",
						area_parent_id: 431200
					},
					"431230": {
						id: 431230,
						area_name: "通道侗族自治县",
						area_code: "Tongdao",
						area_parent_id: 431200
					},
					"431281": {
						id: 431281,
						area_name: "洪江市",
						area_code: "Hongjiang",
						area_parent_id: 431200
					}
				}
			},
			"431300": {
				id: 431300,
				area_name: "娄底市",
				area_code: "Loudi",
				area_parent_id: 430000,
				child: {
					"431302": {
						id: 431302,
						area_name: "娄星区",
						area_code: "Louxing",
						area_parent_id: 431300
					},
					"431321": {
						id: 431321,
						area_name: "双峰县",
						area_code: "Shuangfeng",
						area_parent_id: 431300
					},
					"431322": {
						id: 431322,
						area_name: "新化县",
						area_code: "Xinhua",
						area_parent_id: 431300
					},
					"431381": {
						id: 431381,
						area_name: "冷水江市",
						area_code: "Lengshuijiang",
						area_parent_id: 431300
					},
					"431382": {
						id: 431382,
						area_name: "涟源市",
						area_code: "Lianyuan",
						area_parent_id: 431300
					}
				}
			},
			"433100": {
				id: 433100,
				area_name: "湘西土家族苗族自治州",
				area_code: "Xiangxi",
				area_parent_id: 430000,
				child: {
					"433101": {
						id: 433101,
						area_name: "吉首市",
						area_code: "Jishou",
						area_parent_id: 433100
					},
					"433122": {
						id: 433122,
						area_name: "泸溪县",
						area_code: "Luxi",
						area_parent_id: 433100
					},
					"433123": {
						id: 433123,
						area_name: "凤凰县",
						area_code: "Fenghuang",
						area_parent_id: 433100
					},
					"433124": {
						id: 433124,
						area_name: "花垣县",
						area_code: "Huayuan",
						area_parent_id: 433100
					},
					"433125": {
						id: 433125,
						area_name: "保靖县",
						area_code: "Baojing",
						area_parent_id: 433100
					},
					"433126": {
						id: 433126,
						area_name: "古丈县",
						area_code: "Guzhang",
						area_parent_id: 433100
					},
					"433127": {
						id: 433127,
						area_name: "永顺县",
						area_code: "Yongshun",
						area_parent_id: 433100
					},
					"433130": {
						id: 433130,
						area_name: "龙山县",
						area_code: "Longshan",
						area_parent_id: 433100
					}
				}
			}
		}
	},
	"440000": {
		id: 440000,
		area_name: "广东省",
		area_code: "Guangdong",
		area_parent_id: 0,
		child: {
			"440100": {
				id: 440100,
				area_name: "广州市",
				area_code: "Guangzhou",
				area_parent_id: 440000,
				child: {
					"440103": {
						id: 440103,
						area_name: "荔湾区",
						area_code: "Liwan",
						area_parent_id: 440100
					},
					"440104": {
						id: 440104,
						area_name: "越秀区",
						area_code: "Yuexiu",
						area_parent_id: 440100
					},
					"440105": {
						id: 440105,
						area_name: "海珠区",
						area_code: "Haizhu",
						area_parent_id: 440100
					},
					"440106": {
						id: 440106,
						area_name: "天河区",
						area_code: "Tianhe",
						area_parent_id: 440100
					},
					"440111": {
						id: 440111,
						area_name: "白云区",
						area_code: "Baiyun",
						area_parent_id: 440100
					},
					"440112": {
						id: 440112,
						area_name: "黄埔区",
						area_code: "Huangpu",
						area_parent_id: 440100
					},
					"440113": {
						id: 440113,
						area_name: "番禺区",
						area_code: "Panyu",
						area_parent_id: 440100
					},
					"440114": {
						id: 440114,
						area_name: "花都区",
						area_code: "Huadu",
						area_parent_id: 440100
					},
					"440115": {
						id: 440115,
						area_name: "南沙区",
						area_code: "Nansha",
						area_parent_id: 440100
					},
					"440117": {
						id: 440117,
						area_name: "从化区",
						area_code: "Conghua",
						area_parent_id: 440100
					},
					"440118": {
						id: 440118,
						area_name: "增城区",
						area_code: "Zengcheng",
						area_parent_id: 440100
					}
				}
			},
			"440200": {
				id: 440200,
				area_name: "韶关市",
				area_code: "Shaoguan",
				area_parent_id: 440000,
				child: {
					"440203": {
						id: 440203,
						area_name: "武江区",
						area_code: "Wujiang",
						area_parent_id: 440200
					},
					"440204": {
						id: 440204,
						area_name: "浈江区",
						area_code: "Zhenjiang",
						area_parent_id: 440200
					},
					"440205": {
						id: 440205,
						area_name: "曲江区",
						area_code: "Qujiang",
						area_parent_id: 440200
					},
					"440222": {
						id: 440222,
						area_name: "始兴县",
						area_code: "Shixing",
						area_parent_id: 440200
					},
					"440224": {
						id: 440224,
						area_name: "仁化县",
						area_code: "Renhua",
						area_parent_id: 440200
					},
					"440229": {
						id: 440229,
						area_name: "翁源县",
						area_code: "Wengyuan",
						area_parent_id: 440200
					},
					"440232": {
						id: 440232,
						area_name: "乳源瑶族自治县",
						area_code: "Ruyuan",
						area_parent_id: 440200
					},
					"440233": {
						id: 440233,
						area_name: "新丰县",
						area_code: "Xinfeng",
						area_parent_id: 440200
					},
					"440281": {
						id: 440281,
						area_name: "乐昌市",
						area_code: "Lechang",
						area_parent_id: 440200
					},
					"440282": {
						id: 440282,
						area_name: "南雄市",
						area_code: "Nanxiong",
						area_parent_id: 440200
					}
				}
			},
			"440300": {
				id: 440300,
				area_name: "深圳市",
				area_code: "Shenzhen",
				area_parent_id: 440000,
				child: {
					"440303": {
						id: 440303,
						area_name: "罗湖区",
						area_code: "Luohu",
						area_parent_id: 440300
					},
					"440304": {
						id: 440304,
						area_name: "福田区",
						area_code: "Futian",
						area_parent_id: 440300
					},
					"440305": {
						id: 440305,
						area_name: "南山区",
						area_code: "Nanshan",
						area_parent_id: 440300
					},
					"440306": {
						id: 440306,
						area_name: "宝安区",
						area_code: "Bao'an",
						area_parent_id: 440300
					},
					"440307": {
						id: 440307,
						area_name: "龙岗区",
						area_code: "Longgang",
						area_parent_id: 440300
					},
					"440308": {
						id: 440308,
						area_name: "盐田区",
						area_code: "Yantian",
						area_parent_id: 440300
					},
					"440309": {
						id: 440309,
						area_name: "光明新区",
						area_code: "Guangmingxinqu",
						area_parent_id: 440300
					},
					"440310": {
						id: 440310,
						area_name: "坪山新区",
						area_code: "Pingshanxinqu",
						area_parent_id: 440300
					},
					"440311": {
						id: 440311,
						area_name: "大鹏新区",
						area_code: "Dapengxinqu",
						area_parent_id: 440300
					},
					"440312": {
						id: 440312,
						area_name: "龙华新区",
						area_code: "Longhuaxinqu",
						area_parent_id: 440300
					}
				}
			},
			"440400": {
				id: 440400,
				area_name: "珠海市",
				area_code: "Zhuhai",
				area_parent_id: 440000,
				child: {
					"440402": {
						id: 440402,
						area_name: "香洲区",
						area_code: "Xiangzhou",
						area_parent_id: 440400
					},
					"440403": {
						id: 440403,
						area_name: "斗门区",
						area_code: "Doumen",
						area_parent_id: 440400
					},
					"440404": {
						id: 440404,
						area_name: "金湾区",
						area_code: "Jinwan",
						area_parent_id: 440400
					}
				}
			},
			"440500": {
				id: 440500,
				area_name: "汕头市",
				area_code: "Shantou",
				area_parent_id: 440000,
				child: {
					"440507": {
						id: 440507,
						area_name: "龙湖区",
						area_code: "Longhu",
						area_parent_id: 440500
					},
					"440511": {
						id: 440511,
						area_name: "金平区",
						area_code: "Jinping",
						area_parent_id: 440500
					},
					"440512": {
						id: 440512,
						area_name: "濠江区",
						area_code: "Haojiang",
						area_parent_id: 440500
					},
					"440513": {
						id: 440513,
						area_name: "潮阳区",
						area_code: "Chaoyang",
						area_parent_id: 440500
					},
					"440514": {
						id: 440514,
						area_name: "潮南区",
						area_code: "Chaonan",
						area_parent_id: 440500
					},
					"440515": {
						id: 440515,
						area_name: "澄海区",
						area_code: "Chenghai",
						area_parent_id: 440500
					},
					"440523": {
						id: 440523,
						area_name: "南澳县",
						area_code: "Nanao",
						area_parent_id: 440500
					}
				}
			},
			"440600": {
				id: 440600,
				area_name: "佛山市",
				area_code: "Foshan",
				area_parent_id: 440000,
				child: {
					"440604": {
						id: 440604,
						area_name: "禅城区",
						area_code: "Chancheng",
						area_parent_id: 440600
					},
					"440605": {
						id: 440605,
						area_name: "南海区",
						area_code: "Nanhai",
						area_parent_id: 440600
					},
					"440606": {
						id: 440606,
						area_name: "顺德区",
						area_code: "Shunde",
						area_parent_id: 440600
					},
					"440607": {
						id: 440607,
						area_name: "三水区",
						area_code: "Sanshui",
						area_parent_id: 440600
					},
					"440608": {
						id: 440608,
						area_name: "高明区",
						area_code: "Gaoming",
						area_parent_id: 440600
					}
				}
			},
			"440700": {
				id: 440700,
				area_name: "江门市",
				area_code: "Jiangmen",
				area_parent_id: 440000,
				child: {
					"440703": {
						id: 440703,
						area_name: "蓬江区",
						area_code: "Pengjiang",
						area_parent_id: 440700
					},
					"440704": {
						id: 440704,
						area_name: "江海区",
						area_code: "Jianghai",
						area_parent_id: 440700
					},
					"440705": {
						id: 440705,
						area_name: "新会区",
						area_code: "Xinhui",
						area_parent_id: 440700
					},
					"440781": {
						id: 440781,
						area_name: "台山市",
						area_code: "Taishan",
						area_parent_id: 440700
					},
					"440783": {
						id: 440783,
						area_name: "开平市",
						area_code: "Kaiping",
						area_parent_id: 440700
					},
					"440784": {
						id: 440784,
						area_name: "鹤山市",
						area_code: "Heshan",
						area_parent_id: 440700
					},
					"440785": {
						id: 440785,
						area_name: "恩平市",
						area_code: "Enping",
						area_parent_id: 440700
					}
				}
			},
			"440800": {
				id: 440800,
				area_name: "湛江市",
				area_code: "Zhanjiang",
				area_parent_id: 440000,
				child: {
					"440802": {
						id: 440802,
						area_name: "赤坎区",
						area_code: "Chikan",
						area_parent_id: 440800
					},
					"440803": {
						id: 440803,
						area_name: "霞山区",
						area_code: "Xiashan",
						area_parent_id: 440800
					},
					"440804": {
						id: 440804,
						area_name: "坡头区",
						area_code: "Potou",
						area_parent_id: 440800
					},
					"440811": {
						id: 440811,
						area_name: "麻章区",
						area_code: "Mazhang",
						area_parent_id: 440800
					},
					"440823": {
						id: 440823,
						area_name: "遂溪县",
						area_code: "Suixi",
						area_parent_id: 440800
					},
					"440825": {
						id: 440825,
						area_name: "徐闻县",
						area_code: "Xuwen",
						area_parent_id: 440800
					},
					"440881": {
						id: 440881,
						area_name: "廉江市",
						area_code: "Lianjiang",
						area_parent_id: 440800
					},
					"440882": {
						id: 440882,
						area_name: "雷州市",
						area_code: "Leizhou",
						area_parent_id: 440800
					},
					"440883": {
						id: 440883,
						area_name: "吴川市",
						area_code: "Wuchuan",
						area_parent_id: 440800
					}
				}
			},
			"440900": {
				id: 440900,
				area_name: "茂名市",
				area_code: "Maoming",
				area_parent_id: 440000,
				child: {
					"440902": {
						id: 440902,
						area_name: "茂南区",
						area_code: "Maonan",
						area_parent_id: 440900
					},
					"440904": {
						id: 440904,
						area_name: "电白区",
						area_code: "Dianbai",
						area_parent_id: 440900
					},
					"440981": {
						id: 440981,
						area_name: "高州市",
						area_code: "Gaozhou",
						area_parent_id: 440900
					},
					"440982": {
						id: 440982,
						area_name: "化州市",
						area_code: "Huazhou",
						area_parent_id: 440900
					},
					"440983": {
						id: 440983,
						area_name: "信宜市",
						area_code: "Xinyi",
						area_parent_id: 440900
					}
				}
			},
			"441200": {
				id: 441200,
				area_name: "肇庆市",
				area_code: "Zhaoqing",
				area_parent_id: 440000,
				child: {
					"441202": {
						id: 441202,
						area_name: "端州区",
						area_code: "Duanzhou",
						area_parent_id: 441200
					},
					"441203": {
						id: 441203,
						area_name: "鼎湖区",
						area_code: "Dinghu",
						area_parent_id: 441200
					},
					"441223": {
						id: 441223,
						area_name: "广宁县",
						area_code: "Guangning",
						area_parent_id: 441200
					},
					"441224": {
						id: 441224,
						area_name: "怀集县",
						area_code: "Huaiji",
						area_parent_id: 441200
					},
					"441225": {
						id: 441225,
						area_name: "封开县",
						area_code: "Fengkai",
						area_parent_id: 441200
					},
					"441226": {
						id: 441226,
						area_name: "德庆县",
						area_code: "Deqing",
						area_parent_id: 441200
					},
					"441283": {
						id: 441283,
						area_name: "高要市",
						area_code: "Gaoyao",
						area_parent_id: 441200
					},
					"441284": {
						id: 441284,
						area_name: "四会市",
						area_code: "Sihui",
						area_parent_id: 441200
					}
				}
			},
			"441300": {
				id: 441300,
				area_name: "惠州市",
				area_code: "Huizhou",
				area_parent_id: 440000,
				child: {
					"441302": {
						id: 441302,
						area_name: "惠城区",
						area_code: "Huicheng",
						area_parent_id: 441300
					},
					"441303": {
						id: 441303,
						area_name: "惠阳区",
						area_code: "Huiyang",
						area_parent_id: 441300
					},
					"441322": {
						id: 441322,
						area_name: "博罗县",
						area_code: "Boluo",
						area_parent_id: 441300
					},
					"441323": {
						id: 441323,
						area_name: "惠东县",
						area_code: "Huidong",
						area_parent_id: 441300
					},
					"441324": {
						id: 441324,
						area_name: "龙门县",
						area_code: "Longmen",
						area_parent_id: 441300
					}
				}
			},
			"441400": {
				id: 441400,
				area_name: "梅州市",
				area_code: "Meizhou",
				area_parent_id: 440000,
				child: {
					"441402": {
						id: 441402,
						area_name: "梅江区",
						area_code: "Meijiang",
						area_parent_id: 441400
					},
					"441403": {
						id: 441403,
						area_name: "梅县区",
						area_code: "Meixian",
						area_parent_id: 441400
					},
					"441422": {
						id: 441422,
						area_name: "大埔县",
						area_code: "Dabu",
						area_parent_id: 441400
					},
					"441423": {
						id: 441423,
						area_name: "丰顺县",
						area_code: "Fengshun",
						area_parent_id: 441400
					},
					"441424": {
						id: 441424,
						area_name: "五华县",
						area_code: "Wuhua",
						area_parent_id: 441400
					},
					"441426": {
						id: 441426,
						area_name: "平远县",
						area_code: "Pingyuan",
						area_parent_id: 441400
					},
					"441427": {
						id: 441427,
						area_name: "蕉岭县",
						area_code: "Jiaoling",
						area_parent_id: 441400
					},
					"441481": {
						id: 441481,
						area_name: "兴宁市",
						area_code: "Xingning",
						area_parent_id: 441400
					}
				}
			},
			"441500": {
				id: 441500,
				area_name: "汕尾市",
				area_code: "Shanwei",
				area_parent_id: 440000,
				child: {
					"441502": {
						id: 441502,
						area_name: "城区",
						area_code: "Chengqu",
						area_parent_id: 441500
					},
					"441521": {
						id: 441521,
						area_name: "海丰县",
						area_code: "Haifeng",
						area_parent_id: 441500
					},
					"441523": {
						id: 441523,
						area_name: "陆河县",
						area_code: "Luhe",
						area_parent_id: 441500
					},
					"441581": {
						id: 441581,
						area_name: "陆丰市",
						area_code: "Lufeng",
						area_parent_id: 441500
					}
				}
			},
			"441600": {
				id: 441600,
				area_name: "河源市",
				area_code: "Heyuan",
				area_parent_id: 440000,
				child: {
					"441602": {
						id: 441602,
						area_name: "源城区",
						area_code: "Yuancheng",
						area_parent_id: 441600
					},
					"441621": {
						id: 441621,
						area_name: "紫金县",
						area_code: "Zijin",
						area_parent_id: 441600
					},
					"441622": {
						id: 441622,
						area_name: "龙川县",
						area_code: "Longchuan",
						area_parent_id: 441600
					},
					"441623": {
						id: 441623,
						area_name: "连平县",
						area_code: "Lianping",
						area_parent_id: 441600
					},
					"441624": {
						id: 441624,
						area_name: "和平县",
						area_code: "Heping",
						area_parent_id: 441600
					},
					"441625": {
						id: 441625,
						area_name: "东源县",
						area_code: "Dongyuan",
						area_parent_id: 441600
					}
				}
			},
			"441700": {
				id: 441700,
				area_name: "阳江市",
				area_code: "Yangjiang",
				area_parent_id: 440000,
				child: {
					"441702": {
						id: 441702,
						area_name: "江城区",
						area_code: "Jiangcheng",
						area_parent_id: 441700
					},
					"441704": {
						id: 441704,
						area_name: "阳东区",
						area_code: "Yangdong",
						area_parent_id: 441700
					},
					"441721": {
						id: 441721,
						area_name: "阳西县",
						area_code: "Yangxi",
						area_parent_id: 441700
					},
					"441781": {
						id: 441781,
						area_name: "阳春市",
						area_code: "Yangchun",
						area_parent_id: 441700
					}
				}
			},
			"441800": {
				id: 441800,
				area_name: "清远市",
				area_code: "Qingyuan",
				area_parent_id: 440000,
				child: {
					"441802": {
						id: 441802,
						area_name: "清城区",
						area_code: "Qingcheng",
						area_parent_id: 441800
					},
					"441803": {
						id: 441803,
						area_name: "清新区",
						area_code: "Qingxin",
						area_parent_id: 441800
					},
					"441821": {
						id: 441821,
						area_name: "佛冈县",
						area_code: "Fogang",
						area_parent_id: 441800
					},
					"441823": {
						id: 441823,
						area_name: "阳山县",
						area_code: "Yangshan",
						area_parent_id: 441800
					},
					"441825": {
						id: 441825,
						area_name: "连山壮族瑶族自治县",
						area_code: "Lianshan",
						area_parent_id: 441800
					},
					"441826": {
						id: 441826,
						area_name: "连南瑶族自治县",
						area_code: "Liannan",
						area_parent_id: 441800
					},
					"441881": {
						id: 441881,
						area_name: "英德市",
						area_code: "Yingde",
						area_parent_id: 441800
					},
					"441882": {
						id: 441882,
						area_name: "连州市",
						area_code: "Lianzhou",
						area_parent_id: 441800
					}
				}
			},
			"441900": {
				id: 441900,
				area_name: "东莞市",
				area_code: "Dongguan",
				area_parent_id: 440000,
				child: {
					"441901": {
						id: 441901,
						area_name: "莞城区",
						area_code: "Guancheng",
						area_parent_id: 441900
					},
					"441902": {
						id: 441902,
						area_name: "南城区",
						area_code: "Nancheng",
						area_parent_id: 441900
					},
					"441904": {
						id: 441904,
						area_name: "万江区",
						area_code: "Wanjiang",
						area_parent_id: 441900
					},
					"441905": {
						id: 441905,
						area_name: "石碣镇",
						area_code: "Shijie",
						area_parent_id: 441900
					},
					"441906": {
						id: 441906,
						area_name: "石龙镇",
						area_code: "Shilong",
						area_parent_id: 441900
					},
					"441907": {
						id: 441907,
						area_name: "茶山镇",
						area_code: "Chashan",
						area_parent_id: 441900
					},
					"441908": {
						id: 441908,
						area_name: "石排镇",
						area_code: "Shipai",
						area_parent_id: 441900
					},
					"441909": {
						id: 441909,
						area_name: "企石镇",
						area_code: "Qishi",
						area_parent_id: 441900
					},
					"441910": {
						id: 441910,
						area_name: "横沥镇",
						area_code: "Hengli",
						area_parent_id: 441900
					},
					"441911": {
						id: 441911,
						area_name: "桥头镇",
						area_code: "Qiaotou",
						area_parent_id: 441900
					},
					"441912": {
						id: 441912,
						area_name: "谢岗镇",
						area_code: "Xiegang",
						area_parent_id: 441900
					},
					"441913": {
						id: 441913,
						area_name: "东坑镇",
						area_code: "Dongkeng",
						area_parent_id: 441900
					},
					"441914": {
						id: 441914,
						area_name: "常平镇",
						area_code: "Changping",
						area_parent_id: 441900
					},
					"441915": {
						id: 441915,
						area_name: "寮步镇",
						area_code: "Liaobu",
						area_parent_id: 441900
					},
					"441916": {
						id: 441916,
						area_name: "大朗镇",
						area_code: "Dalang",
						area_parent_id: 441900
					},
					"441917": {
						id: 441917,
						area_name: "麻涌镇",
						area_code: "Machong",
						area_parent_id: 441900
					},
					"441918": {
						id: 441918,
						area_name: "中堂镇",
						area_code: "Zhongtang",
						area_parent_id: 441900
					},
					"441919": {
						id: 441919,
						area_name: "高埗镇",
						area_code: "Gaobu",
						area_parent_id: 441900
					},
					"441920": {
						id: 441920,
						area_name: "樟木头镇",
						area_code: "Zhangmutou",
						area_parent_id: 441900
					},
					"441921": {
						id: 441921,
						area_name: "大岭山镇",
						area_code: "Dalingshan",
						area_parent_id: 441900
					},
					"441922": {
						id: 441922,
						area_name: "望牛墩镇",
						area_code: "Wangniudun",
						area_parent_id: 441900
					},
					"441923": {
						id: 441923,
						area_name: "黄江镇",
						area_code: "Huangjiang",
						area_parent_id: 441900
					},
					"441924": {
						id: 441924,
						area_name: "洪梅镇",
						area_code: "Hongmei",
						area_parent_id: 441900
					},
					"441925": {
						id: 441925,
						area_name: "清溪镇",
						area_code: "Qingxi",
						area_parent_id: 441900
					},
					"441926": {
						id: 441926,
						area_name: "沙田镇",
						area_code: "Shatian",
						area_parent_id: 441900
					},
					"441927": {
						id: 441927,
						area_name: "道滘镇",
						area_code: "Daojiao",
						area_parent_id: 441900
					},
					"441928": {
						id: 441928,
						area_name: "塘厦镇",
						area_code: "Tangxia",
						area_parent_id: 441900
					},
					"441929": {
						id: 441929,
						area_name: "虎门镇",
						area_code: "Humen",
						area_parent_id: 441900
					},
					"441930": {
						id: 441930,
						area_name: "厚街镇",
						area_code: "Houjie",
						area_parent_id: 441900
					},
					"441931": {
						id: 441931,
						area_name: "凤岗镇",
						area_code: "Fenggang",
						area_parent_id: 441900
					},
					"441932": {
						id: 441932,
						area_name: "长安镇",
						area_code: "Chang'an",
						area_parent_id: 441900
					}
				}
			},
			"442000": {
				id: 442000,
				area_name: "中山市",
				area_code: "Zhongshan",
				area_parent_id: 440000,
				child: {
					"442001": {
						id: 442001,
						area_name: "石岐区",
						area_code: "Shiqi",
						area_parent_id: 442000
					},
					"442004": {
						id: 442004,
						area_name: "南区",
						area_code: "Nanqu",
						area_parent_id: 442000
					},
					"442005": {
						id: 442005,
						area_name: "五桂山区",
						area_code: "Wuguishan",
						area_parent_id: 442000
					},
					"442006": {
						id: 442006,
						area_name: "火炬开发区",
						area_code: "Huoju",
						area_parent_id: 442000
					},
					"442007": {
						id: 442007,
						area_name: "黄圃镇",
						area_code: "Huangpu",
						area_parent_id: 442000
					},
					"442008": {
						id: 442008,
						area_name: "南头镇",
						area_code: "Nantou",
						area_parent_id: 442000
					},
					"442009": {
						id: 442009,
						area_name: "东凤镇",
						area_code: "Dongfeng",
						area_parent_id: 442000
					},
					"442010": {
						id: 442010,
						area_name: "阜沙镇",
						area_code: "Fusha",
						area_parent_id: 442000
					},
					"442011": {
						id: 442011,
						area_name: "小榄镇",
						area_code: "Xiaolan",
						area_parent_id: 442000
					},
					"442012": {
						id: 442012,
						area_name: "东升镇",
						area_code: "Dongsheng",
						area_parent_id: 442000
					},
					"442013": {
						id: 442013,
						area_name: "古镇镇",
						area_code: "Guzhen",
						area_parent_id: 442000
					},
					"442014": {
						id: 442014,
						area_name: "横栏镇",
						area_code: "Henglan",
						area_parent_id: 442000
					},
					"442015": {
						id: 442015,
						area_name: "三角镇",
						area_code: "Sanjiao",
						area_parent_id: 442000
					},
					"442016": {
						id: 442016,
						area_name: "民众镇",
						area_code: "Minzhong",
						area_parent_id: 442000
					},
					"442017": {
						id: 442017,
						area_name: "南朗镇",
						area_code: "Nanlang",
						area_parent_id: 442000
					},
					"442018": {
						id: 442018,
						area_name: "港口镇",
						area_code: "Gangkou",
						area_parent_id: 442000
					},
					"442019": {
						id: 442019,
						area_name: "大涌镇",
						area_code: "Dayong",
						area_parent_id: 442000
					},
					"442020": {
						id: 442020,
						area_name: "沙溪镇",
						area_code: "Shaxi",
						area_parent_id: 442000
					},
					"442021": {
						id: 442021,
						area_name: "三乡镇",
						area_code: "Sanxiang",
						area_parent_id: 442000
					},
					"442022": {
						id: 442022,
						area_name: "板芙镇",
						area_code: "Banfu",
						area_parent_id: 442000
					},
					"442023": {
						id: 442023,
						area_name: "神湾镇",
						area_code: "Shenwan",
						area_parent_id: 442000
					},
					"442024": {
						id: 442024,
						area_name: "坦洲镇",
						area_code: "Tanzhou",
						area_parent_id: 442000
					}
				}
			},
			"445100": {
				id: 445100,
				area_name: "潮州市",
				area_code: "Chaozhou",
				area_parent_id: 440000,
				child: {
					"445102": {
						id: 445102,
						area_name: "湘桥区",
						area_code: "Xiangqiao",
						area_parent_id: 445100
					},
					"445103": {
						id: 445103,
						area_name: "潮安区",
						area_code: "Chao'an",
						area_parent_id: 445100
					},
					"445122": {
						id: 445122,
						area_name: "饶平县",
						area_code: "Raoping",
						area_parent_id: 445100
					}
				}
			},
			"445200": {
				id: 445200,
				area_name: "揭阳市",
				area_code: "Jieyang",
				area_parent_id: 440000,
				child: {
					"445202": {
						id: 445202,
						area_name: "榕城区",
						area_code: "Rongcheng",
						area_parent_id: 445200
					},
					"445203": {
						id: 445203,
						area_name: "揭东区",
						area_code: "Jiedong",
						area_parent_id: 445200
					},
					"445222": {
						id: 445222,
						area_name: "揭西县",
						area_code: "Jiexi",
						area_parent_id: 445200
					},
					"445224": {
						id: 445224,
						area_name: "惠来县",
						area_code: "Huilai",
						area_parent_id: 445200
					},
					"445281": {
						id: 445281,
						area_name: "普宁市",
						area_code: "Puning",
						area_parent_id: 445200
					}
				}
			},
			"445300": {
				id: 445300,
				area_name: "云浮市",
				area_code: "Yunfu",
				area_parent_id: 440000,
				child: {
					"445302": {
						id: 445302,
						area_name: "云城区",
						area_code: "Yuncheng",
						area_parent_id: 445300
					},
					"445303": {
						id: 445303,
						area_name: "云安区",
						area_code: "Yun'an",
						area_parent_id: 445300
					},
					"445321": {
						id: 445321,
						area_name: "新兴县",
						area_code: "Xinxing",
						area_parent_id: 445300
					},
					"445322": {
						id: 445322,
						area_name: "郁南县",
						area_code: "Yunan",
						area_parent_id: 445300
					},
					"445381": {
						id: 445381,
						area_name: "罗定市",
						area_code: "Luoding",
						area_parent_id: 445300
					}
				}
			}
		}
	},
	"450000": {
		id: 450000,
		area_name: "广西壮族自治区",
		area_code: "Guangxi",
		area_parent_id: 0,
		child: {
			"450100": {
				id: 450100,
				area_name: "南宁市",
				area_code: "Nanning",
				area_parent_id: 450000,
				child: {
					"450102": {
						id: 450102,
						area_name: "兴宁区",
						area_code: "Xingning",
						area_parent_id: 450100
					},
					"450103": {
						id: 450103,
						area_name: "青秀区",
						area_code: "Qingxiu",
						area_parent_id: 450100
					},
					"450105": {
						id: 450105,
						area_name: "江南区",
						area_code: "Jiangnan",
						area_parent_id: 450100
					},
					"450107": {
						id: 450107,
						area_name: "西乡塘区",
						area_code: "Xixiangtang",
						area_parent_id: 450100
					},
					"450108": {
						id: 450108,
						area_name: "良庆区",
						area_code: "Liangqing",
						area_parent_id: 450100
					},
					"450109": {
						id: 450109,
						area_name: "邕宁区",
						area_code: "Yongning",
						area_parent_id: 450100
					},
					"450122": {
						id: 450122,
						area_name: "武鸣县",
						area_code: "Wuming",
						area_parent_id: 450100
					},
					"450123": {
						id: 450123,
						area_name: "隆安县",
						area_code: "Long'an",
						area_parent_id: 450100
					},
					"450124": {
						id: 450124,
						area_name: "马山县",
						area_code: "Mashan",
						area_parent_id: 450100
					},
					"450125": {
						id: 450125,
						area_name: "上林县",
						area_code: "Shanglin",
						area_parent_id: 450100
					},
					"450126": {
						id: 450126,
						area_name: "宾阳县",
						area_code: "Binyang",
						area_parent_id: 450100
					},
					"450127": {
						id: 450127,
						area_name: "横县",
						area_code: "Hengxian",
						area_parent_id: 450100
					},
					"450128": {
						id: 450128,
						area_name: "埌东新区",
						area_code: "Langdong",
						area_parent_id: 450100
					}
				}
			},
			"450200": {
				id: 450200,
				area_name: "柳州市",
				area_code: "Liuzhou",
				area_parent_id: 450000,
				child: {
					"450202": {
						id: 450202,
						area_name: "城中区",
						area_code: "Chengzhong",
						area_parent_id: 450200
					},
					"450203": {
						id: 450203,
						area_name: "鱼峰区",
						area_code: "Yufeng",
						area_parent_id: 450200
					},
					"450204": {
						id: 450204,
						area_name: "柳南区",
						area_code: "Liunan",
						area_parent_id: 450200
					},
					"450205": {
						id: 450205,
						area_name: "柳北区",
						area_code: "Liubei",
						area_parent_id: 450200
					},
					"450221": {
						id: 450221,
						area_name: "柳江县",
						area_code: "Liujiang",
						area_parent_id: 450200
					},
					"450222": {
						id: 450222,
						area_name: "柳城县",
						area_code: "Liucheng",
						area_parent_id: 450200
					},
					"450223": {
						id: 450223,
						area_name: "鹿寨县",
						area_code: "Luzhai",
						area_parent_id: 450200
					},
					"450224": {
						id: 450224,
						area_name: "融安县",
						area_code: "Rong'an",
						area_parent_id: 450200
					},
					"450225": {
						id: 450225,
						area_name: "融水苗族自治县",
						area_code: "Rongshui",
						area_parent_id: 450200
					},
					"450226": {
						id: 450226,
						area_name: "三江侗族自治县",
						area_code: "Sanjiang",
						area_parent_id: 450200
					},
					"450227": {
						id: 450227,
						area_name: "柳东新区",
						area_code: "Liudong",
						area_parent_id: 450200
					}
				}
			},
			"450300": {
				id: 450300,
				area_name: "桂林市",
				area_code: "Guilin",
				area_parent_id: 450000,
				child: {
					"450302": {
						id: 450302,
						area_name: "秀峰区",
						area_code: "Xiufeng",
						area_parent_id: 450300
					},
					"450303": {
						id: 450303,
						area_name: "叠彩区",
						area_code: "Diecai",
						area_parent_id: 450300
					},
					"450304": {
						id: 450304,
						area_name: "象山区",
						area_code: "Xiangshan",
						area_parent_id: 450300
					},
					"450305": {
						id: 450305,
						area_name: "七星区",
						area_code: "Qixing",
						area_parent_id: 450300
					},
					"450311": {
						id: 450311,
						area_name: "雁山区",
						area_code: "Yanshan",
						area_parent_id: 450300
					},
					"450312": {
						id: 450312,
						area_name: "临桂区",
						area_code: "Lingui",
						area_parent_id: 450300
					},
					"450321": {
						id: 450321,
						area_name: "阳朔县",
						area_code: "Yangshuo",
						area_parent_id: 450300
					},
					"450323": {
						id: 450323,
						area_name: "灵川县",
						area_code: "Lingchuan",
						area_parent_id: 450300
					},
					"450324": {
						id: 450324,
						area_name: "全州县",
						area_code: "Quanzhou",
						area_parent_id: 450300
					},
					"450325": {
						id: 450325,
						area_name: "兴安县",
						area_code: "Xing'an",
						area_parent_id: 450300
					},
					"450326": {
						id: 450326,
						area_name: "永福县",
						area_code: "Yongfu",
						area_parent_id: 450300
					},
					"450327": {
						id: 450327,
						area_name: "灌阳县",
						area_code: "Guanyang",
						area_parent_id: 450300
					},
					"450328": {
						id: 450328,
						area_name: "龙胜各族自治县",
						area_code: "Longsheng",
						area_parent_id: 450300
					},
					"450329": {
						id: 450329,
						area_name: "资源县",
						area_code: "Ziyuan",
						area_parent_id: 450300
					},
					"450330": {
						id: 450330,
						area_name: "平乐县",
						area_code: "Pingle",
						area_parent_id: 450300
					},
					"450331": {
						id: 450331,
						area_name: "荔浦县",
						area_code: "Lipu",
						area_parent_id: 450300
					},
					"450332": {
						id: 450332,
						area_name: "恭城瑶族自治县",
						area_code: "Gongcheng",
						area_parent_id: 450300
					}
				}
			},
			"450400": {
				id: 450400,
				area_name: "梧州市",
				area_code: "Wuzhou",
				area_parent_id: 450000,
				child: {
					"450403": {
						id: 450403,
						area_name: "万秀区",
						area_code: "Wanxiu",
						area_parent_id: 450400
					},
					"450405": {
						id: 450405,
						area_name: "长洲区",
						area_code: "Changzhou",
						area_parent_id: 450400
					},
					"450406": {
						id: 450406,
						area_name: "龙圩区",
						area_code: "Longxu",
						area_parent_id: 450400
					},
					"450421": {
						id: 450421,
						area_name: "苍梧县",
						area_code: "Cangwu",
						area_parent_id: 450400
					},
					"450422": {
						id: 450422,
						area_name: "藤县",
						area_code: "Tengxian",
						area_parent_id: 450400
					},
					"450423": {
						id: 450423,
						area_name: "蒙山县",
						area_code: "Mengshan",
						area_parent_id: 450400
					},
					"450481": {
						id: 450481,
						area_name: "岑溪市",
						area_code: "Cenxi",
						area_parent_id: 450400
					}
				}
			},
			"450500": {
				id: 450500,
				area_name: "北海市",
				area_code: "Beihai",
				area_parent_id: 450000,
				child: {
					"450502": {
						id: 450502,
						area_name: "海城区",
						area_code: "Haicheng",
						area_parent_id: 450500
					},
					"450503": {
						id: 450503,
						area_name: "银海区",
						area_code: "Yinhai",
						area_parent_id: 450500
					},
					"450512": {
						id: 450512,
						area_name: "铁山港区",
						area_code: "Tieshangang",
						area_parent_id: 450500
					},
					"450521": {
						id: 450521,
						area_name: "合浦县",
						area_code: "Hepu",
						area_parent_id: 450500
					}
				}
			},
			"450600": {
				id: 450600,
				area_name: "防城港市",
				area_code: "Fangchenggang",
				area_parent_id: 450000,
				child: {
					"450602": {
						id: 450602,
						area_name: "港口区",
						area_code: "Gangkou",
						area_parent_id: 450600
					},
					"450603": {
						id: 450603,
						area_name: "防城区",
						area_code: "Fangcheng",
						area_parent_id: 450600
					},
					"450621": {
						id: 450621,
						area_name: "上思县",
						area_code: "Shangsi",
						area_parent_id: 450600
					},
					"450681": {
						id: 450681,
						area_name: "东兴市",
						area_code: "Dongxing",
						area_parent_id: 450600
					}
				}
			},
			"450700": {
				id: 450700,
				area_name: "钦州市",
				area_code: "Qinzhou",
				area_parent_id: 450000,
				child: {
					"450702": {
						id: 450702,
						area_name: "钦南区",
						area_code: "Qinnan",
						area_parent_id: 450700
					},
					"450703": {
						id: 450703,
						area_name: "钦北区",
						area_code: "Qinbei",
						area_parent_id: 450700
					},
					"450721": {
						id: 450721,
						area_name: "灵山县",
						area_code: "Lingshan",
						area_parent_id: 450700
					},
					"450722": {
						id: 450722,
						area_name: "浦北县",
						area_code: "Pubei",
						area_parent_id: 450700
					}
				}
			},
			"450800": {
				id: 450800,
				area_name: "贵港市",
				area_code: "Guigang",
				area_parent_id: 450000,
				child: {
					"450802": {
						id: 450802,
						area_name: "港北区",
						area_code: "Gangbei",
						area_parent_id: 450800
					},
					"450803": {
						id: 450803,
						area_name: "港南区",
						area_code: "Gangnan",
						area_parent_id: 450800
					},
					"450804": {
						id: 450804,
						area_name: "覃塘区",
						area_code: "Qintang",
						area_parent_id: 450800
					},
					"450821": {
						id: 450821,
						area_name: "平南县",
						area_code: "Pingnan",
						area_parent_id: 450800
					},
					"450881": {
						id: 450881,
						area_name: "桂平市",
						area_code: "Guiping",
						area_parent_id: 450800
					}
				}
			},
			"450900": {
				id: 450900,
				area_name: "玉林市",
				area_code: "Yulin",
				area_parent_id: 450000,
				child: {
					"450902": {
						id: 450902,
						area_name: "玉州区",
						area_code: "Yuzhou",
						area_parent_id: 450900
					},
					"450903": {
						id: 450903,
						area_name: "福绵区",
						area_code: "Fumian",
						area_parent_id: 450900
					},
					"450904": {
						id: 450904,
						area_name: "玉东新区",
						area_code: "Yudong",
						area_parent_id: 450900
					},
					"450921": {
						id: 450921,
						area_name: "容县",
						area_code: "Rongxian",
						area_parent_id: 450900
					},
					"450922": {
						id: 450922,
						area_name: "陆川县",
						area_code: "Luchuan",
						area_parent_id: 450900
					},
					"450923": {
						id: 450923,
						area_name: "博白县",
						area_code: "Bobai",
						area_parent_id: 450900
					},
					"450924": {
						id: 450924,
						area_name: "兴业县",
						area_code: "Xingye",
						area_parent_id: 450900
					},
					"450981": {
						id: 450981,
						area_name: "北流市",
						area_code: "Beiliu",
						area_parent_id: 450900
					}
				}
			},
			"451000": {
				id: 451000,
				area_name: "百色市",
				area_code: "Baise",
				area_parent_id: 450000,
				child: {
					"451002": {
						id: 451002,
						area_name: "右江区",
						area_code: "Youjiang",
						area_parent_id: 451000
					},
					"451021": {
						id: 451021,
						area_name: "田阳县",
						area_code: "Tianyang",
						area_parent_id: 451000
					},
					"451022": {
						id: 451022,
						area_name: "田东县",
						area_code: "Tiandong",
						area_parent_id: 451000
					},
					"451023": {
						id: 451023,
						area_name: "平果县",
						area_code: "Pingguo",
						area_parent_id: 451000
					},
					"451024": {
						id: 451024,
						area_name: "德保县",
						area_code: "Debao",
						area_parent_id: 451000
					},
					"451025": {
						id: 451025,
						area_name: "靖西县",
						area_code: "Jingxi",
						area_parent_id: 451000
					},
					"451026": {
						id: 451026,
						area_name: "那坡县",
						area_code: "Napo",
						area_parent_id: 451000
					},
					"451027": {
						id: 451027,
						area_name: "凌云县",
						area_code: "Lingyun",
						area_parent_id: 451000
					},
					"451028": {
						id: 451028,
						area_name: "乐业县",
						area_code: "Leye",
						area_parent_id: 451000
					},
					"451029": {
						id: 451029,
						area_name: "田林县",
						area_code: "Tianlin",
						area_parent_id: 451000
					},
					"451030": {
						id: 451030,
						area_name: "西林县",
						area_code: "Xilin",
						area_parent_id: 451000
					},
					"451031": {
						id: 451031,
						area_name: "隆林各族自治县",
						area_code: "Longlin",
						area_parent_id: 451000
					}
				}
			},
			"451100": {
				id: 451100,
				area_name: "贺州市",
				area_code: "Hezhou",
				area_parent_id: 450000,
				child: {
					"451102": {
						id: 451102,
						area_name: "八步区",
						area_code: "Babu",
						area_parent_id: 451100
					},
					"451121": {
						id: 451121,
						area_name: "昭平县",
						area_code: "Zhaoping",
						area_parent_id: 451100
					},
					"451122": {
						id: 451122,
						area_name: "钟山县",
						area_code: "Zhongshan",
						area_parent_id: 451100
					},
					"451123": {
						id: 451123,
						area_name: "富川瑶族自治县",
						area_code: "Fuchuan",
						area_parent_id: 451100
					},
					"451124": {
						id: 451124,
						area_name: "平桂管理区",
						area_code: "Pingui",
						area_parent_id: 451100
					}
				}
			},
			"451200": {
				id: 451200,
				area_name: "河池市",
				area_code: "Hechi",
				area_parent_id: 450000,
				child: {
					"451202": {
						id: 451202,
						area_name: "金城江区",
						area_code: "Jinchengjiang",
						area_parent_id: 451200
					},
					"451221": {
						id: 451221,
						area_name: "南丹县",
						area_code: "Nandan",
						area_parent_id: 451200
					},
					"451222": {
						id: 451222,
						area_name: "天峨县",
						area_code: "Tiane",
						area_parent_id: 451200
					},
					"451223": {
						id: 451223,
						area_name: "凤山县",
						area_code: "Fengshan",
						area_parent_id: 451200
					},
					"451224": {
						id: 451224,
						area_name: "东兰县",
						area_code: "Donglan",
						area_parent_id: 451200
					},
					"451225": {
						id: 451225,
						area_name: "罗城仫佬族自治县",
						area_code: "Luocheng",
						area_parent_id: 451200
					},
					"451226": {
						id: 451226,
						area_name: "环江毛南族自治县",
						area_code: "Huanjiang",
						area_parent_id: 451200
					},
					"451227": {
						id: 451227,
						area_name: "巴马瑶族自治县",
						area_code: "Bama",
						area_parent_id: 451200
					},
					"451228": {
						id: 451228,
						area_name: "都安瑶族自治县",
						area_code: "Du'an",
						area_parent_id: 451200
					},
					"451229": {
						id: 451229,
						area_name: "大化瑶族自治县",
						area_code: "Dahua",
						area_parent_id: 451200
					},
					"451281": {
						id: 451281,
						area_name: "宜州市",
						area_code: "Yizhou",
						area_parent_id: 451200
					}
				}
			},
			"451300": {
				id: 451300,
				area_name: "来宾市",
				area_code: "Laibin",
				area_parent_id: 450000,
				child: {
					"451302": {
						id: 451302,
						area_name: "兴宾区",
						area_code: "Xingbin",
						area_parent_id: 451300
					},
					"451321": {
						id: 451321,
						area_name: "忻城县",
						area_code: "Xincheng",
						area_parent_id: 451300
					},
					"451322": {
						id: 451322,
						area_name: "象州县",
						area_code: "Xiangzhou",
						area_parent_id: 451300
					},
					"451323": {
						id: 451323,
						area_name: "武宣县",
						area_code: "Wuxuan",
						area_parent_id: 451300
					},
					"451324": {
						id: 451324,
						area_name: "金秀瑶族自治县",
						area_code: "Jinxiu",
						area_parent_id: 451300
					},
					"451381": {
						id: 451381,
						area_name: "合山市",
						area_code: "Heshan",
						area_parent_id: 451300
					}
				}
			},
			"451400": {
				id: 451400,
				area_name: "崇左市",
				area_code: "Chongzuo",
				area_parent_id: 450000,
				child: {
					"451402": {
						id: 451402,
						area_name: "江州区",
						area_code: "Jiangzhou",
						area_parent_id: 451400
					},
					"451421": {
						id: 451421,
						area_name: "扶绥县",
						area_code: "Fusui",
						area_parent_id: 451400
					},
					"451422": {
						id: 451422,
						area_name: "宁明县",
						area_code: "Ningming",
						area_parent_id: 451400
					},
					"451423": {
						id: 451423,
						area_name: "龙州县",
						area_code: "Longzhou",
						area_parent_id: 451400
					},
					"451424": {
						id: 451424,
						area_name: "大新县",
						area_code: "Daxin",
						area_parent_id: 451400
					},
					"451425": {
						id: 451425,
						area_name: "天等县",
						area_code: "Tiandeng",
						area_parent_id: 451400
					},
					"451481": {
						id: 451481,
						area_name: "凭祥市",
						area_code: "Pingxiang",
						area_parent_id: 451400
					}
				}
			}
		}
	},
	"460000": {
		id: 460000,
		area_name: "海南省",
		area_code: "Hainan",
		area_parent_id: 0,
		child: {
			"460100": {
				id: 460100,
				area_name: "海口市",
				area_code: "Haikou",
				area_parent_id: 460000,
				child: {
					"460105": {
						id: 460105,
						area_name: "秀英区",
						area_code: "Xiuying",
						area_parent_id: 460100
					},
					"460106": {
						id: 460106,
						area_name: "龙华区",
						area_code: "Longhua",
						area_parent_id: 460100
					},
					"460107": {
						id: 460107,
						area_name: "琼山区",
						area_code: "Qiongshan",
						area_parent_id: 460100
					},
					"460108": {
						id: 460108,
						area_name: "美兰区",
						area_code: "Meilan",
						area_parent_id: 460100
					}
				}
			},
			"460200": {
				id: 460200,
				area_name: "三亚市",
				area_code: "Sanya",
				area_parent_id: 460000,
				child: {
					"460202": {
						id: 460202,
						area_name: "海棠区",
						area_code: "Haitang",
						area_parent_id: 460200
					},
					"460203": {
						id: 460203,
						area_name: "吉阳区",
						area_code: "Jiyang",
						area_parent_id: 460200
					},
					"460204": {
						id: 460204,
						area_name: "天涯区",
						area_code: "Tianya",
						area_parent_id: 460200
					},
					"460205": {
						id: 460205,
						area_name: "崖州区",
						area_code: "Yazhou",
						area_parent_id: 460200
					}
				}
			},
			"460300": {
				id: 460300,
				area_name: "三沙市",
				area_code: "Sansha",
				area_parent_id: 460000,
				child: {
					"460321": {
						id: 460321,
						area_name: "西沙群岛",
						area_code: "Xisha Islands",
						area_parent_id: 460300
					},
					"460322": {
						id: 460322,
						area_name: "南沙群岛",
						area_code: "Nansha Islands",
						area_parent_id: 460300
					},
					"460323": {
						id: 460323,
						area_name: "中沙群岛",
						area_code: "Zhongsha Islands",
						area_parent_id: 460300
					}
				}
			},
			"469000": {
				id: 469000,
				area_name: "直辖县级",
				area_code: "",
				area_parent_id: 460000,
				child: {
					"469001": {
						id: 469001,
						area_name: "五指山市",
						area_code: "Wuzhishan",
						area_parent_id: 469000
					},
					"469002": {
						id: 469002,
						area_name: "琼海市",
						area_code: "Qionghai",
						area_parent_id: 469000
					},
					"469003": {
						id: 469003,
						area_name: "儋州市",
						area_code: "Danzhou",
						area_parent_id: 469000
					},
					"469005": {
						id: 469005,
						area_name: "文昌市",
						area_code: "Wenchang",
						area_parent_id: 469000
					},
					"469006": {
						id: 469006,
						area_name: "万宁市",
						area_code: "Wanning",
						area_parent_id: 469000
					},
					"469007": {
						id: 469007,
						area_name: "东方市",
						area_code: "Dongfang",
						area_parent_id: 469000
					},
					"469021": {
						id: 469021,
						area_name: "定安县",
						area_code: "Ding'an",
						area_parent_id: 469000
					},
					"469022": {
						id: 469022,
						area_name: "屯昌县",
						area_code: "Tunchang",
						area_parent_id: 469000
					},
					"469023": {
						id: 469023,
						area_name: "澄迈县",
						area_code: "Chengmai",
						area_parent_id: 469000
					},
					"469024": {
						id: 469024,
						area_name: "临高县",
						area_code: "Lingao",
						area_parent_id: 469000
					},
					"469025": {
						id: 469025,
						area_name: "白沙黎族自治县",
						area_code: "Baisha",
						area_parent_id: 469000
					},
					"469026": {
						id: 469026,
						area_name: "昌江黎族自治县",
						area_code: "Changjiang",
						area_parent_id: 469000
					},
					"469027": {
						id: 469027,
						area_name: "乐东黎族自治县",
						area_code: "Ledong",
						area_parent_id: 469000
					},
					"469028": {
						id: 469028,
						area_name: "陵水黎族自治县",
						area_code: "Lingshui",
						area_parent_id: 469000
					},
					"469029": {
						id: 469029,
						area_name: "保亭黎族苗族自治县",
						area_code: "Baoting",
						area_parent_id: 469000
					},
					"469030": {
						id: 469030,
						area_name: "琼中黎族苗族自治县",
						area_code: "Qiongzhong",
						area_parent_id: 469000
					}
				}
			}
		}
	},
	"500000": {
		id: 500000,
		area_name: "重庆",
		area_code: "Chongqing",
		area_parent_id: 0,
		child: {
			"500100": {
				id: 500100,
				area_name: "重庆市",
				area_code: "Chongqing",
				area_parent_id: 500000,
				child: {
					"500101": {
						id: 500101,
						area_name: "万州区",
						area_code: "Wanzhou",
						area_parent_id: 500100
					},
					"500102": {
						id: 500102,
						area_name: "涪陵区",
						area_code: "Fuling",
						area_parent_id: 500100
					},
					"500103": {
						id: 500103,
						area_name: "渝中区",
						area_code: "Yuzhong",
						area_parent_id: 500100
					},
					"500104": {
						id: 500104,
						area_name: "大渡口区",
						area_code: "Dadukou",
						area_parent_id: 500100
					},
					"500105": {
						id: 500105,
						area_name: "江北区",
						area_code: "Jiangbei",
						area_parent_id: 500100
					},
					"500106": {
						id: 500106,
						area_name: "沙坪坝区",
						area_code: "Shapingba",
						area_parent_id: 500100
					},
					"500107": {
						id: 500107,
						area_name: "九龙坡区",
						area_code: "Jiulongpo",
						area_parent_id: 500100
					},
					"500108": {
						id: 500108,
						area_name: "南岸区",
						area_code: "Nan'an",
						area_parent_id: 500100
					},
					"500109": {
						id: 500109,
						area_name: "北碚区",
						area_code: "Beibei",
						area_parent_id: 500100
					},
					"500110": {
						id: 500110,
						area_name: "綦江区",
						area_code: "Qijiang",
						area_parent_id: 500100
					},
					"500111": {
						id: 500111,
						area_name: "大足区",
						area_code: "Dazu",
						area_parent_id: 500100
					},
					"500112": {
						id: 500112,
						area_name: "渝北区",
						area_code: "Yubei",
						area_parent_id: 500100
					},
					"500113": {
						id: 500113,
						area_name: "巴南区",
						area_code: "Banan",
						area_parent_id: 500100
					},
					"500114": {
						id: 500114,
						area_name: "黔江区",
						area_code: "Qianjiang",
						area_parent_id: 500100
					},
					"500115": {
						id: 500115,
						area_name: "长寿区",
						area_code: "Changshou",
						area_parent_id: 500100
					},
					"500116": {
						id: 500116,
						area_name: "江津区",
						area_code: "Jiangjin",
						area_parent_id: 500100
					},
					"500117": {
						id: 500117,
						area_name: "合川区",
						area_code: "Hechuan",
						area_parent_id: 500100
					},
					"500118": {
						id: 500118,
						area_name: "永川区",
						area_code: "Yongchuan",
						area_parent_id: 500100
					},
					"500119": {
						id: 500119,
						area_name: "南川区",
						area_code: "Nanchuan",
						area_parent_id: 500100
					},
					"500120": {
						id: 500120,
						area_name: "璧山区",
						area_code: "Bishan",
						area_parent_id: 500100
					},
					"500151": {
						id: 500151,
						area_name: "铜梁区",
						area_code: "Tongliang",
						area_parent_id: 500100
					},
					"500223": {
						id: 500223,
						area_name: "潼南县",
						area_code: "Tongnan",
						area_parent_id: 500100
					},
					"500226": {
						id: 500226,
						area_name: "荣昌县",
						area_code: "Rongchang",
						area_parent_id: 500100
					},
					"500228": {
						id: 500228,
						area_name: "梁平县",
						area_code: "Liangping",
						area_parent_id: 500100
					},
					"500229": {
						id: 500229,
						area_name: "城口县",
						area_code: "Chengkou",
						area_parent_id: 500100
					},
					"500230": {
						id: 500230,
						area_name: "丰都县",
						area_code: "Fengdu",
						area_parent_id: 500100
					},
					"500231": {
						id: 500231,
						area_name: "垫江县",
						area_code: "Dianjiang",
						area_parent_id: 500100
					},
					"500232": {
						id: 500232,
						area_name: "武隆县",
						area_code: "Wulong",
						area_parent_id: 500100
					},
					"500233": {
						id: 500233,
						area_name: "忠县",
						area_code: "Zhongxian",
						area_parent_id: 500100
					},
					"500234": {
						id: 500234,
						area_name: "开县",
						area_code: "Kaixian",
						area_parent_id: 500100
					},
					"500235": {
						id: 500235,
						area_name: "云阳县",
						area_code: "Yunyang",
						area_parent_id: 500100
					},
					"500236": {
						id: 500236,
						area_name: "奉节县",
						area_code: "Fengjie",
						area_parent_id: 500100
					},
					"500237": {
						id: 500237,
						area_name: "巫山县",
						area_code: "Wushan",
						area_parent_id: 500100
					},
					"500238": {
						id: 500238,
						area_name: "巫溪县",
						area_code: "Wuxi",
						area_parent_id: 500100
					},
					"500240": {
						id: 500240,
						area_name: "石柱土家族自治县",
						area_code: "Shizhu",
						area_parent_id: 500100
					},
					"500241": {
						id: 500241,
						area_name: "秀山土家族苗族自治县",
						area_code: "Xiushan",
						area_parent_id: 500100
					},
					"500242": {
						id: 500242,
						area_name: "酉阳土家族苗族自治县",
						area_code: "Youyang",
						area_parent_id: 500100
					},
					"500243": {
						id: 500243,
						area_name: "彭水苗族土家族自治县",
						area_code: "Pengshui",
						area_parent_id: 500100
					}
				}
			},
			"500300": {
				id: 500300,
				area_name: "两江新区",
				area_code: "Liangjiangxinqu",
				area_parent_id: 500000,
				child: {
					"500301": {
						id: 500301,
						area_name: "北部新区",
						area_code: "Beibuxinqu",
						area_parent_id: 500300
					},
					"500302": {
						id: 500302,
						area_name: "保税港区",
						area_code: "Baoshuigangqu",
						area_parent_id: 500300
					},
					"500303": {
						id: 500303,
						area_name: "工业园区",
						area_code: "Gongyeyuanqu",
						area_parent_id: 500300
					}
				}
			}
		}
	},
	"510000": {
		id: 510000,
		area_name: "四川省",
		area_code: "Sichuan",
		area_parent_id: 0,
		child: {
			"510100": {
				id: 510100,
				area_name: "成都市",
				area_code: "Chengdu",
				area_parent_id: 510000,
				child: {
					"510104": {
						id: 510104,
						area_name: "锦江区",
						area_code: "Jinjiang",
						area_parent_id: 510100
					},
					"510105": {
						id: 510105,
						area_name: "青羊区",
						area_code: "Qingyang",
						area_parent_id: 510100
					},
					"510106": {
						id: 510106,
						area_name: "金牛区",
						area_code: "Jinniu",
						area_parent_id: 510100
					},
					"510107": {
						id: 510107,
						area_name: "武侯区",
						area_code: "Wuhou",
						area_parent_id: 510100
					},
					"510108": {
						id: 510108,
						area_name: "成华区",
						area_code: "Chenghua",
						area_parent_id: 510100
					},
					"510112": {
						id: 510112,
						area_name: "龙泉驿区",
						area_code: "Longquanyi",
						area_parent_id: 510100
					},
					"510113": {
						id: 510113,
						area_name: "青白江区",
						area_code: "Qingbaijiang",
						area_parent_id: 510100
					},
					"510114": {
						id: 510114,
						area_name: "新都区",
						area_code: "Xindu",
						area_parent_id: 510100
					},
					"510115": {
						id: 510115,
						area_name: "温江区",
						area_code: "Wenjiang",
						area_parent_id: 510100
					},
					"510121": {
						id: 510121,
						area_name: "金堂县",
						area_code: "Jintang",
						area_parent_id: 510100
					},
					"510122": {
						id: 510122,
						area_name: "双流县",
						area_code: "Shuangliu",
						area_parent_id: 510100
					},
					"510124": {
						id: 510124,
						area_name: "郫县",
						area_code: "Pixian",
						area_parent_id: 510100
					},
					"510129": {
						id: 510129,
						area_name: "大邑县",
						area_code: "Dayi",
						area_parent_id: 510100
					},
					"510131": {
						id: 510131,
						area_name: "蒲江县",
						area_code: "Pujiang",
						area_parent_id: 510100
					},
					"510132": {
						id: 510132,
						area_name: "新津县",
						area_code: "Xinjin",
						area_parent_id: 510100
					},
					"510181": {
						id: 510181,
						area_name: "都江堰市",
						area_code: "Dujiangyan",
						area_parent_id: 510100
					},
					"510182": {
						id: 510182,
						area_name: "彭州市",
						area_code: "Pengzhou",
						area_parent_id: 510100
					},
					"510183": {
						id: 510183,
						area_name: "邛崃市",
						area_code: "Qionglai",
						area_parent_id: 510100
					},
					"510184": {
						id: 510184,
						area_name: "崇州市",
						area_code: "Chongzhou",
						area_parent_id: 510100
					}
				}
			},
			"510300": {
				id: 510300,
				area_name: "自贡市",
				area_code: "Zigong",
				area_parent_id: 510000,
				child: {
					"510302": {
						id: 510302,
						area_name: "自流井区",
						area_code: "Ziliujing",
						area_parent_id: 510300
					},
					"510303": {
						id: 510303,
						area_name: "贡井区",
						area_code: "Gongjing",
						area_parent_id: 510300
					},
					"510304": {
						id: 510304,
						area_name: "大安区",
						area_code: "Da'an",
						area_parent_id: 510300
					},
					"510311": {
						id: 510311,
						area_name: "沿滩区",
						area_code: "Yantan",
						area_parent_id: 510300
					},
					"510321": {
						id: 510321,
						area_name: "荣县",
						area_code: "Rongxian",
						area_parent_id: 510300
					},
					"510322": {
						id: 510322,
						area_name: "富顺县",
						area_code: "Fushun",
						area_parent_id: 510300
					}
				}
			},
			"510400": {
				id: 510400,
				area_name: "攀枝花市",
				area_code: "Panzhihua",
				area_parent_id: 510000,
				child: {
					"510402": {
						id: 510402,
						area_name: "东区",
						area_code: "Dongqu",
						area_parent_id: 510400
					},
					"510403": {
						id: 510403,
						area_name: "西区",
						area_code: "Xiqu",
						area_parent_id: 510400
					},
					"510411": {
						id: 510411,
						area_name: "仁和区",
						area_code: "Renhe",
						area_parent_id: 510400
					},
					"510421": {
						id: 510421,
						area_name: "米易县",
						area_code: "Miyi",
						area_parent_id: 510400
					},
					"510422": {
						id: 510422,
						area_name: "盐边县",
						area_code: "Yanbian",
						area_parent_id: 510400
					}
				}
			},
			"510500": {
				id: 510500,
				area_name: "泸州市",
				area_code: "Luzhou",
				area_parent_id: 510000,
				child: {
					"510502": {
						id: 510502,
						area_name: "江阳区",
						area_code: "Jiangyang",
						area_parent_id: 510500
					},
					"510503": {
						id: 510503,
						area_name: "纳溪区",
						area_code: "Naxi",
						area_parent_id: 510500
					},
					"510504": {
						id: 510504,
						area_name: "龙马潭区",
						area_code: "Longmatan",
						area_parent_id: 510500
					},
					"510521": {
						id: 510521,
						area_name: "泸县",
						area_code: "Luxian",
						area_parent_id: 510500
					},
					"510522": {
						id: 510522,
						area_name: "合江县",
						area_code: "Hejiang",
						area_parent_id: 510500
					},
					"510524": {
						id: 510524,
						area_name: "叙永县",
						area_code: "Xuyong",
						area_parent_id: 510500
					},
					"510525": {
						id: 510525,
						area_name: "古蔺县",
						area_code: "Gulin",
						area_parent_id: 510500
					}
				}
			},
			"510600": {
				id: 510600,
				area_name: "德阳市",
				area_code: "Deyang",
				area_parent_id: 510000,
				child: {
					"510603": {
						id: 510603,
						area_name: "旌阳区",
						area_code: "Jingyang",
						area_parent_id: 510600
					},
					"510623": {
						id: 510623,
						area_name: "中江县",
						area_code: "Zhongjiang",
						area_parent_id: 510600
					},
					"510626": {
						id: 510626,
						area_name: "罗江县",
						area_code: "Luojiang",
						area_parent_id: 510600
					},
					"510681": {
						id: 510681,
						area_name: "广汉市",
						area_code: "Guanghan",
						area_parent_id: 510600
					},
					"510682": {
						id: 510682,
						area_name: "什邡市",
						area_code: "Shifang",
						area_parent_id: 510600
					},
					"510683": {
						id: 510683,
						area_name: "绵竹市",
						area_code: "Mianzhu",
						area_parent_id: 510600
					}
				}
			},
			"510700": {
				id: 510700,
				area_name: "绵阳市",
				area_code: "Mianyang",
				area_parent_id: 510000,
				child: {
					"510703": {
						id: 510703,
						area_name: "涪城区",
						area_code: "Fucheng",
						area_parent_id: 510700
					},
					"510704": {
						id: 510704,
						area_name: "游仙区",
						area_code: "Youxian",
						area_parent_id: 510700
					},
					"510722": {
						id: 510722,
						area_name: "三台县",
						area_code: "Santai",
						area_parent_id: 510700
					},
					"510723": {
						id: 510723,
						area_name: "盐亭县",
						area_code: "Yanting",
						area_parent_id: 510700
					},
					"510724": {
						id: 510724,
						area_name: "安县",
						area_code: "Anxian",
						area_parent_id: 510700
					},
					"510725": {
						id: 510725,
						area_name: "梓潼县",
						area_code: "Zitong",
						area_parent_id: 510700
					},
					"510726": {
						id: 510726,
						area_name: "北川羌族自治县",
						area_code: "Beichuan",
						area_parent_id: 510700
					},
					"510727": {
						id: 510727,
						area_name: "平武县",
						area_code: "Pingwu",
						area_parent_id: 510700
					},
					"510781": {
						id: 510781,
						area_name: "江油市",
						area_code: "Jiangyou",
						area_parent_id: 510700
					}
				}
			},
			"510800": {
				id: 510800,
				area_name: "广元市",
				area_code: "Guangyuan",
				area_parent_id: 510000,
				child: {
					"510802": {
						id: 510802,
						area_name: "利州区",
						area_code: "Lizhou",
						area_parent_id: 510800
					},
					"510811": {
						id: 510811,
						area_name: "昭化区",
						area_code: "Zhaohua",
						area_parent_id: 510800
					},
					"510812": {
						id: 510812,
						area_name: "朝天区",
						area_code: "Chaotian",
						area_parent_id: 510800
					},
					"510821": {
						id: 510821,
						area_name: "旺苍县",
						area_code: "Wangcang",
						area_parent_id: 510800
					},
					"510822": {
						id: 510822,
						area_name: "青川县",
						area_code: "Qingchuan",
						area_parent_id: 510800
					},
					"510823": {
						id: 510823,
						area_name: "剑阁县",
						area_code: "Jiange",
						area_parent_id: 510800
					},
					"510824": {
						id: 510824,
						area_name: "苍溪县",
						area_code: "Cangxi",
						area_parent_id: 510800
					}
				}
			},
			"510900": {
				id: 510900,
				area_name: "遂宁市",
				area_code: "Suining",
				area_parent_id: 510000,
				child: {
					"510903": {
						id: 510903,
						area_name: "船山区",
						area_code: "Chuanshan",
						area_parent_id: 510900
					},
					"510904": {
						id: 510904,
						area_name: "安居区",
						area_code: "Anju",
						area_parent_id: 510900
					},
					"510921": {
						id: 510921,
						area_name: "蓬溪县",
						area_code: "Pengxi",
						area_parent_id: 510900
					},
					"510922": {
						id: 510922,
						area_name: "射洪县",
						area_code: "Shehong",
						area_parent_id: 510900
					},
					"510923": {
						id: 510923,
						area_name: "大英县",
						area_code: "Daying",
						area_parent_id: 510900
					}
				}
			},
			"511000": {
				id: 511000,
				area_name: "内江市",
				area_code: "Neijiang",
				area_parent_id: 510000,
				child: {
					"511002": {
						id: 511002,
						area_name: "市中区",
						area_code: "Shizhongqu",
						area_parent_id: 511000
					},
					"511011": {
						id: 511011,
						area_name: "东兴区",
						area_code: "Dongxing",
						area_parent_id: 511000
					},
					"511024": {
						id: 511024,
						area_name: "威远县",
						area_code: "Weiyuan",
						area_parent_id: 511000
					},
					"511025": {
						id: 511025,
						area_name: "资中县",
						area_code: "Zizhong",
						area_parent_id: 511000
					},
					"511028": {
						id: 511028,
						area_name: "隆昌县",
						area_code: "Longchang",
						area_parent_id: 511000
					}
				}
			},
			"511100": {
				id: 511100,
				area_name: "乐山市",
				area_code: "Leshan",
				area_parent_id: 510000,
				child: {
					"511102": {
						id: 511102,
						area_name: "市中区",
						area_code: "Shizhongqu",
						area_parent_id: 511100
					},
					"511111": {
						id: 511111,
						area_name: "沙湾区",
						area_code: "Shawan",
						area_parent_id: 511100
					},
					"511112": {
						id: 511112,
						area_name: "五通桥区",
						area_code: "Wutongqiao",
						area_parent_id: 511100
					},
					"511113": {
						id: 511113,
						area_name: "金口河区",
						area_code: "Jinkouhe",
						area_parent_id: 511100
					},
					"511123": {
						id: 511123,
						area_name: "犍为县",
						area_code: "Qianwei",
						area_parent_id: 511100
					},
					"511124": {
						id: 511124,
						area_name: "井研县",
						area_code: "Jingyan",
						area_parent_id: 511100
					},
					"511126": {
						id: 511126,
						area_name: "夹江县",
						area_code: "Jiajiang",
						area_parent_id: 511100
					},
					"511129": {
						id: 511129,
						area_name: "沐川县",
						area_code: "Muchuan",
						area_parent_id: 511100
					},
					"511132": {
						id: 511132,
						area_name: "峨边彝族自治县",
						area_code: "Ebian",
						area_parent_id: 511100
					},
					"511133": {
						id: 511133,
						area_name: "马边彝族自治县",
						area_code: "Mabian",
						area_parent_id: 511100
					},
					"511181": {
						id: 511181,
						area_name: "峨眉山市",
						area_code: "Emeishan",
						area_parent_id: 511100
					}
				}
			},
			"511300": {
				id: 511300,
				area_name: "南充市",
				area_code: "Nanchong",
				area_parent_id: 510000,
				child: {
					"511302": {
						id: 511302,
						area_name: "顺庆区",
						area_code: "Shunqing",
						area_parent_id: 511300
					},
					"511303": {
						id: 511303,
						area_name: "高坪区",
						area_code: "Gaoping",
						area_parent_id: 511300
					},
					"511304": {
						id: 511304,
						area_name: "嘉陵区",
						area_code: "Jialing",
						area_parent_id: 511300
					},
					"511321": {
						id: 511321,
						area_name: "南部县",
						area_code: "Nanbu",
						area_parent_id: 511300
					},
					"511322": {
						id: 511322,
						area_name: "营山县",
						area_code: "Yingshan",
						area_parent_id: 511300
					},
					"511323": {
						id: 511323,
						area_name: "蓬安县",
						area_code: "Peng'an",
						area_parent_id: 511300
					},
					"511324": {
						id: 511324,
						area_name: "仪陇县",
						area_code: "Yilong",
						area_parent_id: 511300
					},
					"511325": {
						id: 511325,
						area_name: "西充县",
						area_code: "Xichong",
						area_parent_id: 511300
					},
					"511381": {
						id: 511381,
						area_name: "阆中市",
						area_code: "Langzhong",
						area_parent_id: 511300
					}
				}
			},
			"511400": {
				id: 511400,
				area_name: "眉山市",
				area_code: "Meishan",
				area_parent_id: 510000,
				child: {
					"511402": {
						id: 511402,
						area_name: "东坡区",
						area_code: "Dongpo",
						area_parent_id: 511400
					},
					"511403": {
						id: 511403,
						area_name: "彭山区",
						area_code: "Pengshan",
						area_parent_id: 511400
					},
					"511421": {
						id: 511421,
						area_name: "仁寿县",
						area_code: "Renshou",
						area_parent_id: 511400
					},
					"511423": {
						id: 511423,
						area_name: "洪雅县",
						area_code: "Hongya",
						area_parent_id: 511400
					},
					"511424": {
						id: 511424,
						area_name: "丹棱县",
						area_code: "Danling",
						area_parent_id: 511400
					},
					"511425": {
						id: 511425,
						area_name: "青神县",
						area_code: "Qingshen",
						area_parent_id: 511400
					}
				}
			},
			"511500": {
				id: 511500,
				area_name: "宜宾市",
				area_code: "Yibin",
				area_parent_id: 510000,
				child: {
					"511502": {
						id: 511502,
						area_name: "翠屏区",
						area_code: "Cuiping",
						area_parent_id: 511500
					},
					"511503": {
						id: 511503,
						area_name: "南溪区",
						area_code: "Nanxi",
						area_parent_id: 511500
					},
					"511521": {
						id: 511521,
						area_name: "宜宾县",
						area_code: "Yibin",
						area_parent_id: 511500
					},
					"511523": {
						id: 511523,
						area_name: "江安县",
						area_code: "Jiang'an",
						area_parent_id: 511500
					},
					"511524": {
						id: 511524,
						area_name: "长宁县",
						area_code: "Changning",
						area_parent_id: 511500
					},
					"511525": {
						id: 511525,
						area_name: "高县",
						area_code: "Gaoxian",
						area_parent_id: 511500
					},
					"511526": {
						id: 511526,
						area_name: "珙县",
						area_code: "Gongxian",
						area_parent_id: 511500
					},
					"511527": {
						id: 511527,
						area_name: "筠连县",
						area_code: "Junlian",
						area_parent_id: 511500
					},
					"511528": {
						id: 511528,
						area_name: "兴文县",
						area_code: "Xingwen",
						area_parent_id: 511500
					},
					"511529": {
						id: 511529,
						area_name: "屏山县",
						area_code: "Pingshan",
						area_parent_id: 511500
					}
				}
			},
			"511600": {
				id: 511600,
				area_name: "广安市",
				area_code: "Guang'an",
				area_parent_id: 510000,
				child: {
					"511602": {
						id: 511602,
						area_name: "广安区",
						area_code: "Guang'an",
						area_parent_id: 511600
					},
					"511603": {
						id: 511603,
						area_name: "前锋区",
						area_code: "Qianfeng",
						area_parent_id: 511600
					},
					"511621": {
						id: 511621,
						area_name: "岳池县",
						area_code: "Yuechi",
						area_parent_id: 511600
					},
					"511622": {
						id: 511622,
						area_name: "武胜县",
						area_code: "Wusheng",
						area_parent_id: 511600
					},
					"511623": {
						id: 511623,
						area_name: "邻水县",
						area_code: "Linshui",
						area_parent_id: 511600
					},
					"511681": {
						id: 511681,
						area_name: "华蓥市",
						area_code: "Huaying",
						area_parent_id: 511600
					}
				}
			},
			"511700": {
				id: 511700,
				area_name: "达州市",
				area_code: "Dazhou",
				area_parent_id: 510000,
				child: {
					"511702": {
						id: 511702,
						area_name: "通川区",
						area_code: "Tongchuan",
						area_parent_id: 511700
					},
					"511703": {
						id: 511703,
						area_name: "达川区",
						area_code: "Dachuan",
						area_parent_id: 511700
					},
					"511722": {
						id: 511722,
						area_name: "宣汉县",
						area_code: "Xuanhan",
						area_parent_id: 511700
					},
					"511723": {
						id: 511723,
						area_name: "开江县",
						area_code: "Kaijiang",
						area_parent_id: 511700
					},
					"511724": {
						id: 511724,
						area_name: "大竹县",
						area_code: "Dazhu",
						area_parent_id: 511700
					},
					"511725": {
						id: 511725,
						area_name: "渠县",
						area_code: "Quxian",
						area_parent_id: 511700
					},
					"511781": {
						id: 511781,
						area_name: "万源市",
						area_code: "Wanyuan",
						area_parent_id: 511700
					}
				}
			},
			"511800": {
				id: 511800,
				area_name: "雅安市",
				area_code: "Ya'an",
				area_parent_id: 510000,
				child: {
					"511802": {
						id: 511802,
						area_name: "雨城区",
						area_code: "Yucheng",
						area_parent_id: 511800
					},
					"511803": {
						id: 511803,
						area_name: "名山区",
						area_code: "Mingshan",
						area_parent_id: 511800
					},
					"511822": {
						id: 511822,
						area_name: "荥经县",
						area_code: "Yingjing",
						area_parent_id: 511800
					},
					"511823": {
						id: 511823,
						area_name: "汉源县",
						area_code: "Hanyuan",
						area_parent_id: 511800
					},
					"511824": {
						id: 511824,
						area_name: "石棉县",
						area_code: "Shimian",
						area_parent_id: 511800
					},
					"511825": {
						id: 511825,
						area_name: "天全县",
						area_code: "Tianquan",
						area_parent_id: 511800
					},
					"511826": {
						id: 511826,
						area_name: "芦山县",
						area_code: "Lushan",
						area_parent_id: 511800
					},
					"511827": {
						id: 511827,
						area_name: "宝兴县",
						area_code: "Baoxing",
						area_parent_id: 511800
					}
				}
			},
			"511900": {
				id: 511900,
				area_name: "巴中市",
				area_code: "Bazhong",
				area_parent_id: 510000,
				child: {
					"511902": {
						id: 511902,
						area_name: "巴州区",
						area_code: "Bazhou",
						area_parent_id: 511900
					},
					"511903": {
						id: 511903,
						area_name: "恩阳区",
						area_code: "Enyang",
						area_parent_id: 511900
					},
					"511921": {
						id: 511921,
						area_name: "通江县",
						area_code: "Tongjiang",
						area_parent_id: 511900
					},
					"511922": {
						id: 511922,
						area_name: "南江县",
						area_code: "Nanjiang",
						area_parent_id: 511900
					},
					"511923": {
						id: 511923,
						area_name: "平昌县",
						area_code: "Pingchang",
						area_parent_id: 511900
					}
				}
			},
			"512000": {
				id: 512000,
				area_name: "资阳市",
				area_code: "Ziyang",
				area_parent_id: 510000,
				child: {
					"512002": {
						id: 512002,
						area_name: "雁江区",
						area_code: "Yanjiang",
						area_parent_id: 512000
					},
					"512021": {
						id: 512021,
						area_name: "安岳县",
						area_code: "Anyue",
						area_parent_id: 512000
					},
					"512022": {
						id: 512022,
						area_name: "乐至县",
						area_code: "Lezhi",
						area_parent_id: 512000
					},
					"512081": {
						id: 512081,
						area_name: "简阳市",
						area_code: "Jianyang",
						area_parent_id: 512000
					}
				}
			},
			"513200": {
				id: 513200,
				area_name: "阿坝藏族羌族自治州",
				area_code: "Aba",
				area_parent_id: 510000,
				child: {
					"513221": {
						id: 513221,
						area_name: "汶川县",
						area_code: "Wenchuan",
						area_parent_id: 513200
					},
					"513222": {
						id: 513222,
						area_name: "理县",
						area_code: "Lixian",
						area_parent_id: 513200
					},
					"513223": {
						id: 513223,
						area_name: "茂县",
						area_code: "Maoxian",
						area_parent_id: 513200
					},
					"513224": {
						id: 513224,
						area_name: "松潘县",
						area_code: "Songpan",
						area_parent_id: 513200
					},
					"513225": {
						id: 513225,
						area_name: "九寨沟县",
						area_code: "Jiuzhaigou",
						area_parent_id: 513200
					},
					"513226": {
						id: 513226,
						area_name: "金川县",
						area_code: "Jinchuan",
						area_parent_id: 513200
					},
					"513227": {
						id: 513227,
						area_name: "小金县",
						area_code: "Xiaojin",
						area_parent_id: 513200
					},
					"513228": {
						id: 513228,
						area_name: "黑水县",
						area_code: "Heishui",
						area_parent_id: 513200
					},
					"513229": {
						id: 513229,
						area_name: "马尔康县",
						area_code: "Maerkang",
						area_parent_id: 513200
					},
					"513230": {
						id: 513230,
						area_name: "壤塘县",
						area_code: "Rangtang",
						area_parent_id: 513200
					},
					"513231": {
						id: 513231,
						area_name: "阿坝县",
						area_code: "Aba",
						area_parent_id: 513200
					},
					"513232": {
						id: 513232,
						area_name: "若尔盖县",
						area_code: "Ruoergai",
						area_parent_id: 513200
					},
					"513233": {
						id: 513233,
						area_name: "红原县",
						area_code: "Hongyuan",
						area_parent_id: 513200
					}
				}
			},
			"513300": {
				id: 513300,
				area_name: "甘孜藏族自治州",
				area_code: "Garze",
				area_parent_id: 510000,
				child: {
					"513321": {
						id: 513321,
						area_name: "康定县",
						area_code: "Kangding",
						area_parent_id: 513300
					},
					"513322": {
						id: 513322,
						area_name: "泸定县",
						area_code: "Luding",
						area_parent_id: 513300
					},
					"513323": {
						id: 513323,
						area_name: "丹巴县",
						area_code: "Danba",
						area_parent_id: 513300
					},
					"513324": {
						id: 513324,
						area_name: "九龙县",
						area_code: "Jiulong",
						area_parent_id: 513300
					},
					"513325": {
						id: 513325,
						area_name: "雅江县",
						area_code: "Yajiang",
						area_parent_id: 513300
					},
					"513326": {
						id: 513326,
						area_name: "道孚县",
						area_code: "Daofu",
						area_parent_id: 513300
					},
					"513327": {
						id: 513327,
						area_name: "炉霍县",
						area_code: "Luhuo",
						area_parent_id: 513300
					},
					"513328": {
						id: 513328,
						area_name: "甘孜县",
						area_code: "Ganzi",
						area_parent_id: 513300
					},
					"513329": {
						id: 513329,
						area_name: "新龙县",
						area_code: "Xinlong",
						area_parent_id: 513300
					},
					"513330": {
						id: 513330,
						area_name: "德格县",
						area_code: "Dege",
						area_parent_id: 513300
					},
					"513331": {
						id: 513331,
						area_name: "白玉县",
						area_code: "Baiyu",
						area_parent_id: 513300
					},
					"513332": {
						id: 513332,
						area_name: "石渠县",
						area_code: "Shiqu",
						area_parent_id: 513300
					},
					"513333": {
						id: 513333,
						area_name: "色达县",
						area_code: "Seda",
						area_parent_id: 513300
					},
					"513334": {
						id: 513334,
						area_name: "理塘县",
						area_code: "Litang",
						area_parent_id: 513300
					},
					"513335": {
						id: 513335,
						area_name: "巴塘县",
						area_code: "Batang",
						area_parent_id: 513300
					},
					"513336": {
						id: 513336,
						area_name: "乡城县",
						area_code: "Xiangcheng",
						area_parent_id: 513300
					},
					"513337": {
						id: 513337,
						area_name: "稻城县",
						area_code: "Daocheng",
						area_parent_id: 513300
					},
					"513338": {
						id: 513338,
						area_name: "得荣县",
						area_code: "Derong",
						area_parent_id: 513300
					}
				}
			},
			"513400": {
				id: 513400,
				area_name: "凉山彝族自治州",
				area_code: "Liangshan",
				area_parent_id: 510000,
				child: {
					"513401": {
						id: 513401,
						area_name: "西昌市",
						area_code: "Xichang",
						area_parent_id: 513400
					},
					"513422": {
						id: 513422,
						area_name: "木里藏族自治县",
						area_code: "Muli",
						area_parent_id: 513400
					},
					"513423": {
						id: 513423,
						area_name: "盐源县",
						area_code: "Yanyuan",
						area_parent_id: 513400
					},
					"513424": {
						id: 513424,
						area_name: "德昌县",
						area_code: "Dechang",
						area_parent_id: 513400
					},
					"513425": {
						id: 513425,
						area_name: "会理县",
						area_code: "Huili",
						area_parent_id: 513400
					},
					"513426": {
						id: 513426,
						area_name: "会东县",
						area_code: "Huidong",
						area_parent_id: 513400
					},
					"513427": {
						id: 513427,
						area_name: "宁南县",
						area_code: "Ningnan",
						area_parent_id: 513400
					},
					"513428": {
						id: 513428,
						area_name: "普格县",
						area_code: "Puge",
						area_parent_id: 513400
					},
					"513429": {
						id: 513429,
						area_name: "布拖县",
						area_code: "Butuo",
						area_parent_id: 513400
					},
					"513430": {
						id: 513430,
						area_name: "金阳县",
						area_code: "Jinyang",
						area_parent_id: 513400
					},
					"513431": {
						id: 513431,
						area_name: "昭觉县",
						area_code: "Zhaojue",
						area_parent_id: 513400
					},
					"513432": {
						id: 513432,
						area_name: "喜德县",
						area_code: "Xide",
						area_parent_id: 513400
					},
					"513433": {
						id: 513433,
						area_name: "冕宁县",
						area_code: "Mianning",
						area_parent_id: 513400
					},
					"513434": {
						id: 513434,
						area_name: "越西县",
						area_code: "Yuexi",
						area_parent_id: 513400
					},
					"513435": {
						id: 513435,
						area_name: "甘洛县",
						area_code: "Ganluo",
						area_parent_id: 513400
					},
					"513436": {
						id: 513436,
						area_name: "美姑县",
						area_code: "Meigu",
						area_parent_id: 513400
					},
					"513437": {
						id: 513437,
						area_name: "雷波县",
						area_code: "Leibo",
						area_parent_id: 513400
					}
				}
			}
		}
	},
	"520000": {
		id: 520000,
		area_name: "贵州省",
		area_code: "Guizhou",
		area_parent_id: 0,
		child: {
			"520100": {
				id: 520100,
				area_name: "贵阳市",
				area_code: "Guiyang",
				area_parent_id: 520000,
				child: {
					"520102": {
						id: 520102,
						area_name: "南明区",
						area_code: "Nanming",
						area_parent_id: 520100
					},
					"520103": {
						id: 520103,
						area_name: "云岩区",
						area_code: "Yunyan",
						area_parent_id: 520100
					},
					"520111": {
						id: 520111,
						area_name: "花溪区",
						area_code: "Huaxi",
						area_parent_id: 520100
					},
					"520112": {
						id: 520112,
						area_name: "乌当区",
						area_code: "Wudang",
						area_parent_id: 520100
					},
					"520113": {
						id: 520113,
						area_name: "白云区",
						area_code: "Baiyun",
						area_parent_id: 520100
					},
					"520115": {
						id: 520115,
						area_name: "观山湖区",
						area_code: "Guanshanhu",
						area_parent_id: 520100
					},
					"520121": {
						id: 520121,
						area_name: "开阳县",
						area_code: "Kaiyang",
						area_parent_id: 520100
					},
					"520122": {
						id: 520122,
						area_name: "息烽县",
						area_code: "Xifeng",
						area_parent_id: 520100
					},
					"520123": {
						id: 520123,
						area_name: "修文县",
						area_code: "Xiuwen",
						area_parent_id: 520100
					},
					"520181": {
						id: 520181,
						area_name: "清镇市",
						area_code: "Qingzhen",
						area_parent_id: 520100
					}
				}
			},
			"520200": {
				id: 520200,
				area_name: "六盘水市",
				area_code: "Liupanshui",
				area_parent_id: 520000,
				child: {
					"520201": {
						id: 520201,
						area_name: "钟山区",
						area_code: "Zhongshan",
						area_parent_id: 520200
					},
					"520203": {
						id: 520203,
						area_name: "六枝特区",
						area_code: "Liuzhi",
						area_parent_id: 520200
					},
					"520221": {
						id: 520221,
						area_name: "水城县",
						area_code: "Shuicheng",
						area_parent_id: 520200
					},
					"520222": {
						id: 520222,
						area_name: "盘县",
						area_code: "Panxian",
						area_parent_id: 520200
					}
				}
			},
			"520300": {
				id: 520300,
				area_name: "遵义市",
				area_code: "Zunyi",
				area_parent_id: 520000,
				child: {
					"520302": {
						id: 520302,
						area_name: "红花岗区",
						area_code: "Honghuagang",
						area_parent_id: 520300
					},
					"520303": {
						id: 520303,
						area_name: "汇川区",
						area_code: "Huichuan",
						area_parent_id: 520300
					},
					"520321": {
						id: 520321,
						area_name: "遵义县",
						area_code: "Zunyi",
						area_parent_id: 520300
					},
					"520322": {
						id: 520322,
						area_name: "桐梓县",
						area_code: "Tongzi",
						area_parent_id: 520300
					},
					"520323": {
						id: 520323,
						area_name: "绥阳县",
						area_code: "Suiyang",
						area_parent_id: 520300
					},
					"520324": {
						id: 520324,
						area_name: "正安县",
						area_code: "Zheng'an",
						area_parent_id: 520300
					},
					"520325": {
						id: 520325,
						area_name: "道真仡佬族苗族自治县",
						area_code: "Daozhen",
						area_parent_id: 520300
					},
					"520326": {
						id: 520326,
						area_name: "务川仡佬族苗族自治县",
						area_code: "Wuchuan",
						area_parent_id: 520300
					},
					"520327": {
						id: 520327,
						area_name: "凤冈县",
						area_code: "Fenggang",
						area_parent_id: 520300
					},
					"520328": {
						id: 520328,
						area_name: "湄潭县",
						area_code: "Meitan",
						area_parent_id: 520300
					},
					"520329": {
						id: 520329,
						area_name: "余庆县",
						area_code: "Yuqing",
						area_parent_id: 520300
					},
					"520330": {
						id: 520330,
						area_name: "习水县",
						area_code: "Xishui",
						area_parent_id: 520300
					},
					"520381": {
						id: 520381,
						area_name: "赤水市",
						area_code: "Chishui",
						area_parent_id: 520300
					},
					"520382": {
						id: 520382,
						area_name: "仁怀市",
						area_code: "Renhuai",
						area_parent_id: 520300
					}
				}
			},
			"520400": {
				id: 520400,
				area_name: "安顺市",
				area_code: "Anshun",
				area_parent_id: 520000,
				child: {
					"520402": {
						id: 520402,
						area_name: "西秀区",
						area_code: "Xixiu",
						area_parent_id: 520400
					},
					"520421": {
						id: 520421,
						area_name: "平坝区",
						area_code: "Pingba",
						area_parent_id: 520400
					},
					"520422": {
						id: 520422,
						area_name: "普定县",
						area_code: "Puding",
						area_parent_id: 520400
					},
					"520423": {
						id: 520423,
						area_name: "镇宁布依族苗族自治县",
						area_code: "Zhenning",
						area_parent_id: 520400
					},
					"520424": {
						id: 520424,
						area_name: "关岭布依族苗族自治县",
						area_code: "Guanling",
						area_parent_id: 520400
					},
					"520425": {
						id: 520425,
						area_name: "紫云苗族布依族自治县",
						area_code: "Ziyun",
						area_parent_id: 520400
					}
				}
			},
			"520500": {
				id: 520500,
				area_name: "毕节市",
				area_code: "Bijie",
				area_parent_id: 520000,
				child: {
					"520502": {
						id: 520502,
						area_name: "七星关区",
						area_code: "Qixingguan",
						area_parent_id: 520500
					},
					"520521": {
						id: 520521,
						area_name: "大方县",
						area_code: "Dafang",
						area_parent_id: 520500
					},
					"520522": {
						id: 520522,
						area_name: "黔西县",
						area_code: "Qianxi",
						area_parent_id: 520500
					},
					"520523": {
						id: 520523,
						area_name: "金沙县",
						area_code: "Jinsha",
						area_parent_id: 520500
					},
					"520524": {
						id: 520524,
						area_name: "织金县",
						area_code: "Zhijin",
						area_parent_id: 520500
					},
					"520525": {
						id: 520525,
						area_name: "纳雍县",
						area_code: "Nayong",
						area_parent_id: 520500
					},
					"520526": {
						id: 520526,
						area_name: "威宁彝族回族苗族自治县",
						area_code: "Weining",
						area_parent_id: 520500
					},
					"520527": {
						id: 520527,
						area_name: "赫章县",
						area_code: "Hezhang",
						area_parent_id: 520500
					}
				}
			},
			"520600": {
				id: 520600,
				area_name: "铜仁市",
				area_code: "Tongren",
				area_parent_id: 520000,
				child: {
					"520602": {
						id: 520602,
						area_name: "碧江区",
						area_code: "Bijiang",
						area_parent_id: 520600
					},
					"520603": {
						id: 520603,
						area_name: "万山区",
						area_code: "Wanshan",
						area_parent_id: 520600
					},
					"520621": {
						id: 520621,
						area_name: "江口县",
						area_code: "Jiangkou",
						area_parent_id: 520600
					},
					"520622": {
						id: 520622,
						area_name: "玉屏侗族自治县",
						area_code: "Yuping",
						area_parent_id: 520600
					},
					"520623": {
						id: 520623,
						area_name: "石阡县",
						area_code: "Shiqian",
						area_parent_id: 520600
					},
					"520624": {
						id: 520624,
						area_name: "思南县",
						area_code: "Sinan",
						area_parent_id: 520600
					},
					"520625": {
						id: 520625,
						area_name: "印江土家族苗族自治县",
						area_code: "Yinjiang",
						area_parent_id: 520600
					},
					"520626": {
						id: 520626,
						area_name: "德江县",
						area_code: "Dejiang",
						area_parent_id: 520600
					},
					"520627": {
						id: 520627,
						area_name: "沿河土家族自治县",
						area_code: "Yuanhe",
						area_parent_id: 520600
					},
					"520628": {
						id: 520628,
						area_name: "松桃苗族自治县",
						area_code: "Songtao",
						area_parent_id: 520600
					}
				}
			},
			"522300": {
				id: 522300,
				area_name: "黔西南布依族苗族自治州",
				area_code: "Qianxinan",
				area_parent_id: 520000,
				child: {
					"522301": {
						id: 522301,
						area_name: "兴义市 ",
						area_code: "Xingyi",
						area_parent_id: 522300
					},
					"522322": {
						id: 522322,
						area_name: "兴仁县",
						area_code: "Xingren",
						area_parent_id: 522300
					},
					"522323": {
						id: 522323,
						area_name: "普安县",
						area_code: "Pu'an",
						area_parent_id: 522300
					},
					"522324": {
						id: 522324,
						area_name: "晴隆县",
						area_code: "Qinglong",
						area_parent_id: 522300
					},
					"522325": {
						id: 522325,
						area_name: "贞丰县",
						area_code: "Zhenfeng",
						area_parent_id: 522300
					},
					"522326": {
						id: 522326,
						area_name: "望谟县",
						area_code: "Wangmo",
						area_parent_id: 522300
					},
					"522327": {
						id: 522327,
						area_name: "册亨县",
						area_code: "Ceheng",
						area_parent_id: 522300
					},
					"522328": {
						id: 522328,
						area_name: "安龙县",
						area_code: "Anlong",
						area_parent_id: 522300
					}
				}
			},
			"522600": {
				id: 522600,
				area_name: "黔东南苗族侗族自治州",
				area_code: "Qiandongnan",
				area_parent_id: 520000,
				child: {
					"522601": {
						id: 522601,
						area_name: "凯里市",
						area_code: "Kaili",
						area_parent_id: 522600
					},
					"522622": {
						id: 522622,
						area_name: "黄平县",
						area_code: "Huangping",
						area_parent_id: 522600
					},
					"522623": {
						id: 522623,
						area_name: "施秉县",
						area_code: "Shibing",
						area_parent_id: 522600
					},
					"522624": {
						id: 522624,
						area_name: "三穗县",
						area_code: "Sansui",
						area_parent_id: 522600
					},
					"522625": {
						id: 522625,
						area_name: "镇远县",
						area_code: "Zhenyuan",
						area_parent_id: 522600
					},
					"522626": {
						id: 522626,
						area_name: "岑巩县",
						area_code: "Cengong",
						area_parent_id: 522600
					},
					"522627": {
						id: 522627,
						area_name: "天柱县",
						area_code: "Tianzhu",
						area_parent_id: 522600
					},
					"522628": {
						id: 522628,
						area_name: "锦屏县",
						area_code: "Jinping",
						area_parent_id: 522600
					},
					"522629": {
						id: 522629,
						area_name: "剑河县",
						area_code: "Jianhe",
						area_parent_id: 522600
					},
					"522630": {
						id: 522630,
						area_name: "台江县",
						area_code: "Taijiang",
						area_parent_id: 522600
					},
					"522631": {
						id: 522631,
						area_name: "黎平县",
						area_code: "Liping",
						area_parent_id: 522600
					},
					"522632": {
						id: 522632,
						area_name: "榕江县",
						area_code: "Rongjiang",
						area_parent_id: 522600
					},
					"522633": {
						id: 522633,
						area_name: "从江县",
						area_code: "Congjiang",
						area_parent_id: 522600
					},
					"522634": {
						id: 522634,
						area_name: "雷山县",
						area_code: "Leishan",
						area_parent_id: 522600
					},
					"522635": {
						id: 522635,
						area_name: "麻江县",
						area_code: "Majiang",
						area_parent_id: 522600
					},
					"522636": {
						id: 522636,
						area_name: "丹寨县",
						area_code: "Danzhai",
						area_parent_id: 522600
					}
				}
			},
			"522700": {
				id: 522700,
				area_name: "黔南布依族苗族自治州",
				area_code: "Qiannan",
				area_parent_id: 520000,
				child: {
					"522701": {
						id: 522701,
						area_name: "都匀市",
						area_code: "Duyun",
						area_parent_id: 522700
					},
					"522702": {
						id: 522702,
						area_name: "福泉市",
						area_code: "Fuquan",
						area_parent_id: 522700
					},
					"522722": {
						id: 522722,
						area_name: "荔波县",
						area_code: "Libo",
						area_parent_id: 522700
					},
					"522723": {
						id: 522723,
						area_name: "贵定县",
						area_code: "Guiding",
						area_parent_id: 522700
					},
					"522725": {
						id: 522725,
						area_name: "瓮安县",
						area_code: "Weng'an",
						area_parent_id: 522700
					},
					"522726": {
						id: 522726,
						area_name: "独山县",
						area_code: "Dushan",
						area_parent_id: 522700
					},
					"522727": {
						id: 522727,
						area_name: "平塘县",
						area_code: "Pingtang",
						area_parent_id: 522700
					},
					"522728": {
						id: 522728,
						area_name: "罗甸县",
						area_code: "Luodian",
						area_parent_id: 522700
					},
					"522729": {
						id: 522729,
						area_name: "长顺县",
						area_code: "Changshun",
						area_parent_id: 522700
					},
					"522730": {
						id: 522730,
						area_name: "龙里县",
						area_code: "Longli",
						area_parent_id: 522700
					},
					"522731": {
						id: 522731,
						area_name: "惠水县",
						area_code: "Huishui",
						area_parent_id: 522700
					},
					"522732": {
						id: 522732,
						area_name: "三都水族自治县",
						area_code: "Sandu",
						area_parent_id: 522700
					}
				}
			}
		}
	},
	"530000": {
		id: 530000,
		area_name: "云南省",
		area_code: "Yunnan",
		area_parent_id: 0,
		child: {
			"530100": {
				id: 530100,
				area_name: "昆明市",
				area_code: "Kunming",
				area_parent_id: 530000,
				child: {
					"530102": {
						id: 530102,
						area_name: "五华区",
						area_code: "Wuhua",
						area_parent_id: 530100
					},
					"530103": {
						id: 530103,
						area_name: "盘龙区",
						area_code: "Panlong",
						area_parent_id: 530100
					},
					"530111": {
						id: 530111,
						area_name: "官渡区",
						area_code: "Guandu",
						area_parent_id: 530100
					},
					"530112": {
						id: 530112,
						area_name: "西山区",
						area_code: "Xishan",
						area_parent_id: 530100
					},
					"530113": {
						id: 530113,
						area_name: "东川区",
						area_code: "Dongchuan",
						area_parent_id: 530100
					},
					"530114": {
						id: 530114,
						area_name: "呈贡区",
						area_code: "Chenggong",
						area_parent_id: 530100
					},
					"530122": {
						id: 530122,
						area_name: "晋宁县",
						area_code: "Jinning",
						area_parent_id: 530100
					},
					"530124": {
						id: 530124,
						area_name: "富民县",
						area_code: "Fumin",
						area_parent_id: 530100
					},
					"530125": {
						id: 530125,
						area_name: "宜良县",
						area_code: "Yiliang",
						area_parent_id: 530100
					},
					"530126": {
						id: 530126,
						area_name: "石林彝族自治县",
						area_code: "Shilin",
						area_parent_id: 530100
					},
					"530127": {
						id: 530127,
						area_name: "嵩明县",
						area_code: "Songming",
						area_parent_id: 530100
					},
					"530128": {
						id: 530128,
						area_name: "禄劝彝族苗族自治县",
						area_code: "Luquan",
						area_parent_id: 530100
					},
					"530129": {
						id: 530129,
						area_name: "寻甸回族彝族自治县 ",
						area_code: "Xundian",
						area_parent_id: 530100
					},
					"530181": {
						id: 530181,
						area_name: "安宁市",
						area_code: "Anning",
						area_parent_id: 530100
					}
				}
			},
			"530300": {
				id: 530300,
				area_name: "曲靖市",
				area_code: "Qujing",
				area_parent_id: 530000,
				child: {
					"530302": {
						id: 530302,
						area_name: "麒麟区",
						area_code: "Qilin",
						area_parent_id: 530300
					},
					"530321": {
						id: 530321,
						area_name: "马龙县",
						area_code: "Malong",
						area_parent_id: 530300
					},
					"530322": {
						id: 530322,
						area_name: "陆良县",
						area_code: "Luliang",
						area_parent_id: 530300
					},
					"530323": {
						id: 530323,
						area_name: "师宗县",
						area_code: "Shizong",
						area_parent_id: 530300
					},
					"530324": {
						id: 530324,
						area_name: "罗平县",
						area_code: "Luoping",
						area_parent_id: 530300
					},
					"530325": {
						id: 530325,
						area_name: "富源县",
						area_code: "Fuyuan",
						area_parent_id: 530300
					},
					"530326": {
						id: 530326,
						area_name: "会泽县",
						area_code: "Huize",
						area_parent_id: 530300
					},
					"530328": {
						id: 530328,
						area_name: "沾益县",
						area_code: "Zhanyi",
						area_parent_id: 530300
					},
					"530381": {
						id: 530381,
						area_name: "宣威市",
						area_code: "Xuanwei",
						area_parent_id: 530300
					}
				}
			},
			"530400": {
				id: 530400,
				area_name: "玉溪市",
				area_code: "Yuxi",
				area_parent_id: 530000,
				child: {
					"530402": {
						id: 530402,
						area_name: "红塔区",
						area_code: "Hongta",
						area_parent_id: 530400
					},
					"530421": {
						id: 530421,
						area_name: "江川县",
						area_code: "Jiangchuan",
						area_parent_id: 530400
					},
					"530422": {
						id: 530422,
						area_name: "澄江县",
						area_code: "Chengjiang",
						area_parent_id: 530400
					},
					"530423": {
						id: 530423,
						area_name: "通海县",
						area_code: "Tonghai",
						area_parent_id: 530400
					},
					"530424": {
						id: 530424,
						area_name: "华宁县",
						area_code: "Huaning",
						area_parent_id: 530400
					},
					"530425": {
						id: 530425,
						area_name: "易门县",
						area_code: "Yimen",
						area_parent_id: 530400
					},
					"530426": {
						id: 530426,
						area_name: "峨山彝族自治县",
						area_code: "Eshan",
						area_parent_id: 530400
					},
					"530427": {
						id: 530427,
						area_name: "新平彝族傣族自治县",
						area_code: "Xinping",
						area_parent_id: 530400
					},
					"530428": {
						id: 530428,
						area_name: "元江哈尼族彝族傣族自治县",
						area_code: "Yuanjiang",
						area_parent_id: 530400
					}
				}
			},
			"530500": {
				id: 530500,
				area_name: "保山市",
				area_code: "Baoshan",
				area_parent_id: 530000,
				child: {
					"530502": {
						id: 530502,
						area_name: "隆阳区",
						area_code: "Longyang",
						area_parent_id: 530500
					},
					"530521": {
						id: 530521,
						area_name: "施甸县",
						area_code: "Shidian",
						area_parent_id: 530500
					},
					"530522": {
						id: 530522,
						area_name: "腾冲县",
						area_code: "Tengchong",
						area_parent_id: 530500
					},
					"530523": {
						id: 530523,
						area_name: "龙陵县",
						area_code: "Longling",
						area_parent_id: 530500
					},
					"530524": {
						id: 530524,
						area_name: "昌宁县",
						area_code: "Changning",
						area_parent_id: 530500
					}
				}
			},
			"530600": {
				id: 530600,
				area_name: "昭通市",
				area_code: "Zhaotong",
				area_parent_id: 530000,
				child: {
					"530602": {
						id: 530602,
						area_name: "昭阳区",
						area_code: "Zhaoyang",
						area_parent_id: 530600
					},
					"530621": {
						id: 530621,
						area_name: "鲁甸县",
						area_code: "Ludian",
						area_parent_id: 530600
					},
					"530622": {
						id: 530622,
						area_name: "巧家县",
						area_code: "Qiaojia",
						area_parent_id: 530600
					},
					"530623": {
						id: 530623,
						area_name: "盐津县",
						area_code: "Yanjin",
						area_parent_id: 530600
					},
					"530624": {
						id: 530624,
						area_name: "大关县",
						area_code: "Daguan",
						area_parent_id: 530600
					},
					"530625": {
						id: 530625,
						area_name: "永善县",
						area_code: "Yongshan",
						area_parent_id: 530600
					},
					"530626": {
						id: 530626,
						area_name: "绥江县",
						area_code: "Suijiang",
						area_parent_id: 530600
					},
					"530627": {
						id: 530627,
						area_name: "镇雄县",
						area_code: "Zhenxiong",
						area_parent_id: 530600
					},
					"530628": {
						id: 530628,
						area_name: "彝良县",
						area_code: "Yiliang",
						area_parent_id: 530600
					},
					"530629": {
						id: 530629,
						area_name: "威信县",
						area_code: "Weixin",
						area_parent_id: 530600
					},
					"530630": {
						id: 530630,
						area_name: "水富县",
						area_code: "Shuifu",
						area_parent_id: 530600
					}
				}
			},
			"530700": {
				id: 530700,
				area_name: "丽江市",
				area_code: "Lijiang",
				area_parent_id: 530000,
				child: {
					"530702": {
						id: 530702,
						area_name: "古城区",
						area_code: "Gucheng",
						area_parent_id: 530700
					},
					"530721": {
						id: 530721,
						area_name: "玉龙纳西族自治县",
						area_code: "Yulong",
						area_parent_id: 530700
					},
					"530722": {
						id: 530722,
						area_name: "永胜县",
						area_code: "Yongsheng",
						area_parent_id: 530700
					},
					"530723": {
						id: 530723,
						area_name: "华坪县",
						area_code: "Huaping",
						area_parent_id: 530700
					},
					"530724": {
						id: 530724,
						area_name: "宁蒗彝族自治县",
						area_code: "Ninglang",
						area_parent_id: 530700
					}
				}
			},
			"530800": {
				id: 530800,
				area_name: "普洱市",
				area_code: "Pu'er",
				area_parent_id: 530000,
				child: {
					"530802": {
						id: 530802,
						area_name: "思茅区",
						area_code: "Simao",
						area_parent_id: 530800
					},
					"530821": {
						id: 530821,
						area_name: "宁洱哈尼族彝族自治县",
						area_code: "Ninger",
						area_parent_id: 530800
					},
					"530822": {
						id: 530822,
						area_name: "墨江哈尼族自治县",
						area_code: "Mojiang",
						area_parent_id: 530800
					},
					"530823": {
						id: 530823,
						area_name: "景东彝族自治县",
						area_code: "Jingdong",
						area_parent_id: 530800
					},
					"530824": {
						id: 530824,
						area_name: "景谷傣族彝族自治县",
						area_code: "Jinggu",
						area_parent_id: 530800
					},
					"530825": {
						id: 530825,
						area_name: "镇沅彝族哈尼族拉祜族自治县",
						area_code: "Zhenyuan",
						area_parent_id: 530800
					},
					"530826": {
						id: 530826,
						area_name: "江城哈尼族彝族自治县",
						area_code: "Jiangcheng",
						area_parent_id: 530800
					},
					"530827": {
						id: 530827,
						area_name: "孟连傣族拉祜族佤族自治县",
						area_code: "Menglian",
						area_parent_id: 530800
					},
					"530828": {
						id: 530828,
						area_name: "澜沧拉祜族自治县",
						area_code: "Lancang",
						area_parent_id: 530800
					},
					"530829": {
						id: 530829,
						area_name: "西盟佤族自治县",
						area_code: "Ximeng",
						area_parent_id: 530800
					}
				}
			},
			"530900": {
				id: 530900,
				area_name: "临沧市",
				area_code: "Lincang",
				area_parent_id: 530000,
				child: {
					"530902": {
						id: 530902,
						area_name: "临翔区",
						area_code: "Linxiang",
						area_parent_id: 530900
					},
					"530921": {
						id: 530921,
						area_name: "凤庆县",
						area_code: "Fengqing",
						area_parent_id: 530900
					},
					"530922": {
						id: 530922,
						area_name: "云县",
						area_code: "Yunxian",
						area_parent_id: 530900
					},
					"530923": {
						id: 530923,
						area_name: "永德县",
						area_code: "Yongde",
						area_parent_id: 530900
					},
					"530924": {
						id: 530924,
						area_name: "镇康县",
						area_code: "Zhenkang",
						area_parent_id: 530900
					},
					"530925": {
						id: 530925,
						area_name: "双江拉祜族佤族布朗族傣族自治县",
						area_code: "Shuangjiang",
						area_parent_id: 530900
					},
					"530926": {
						id: 530926,
						area_name: "耿马傣族佤族自治县",
						area_code: "Gengma",
						area_parent_id: 530900
					},
					"530927": {
						id: 530927,
						area_name: "沧源佤族自治县",
						area_code: "Cangyuan",
						area_parent_id: 530900
					}
				}
			},
			"532300": {
				id: 532300,
				area_name: "楚雄彝族自治州",
				area_code: "Chuxiong",
				area_parent_id: 530000,
				child: {
					"532301": {
						id: 532301,
						area_name: "楚雄市",
						area_code: "Chuxiong",
						area_parent_id: 532300
					},
					"532322": {
						id: 532322,
						area_name: "双柏县",
						area_code: "Shuangbai",
						area_parent_id: 532300
					},
					"532323": {
						id: 532323,
						area_name: "牟定县",
						area_code: "Mouding",
						area_parent_id: 532300
					},
					"532324": {
						id: 532324,
						area_name: "南华县",
						area_code: "Nanhua",
						area_parent_id: 532300
					},
					"532325": {
						id: 532325,
						area_name: "姚安县",
						area_code: "Yao'an",
						area_parent_id: 532300
					},
					"532326": {
						id: 532326,
						area_name: "大姚县",
						area_code: "Dayao",
						area_parent_id: 532300
					},
					"532327": {
						id: 532327,
						area_name: "永仁县",
						area_code: "Yongren",
						area_parent_id: 532300
					},
					"532328": {
						id: 532328,
						area_name: "元谋县",
						area_code: "Yuanmou",
						area_parent_id: 532300
					},
					"532329": {
						id: 532329,
						area_name: "武定县",
						area_code: "Wuding",
						area_parent_id: 532300
					},
					"532331": {
						id: 532331,
						area_name: "禄丰县",
						area_code: "Lufeng",
						area_parent_id: 532300
					}
				}
			},
			"532500": {
				id: 532500,
				area_name: "红河哈尼族彝族自治州",
				area_code: "Honghe",
				area_parent_id: 530000,
				child: {
					"532501": {
						id: 532501,
						area_name: "个旧市",
						area_code: "Gejiu",
						area_parent_id: 532500
					},
					"532502": {
						id: 532502,
						area_name: "开远市",
						area_code: "Kaiyuan",
						area_parent_id: 532500
					},
					"532503": {
						id: 532503,
						area_name: "蒙自市",
						area_code: "Mengzi",
						area_parent_id: 532500
					},
					"532504": {
						id: 532504,
						area_name: "弥勒市",
						area_code: "Mile ",
						area_parent_id: 532500
					},
					"532523": {
						id: 532523,
						area_name: "屏边苗族自治县",
						area_code: "Pingbian",
						area_parent_id: 532500
					},
					"532524": {
						id: 532524,
						area_name: "建水县",
						area_code: "Jianshui",
						area_parent_id: 532500
					},
					"532525": {
						id: 532525,
						area_name: "石屏县",
						area_code: "Shiping",
						area_parent_id: 532500
					},
					"532527": {
						id: 532527,
						area_name: "泸西县",
						area_code: "Luxi",
						area_parent_id: 532500
					},
					"532528": {
						id: 532528,
						area_name: "元阳县",
						area_code: "Yuanyang",
						area_parent_id: 532500
					},
					"532529": {
						id: 532529,
						area_name: "红河县",
						area_code: "Honghexian",
						area_parent_id: 532500
					},
					"532530": {
						id: 532530,
						area_name: "金平苗族瑶族傣族自治县",
						area_code: "Jinping",
						area_parent_id: 532500
					},
					"532531": {
						id: 532531,
						area_name: "绿春县",
						area_code: "Lvchun",
						area_parent_id: 532500
					},
					"532532": {
						id: 532532,
						area_name: "河口瑶族自治县",
						area_code: "Hekou",
						area_parent_id: 532500
					}
				}
			},
			"532600": {
				id: 532600,
				area_name: "文山壮族苗族自治州",
				area_code: "Wenshan",
				area_parent_id: 530000,
				child: {
					"532601": {
						id: 532601,
						area_name: "文山市",
						area_code: "Wenshan",
						area_parent_id: 532600
					},
					"532622": {
						id: 532622,
						area_name: "砚山县",
						area_code: "Yanshan",
						area_parent_id: 532600
					},
					"532623": {
						id: 532623,
						area_name: "西畴县",
						area_code: "Xichou",
						area_parent_id: 532600
					},
					"532624": {
						id: 532624,
						area_name: "麻栗坡县",
						area_code: "Malipo",
						area_parent_id: 532600
					},
					"532625": {
						id: 532625,
						area_name: "马关县",
						area_code: "Maguan",
						area_parent_id: 532600
					},
					"532626": {
						id: 532626,
						area_name: "丘北县",
						area_code: "Qiubei",
						area_parent_id: 532600
					},
					"532627": {
						id: 532627,
						area_name: "广南县",
						area_code: "Guangnan",
						area_parent_id: 532600
					},
					"532628": {
						id: 532628,
						area_name: "富宁县",
						area_code: "Funing",
						area_parent_id: 532600
					}
				}
			},
			"532800": {
				id: 532800,
				area_name: "西双版纳傣族自治州",
				area_code: "Xishuangbanna",
				area_parent_id: 530000,
				child: {
					"532801": {
						id: 532801,
						area_name: "景洪市",
						area_code: "Jinghong",
						area_parent_id: 532800
					},
					"532822": {
						id: 532822,
						area_name: "勐海县",
						area_code: "Menghai",
						area_parent_id: 532800
					},
					"532823": {
						id: 532823,
						area_name: "勐腊县",
						area_code: "Mengla",
						area_parent_id: 532800
					}
				}
			},
			"532900": {
				id: 532900,
				area_name: "大理白族自治州",
				area_code: "Dali",
				area_parent_id: 530000,
				child: {
					"532901": {
						id: 532901,
						area_name: "大理市",
						area_code: "Dali",
						area_parent_id: 532900
					},
					"532922": {
						id: 532922,
						area_name: "漾濞彝族自治县",
						area_code: "Yangbi",
						area_parent_id: 532900
					},
					"532923": {
						id: 532923,
						area_name: "祥云县",
						area_code: "Xiangyun",
						area_parent_id: 532900
					},
					"532924": {
						id: 532924,
						area_name: "宾川县",
						area_code: "Binchuan",
						area_parent_id: 532900
					},
					"532925": {
						id: 532925,
						area_name: "弥渡县",
						area_code: "Midu",
						area_parent_id: 532900
					},
					"532926": {
						id: 532926,
						area_name: "南涧彝族自治县",
						area_code: "Nanjian",
						area_parent_id: 532900
					},
					"532927": {
						id: 532927,
						area_name: "巍山彝族回族自治县",
						area_code: "Weishan",
						area_parent_id: 532900
					},
					"532928": {
						id: 532928,
						area_name: "永平县",
						area_code: "Yongping",
						area_parent_id: 532900
					},
					"532929": {
						id: 532929,
						area_name: "云龙县",
						area_code: "Yunlong",
						area_parent_id: 532900
					},
					"532930": {
						id: 532930,
						area_name: "洱源县",
						area_code: "Eryuan",
						area_parent_id: 532900
					},
					"532931": {
						id: 532931,
						area_name: "剑川县",
						area_code: "Jianchuan",
						area_parent_id: 532900
					},
					"532932": {
						id: 532932,
						area_name: "鹤庆县",
						area_code: "Heqing",
						area_parent_id: 532900
					}
				}
			},
			"533100": {
				id: 533100,
				area_name: "德宏傣族景颇族自治州",
				area_code: "Dehong",
				area_parent_id: 530000,
				child: {
					"533102": {
						id: 533102,
						area_name: "瑞丽市",
						area_code: "Ruili",
						area_parent_id: 533100
					},
					"533103": {
						id: 533103,
						area_name: "芒市",
						area_code: "Mangshi",
						area_parent_id: 533100
					},
					"533122": {
						id: 533122,
						area_name: "梁河县",
						area_code: "Lianghe",
						area_parent_id: 533100
					},
					"533123": {
						id: 533123,
						area_name: "盈江县",
						area_code: "Yingjiang",
						area_parent_id: 533100
					},
					"533124": {
						id: 533124,
						area_name: "陇川县",
						area_code: "Longchuan",
						area_parent_id: 533100
					}
				}
			},
			"533300": {
				id: 533300,
				area_name: "怒江傈僳族自治州",
				area_code: "Nujiang",
				area_parent_id: 530000,
				child: {
					"533321": {
						id: 533321,
						area_name: "泸水县",
						area_code: "Lushui",
						area_parent_id: 533300
					},
					"533323": {
						id: 533323,
						area_name: "福贡县",
						area_code: "Fugong",
						area_parent_id: 533300
					},
					"533324": {
						id: 533324,
						area_name: "贡山独龙族怒族自治县",
						area_code: "Gongshan",
						area_parent_id: 533300
					},
					"533325": {
						id: 533325,
						area_name: "兰坪白族普米族自治县",
						area_code: "Lanping",
						area_parent_id: 533300
					}
				}
			},
			"533400": {
				id: 533400,
				area_name: "迪庆藏族自治州",
				area_code: "Deqen",
				area_parent_id: 530000,
				child: {
					"533421": {
						id: 533421,
						area_name: "香格里拉市",
						area_code: "Xianggelila",
						area_parent_id: 533400
					},
					"533422": {
						id: 533422,
						area_name: "德钦县",
						area_code: "Deqin",
						area_parent_id: 533400
					},
					"533423": {
						id: 533423,
						area_name: "维西傈僳族自治县",
						area_code: "Weixi",
						area_parent_id: 533400
					}
				}
			}
		}
	},
	"540000": {
		id: 540000,
		area_name: "西藏自治区",
		area_code: "Tibet",
		area_parent_id: 0,
		child: {
			"540100": {
				id: 540100,
				area_name: "拉萨市",
				area_code: "Lhasa",
				area_parent_id: 540000,
				child: {
					"540102": {
						id: 540102,
						area_name: "城关区",
						area_code: "Chengguan",
						area_parent_id: 540100
					},
					"540121": {
						id: 540121,
						area_name: "林周县",
						area_code: "Linzhou",
						area_parent_id: 540100
					},
					"540122": {
						id: 540122,
						area_name: "当雄县",
						area_code: "Dangxiong",
						area_parent_id: 540100
					},
					"540123": {
						id: 540123,
						area_name: "尼木县",
						area_code: "Nimu",
						area_parent_id: 540100
					},
					"540124": {
						id: 540124,
						area_name: "曲水县",
						area_code: "Qushui",
						area_parent_id: 540100
					},
					"540125": {
						id: 540125,
						area_name: "堆龙德庆县",
						area_code: "Duilongdeqing",
						area_parent_id: 540100
					},
					"540126": {
						id: 540126,
						area_name: "达孜县",
						area_code: "Dazi",
						area_parent_id: 540100
					},
					"540127": {
						id: 540127,
						area_name: "墨竹工卡县",
						area_code: "Mozhugongka",
						area_parent_id: 540100
					}
				}
			},
			"540200": {
				id: 540200,
				area_name: "日喀则市",
				area_code: "Rikaze",
				area_parent_id: 540000,
				child: {
					"540202": {
						id: 540202,
						area_name: "桑珠孜区",
						area_code: "Sangzhuzi",
						area_parent_id: 540200
					},
					"540221": {
						id: 540221,
						area_name: "南木林县",
						area_code: "Nanmulin",
						area_parent_id: 540200
					},
					"540222": {
						id: 540222,
						area_name: "江孜县",
						area_code: "Jiangzi",
						area_parent_id: 540200
					},
					"540223": {
						id: 540223,
						area_name: "定日县",
						area_code: "Dingri",
						area_parent_id: 540200
					},
					"540224": {
						id: 540224,
						area_name: "萨迦县",
						area_code: "Sajia",
						area_parent_id: 540200
					},
					"540225": {
						id: 540225,
						area_name: "拉孜县",
						area_code: "Lazi",
						area_parent_id: 540200
					},
					"540226": {
						id: 540226,
						area_name: "昂仁县",
						area_code: "Angren",
						area_parent_id: 540200
					},
					"540227": {
						id: 540227,
						area_name: "谢通门县",
						area_code: "Xietongmen",
						area_parent_id: 540200
					},
					"540228": {
						id: 540228,
						area_name: "白朗县",
						area_code: "Bailang",
						area_parent_id: 540200
					},
					"540229": {
						id: 540229,
						area_name: "仁布县",
						area_code: "Renbu",
						area_parent_id: 540200
					},
					"540230": {
						id: 540230,
						area_name: "康马县",
						area_code: "Kangma",
						area_parent_id: 540200
					},
					"540231": {
						id: 540231,
						area_name: "定结县",
						area_code: "Dingjie",
						area_parent_id: 540200
					},
					"540232": {
						id: 540232,
						area_name: "仲巴县",
						area_code: "Zhongba",
						area_parent_id: 540200
					},
					"540233": {
						id: 540233,
						area_name: "亚东县",
						area_code: "Yadong",
						area_parent_id: 540200
					},
					"540234": {
						id: 540234,
						area_name: "吉隆县",
						area_code: "Jilong",
						area_parent_id: 540200
					},
					"540235": {
						id: 540235,
						area_name: "聂拉木县",
						area_code: "Nielamu",
						area_parent_id: 540200
					},
					"540236": {
						id: 540236,
						area_name: "萨嘎县",
						area_code: "Saga",
						area_parent_id: 540200
					},
					"540237": {
						id: 540237,
						area_name: "岗巴县",
						area_code: "Gangba",
						area_parent_id: 540200
					}
				}
			},
			"540300": {
				id: 540300,
				area_name: "昌都市",
				area_code: "Qamdo",
				area_parent_id: 540000,
				child: {
					"540302": {
						id: 540302,
						area_name: "卡若区",
						area_code: "Karuo",
						area_parent_id: 540300
					},
					"540321": {
						id: 540321,
						area_name: "江达县",
						area_code: "Jiangda",
						area_parent_id: 540300
					},
					"540322": {
						id: 540322,
						area_name: "贡觉县",
						area_code: "Gongjue",
						area_parent_id: 540300
					},
					"540323": {
						id: 540323,
						area_name: "类乌齐县",
						area_code: "Leiwuqi",
						area_parent_id: 540300
					},
					"540324": {
						id: 540324,
						area_name: "丁青县",
						area_code: "Dingqing",
						area_parent_id: 540300
					},
					"540325": {
						id: 540325,
						area_name: "察雅县",
						area_code: "Chaya",
						area_parent_id: 540300
					},
					"540326": {
						id: 540326,
						area_name: "八宿县",
						area_code: "Basu",
						area_parent_id: 540300
					},
					"540327": {
						id: 540327,
						area_name: "左贡县",
						area_code: "Zuogong",
						area_parent_id: 540300
					},
					"540328": {
						id: 540328,
						area_name: "芒康县",
						area_code: "Mangkang",
						area_parent_id: 540300
					},
					"540329": {
						id: 540329,
						area_name: "洛隆县",
						area_code: "Luolong",
						area_parent_id: 540300
					},
					"540330": {
						id: 540330,
						area_name: "边坝县",
						area_code: "Bianba",
						area_parent_id: 540300
					}
				}
			},
			"542200": {
				id: 542200,
				area_name: "山南地区",
				area_code: "Shannan",
				area_parent_id: 540000,
				child: {
					"542221": {
						id: 542221,
						area_name: "乃东县",
						area_code: "Naidong",
						area_parent_id: 542200
					},
					"542222": {
						id: 542222,
						area_name: "扎囊县",
						area_code: "Zhanang",
						area_parent_id: 542200
					},
					"542223": {
						id: 542223,
						area_name: "贡嘎县",
						area_code: "Gongga",
						area_parent_id: 542200
					},
					"542224": {
						id: 542224,
						area_name: "桑日县",
						area_code: "Sangri",
						area_parent_id: 542200
					},
					"542225": {
						id: 542225,
						area_name: "琼结县",
						area_code: "Qiongjie",
						area_parent_id: 542200
					},
					"542226": {
						id: 542226,
						area_name: "曲松县",
						area_code: "Qusong",
						area_parent_id: 542200
					},
					"542227": {
						id: 542227,
						area_name: "措美县",
						area_code: "Cuomei",
						area_parent_id: 542200
					},
					"542228": {
						id: 542228,
						area_name: "洛扎县",
						area_code: "Luozha",
						area_parent_id: 542200
					},
					"542229": {
						id: 542229,
						area_name: "加查县",
						area_code: "Jiacha",
						area_parent_id: 542200
					},
					"542231": {
						id: 542231,
						area_name: "隆子县",
						area_code: "Longzi",
						area_parent_id: 542200
					},
					"542232": {
						id: 542232,
						area_name: "错那县",
						area_code: "Cuona",
						area_parent_id: 542200
					},
					"542233": {
						id: 542233,
						area_name: "浪卡子县",
						area_code: "Langkazi",
						area_parent_id: 542200
					}
				}
			},
			"542400": {
				id: 542400,
				area_name: "那曲地区",
				area_code: "Nagqu",
				area_parent_id: 540000,
				child: {
					"542421": {
						id: 542421,
						area_name: "那曲县",
						area_code: "Naqu",
						area_parent_id: 542400
					},
					"542422": {
						id: 542422,
						area_name: "嘉黎县",
						area_code: "Jiali",
						area_parent_id: 542400
					},
					"542423": {
						id: 542423,
						area_name: "比如县",
						area_code: "Biru",
						area_parent_id: 542400
					},
					"542424": {
						id: 542424,
						area_name: "聂荣县",
						area_code: "Nierong",
						area_parent_id: 542400
					},
					"542425": {
						id: 542425,
						area_name: "安多县",
						area_code: "Anduo",
						area_parent_id: 542400
					},
					"542426": {
						id: 542426,
						area_name: "申扎县",
						area_code: "Shenzha",
						area_parent_id: 542400
					},
					"542427": {
						id: 542427,
						area_name: "索县",
						area_code: "Suoxian",
						area_parent_id: 542400
					},
					"542428": {
						id: 542428,
						area_name: "班戈县",
						area_code: "Bange",
						area_parent_id: 542400
					},
					"542429": {
						id: 542429,
						area_name: "巴青县",
						area_code: "Baqing",
						area_parent_id: 542400
					},
					"542430": {
						id: 542430,
						area_name: "尼玛县",
						area_code: "Nima",
						area_parent_id: 542400
					},
					"542431": {
						id: 542431,
						area_name: "双湖县",
						area_code: "Shuanghu",
						area_parent_id: 542400
					}
				}
			},
			"542500": {
				id: 542500,
				area_name: "阿里地区",
				area_code: "Ngari",
				area_parent_id: 540000,
				child: {
					"542521": {
						id: 542521,
						area_name: "普兰县",
						area_code: "Pulan",
						area_parent_id: 542500
					},
					"542522": {
						id: 542522,
						area_name: "札达县",
						area_code: "Zhada",
						area_parent_id: 542500
					},
					"542523": {
						id: 542523,
						area_name: "噶尔县",
						area_code: "Gaer",
						area_parent_id: 542500
					},
					"542524": {
						id: 542524,
						area_name: "日土县",
						area_code: "Ritu",
						area_parent_id: 542500
					},
					"542525": {
						id: 542525,
						area_name: "革吉县",
						area_code: "Geji",
						area_parent_id: 542500
					},
					"542526": {
						id: 542526,
						area_name: "改则县",
						area_code: "Gaize",
						area_parent_id: 542500
					},
					"542527": {
						id: 542527,
						area_name: "措勤县",
						area_code: "Cuoqin",
						area_parent_id: 542500
					}
				}
			},
			"542600": {
				id: 542600,
				area_name: "林芝地区",
				area_code: "Nyingchi",
				area_parent_id: 540000,
				child: {
					"542621": {
						id: 542621,
						area_name: "林芝县",
						area_code: "Linzhi",
						area_parent_id: 542600
					},
					"542622": {
						id: 542622,
						area_name: "工布江达县",
						area_code: "Gongbujiangda",
						area_parent_id: 542600
					},
					"542623": {
						id: 542623,
						area_name: "米林县",
						area_code: "Milin",
						area_parent_id: 542600
					},
					"542624": {
						id: 542624,
						area_name: "墨脱县",
						area_code: "Motuo",
						area_parent_id: 542600
					},
					"542625": {
						id: 542625,
						area_name: "波密县",
						area_code: "Bomi",
						area_parent_id: 542600
					},
					"542626": {
						id: 542626,
						area_name: "察隅县",
						area_code: "Chayu",
						area_parent_id: 542600
					},
					"542627": {
						id: 542627,
						area_name: "朗县",
						area_code: "Langxian",
						area_parent_id: 542600
					}
				}
			}
		}
	},
	"610000": {
		id: 610000,
		area_name: "陕西省",
		area_code: "Shaanxi",
		area_parent_id: 0,
		child: {
			"610100": {
				id: 610100,
				area_name: "西安市",
				area_code: "Xi'an",
				area_parent_id: 610000,
				child: {
					"610102": {
						id: 610102,
						area_name: "新城区",
						area_code: "Xincheng",
						area_parent_id: 610100
					},
					"610103": {
						id: 610103,
						area_name: "碑林区",
						area_code: "Beilin",
						area_parent_id: 610100
					},
					"610104": {
						id: 610104,
						area_name: "莲湖区",
						area_code: "Lianhu",
						area_parent_id: 610100
					},
					"610111": {
						id: 610111,
						area_name: "灞桥区",
						area_code: "Baqiao",
						area_parent_id: 610100
					},
					"610112": {
						id: 610112,
						area_name: "未央区",
						area_code: "Weiyang",
						area_parent_id: 610100
					},
					"610113": {
						id: 610113,
						area_name: "雁塔区",
						area_code: "Yanta",
						area_parent_id: 610100
					},
					"610114": {
						id: 610114,
						area_name: "阎良区",
						area_code: "Yanliang",
						area_parent_id: 610100
					},
					"610115": {
						id: 610115,
						area_name: "临潼区",
						area_code: "Lintong",
						area_parent_id: 610100
					},
					"610116": {
						id: 610116,
						area_name: "长安区",
						area_code: "Chang'an",
						area_parent_id: 610100
					},
					"610122": {
						id: 610122,
						area_name: "蓝田县",
						area_code: "Lantian",
						area_parent_id: 610100
					},
					"610124": {
						id: 610124,
						area_name: "周至县",
						area_code: "Zhouzhi",
						area_parent_id: 610100
					},
					"610125": {
						id: 610125,
						area_name: "户县",
						area_code: "Huxian",
						area_parent_id: 610100
					},
					"610126": {
						id: 610126,
						area_name: "高陵区",
						area_code: "Gaoling",
						area_parent_id: 610100
					}
				}
			},
			"610200": {
				id: 610200,
				area_name: "铜川市",
				area_code: "Tongchuan",
				area_parent_id: 610000,
				child: {
					"610202": {
						id: 610202,
						area_name: "王益区",
						area_code: "Wangyi",
						area_parent_id: 610200
					},
					"610203": {
						id: 610203,
						area_name: "印台区",
						area_code: "Yintai",
						area_parent_id: 610200
					},
					"610204": {
						id: 610204,
						area_name: "耀州区",
						area_code: "Yaozhou",
						area_parent_id: 610200
					},
					"610222": {
						id: 610222,
						area_name: "宜君县",
						area_code: "Yijun",
						area_parent_id: 610200
					}
				}
			},
			"610300": {
				id: 610300,
				area_name: "宝鸡市",
				area_code: "Baoji",
				area_parent_id: 610000,
				child: {
					"610302": {
						id: 610302,
						area_name: "渭滨区",
						area_code: "Weibin",
						area_parent_id: 610300
					},
					"610303": {
						id: 610303,
						area_name: "金台区",
						area_code: "Jintai",
						area_parent_id: 610300
					},
					"610304": {
						id: 610304,
						area_name: "陈仓区",
						area_code: "Chencang",
						area_parent_id: 610300
					},
					"610322": {
						id: 610322,
						area_name: "凤翔县",
						area_code: "Fengxiang",
						area_parent_id: 610300
					},
					"610323": {
						id: 610323,
						area_name: "岐山县",
						area_code: "Qishan",
						area_parent_id: 610300
					},
					"610324": {
						id: 610324,
						area_name: "扶风县",
						area_code: "Fufeng",
						area_parent_id: 610300
					},
					"610326": {
						id: 610326,
						area_name: "眉县",
						area_code: "Meixian",
						area_parent_id: 610300
					},
					"610327": {
						id: 610327,
						area_name: "陇县",
						area_code: "Longxian",
						area_parent_id: 610300
					},
					"610328": {
						id: 610328,
						area_name: "千阳县",
						area_code: "Qianyang",
						area_parent_id: 610300
					},
					"610329": {
						id: 610329,
						area_name: "麟游县",
						area_code: "Linyou",
						area_parent_id: 610300
					},
					"610330": {
						id: 610330,
						area_name: "凤县",
						area_code: "Fengxian",
						area_parent_id: 610300
					},
					"610331": {
						id: 610331,
						area_name: "太白县",
						area_code: "Taibai",
						area_parent_id: 610300
					}
				}
			},
			"610400": {
				id: 610400,
				area_name: "咸阳市",
				area_code: "Xianyang",
				area_parent_id: 610000,
				child: {
					"610402": {
						id: 610402,
						area_name: "秦都区",
						area_code: "Qindu",
						area_parent_id: 610400
					},
					"610403": {
						id: 610403,
						area_name: "杨陵区",
						area_code: "Yangling",
						area_parent_id: 610400
					},
					"610404": {
						id: 610404,
						area_name: "渭城区",
						area_code: "Weicheng",
						area_parent_id: 610400
					},
					"610422": {
						id: 610422,
						area_name: "三原县",
						area_code: "Sanyuan",
						area_parent_id: 610400
					},
					"610423": {
						id: 610423,
						area_name: "泾阳县",
						area_code: "Jingyang",
						area_parent_id: 610400
					},
					"610424": {
						id: 610424,
						area_name: "乾县",
						area_code: "Qianxian",
						area_parent_id: 610400
					},
					"610425": {
						id: 610425,
						area_name: "礼泉县",
						area_code: "Liquan",
						area_parent_id: 610400
					},
					"610426": {
						id: 610426,
						area_name: "永寿县",
						area_code: "Yongshou",
						area_parent_id: 610400
					},
					"610427": {
						id: 610427,
						area_name: "彬县",
						area_code: "Binxian",
						area_parent_id: 610400
					},
					"610428": {
						id: 610428,
						area_name: "长武县",
						area_code: "Changwu",
						area_parent_id: 610400
					},
					"610429": {
						id: 610429,
						area_name: "旬邑县",
						area_code: "Xunyi",
						area_parent_id: 610400
					},
					"610430": {
						id: 610430,
						area_name: "淳化县",
						area_code: "Chunhua",
						area_parent_id: 610400
					},
					"610431": {
						id: 610431,
						area_name: "武功县",
						area_code: "Wugong",
						area_parent_id: 610400
					},
					"610481": {
						id: 610481,
						area_name: "兴平市",
						area_code: "Xingping",
						area_parent_id: 610400
					}
				}
			},
			"610500": {
				id: 610500,
				area_name: "渭南市",
				area_code: "Weinan",
				area_parent_id: 610000,
				child: {
					"610502": {
						id: 610502,
						area_name: "临渭区",
						area_code: "Linwei",
						area_parent_id: 610500
					},
					"610521": {
						id: 610521,
						area_name: "华县",
						area_code: "Huaxian",
						area_parent_id: 610500
					},
					"610522": {
						id: 610522,
						area_name: "潼关县",
						area_code: "Tongguan",
						area_parent_id: 610500
					},
					"610523": {
						id: 610523,
						area_name: "大荔县",
						area_code: "Dali",
						area_parent_id: 610500
					},
					"610524": {
						id: 610524,
						area_name: "合阳县",
						area_code: "Heyang",
						area_parent_id: 610500
					},
					"610525": {
						id: 610525,
						area_name: "澄城县",
						area_code: "Chengcheng",
						area_parent_id: 610500
					},
					"610526": {
						id: 610526,
						area_name: "蒲城县",
						area_code: "Pucheng",
						area_parent_id: 610500
					},
					"610527": {
						id: 610527,
						area_name: "白水县",
						area_code: "Baishui",
						area_parent_id: 610500
					},
					"610528": {
						id: 610528,
						area_name: "富平县",
						area_code: "Fuping",
						area_parent_id: 610500
					},
					"610581": {
						id: 610581,
						area_name: "韩城市",
						area_code: "Hancheng",
						area_parent_id: 610500
					},
					"610582": {
						id: 610582,
						area_name: "华阴市",
						area_code: "Huayin",
						area_parent_id: 610500
					}
				}
			},
			"610600": {
				id: 610600,
				area_name: "延安市",
				area_code: "Yan'an",
				area_parent_id: 610000,
				child: {
					"610602": {
						id: 610602,
						area_name: "宝塔区",
						area_code: "Baota",
						area_parent_id: 610600
					},
					"610621": {
						id: 610621,
						area_name: "延长县",
						area_code: "Yanchang",
						area_parent_id: 610600
					},
					"610622": {
						id: 610622,
						area_name: "延川县",
						area_code: "Yanchuan",
						area_parent_id: 610600
					},
					"610623": {
						id: 610623,
						area_name: "子长县",
						area_code: "Zichang",
						area_parent_id: 610600
					},
					"610624": {
						id: 610624,
						area_name: "安塞县",
						area_code: "Ansai",
						area_parent_id: 610600
					},
					"610625": {
						id: 610625,
						area_name: "志丹县",
						area_code: "Zhidan",
						area_parent_id: 610600
					},
					"610626": {
						id: 610626,
						area_name: "吴起县",
						area_code: "Wuqi",
						area_parent_id: 610600
					},
					"610627": {
						id: 610627,
						area_name: "甘泉县",
						area_code: "Ganquan",
						area_parent_id: 610600
					},
					"610628": {
						id: 610628,
						area_name: "富县",
						area_code: "Fuxian",
						area_parent_id: 610600
					},
					"610629": {
						id: 610629,
						area_name: "洛川县",
						area_code: "Luochuan",
						area_parent_id: 610600
					},
					"610630": {
						id: 610630,
						area_name: "宜川县",
						area_code: "Yichuan",
						area_parent_id: 610600
					},
					"610631": {
						id: 610631,
						area_name: "黄龙县",
						area_code: "Huanglong",
						area_parent_id: 610600
					},
					"610632": {
						id: 610632,
						area_name: "黄陵县",
						area_code: "Huangling",
						area_parent_id: 610600
					}
				}
			},
			"610700": {
				id: 610700,
				area_name: "汉中市",
				area_code: "Hanzhong",
				area_parent_id: 610000,
				child: {
					"610702": {
						id: 610702,
						area_name: "汉台区",
						area_code: "Hantai",
						area_parent_id: 610700
					},
					"610721": {
						id: 610721,
						area_name: "南郑县",
						area_code: "Nanzheng",
						area_parent_id: 610700
					},
					"610722": {
						id: 610722,
						area_name: "城固县",
						area_code: "Chenggu",
						area_parent_id: 610700
					},
					"610723": {
						id: 610723,
						area_name: "洋县",
						area_code: "Yangxian",
						area_parent_id: 610700
					},
					"610724": {
						id: 610724,
						area_name: "西乡县",
						area_code: "Xixiang",
						area_parent_id: 610700
					},
					"610725": {
						id: 610725,
						area_name: "勉县",
						area_code: "Mianxian",
						area_parent_id: 610700
					},
					"610726": {
						id: 610726,
						area_name: "宁强县",
						area_code: "Ningqiang",
						area_parent_id: 610700
					},
					"610727": {
						id: 610727,
						area_name: "略阳县",
						area_code: "Lueyang",
						area_parent_id: 610700
					},
					"610728": {
						id: 610728,
						area_name: "镇巴县",
						area_code: "Zhenba",
						area_parent_id: 610700
					},
					"610729": {
						id: 610729,
						area_name: "留坝县",
						area_code: "Liuba",
						area_parent_id: 610700
					},
					"610730": {
						id: 610730,
						area_name: "佛坪县",
						area_code: "Foping",
						area_parent_id: 610700
					}
				}
			},
			"610800": {
				id: 610800,
				area_name: "榆林市",
				area_code: "Yulin",
				area_parent_id: 610000,
				child: {
					"610802": {
						id: 610802,
						area_name: "榆阳区",
						area_code: "Yuyang",
						area_parent_id: 610800
					},
					"610821": {
						id: 610821,
						area_name: "神木县",
						area_code: "Shenmu",
						area_parent_id: 610800
					},
					"610822": {
						id: 610822,
						area_name: "府谷县",
						area_code: "Fugu",
						area_parent_id: 610800
					},
					"610823": {
						id: 610823,
						area_name: "横山县",
						area_code: "Hengshan",
						area_parent_id: 610800
					},
					"610824": {
						id: 610824,
						area_name: "靖边县",
						area_code: "Jingbian",
						area_parent_id: 610800
					},
					"610825": {
						id: 610825,
						area_name: "定边县",
						area_code: "Dingbian",
						area_parent_id: 610800
					},
					"610826": {
						id: 610826,
						area_name: "绥德县",
						area_code: "Suide",
						area_parent_id: 610800
					},
					"610827": {
						id: 610827,
						area_name: "米脂县",
						area_code: "Mizhi",
						area_parent_id: 610800
					},
					"610828": {
						id: 610828,
						area_name: "佳县",
						area_code: "Jiaxian",
						area_parent_id: 610800
					},
					"610829": {
						id: 610829,
						area_name: "吴堡县",
						area_code: "Wubu",
						area_parent_id: 610800
					},
					"610830": {
						id: 610830,
						area_name: "清涧县",
						area_code: "Qingjian",
						area_parent_id: 610800
					},
					"610831": {
						id: 610831,
						area_name: "子洲县",
						area_code: "Zizhou",
						area_parent_id: 610800
					}
				}
			},
			"610900": {
				id: 610900,
				area_name: "安康市",
				area_code: "Ankang",
				area_parent_id: 610000,
				child: {
					"610902": {
						id: 610902,
						area_name: "汉滨区",
						area_code: "Hanbin",
						area_parent_id: 610900
					},
					"610921": {
						id: 610921,
						area_name: "汉阴县",
						area_code: "Hanyin",
						area_parent_id: 610900
					},
					"610922": {
						id: 610922,
						area_name: "石泉县",
						area_code: "Shiquan",
						area_parent_id: 610900
					},
					"610923": {
						id: 610923,
						area_name: "宁陕县",
						area_code: "Ningshan",
						area_parent_id: 610900
					},
					"610924": {
						id: 610924,
						area_name: "紫阳县",
						area_code: "Ziyang",
						area_parent_id: 610900
					},
					"610925": {
						id: 610925,
						area_name: "岚皋县",
						area_code: "Langao",
						area_parent_id: 610900
					},
					"610926": {
						id: 610926,
						area_name: "平利县",
						area_code: "Pingli",
						area_parent_id: 610900
					},
					"610927": {
						id: 610927,
						area_name: "镇坪县",
						area_code: "Zhenping",
						area_parent_id: 610900
					},
					"610928": {
						id: 610928,
						area_name: "旬阳县",
						area_code: "Xunyang",
						area_parent_id: 610900
					},
					"610929": {
						id: 610929,
						area_name: "白河县",
						area_code: "Baihe",
						area_parent_id: 610900
					}
				}
			},
			"611000": {
				id: 611000,
				area_name: "商洛市",
				area_code: "Shangluo",
				area_parent_id: 610000,
				child: {
					"611002": {
						id: 611002,
						area_name: "商州区",
						area_code: "Shangzhou",
						area_parent_id: 611000
					},
					"611021": {
						id: 611021,
						area_name: "洛南县",
						area_code: "Luonan",
						area_parent_id: 611000
					},
					"611022": {
						id: 611022,
						area_name: "丹凤县",
						area_code: "Danfeng",
						area_parent_id: 611000
					},
					"611023": {
						id: 611023,
						area_name: "商南县",
						area_code: "Shangnan",
						area_parent_id: 611000
					},
					"611024": {
						id: 611024,
						area_name: "山阳县",
						area_code: "Shanyang",
						area_parent_id: 611000
					},
					"611025": {
						id: 611025,
						area_name: "镇安县",
						area_code: "Zhen'an",
						area_parent_id: 611000
					},
					"611026": {
						id: 611026,
						area_name: "柞水县",
						area_code: "Zhashui",
						area_parent_id: 611000
					}
				}
			},
			"611100": {
				id: 611100,
				area_name: "西咸新区",
				area_code: "Xixian",
				area_parent_id: 610000,
				child: {
					"611101": {
						id: 611101,
						area_name: "空港新城",
						area_code: "Konggang",
						area_parent_id: 611100
					},
					"611102": {
						id: 611102,
						area_name: "沣东新城",
						area_code: "Fengdong",
						area_parent_id: 611100
					},
					"611103": {
						id: 611103,
						area_name: "秦汉新城",
						area_code: "Qinhan",
						area_parent_id: 611100
					},
					"611104": {
						id: 611104,
						area_name: "沣西新城",
						area_code: "Fengxi",
						area_parent_id: 611100
					},
					"611105": {
						id: 611105,
						area_name: "泾河新城",
						area_code: "Jinghe",
						area_parent_id: 611100
					}
				}
			}
		}
	},
	"620000": {
		id: 620000,
		area_name: "甘肃省",
		area_code: "Gansu",
		area_parent_id: 0,
		child: {
			"620100": {
				id: 620100,
				area_name: "兰州市",
				area_code: "Lanzhou",
				area_parent_id: 620000,
				child: {
					"620102": {
						id: 620102,
						area_name: "城关区",
						area_code: "Chengguan",
						area_parent_id: 620100
					},
					"620103": {
						id: 620103,
						area_name: "七里河区",
						area_code: "Qilihe",
						area_parent_id: 620100
					},
					"620104": {
						id: 620104,
						area_name: "西固区",
						area_code: "Xigu",
						area_parent_id: 620100
					},
					"620105": {
						id: 620105,
						area_name: "安宁区",
						area_code: "Anning",
						area_parent_id: 620100
					},
					"620111": {
						id: 620111,
						area_name: "红古区",
						area_code: "Honggu",
						area_parent_id: 620100
					},
					"620121": {
						id: 620121,
						area_name: "永登县",
						area_code: "Yongdeng",
						area_parent_id: 620100
					},
					"620122": {
						id: 620122,
						area_name: "皋兰县",
						area_code: "Gaolan",
						area_parent_id: 620100
					},
					"620123": {
						id: 620123,
						area_name: "榆中县",
						area_code: "Yuzhong",
						area_parent_id: 620100
					}
				}
			},
			"620200": {
				id: 620200,
				area_name: "嘉峪关市",
				area_code: "Jiayuguan",
				area_parent_id: 620000,
				child: {
					"620201": {
						id: 620201,
						area_name: "雄关区",
						area_code: "Xiongguan",
						area_parent_id: 620200
					},
					"620202": {
						id: 620202,
						area_name: "长城区",
						area_code: "Changcheng",
						area_parent_id: 620200
					},
					"620203": {
						id: 620203,
						area_name: "镜铁区",
						area_code: "Jingtie",
						area_parent_id: 620200
					}
				}
			},
			"620300": {
				id: 620300,
				area_name: "金昌市",
				area_code: "Jinchang",
				area_parent_id: 620000,
				child: {
					"620302": {
						id: 620302,
						area_name: "金川区",
						area_code: "Jinchuan",
						area_parent_id: 620300
					},
					"620321": {
						id: 620321,
						area_name: "永昌县",
						area_code: "Yongchang",
						area_parent_id: 620300
					}
				}
			},
			"620400": {
				id: 620400,
				area_name: "白银市",
				area_code: "Baiyin",
				area_parent_id: 620000,
				child: {
					"620402": {
						id: 620402,
						area_name: "白银区",
						area_code: "Baiyin",
						area_parent_id: 620400
					},
					"620403": {
						id: 620403,
						area_name: "平川区",
						area_code: "Pingchuan",
						area_parent_id: 620400
					},
					"620421": {
						id: 620421,
						area_name: "靖远县",
						area_code: "Jingyuan",
						area_parent_id: 620400
					},
					"620422": {
						id: 620422,
						area_name: "会宁县",
						area_code: "Huining",
						area_parent_id: 620400
					},
					"620423": {
						id: 620423,
						area_name: "景泰县",
						area_code: "Jingtai",
						area_parent_id: 620400
					}
				}
			},
			"620500": {
				id: 620500,
				area_name: "天水市",
				area_code: "Tianshui",
				area_parent_id: 620000,
				child: {
					"620502": {
						id: 620502,
						area_name: "秦州区",
						area_code: "Qinzhou",
						area_parent_id: 620500
					},
					"620503": {
						id: 620503,
						area_name: "麦积区",
						area_code: "Maiji",
						area_parent_id: 620500
					},
					"620521": {
						id: 620521,
						area_name: "清水县",
						area_code: "Qingshui",
						area_parent_id: 620500
					},
					"620522": {
						id: 620522,
						area_name: "秦安县",
						area_code: "Qin'an",
						area_parent_id: 620500
					},
					"620523": {
						id: 620523,
						area_name: "甘谷县",
						area_code: "Gangu",
						area_parent_id: 620500
					},
					"620524": {
						id: 620524,
						area_name: "武山县",
						area_code: "Wushan",
						area_parent_id: 620500
					},
					"620525": {
						id: 620525,
						area_name: "张家川回族自治县",
						area_code: "Zhangjiachuan",
						area_parent_id: 620500
					}
				}
			},
			"620600": {
				id: 620600,
				area_name: "武威市",
				area_code: "Wuwei",
				area_parent_id: 620000,
				child: {
					"620602": {
						id: 620602,
						area_name: "凉州区",
						area_code: "Liangzhou",
						area_parent_id: 620600
					},
					"620621": {
						id: 620621,
						area_name: "民勤县",
						area_code: "Minqin",
						area_parent_id: 620600
					},
					"620622": {
						id: 620622,
						area_name: "古浪县",
						area_code: "Gulang",
						area_parent_id: 620600
					},
					"620623": {
						id: 620623,
						area_name: "天祝藏族自治县",
						area_code: "Tianzhu",
						area_parent_id: 620600
					}
				}
			},
			"620700": {
				id: 620700,
				area_name: "张掖市",
				area_code: "Zhangye",
				area_parent_id: 620000,
				child: {
					"620702": {
						id: 620702,
						area_name: "甘州区",
						area_code: "Ganzhou",
						area_parent_id: 620700
					},
					"620721": {
						id: 620721,
						area_name: "肃南裕固族自治县",
						area_code: "Sunan",
						area_parent_id: 620700
					},
					"620722": {
						id: 620722,
						area_name: "民乐县",
						area_code: "Minle",
						area_parent_id: 620700
					},
					"620723": {
						id: 620723,
						area_name: "临泽县",
						area_code: "Linze",
						area_parent_id: 620700
					},
					"620724": {
						id: 620724,
						area_name: "高台县",
						area_code: "Gaotai",
						area_parent_id: 620700
					},
					"620725": {
						id: 620725,
						area_name: "山丹县",
						area_code: "Shandan",
						area_parent_id: 620700
					}
				}
			},
			"620800": {
				id: 620800,
				area_name: "平凉市",
				area_code: "Pingliang",
				area_parent_id: 620000,
				child: {
					"620802": {
						id: 620802,
						area_name: "崆峒区",
						area_code: "Kongtong",
						area_parent_id: 620800
					},
					"620821": {
						id: 620821,
						area_name: "泾川县",
						area_code: "Jingchuan",
						area_parent_id: 620800
					},
					"620822": {
						id: 620822,
						area_name: "灵台县",
						area_code: "Lingtai",
						area_parent_id: 620800
					},
					"620823": {
						id: 620823,
						area_name: "崇信县",
						area_code: "Chongxin",
						area_parent_id: 620800
					},
					"620824": {
						id: 620824,
						area_name: "华亭县",
						area_code: "Huating",
						area_parent_id: 620800
					},
					"620825": {
						id: 620825,
						area_name: "庄浪县",
						area_code: "Zhuanglang",
						area_parent_id: 620800
					},
					"620826": {
						id: 620826,
						area_name: "静宁县",
						area_code: "Jingning",
						area_parent_id: 620800
					}
				}
			},
			"620900": {
				id: 620900,
				area_name: "酒泉市",
				area_code: "Jiuquan",
				area_parent_id: 620000,
				child: {
					"620902": {
						id: 620902,
						area_name: "肃州区",
						area_code: "Suzhou",
						area_parent_id: 620900
					},
					"620921": {
						id: 620921,
						area_name: "金塔县",
						area_code: "Jinta",
						area_parent_id: 620900
					},
					"620922": {
						id: 620922,
						area_name: "瓜州县",
						area_code: "Guazhou",
						area_parent_id: 620900
					},
					"620923": {
						id: 620923,
						area_name: "肃北蒙古族自治县",
						area_code: "Subei",
						area_parent_id: 620900
					},
					"620924": {
						id: 620924,
						area_name: "阿克塞哈萨克族自治县",
						area_code: "Akesai",
						area_parent_id: 620900
					},
					"620981": {
						id: 620981,
						area_name: "玉门市",
						area_code: "Yumen",
						area_parent_id: 620900
					},
					"620982": {
						id: 620982,
						area_name: "敦煌市",
						area_code: "Dunhuang",
						area_parent_id: 620900
					}
				}
			},
			"621000": {
				id: 621000,
				area_name: "庆阳市",
				area_code: "Qingyang",
				area_parent_id: 620000,
				child: {
					"621002": {
						id: 621002,
						area_name: "西峰区",
						area_code: "Xifeng",
						area_parent_id: 621000
					},
					"621021": {
						id: 621021,
						area_name: "庆城县",
						area_code: "Qingcheng",
						area_parent_id: 621000
					},
					"621022": {
						id: 621022,
						area_name: "环县",
						area_code: "Huanxian",
						area_parent_id: 621000
					},
					"621023": {
						id: 621023,
						area_name: "华池县",
						area_code: "Huachi",
						area_parent_id: 621000
					},
					"621024": {
						id: 621024,
						area_name: "合水县",
						area_code: "Heshui",
						area_parent_id: 621000
					},
					"621025": {
						id: 621025,
						area_name: "正宁县",
						area_code: "Zhengning",
						area_parent_id: 621000
					},
					"621026": {
						id: 621026,
						area_name: "宁县",
						area_code: "Ningxian",
						area_parent_id: 621000
					},
					"621027": {
						id: 621027,
						area_name: "镇原县",
						area_code: "Zhenyuan",
						area_parent_id: 621000
					}
				}
			},
			"621100": {
				id: 621100,
				area_name: "定西市",
				area_code: "Dingxi",
				area_parent_id: 620000,
				child: {
					"621102": {
						id: 621102,
						area_name: "安定区",
						area_code: "Anding",
						area_parent_id: 621100
					},
					"621121": {
						id: 621121,
						area_name: "通渭县",
						area_code: "Tongwei",
						area_parent_id: 621100
					},
					"621122": {
						id: 621122,
						area_name: "陇西县",
						area_code: "Longxi",
						area_parent_id: 621100
					},
					"621123": {
						id: 621123,
						area_name: "渭源县",
						area_code: "Weiyuan",
						area_parent_id: 621100
					},
					"621124": {
						id: 621124,
						area_name: "临洮县",
						area_code: "Lintao",
						area_parent_id: 621100
					},
					"621125": {
						id: 621125,
						area_name: "漳县",
						area_code: "Zhangxian",
						area_parent_id: 621100
					},
					"621126": {
						id: 621126,
						area_name: "岷县",
						area_code: "Minxian",
						area_parent_id: 621100
					}
				}
			},
			"621200": {
				id: 621200,
				area_name: "陇南市",
				area_code: "Longnan",
				area_parent_id: 620000,
				child: {
					"621202": {
						id: 621202,
						area_name: "武都区",
						area_code: "Wudu",
						area_parent_id: 621200
					},
					"621221": {
						id: 621221,
						area_name: "成县",
						area_code: "Chengxian",
						area_parent_id: 621200
					},
					"621222": {
						id: 621222,
						area_name: "文县",
						area_code: "Wenxian",
						area_parent_id: 621200
					},
					"621223": {
						id: 621223,
						area_name: "宕昌县",
						area_code: "Dangchang",
						area_parent_id: 621200
					},
					"621224": {
						id: 621224,
						area_name: "康县",
						area_code: "Kangxian",
						area_parent_id: 621200
					},
					"621225": {
						id: 621225,
						area_name: "西和县",
						area_code: "Xihe",
						area_parent_id: 621200
					},
					"621226": {
						id: 621226,
						area_name: "礼县",
						area_code: "Lixian",
						area_parent_id: 621200
					},
					"621227": {
						id: 621227,
						area_name: "徽县",
						area_code: "Huixian",
						area_parent_id: 621200
					},
					"621228": {
						id: 621228,
						area_name: "两当县",
						area_code: "Liangdang",
						area_parent_id: 621200
					}
				}
			},
			"622900": {
				id: 622900,
				area_name: "临夏回族自治州",
				area_code: "Linxia",
				area_parent_id: 620000,
				child: {
					"622901": {
						id: 622901,
						area_name: "临夏市",
						area_code: "Linxia",
						area_parent_id: 622900
					},
					"622921": {
						id: 622921,
						area_name: "临夏县",
						area_code: "Linxia",
						area_parent_id: 622900
					},
					"622922": {
						id: 622922,
						area_name: "康乐县",
						area_code: "Kangle",
						area_parent_id: 622900
					},
					"622923": {
						id: 622923,
						area_name: "永靖县",
						area_code: "Yongjing",
						area_parent_id: 622900
					},
					"622924": {
						id: 622924,
						area_name: "广河县",
						area_code: "Guanghe",
						area_parent_id: 622900
					},
					"622925": {
						id: 622925,
						area_name: "和政县",
						area_code: "Hezheng",
						area_parent_id: 622900
					},
					"622926": {
						id: 622926,
						area_name: "东乡族自治县",
						area_code: "Dongxiangzu",
						area_parent_id: 622900
					},
					"622927": {
						id: 622927,
						area_name: "积石山保安族东乡族撒拉族自治县",
						area_code: "Jishishan",
						area_parent_id: 622900
					}
				}
			},
			"623000": {
				id: 623000,
				area_name: "甘南藏族自治州",
				area_code: "Gannan",
				area_parent_id: 620000,
				child: {
					"623001": {
						id: 623001,
						area_name: "合作市",
						area_code: "Hezuo",
						area_parent_id: 623000
					},
					"623021": {
						id: 623021,
						area_name: "临潭县",
						area_code: "Lintan",
						area_parent_id: 623000
					},
					"623022": {
						id: 623022,
						area_name: "卓尼县",
						area_code: "Zhuoni",
						area_parent_id: 623000
					},
					"623023": {
						id: 623023,
						area_name: "舟曲县",
						area_code: "Zhouqu",
						area_parent_id: 623000
					},
					"623024": {
						id: 623024,
						area_name: "迭部县",
						area_code: "Diebu",
						area_parent_id: 623000
					},
					"623025": {
						id: 623025,
						area_name: "玛曲县",
						area_code: "Maqu",
						area_parent_id: 623000
					},
					"623026": {
						id: 623026,
						area_name: "碌曲县",
						area_code: "Luqu",
						area_parent_id: 623000
					},
					"623027": {
						id: 623027,
						area_name: "夏河县",
						area_code: "Xiahe",
						area_parent_id: 623000
					}
				}
			}
		}
	},
	"630000": {
		id: 630000,
		area_name: "青海省",
		area_code: "Qinghai",
		area_parent_id: 0,
		child: {
			"630100": {
				id: 630100,
				area_name: "西宁市",
				area_code: "Xining",
				area_parent_id: 630000,
				child: {
					"630102": {
						id: 630102,
						area_name: "城东区",
						area_code: "Chengdong",
						area_parent_id: 630100
					},
					"630103": {
						id: 630103,
						area_name: "城中区",
						area_code: "Chengzhong",
						area_parent_id: 630100
					},
					"630104": {
						id: 630104,
						area_name: "城西区",
						area_code: "Chengxi",
						area_parent_id: 630100
					},
					"630105": {
						id: 630105,
						area_name: "城北区",
						area_code: "Chengbei",
						area_parent_id: 630100
					},
					"630121": {
						id: 630121,
						area_name: "大通回族土族自治县",
						area_code: "Datong",
						area_parent_id: 630100
					},
					"630122": {
						id: 630122,
						area_name: "湟中县",
						area_code: "Huangzhong",
						area_parent_id: 630100
					},
					"630123": {
						id: 630123,
						area_name: "湟源县",
						area_code: "Huangyuan",
						area_parent_id: 630100
					}
				}
			},
			"630200": {
				id: 630200,
				area_name: "海东市",
				area_code: "Haidong",
				area_parent_id: 630000,
				child: {
					"630202": {
						id: 630202,
						area_name: "乐都区",
						area_code: "Ledu",
						area_parent_id: 630200
					},
					"630221": {
						id: 630221,
						area_name: "平安县",
						area_code: "Ping'an",
						area_parent_id: 630200
					},
					"630222": {
						id: 630222,
						area_name: "民和回族土族自治县",
						area_code: "Minhe",
						area_parent_id: 630200
					},
					"630223": {
						id: 630223,
						area_name: "互助土族自治县",
						area_code: "Huzhu",
						area_parent_id: 630200
					},
					"630224": {
						id: 630224,
						area_name: "化隆回族自治县",
						area_code: "Hualong",
						area_parent_id: 630200
					},
					"630225": {
						id: 630225,
						area_name: "循化撒拉族自治县",
						area_code: "Xunhua",
						area_parent_id: 630200
					}
				}
			},
			"632200": {
				id: 632200,
				area_name: "海北藏族自治州",
				area_code: "Haibei",
				area_parent_id: 630000,
				child: {
					"632221": {
						id: 632221,
						area_name: "门源回族自治县",
						area_code: "Menyuan",
						area_parent_id: 632200
					},
					"632222": {
						id: 632222,
						area_name: "祁连县",
						area_code: "Qilian",
						area_parent_id: 632200
					},
					"632223": {
						id: 632223,
						area_name: "海晏县",
						area_code: "Haiyan",
						area_parent_id: 632200
					},
					"632224": {
						id: 632224,
						area_name: "刚察县",
						area_code: "Gangcha",
						area_parent_id: 632200
					}
				}
			},
			"632300": {
				id: 632300,
				area_name: "黄南藏族自治州",
				area_code: "Huangnan",
				area_parent_id: 630000,
				child: {
					"632321": {
						id: 632321,
						area_name: "同仁县",
						area_code: "Tongren",
						area_parent_id: 632300
					},
					"632322": {
						id: 632322,
						area_name: "尖扎县",
						area_code: "Jianzha",
						area_parent_id: 632300
					},
					"632323": {
						id: 632323,
						area_name: "泽库县",
						area_code: "Zeku",
						area_parent_id: 632300
					},
					"632324": {
						id: 632324,
						area_name: "河南蒙古族自治县",
						area_code: "Henan",
						area_parent_id: 632300
					}
				}
			},
			"632500": {
				id: 632500,
				area_name: "海南藏族自治州",
				area_code: "Hainan",
				area_parent_id: 630000,
				child: {
					"632521": {
						id: 632521,
						area_name: "共和县",
						area_code: "Gonghe",
						area_parent_id: 632500
					},
					"632522": {
						id: 632522,
						area_name: "同德县",
						area_code: "Tongde",
						area_parent_id: 632500
					},
					"632523": {
						id: 632523,
						area_name: "贵德县",
						area_code: "Guide",
						area_parent_id: 632500
					},
					"632524": {
						id: 632524,
						area_name: "兴海县",
						area_code: "Xinghai",
						area_parent_id: 632500
					},
					"632525": {
						id: 632525,
						area_name: "贵南县",
						area_code: "Guinan",
						area_parent_id: 632500
					}
				}
			},
			"632600": {
				id: 632600,
				area_name: "果洛藏族自治州",
				area_code: "Golog",
				area_parent_id: 630000,
				child: {
					"632621": {
						id: 632621,
						area_name: "玛沁县",
						area_code: "Maqin",
						area_parent_id: 632600
					},
					"632622": {
						id: 632622,
						area_name: "班玛县",
						area_code: "Banma",
						area_parent_id: 632600
					},
					"632623": {
						id: 632623,
						area_name: "甘德县",
						area_code: "Gande",
						area_parent_id: 632600
					},
					"632624": {
						id: 632624,
						area_name: "达日县",
						area_code: "Dari",
						area_parent_id: 632600
					},
					"632625": {
						id: 632625,
						area_name: "久治县",
						area_code: "Jiuzhi",
						area_parent_id: 632600
					},
					"632626": {
						id: 632626,
						area_name: "玛多县",
						area_code: "Maduo",
						area_parent_id: 632600
					}
				}
			},
			"632700": {
				id: 632700,
				area_name: "玉树藏族自治州",
				area_code: "Yushu",
				area_parent_id: 630000,
				child: {
					"632701": {
						id: 632701,
						area_name: "玉树市",
						area_code: "Yushu",
						area_parent_id: 632700
					},
					"632722": {
						id: 632722,
						area_name: "杂多县",
						area_code: "Zaduo",
						area_parent_id: 632700
					},
					"632723": {
						id: 632723,
						area_name: "称多县",
						area_code: "Chenduo",
						area_parent_id: 632700
					},
					"632724": {
						id: 632724,
						area_name: "治多县",
						area_code: "Zhiduo",
						area_parent_id: 632700
					},
					"632725": {
						id: 632725,
						area_name: "囊谦县",
						area_code: "Nangqian",
						area_parent_id: 632700
					},
					"632726": {
						id: 632726,
						area_name: "曲麻莱县",
						area_code: "Qumalai",
						area_parent_id: 632700
					}
				}
			},
			"632800": {
				id: 632800,
				area_name: "海西蒙古族藏族自治州",
				area_code: "Haixi",
				area_parent_id: 630000,
				child: {
					"632801": {
						id: 632801,
						area_name: "格尔木市",
						area_code: "Geermu",
						area_parent_id: 632800
					},
					"632802": {
						id: 632802,
						area_name: "德令哈市",
						area_code: "Delingha",
						area_parent_id: 632800
					},
					"632821": {
						id: 632821,
						area_name: "乌兰县",
						area_code: "Wulan",
						area_parent_id: 632800
					},
					"632822": {
						id: 632822,
						area_name: "都兰县",
						area_code: "Dulan",
						area_parent_id: 632800
					},
					"632823": {
						id: 632823,
						area_name: "天峻县",
						area_code: "Tianjun",
						area_parent_id: 632800
					}
				}
			}
		}
	},
	"640000": {
		id: 640000,
		area_name: "宁夏回族自治区",
		area_code: "Ningxia",
		area_parent_id: 0,
		child: {
			"640100": {
				id: 640100,
				area_name: "银川市",
				area_code: "Yinchuan",
				area_parent_id: 640000,
				child: {
					"640104": {
						id: 640104,
						area_name: "兴庆区",
						area_code: "Xingqing",
						area_parent_id: 640100
					},
					"640105": {
						id: 640105,
						area_name: "西夏区",
						area_code: "Xixia",
						area_parent_id: 640100
					},
					"640106": {
						id: 640106,
						area_name: "金凤区",
						area_code: "Jinfeng",
						area_parent_id: 640100
					},
					"640121": {
						id: 640121,
						area_name: "永宁县",
						area_code: "Yongning",
						area_parent_id: 640100
					},
					"640122": {
						id: 640122,
						area_name: "贺兰县",
						area_code: "Helan",
						area_parent_id: 640100
					},
					"640181": {
						id: 640181,
						area_name: "灵武市",
						area_code: "Lingwu",
						area_parent_id: 640100
					}
				}
			},
			"640200": {
				id: 640200,
				area_name: "石嘴山市",
				area_code: "Shizuishan",
				area_parent_id: 640000,
				child: {
					"640202": {
						id: 640202,
						area_name: "大武口区",
						area_code: "Dawukou",
						area_parent_id: 640200
					},
					"640205": {
						id: 640205,
						area_name: "惠农区",
						area_code: "Huinong",
						area_parent_id: 640200
					},
					"640221": {
						id: 640221,
						area_name: "平罗县",
						area_code: "Pingluo",
						area_parent_id: 640200
					}
				}
			},
			"640300": {
				id: 640300,
				area_name: "吴忠市",
				area_code: "Wuzhong",
				area_parent_id: 640000,
				child: {
					"640302": {
						id: 640302,
						area_name: "利通区",
						area_code: "Litong",
						area_parent_id: 640300
					},
					"640303": {
						id: 640303,
						area_name: "红寺堡区",
						area_code: "Hongsibao",
						area_parent_id: 640300
					},
					"640323": {
						id: 640323,
						area_name: "盐池县",
						area_code: "Yanchi",
						area_parent_id: 640300
					},
					"640324": {
						id: 640324,
						area_name: "同心县",
						area_code: "Tongxin",
						area_parent_id: 640300
					},
					"640381": {
						id: 640381,
						area_name: "青铜峡市",
						area_code: "Qingtongxia",
						area_parent_id: 640300
					}
				}
			},
			"640400": {
				id: 640400,
				area_name: "固原市",
				area_code: "Guyuan",
				area_parent_id: 640000,
				child: {
					"640402": {
						id: 640402,
						area_name: "原州区",
						area_code: "Yuanzhou",
						area_parent_id: 640400
					},
					"640422": {
						id: 640422,
						area_name: "西吉县",
						area_code: "Xiji",
						area_parent_id: 640400
					},
					"640423": {
						id: 640423,
						area_name: "隆德县",
						area_code: "Longde",
						area_parent_id: 640400
					},
					"640424": {
						id: 640424,
						area_name: "泾源县",
						area_code: "Jingyuan",
						area_parent_id: 640400
					},
					"640425": {
						id: 640425,
						area_name: "彭阳县",
						area_code: "Pengyang",
						area_parent_id: 640400
					}
				}
			},
			"640500": {
				id: 640500,
				area_name: "中卫市",
				area_code: "Zhongwei",
				area_parent_id: 640000,
				child: {
					"640502": {
						id: 640502,
						area_name: "沙坡头区",
						area_code: "Shapotou",
						area_parent_id: 640500
					},
					"640521": {
						id: 640521,
						area_name: "中宁县",
						area_code: "Zhongning",
						area_parent_id: 640500
					},
					"640522": {
						id: 640522,
						area_name: "海原县",
						area_code: "Haiyuan",
						area_parent_id: 640500
					}
				}
			}
		}
	},
	"650000": {
		id: 650000,
		area_name: "新疆维吾尔自治区",
		area_code: "Xinjiang",
		area_parent_id: 0,
		child: {
			"650100": {
				id: 650100,
				area_name: "乌鲁木齐市",
				area_code: "Urumqi",
				area_parent_id: 650000,
				child: {
					"650102": {
						id: 650102,
						area_name: "天山区",
						area_code: "Tianshan",
						area_parent_id: 650100
					},
					"650103": {
						id: 650103,
						area_name: "沙依巴克区",
						area_code: "Shayibake",
						area_parent_id: 650100
					},
					"650104": {
						id: 650104,
						area_name: "新市区",
						area_code: "Xinshi",
						area_parent_id: 650100
					},
					"650105": {
						id: 650105,
						area_name: "水磨沟区",
						area_code: "Shuimogou",
						area_parent_id: 650100
					},
					"650106": {
						id: 650106,
						area_name: "头屯河区",
						area_code: "Toutunhe",
						area_parent_id: 650100
					},
					"650107": {
						id: 650107,
						area_name: "达坂城区",
						area_code: "Dabancheng",
						area_parent_id: 650100
					},
					"650109": {
						id: 650109,
						area_name: "米东区",
						area_code: "Midong",
						area_parent_id: 650100
					},
					"650121": {
						id: 650121,
						area_name: "乌鲁木齐县",
						area_code: "Wulumuqi",
						area_parent_id: 650100
					}
				}
			},
			"650200": {
				id: 650200,
				area_name: "克拉玛依市",
				area_code: "Karamay",
				area_parent_id: 650000,
				child: {
					"650202": {
						id: 650202,
						area_name: "独山子区",
						area_code: "Dushanzi",
						area_parent_id: 650200
					},
					"650203": {
						id: 650203,
						area_name: "克拉玛依区",
						area_code: "Kelamayi",
						area_parent_id: 650200
					},
					"650204": {
						id: 650204,
						area_name: "白碱滩区",
						area_code: "Baijiantan",
						area_parent_id: 650200
					},
					"650205": {
						id: 650205,
						area_name: "乌尔禾区",
						area_code: "Wuerhe",
						area_parent_id: 650200
					}
				}
			},
			"652100": {
				id: 652100,
				area_name: "吐鲁番地区",
				area_code: "Turpan",
				area_parent_id: 650000,
				child: {
					"652101": {
						id: 652101,
						area_name: "吐鲁番市",
						area_code: "Tulufan",
						area_parent_id: 652100
					},
					"652122": {
						id: 652122,
						area_name: "鄯善县",
						area_code: "Shanshan",
						area_parent_id: 652100
					},
					"652123": {
						id: 652123,
						area_name: "托克逊县",
						area_code: "Tuokexun",
						area_parent_id: 652100
					}
				}
			},
			"652200": {
				id: 652200,
				area_name: "哈密地区",
				area_code: "Hami",
				area_parent_id: 650000,
				child: {
					"652201": {
						id: 652201,
						area_name: "哈密市",
						area_code: "Hami",
						area_parent_id: 652200
					},
					"652222": {
						id: 652222,
						area_name: "巴里坤哈萨克自治县",
						area_code: "Balikun",
						area_parent_id: 652200
					},
					"652223": {
						id: 652223,
						area_name: "伊吾县",
						area_code: "Yiwu",
						area_parent_id: 652200
					}
				}
			},
			"652300": {
				id: 652300,
				area_name: "昌吉回族自治州",
				area_code: "Changji",
				area_parent_id: 650000,
				child: {
					"652301": {
						id: 652301,
						area_name: "昌吉市",
						area_code: "Changji",
						area_parent_id: 652300
					},
					"652302": {
						id: 652302,
						area_name: "阜康市",
						area_code: "Fukang",
						area_parent_id: 652300
					},
					"652323": {
						id: 652323,
						area_name: "呼图壁县",
						area_code: "Hutubi",
						area_parent_id: 652300
					},
					"652324": {
						id: 652324,
						area_name: "玛纳斯县",
						area_code: "Manasi",
						area_parent_id: 652300
					},
					"652325": {
						id: 652325,
						area_name: "奇台县",
						area_code: "Qitai",
						area_parent_id: 652300
					},
					"652327": {
						id: 652327,
						area_name: "吉木萨尔县",
						area_code: "Jimusaer",
						area_parent_id: 652300
					},
					"652328": {
						id: 652328,
						area_name: "木垒哈萨克自治县",
						area_code: "Mulei",
						area_parent_id: 652300
					}
				}
			},
			"652700": {
				id: 652700,
				area_name: "博尔塔拉蒙古自治州",
				area_code: "Bortala",
				area_parent_id: 650000,
				child: {
					"652701": {
						id: 652701,
						area_name: "博乐市",
						area_code: "Bole",
						area_parent_id: 652700
					},
					"652702": {
						id: 652702,
						area_name: "阿拉山口市",
						area_code: "Alashankou",
						area_parent_id: 652700
					},
					"652722": {
						id: 652722,
						area_name: "精河县",
						area_code: "Jinghe",
						area_parent_id: 652700
					},
					"652723": {
						id: 652723,
						area_name: "温泉县",
						area_code: "Wenquan",
						area_parent_id: 652700
					}
				}
			},
			"652800": {
				id: 652800,
				area_name: "巴音郭楞蒙古自治州",
				area_code: "Bayingol",
				area_parent_id: 650000,
				child: {
					"652801": {
						id: 652801,
						area_name: "库尔勒市",
						area_code: "Kuerle",
						area_parent_id: 652800
					},
					"652822": {
						id: 652822,
						area_name: "轮台县",
						area_code: "Luntai",
						area_parent_id: 652800
					},
					"652823": {
						id: 652823,
						area_name: "尉犁县",
						area_code: "Yuli",
						area_parent_id: 652800
					},
					"652824": {
						id: 652824,
						area_name: "若羌县",
						area_code: "Ruoqiang",
						area_parent_id: 652800
					},
					"652825": {
						id: 652825,
						area_name: "且末县",
						area_code: "Qiemo",
						area_parent_id: 652800
					},
					"652826": {
						id: 652826,
						area_name: "焉耆回族自治县",
						area_code: "Yanqi",
						area_parent_id: 652800
					},
					"652827": {
						id: 652827,
						area_name: "和静县",
						area_code: "Hejing",
						area_parent_id: 652800
					},
					"652828": {
						id: 652828,
						area_name: "和硕县",
						area_code: "Heshuo",
						area_parent_id: 652800
					},
					"652829": {
						id: 652829,
						area_name: "博湖县",
						area_code: "Bohu",
						area_parent_id: 652800
					}
				}
			},
			"652900": {
				id: 652900,
				area_name: "阿克苏地区",
				area_code: "Aksu",
				area_parent_id: 650000,
				child: {
					"652901": {
						id: 652901,
						area_name: "阿克苏市",
						area_code: "Akesu",
						area_parent_id: 652900
					},
					"652922": {
						id: 652922,
						area_name: "温宿县",
						area_code: "Wensu",
						area_parent_id: 652900
					},
					"652923": {
						id: 652923,
						area_name: "库车县",
						area_code: "Kuche",
						area_parent_id: 652900
					},
					"652924": {
						id: 652924,
						area_name: "沙雅县",
						area_code: "Shaya",
						area_parent_id: 652900
					},
					"652925": {
						id: 652925,
						area_name: "新和县",
						area_code: "Xinhe",
						area_parent_id: 652900
					},
					"652926": {
						id: 652926,
						area_name: "拜城县",
						area_code: "Baicheng",
						area_parent_id: 652900
					},
					"652927": {
						id: 652927,
						area_name: "乌什县",
						area_code: "Wushi",
						area_parent_id: 652900
					},
					"652928": {
						id: 652928,
						area_name: "阿瓦提县",
						area_code: "Awati",
						area_parent_id: 652900
					},
					"652929": {
						id: 652929,
						area_name: "柯坪县",
						area_code: "Keping",
						area_parent_id: 652900
					}
				}
			},
			"653000": {
				id: 653000,
				area_name: "克孜勒苏柯尔克孜自治州",
				area_code: "Kizilsu",
				area_parent_id: 650000,
				child: {
					"653001": {
						id: 653001,
						area_name: "阿图什市",
						area_code: "Atushi",
						area_parent_id: 653000
					},
					"653022": {
						id: 653022,
						area_name: "阿克陶县",
						area_code: "Aketao",
						area_parent_id: 653000
					},
					"653023": {
						id: 653023,
						area_name: "阿合奇县",
						area_code: "Aheqi",
						area_parent_id: 653000
					},
					"653024": {
						id: 653024,
						area_name: "乌恰县",
						area_code: "Wuqia",
						area_parent_id: 653000
					}
				}
			},
			"653100": {
				id: 653100,
				area_name: "喀什地区",
				area_code: "Kashgar",
				area_parent_id: 650000,
				child: {
					"653101": {
						id: 653101,
						area_name: "喀什市",
						area_code: "Kashi",
						area_parent_id: 653100
					},
					"653121": {
						id: 653121,
						area_name: "疏附县",
						area_code: "Shufu",
						area_parent_id: 653100
					},
					"653122": {
						id: 653122,
						area_name: "疏勒县",
						area_code: "Shule",
						area_parent_id: 653100
					},
					"653123": {
						id: 653123,
						area_name: "英吉沙县",
						area_code: "Yingjisha",
						area_parent_id: 653100
					},
					"653124": {
						id: 653124,
						area_name: "泽普县",
						area_code: "Zepu",
						area_parent_id: 653100
					},
					"653125": {
						id: 653125,
						area_name: "莎车县",
						area_code: "Shache",
						area_parent_id: 653100
					},
					"653126": {
						id: 653126,
						area_name: "叶城县",
						area_code: "Yecheng",
						area_parent_id: 653100
					},
					"653127": {
						id: 653127,
						area_name: "麦盖提县",
						area_code: "Maigaiti",
						area_parent_id: 653100
					},
					"653128": {
						id: 653128,
						area_name: "岳普湖县",
						area_code: "Yuepuhu",
						area_parent_id: 653100
					},
					"653129": {
						id: 653129,
						area_name: "伽师县",
						area_code: "Jiashi",
						area_parent_id: 653100
					},
					"653130": {
						id: 653130,
						area_name: "巴楚县",
						area_code: "Bachu",
						area_parent_id: 653100
					},
					"653131": {
						id: 653131,
						area_name: "塔什库尔干塔吉克自治县",
						area_code: "Tashikuergantajike",
						area_parent_id: 653100
					}
				}
			},
			"653200": {
				id: 653200,
				area_name: "和田地区",
				area_code: "Hotan",
				area_parent_id: 650000,
				child: {
					"653201": {
						id: 653201,
						area_name: "和田市",
						area_code: "Hetianshi",
						area_parent_id: 653200
					},
					"653221": {
						id: 653221,
						area_name: "和田县",
						area_code: "Hetianxian",
						area_parent_id: 653200
					},
					"653222": {
						id: 653222,
						area_name: "墨玉县",
						area_code: "Moyu",
						area_parent_id: 653200
					},
					"653223": {
						id: 653223,
						area_name: "皮山县",
						area_code: "Pishan",
						area_parent_id: 653200
					},
					"653224": {
						id: 653224,
						area_name: "洛浦县",
						area_code: "Luopu",
						area_parent_id: 653200
					},
					"653225": {
						id: 653225,
						area_name: "策勒县",
						area_code: "Cele",
						area_parent_id: 653200
					},
					"653226": {
						id: 653226,
						area_name: "于田县",
						area_code: "Yutian",
						area_parent_id: 653200
					},
					"653227": {
						id: 653227,
						area_name: "民丰县",
						area_code: "Minfeng",
						area_parent_id: 653200
					}
				}
			},
			"654000": {
				id: 654000,
				area_name: "伊犁哈萨克自治州",
				area_code: "Ili",
				area_parent_id: 650000,
				child: {
					"654002": {
						id: 654002,
						area_name: "伊宁市",
						area_code: "Yining",
						area_parent_id: 654000
					},
					"654003": {
						id: 654003,
						area_name: "奎屯市",
						area_code: "Kuitun",
						area_parent_id: 654000
					},
					"654004": {
						id: 654004,
						area_name: "霍尔果斯市",
						area_code: "Huoerguosi",
						area_parent_id: 654000
					},
					"654021": {
						id: 654021,
						area_name: "伊宁县",
						area_code: "Yining",
						area_parent_id: 654000
					},
					"654022": {
						id: 654022,
						area_name: "察布查尔锡伯自治县",
						area_code: "Chabuchaerxibo",
						area_parent_id: 654000
					},
					"654023": {
						id: 654023,
						area_name: "霍城县",
						area_code: "Huocheng",
						area_parent_id: 654000
					},
					"654024": {
						id: 654024,
						area_name: "巩留县",
						area_code: "Gongliu",
						area_parent_id: 654000
					},
					"654025": {
						id: 654025,
						area_name: "新源县",
						area_code: "Xinyuan",
						area_parent_id: 654000
					},
					"654026": {
						id: 654026,
						area_name: "昭苏县",
						area_code: "Zhaosu",
						area_parent_id: 654000
					},
					"654027": {
						id: 654027,
						area_name: "特克斯县",
						area_code: "Tekesi",
						area_parent_id: 654000
					},
					"654028": {
						id: 654028,
						area_name: "尼勒克县",
						area_code: "Nileke",
						area_parent_id: 654000
					}
				}
			},
			"654200": {
				id: 654200,
				area_name: "塔城地区",
				area_code: "Qoqek",
				area_parent_id: 650000,
				child: {
					"654201": {
						id: 654201,
						area_name: "塔城市",
						area_code: "Tacheng",
						area_parent_id: 654200
					},
					"654202": {
						id: 654202,
						area_name: "乌苏市",
						area_code: "Wusu",
						area_parent_id: 654200
					},
					"654221": {
						id: 654221,
						area_name: "额敏县",
						area_code: "Emin",
						area_parent_id: 654200
					},
					"654223": {
						id: 654223,
						area_name: "沙湾县",
						area_code: "Shawan",
						area_parent_id: 654200
					},
					"654224": {
						id: 654224,
						area_name: "托里县",
						area_code: "Tuoli",
						area_parent_id: 654200
					},
					"654225": {
						id: 654225,
						area_name: "裕民县",
						area_code: "Yumin",
						area_parent_id: 654200
					},
					"654226": {
						id: 654226,
						area_name: "和布克赛尔蒙古自治县",
						area_code: "Hebukesaier",
						area_parent_id: 654200
					}
				}
			},
			"654300": {
				id: 654300,
				area_name: "阿勒泰地区",
				area_code: "Altay",
				area_parent_id: 650000,
				child: {
					"654301": {
						id: 654301,
						area_name: "阿勒泰市",
						area_code: "Aletai",
						area_parent_id: 654300
					},
					"654321": {
						id: 654321,
						area_name: "布尔津县",
						area_code: "Buerjin",
						area_parent_id: 654300
					},
					"654322": {
						id: 654322,
						area_name: "富蕴县",
						area_code: "Fuyun",
						area_parent_id: 654300
					},
					"654323": {
						id: 654323,
						area_name: "福海县",
						area_code: "Fuhai",
						area_parent_id: 654300
					},
					"654324": {
						id: 654324,
						area_name: "哈巴河县",
						area_code: "Habahe",
						area_parent_id: 654300
					},
					"654325": {
						id: 654325,
						area_name: "青河县",
						area_code: "Qinghe",
						area_parent_id: 654300
					},
					"654326": {
						id: 654326,
						area_name: "吉木乃县",
						area_code: "Jimunai",
						area_parent_id: 654300
					}
				}
			},
			"659000": {
				id: 659000,
				area_name: "直辖县级",
				area_code: "",
				area_parent_id: 650000,
				child: {
					"659001": {
						id: 659001,
						area_name: "石河子市",
						area_code: "Shihezi",
						area_parent_id: 659000
					},
					"659002": {
						id: 659002,
						area_name: "阿拉尔市",
						area_code: "Aral",
						area_parent_id: 659000
					},
					"659003": {
						id: 659003,
						area_name: "图木舒克市",
						area_code: "Tumxuk",
						area_parent_id: 659000
					},
					"659004": {
						id: 659004,
						area_name: "五家渠市",
						area_code: "Wujiaqu",
						area_parent_id: 659000
					},
					"659005": {
						id: 659005,
						area_name: "北屯市",
						area_code: "Beitun",
						area_parent_id: 659000
					},
					"659006": {
						id: 659006,
						area_name: "铁门关市",
						area_code: "Tiemenguan",
						area_parent_id: 659000
					},
					"659007": {
						id: 659007,
						area_name: "双河市",
						area_code: "Shuanghe",
						area_parent_id: 659000
					}
				}
			}
		}
	},
	"710000": {
		id: 710000,
		area_name: "台湾",
		area_code: "Taiwan",
		area_parent_id: 0,
		child: {
			"710100": {
				id: 710100,
				area_name: "台北市",
				area_code: "Taipei",
				area_parent_id: 710000,
				child: {
					"710101": {
						id: 710101,
						area_name: "松山区",
						area_code: "Songshan",
						area_parent_id: 710100
					},
					"710102": {
						id: 710102,
						area_name: "信义区",
						area_code: "Xinyi",
						area_parent_id: 710100
					},
					"710103": {
						id: 710103,
						area_name: "大安区",
						area_code: "Da'an",
						area_parent_id: 710100
					},
					"710104": {
						id: 710104,
						area_name: "中山区",
						area_code: "Zhongshan",
						area_parent_id: 710100
					},
					"710105": {
						id: 710105,
						area_name: "中正区",
						area_code: "Zhongzheng",
						area_parent_id: 710100
					},
					"710106": {
						id: 710106,
						area_name: "大同区",
						area_code: "Datong",
						area_parent_id: 710100
					},
					"710107": {
						id: 710107,
						area_name: "万华区",
						area_code: "Wanhua",
						area_parent_id: 710100
					},
					"710108": {
						id: 710108,
						area_name: "文山区",
						area_code: "Wenshan",
						area_parent_id: 710100
					},
					"710109": {
						id: 710109,
						area_name: "南港区",
						area_code: "Nangang",
						area_parent_id: 710100
					},
					"710110": {
						id: 710110,
						area_name: "内湖区",
						area_code: "Nahu",
						area_parent_id: 710100
					},
					"710111": {
						id: 710111,
						area_name: "士林区",
						area_code: "Shilin",
						area_parent_id: 710100
					},
					"710112": {
						id: 710112,
						area_name: "北投区",
						area_code: "Beitou",
						area_parent_id: 710100
					}
				}
			},
			"710200": {
				id: 710200,
				area_name: "高雄市",
				area_code: "Kaohsiung",
				area_parent_id: 710000,
				child: {
					"710201": {
						id: 710201,
						area_name: "盐埕区",
						area_code: "Yancheng",
						area_parent_id: 710200
					},
					"710202": {
						id: 710202,
						area_name: "鼓山区",
						area_code: "Gushan",
						area_parent_id: 710200
					},
					"710203": {
						id: 710203,
						area_name: "左营区",
						area_code: "Zuoying",
						area_parent_id: 710200
					},
					"710204": {
						id: 710204,
						area_name: "楠梓区",
						area_code: "Nanzi",
						area_parent_id: 710200
					},
					"710205": {
						id: 710205,
						area_name: "三民区",
						area_code: "Sanmin",
						area_parent_id: 710200
					},
					"710206": {
						id: 710206,
						area_name: "新兴区",
						area_code: "Xinxing",
						area_parent_id: 710200
					},
					"710207": {
						id: 710207,
						area_name: "前金区",
						area_code: "Qianjin",
						area_parent_id: 710200
					},
					"710208": {
						id: 710208,
						area_name: "苓雅区",
						area_code: "Lingya",
						area_parent_id: 710200
					},
					"710209": {
						id: 710209,
						area_name: "前镇区",
						area_code: "Qianzhen",
						area_parent_id: 710200
					},
					"710210": {
						id: 710210,
						area_name: "旗津区",
						area_code: "Qijin",
						area_parent_id: 710200
					},
					"710211": {
						id: 710211,
						area_name: "小港区",
						area_code: "Xiaogang",
						area_parent_id: 710200
					},
					"710212": {
						id: 710212,
						area_name: "凤山区",
						area_code: "Fengshan",
						area_parent_id: 710200
					},
					"710213": {
						id: 710213,
						area_name: "林园区",
						area_code: "Linyuan",
						area_parent_id: 710200
					},
					"710214": {
						id: 710214,
						area_name: "大寮区",
						area_code: "Daliao",
						area_parent_id: 710200
					},
					"710215": {
						id: 710215,
						area_name: "大树区",
						area_code: "Dashu",
						area_parent_id: 710200
					},
					"710216": {
						id: 710216,
						area_name: "大社区",
						area_code: "Dashe",
						area_parent_id: 710200
					},
					"710217": {
						id: 710217,
						area_name: "仁武区",
						area_code: "Renwu",
						area_parent_id: 710200
					},
					"710218": {
						id: 710218,
						area_name: "鸟松区",
						area_code: "Niaosong",
						area_parent_id: 710200
					},
					"710219": {
						id: 710219,
						area_name: "冈山区",
						area_code: "Gangshan",
						area_parent_id: 710200
					},
					"710220": {
						id: 710220,
						area_name: "桥头区",
						area_code: "Qiaotou",
						area_parent_id: 710200
					},
					"710221": {
						id: 710221,
						area_name: "燕巢区",
						area_code: "Yanchao",
						area_parent_id: 710200
					},
					"710222": {
						id: 710222,
						area_name: "田寮区",
						area_code: "Tianliao",
						area_parent_id: 710200
					},
					"710223": {
						id: 710223,
						area_name: "阿莲区",
						area_code: "Alian",
						area_parent_id: 710200
					},
					"710224": {
						id: 710224,
						area_name: "路竹区",
						area_code: "Luzhu",
						area_parent_id: 710200
					},
					"710225": {
						id: 710225,
						area_name: "湖内区",
						area_code: "Huna",
						area_parent_id: 710200
					},
					"710226": {
						id: 710226,
						area_name: "茄萣区",
						area_code: "Qieding",
						area_parent_id: 710200
					},
					"710227": {
						id: 710227,
						area_name: "永安区",
						area_code: "Yong'an",
						area_parent_id: 710200
					},
					"710228": {
						id: 710228,
						area_name: "弥陀区",
						area_code: "Mituo",
						area_parent_id: 710200
					},
					"710229": {
						id: 710229,
						area_name: "梓官区",
						area_code: "Ziguan",
						area_parent_id: 710200
					},
					"710230": {
						id: 710230,
						area_name: "旗山区",
						area_code: "Qishan",
						area_parent_id: 710200
					},
					"710231": {
						id: 710231,
						area_name: "美浓区",
						area_code: "Meinong",
						area_parent_id: 710200
					},
					"710232": {
						id: 710232,
						area_name: "六龟区",
						area_code: "Liugui",
						area_parent_id: 710200
					},
					"710233": {
						id: 710233,
						area_name: "甲仙区",
						area_code: "Jiaxian",
						area_parent_id: 710200
					},
					"710234": {
						id: 710234,
						area_name: "杉林区",
						area_code: "Shanlin",
						area_parent_id: 710200
					},
					"710235": {
						id: 710235,
						area_name: "内门区",
						area_code: "Namen",
						area_parent_id: 710200
					},
					"710236": {
						id: 710236,
						area_name: "茂林区",
						area_code: "Maolin",
						area_parent_id: 710200
					},
					"710237": {
						id: 710237,
						area_name: "桃源区",
						area_code: "Taoyuan",
						area_parent_id: 710200
					},
					"710238": {
						id: 710238,
						area_name: "那玛夏区",
						area_code: "Namaxia",
						area_parent_id: 710200
					}
				}
			},
			"710300": {
				id: 710300,
				area_name: "基隆市",
				area_code: "Keelung",
				area_parent_id: 710000,
				child: {
					"710301": {
						id: 710301,
						area_name: "中正区",
						area_code: "Zhongzheng",
						area_parent_id: 710300
					},
					"710302": {
						id: 710302,
						area_name: "七堵区",
						area_code: "Qidu",
						area_parent_id: 710300
					},
					"710303": {
						id: 710303,
						area_name: "暖暖区",
						area_code: "Nuannuan",
						area_parent_id: 710300
					},
					"710304": {
						id: 710304,
						area_name: "仁爱区",
						area_code: "Renai",
						area_parent_id: 710300
					},
					"710305": {
						id: 710305,
						area_name: "中山区",
						area_code: "Zhongshan",
						area_parent_id: 710300
					},
					"710306": {
						id: 710306,
						area_name: "安乐区",
						area_code: "Anle",
						area_parent_id: 710300
					},
					"710307": {
						id: 710307,
						area_name: "信义区",
						area_code: "Xinyi",
						area_parent_id: 710300
					}
				}
			},
			"710400": {
				id: 710400,
				area_name: "台中市",
				area_code: "Taichung",
				area_parent_id: 710000,
				child: {
					"710401": {
						id: 710401,
						area_name: "中区",
						area_code: "Zhongqu",
						area_parent_id: 710400
					},
					"710402": {
						id: 710402,
						area_name: "东区",
						area_code: "Dongqu",
						area_parent_id: 710400
					},
					"710403": {
						id: 710403,
						area_name: "南区",
						area_code: "Nanqu",
						area_parent_id: 710400
					},
					"710404": {
						id: 710404,
						area_name: "西区",
						area_code: "Xiqu",
						area_parent_id: 710400
					},
					"710405": {
						id: 710405,
						area_name: "北区",
						area_code: "Beiqu",
						area_parent_id: 710400
					},
					"710406": {
						id: 710406,
						area_name: "西屯区",
						area_code: "Xitun",
						area_parent_id: 710400
					},
					"710407": {
						id: 710407,
						area_name: "南屯区",
						area_code: "Nantun",
						area_parent_id: 710400
					},
					"710408": {
						id: 710408,
						area_name: "北屯区",
						area_code: "Beitun",
						area_parent_id: 710400
					},
					"710409": {
						id: 710409,
						area_name: "丰原区",
						area_code: "Fengyuan",
						area_parent_id: 710400
					},
					"710410": {
						id: 710410,
						area_name: "东势区",
						area_code: "Dongshi",
						area_parent_id: 710400
					},
					"710411": {
						id: 710411,
						area_name: "大甲区",
						area_code: "Dajia",
						area_parent_id: 710400
					},
					"710412": {
						id: 710412,
						area_name: "清水区",
						area_code: "Qingshui",
						area_parent_id: 710400
					},
					"710413": {
						id: 710413,
						area_name: "沙鹿区",
						area_code: "Shalu",
						area_parent_id: 710400
					},
					"710414": {
						id: 710414,
						area_name: "梧栖区",
						area_code: "Wuqi",
						area_parent_id: 710400
					},
					"710415": {
						id: 710415,
						area_name: "后里区",
						area_code: "Houli",
						area_parent_id: 710400
					},
					"710416": {
						id: 710416,
						area_name: "神冈区",
						area_code: "Shengang",
						area_parent_id: 710400
					},
					"710417": {
						id: 710417,
						area_name: "潭子区",
						area_code: "Tanzi",
						area_parent_id: 710400
					},
					"710418": {
						id: 710418,
						area_name: "大雅区",
						area_code: "Daya",
						area_parent_id: 710400
					},
					"710419": {
						id: 710419,
						area_name: "新社区",
						area_code: "Xinshe",
						area_parent_id: 710400
					},
					"710420": {
						id: 710420,
						area_name: "石冈区",
						area_code: "Shigang",
						area_parent_id: 710400
					},
					"710421": {
						id: 710421,
						area_name: "外埔区",
						area_code: "Waipu",
						area_parent_id: 710400
					},
					"710422": {
						id: 710422,
						area_name: "大安区",
						area_code: "Da'an",
						area_parent_id: 710400
					},
					"710423": {
						id: 710423,
						area_name: "乌日区",
						area_code: "Wuri",
						area_parent_id: 710400
					},
					"710424": {
						id: 710424,
						area_name: "大肚区",
						area_code: "Dadu",
						area_parent_id: 710400
					},
					"710425": {
						id: 710425,
						area_name: "龙井区",
						area_code: "Longjing",
						area_parent_id: 710400
					},
					"710426": {
						id: 710426,
						area_name: "雾峰区",
						area_code: "Wufeng",
						area_parent_id: 710400
					},
					"710427": {
						id: 710427,
						area_name: "太平区",
						area_code: "Taiping",
						area_parent_id: 710400
					},
					"710428": {
						id: 710428,
						area_name: "大里区",
						area_code: "Dali",
						area_parent_id: 710400
					},
					"710429": {
						id: 710429,
						area_name: "和平区",
						area_code: "Heping",
						area_parent_id: 710400
					}
				}
			},
			"710500": {
				id: 710500,
				area_name: "台南市",
				area_code: "Tainan",
				area_parent_id: 710000,
				child: {
					"710501": {
						id: 710501,
						area_name: "东区",
						area_code: "Dongqu",
						area_parent_id: 710500
					},
					"710502": {
						id: 710502,
						area_name: "南区",
						area_code: "Nanqu",
						area_parent_id: 710500
					},
					"710504": {
						id: 710504,
						area_name: "北区",
						area_code: "Beiqu",
						area_parent_id: 710500
					},
					"710506": {
						id: 710506,
						area_name: "安南区",
						area_code: "Annan",
						area_parent_id: 710500
					},
					"710507": {
						id: 710507,
						area_name: "安平区",
						area_code: "Anping",
						area_parent_id: 710500
					},
					"710508": {
						id: 710508,
						area_name: "中西区",
						area_code: "Zhongxi",
						area_parent_id: 710500
					},
					"710509": {
						id: 710509,
						area_name: "新营区",
						area_code: "Xinying",
						area_parent_id: 710500
					},
					"710510": {
						id: 710510,
						area_name: "盐水区",
						area_code: "Yanshui",
						area_parent_id: 710500
					},
					"710511": {
						id: 710511,
						area_name: "白河区",
						area_code: "Baihe",
						area_parent_id: 710500
					},
					"710512": {
						id: 710512,
						area_name: "柳营区",
						area_code: "Liuying",
						area_parent_id: 710500
					},
					"710513": {
						id: 710513,
						area_name: "后壁区",
						area_code: "Houbi",
						area_parent_id: 710500
					},
					"710514": {
						id: 710514,
						area_name: "东山区",
						area_code: "Dongshan",
						area_parent_id: 710500
					},
					"710515": {
						id: 710515,
						area_name: "麻豆区",
						area_code: "Madou",
						area_parent_id: 710500
					},
					"710516": {
						id: 710516,
						area_name: "下营区",
						area_code: "Xiaying",
						area_parent_id: 710500
					},
					"710517": {
						id: 710517,
						area_name: "六甲区",
						area_code: "Liujia",
						area_parent_id: 710500
					},
					"710518": {
						id: 710518,
						area_name: "官田区",
						area_code: "Guantian",
						area_parent_id: 710500
					},
					"710519": {
						id: 710519,
						area_name: "大内区",
						area_code: "Dana",
						area_parent_id: 710500
					},
					"710520": {
						id: 710520,
						area_name: "佳里区",
						area_code: "Jiali",
						area_parent_id: 710500
					},
					"710521": {
						id: 710521,
						area_name: "学甲区",
						area_code: "Xuejia",
						area_parent_id: 710500
					},
					"710522": {
						id: 710522,
						area_name: "西港区",
						area_code: "Xigang",
						area_parent_id: 710500
					},
					"710523": {
						id: 710523,
						area_name: "七股区",
						area_code: "Qigu",
						area_parent_id: 710500
					},
					"710524": {
						id: 710524,
						area_name: "将军区",
						area_code: "Jiangjun",
						area_parent_id: 710500
					},
					"710525": {
						id: 710525,
						area_name: "北门区",
						area_code: "Beimen",
						area_parent_id: 710500
					},
					"710526": {
						id: 710526,
						area_name: "新化区",
						area_code: "Xinhua",
						area_parent_id: 710500
					},
					"710527": {
						id: 710527,
						area_name: "善化区",
						area_code: "Shanhua",
						area_parent_id: 710500
					},
					"710528": {
						id: 710528,
						area_name: "新市区",
						area_code: "Xinshi",
						area_parent_id: 710500
					},
					"710529": {
						id: 710529,
						area_name: "安定区",
						area_code: "Anding",
						area_parent_id: 710500
					},
					"710530": {
						id: 710530,
						area_name: "山上区",
						area_code: "Shanshang",
						area_parent_id: 710500
					},
					"710531": {
						id: 710531,
						area_name: "玉井区",
						area_code: "Yujing",
						area_parent_id: 710500
					},
					"710532": {
						id: 710532,
						area_name: "楠西区",
						area_code: "Nanxi",
						area_parent_id: 710500
					},
					"710533": {
						id: 710533,
						area_name: "南化区",
						area_code: "Nanhua",
						area_parent_id: 710500
					},
					"710534": {
						id: 710534,
						area_name: "左镇区",
						area_code: "Zuozhen",
						area_parent_id: 710500
					},
					"710535": {
						id: 710535,
						area_name: "仁德区",
						area_code: "Rende",
						area_parent_id: 710500
					},
					"710536": {
						id: 710536,
						area_name: "归仁区",
						area_code: "Guiren",
						area_parent_id: 710500
					},
					"710537": {
						id: 710537,
						area_name: "关庙区",
						area_code: "Guanmiao",
						area_parent_id: 710500
					},
					"710538": {
						id: 710538,
						area_name: "龙崎区",
						area_code: "Longqi",
						area_parent_id: 710500
					},
					"710539": {
						id: 710539,
						area_name: "永康区",
						area_code: "Yongkang",
						area_parent_id: 710500
					}
				}
			},
			"710600": {
				id: 710600,
				area_name: "新竹市",
				area_code: "Hsinchu",
				area_parent_id: 710000,
				child: {
					"710601": {
						id: 710601,
						area_name: "东区",
						area_code: "Dongqu",
						area_parent_id: 710600
					},
					"710602": {
						id: 710602,
						area_name: "北区",
						area_code: "Beiqu",
						area_parent_id: 710600
					},
					"710603": {
						id: 710603,
						area_name: "香山区",
						area_code: "Xiangshan",
						area_parent_id: 710600
					}
				}
			},
			"710700": {
				id: 710700,
				area_name: "嘉义市",
				area_code: "Chiayi",
				area_parent_id: 710000,
				child: {
					"710701": {
						id: 710701,
						area_name: "东区",
						area_code: "Dongqu",
						area_parent_id: 710700
					},
					"710702": {
						id: 710702,
						area_name: "西区",
						area_code: "Xiqu",
						area_parent_id: 710700
					}
				}
			},
			"710800": {
				id: 710800,
				area_name: "新北市",
				area_code: "New Taipei",
				area_parent_id: 710000,
				child: {
					"710801": {
						id: 710801,
						area_name: "板桥区",
						area_code: "Banqiao",
						area_parent_id: 710800
					},
					"710802": {
						id: 710802,
						area_name: "三重区",
						area_code: "Sanzhong",
						area_parent_id: 710800
					},
					"710803": {
						id: 710803,
						area_name: "中和区",
						area_code: "Zhonghe",
						area_parent_id: 710800
					},
					"710804": {
						id: 710804,
						area_name: "永和区",
						area_code: "Yonghe",
						area_parent_id: 710800
					},
					"710805": {
						id: 710805,
						area_name: "新庄区",
						area_code: "Xinzhuang",
						area_parent_id: 710800
					},
					"710806": {
						id: 710806,
						area_name: "新店区",
						area_code: "Xindian",
						area_parent_id: 710800
					},
					"710807": {
						id: 710807,
						area_name: "树林区",
						area_code: "Shulin",
						area_parent_id: 710800
					},
					"710808": {
						id: 710808,
						area_name: "莺歌区",
						area_code: "Yingge",
						area_parent_id: 710800
					},
					"710809": {
						id: 710809,
						area_name: "三峡区",
						area_code: "Sanxia",
						area_parent_id: 710800
					},
					"710810": {
						id: 710810,
						area_name: "淡水区",
						area_code: "Danshui",
						area_parent_id: 710800
					},
					"710811": {
						id: 710811,
						area_name: "汐止区",
						area_code: "Xizhi",
						area_parent_id: 710800
					},
					"710812": {
						id: 710812,
						area_name: "瑞芳区",
						area_code: "Ruifang",
						area_parent_id: 710800
					},
					"710813": {
						id: 710813,
						area_name: "土城区",
						area_code: "Tucheng",
						area_parent_id: 710800
					},
					"710814": {
						id: 710814,
						area_name: "芦洲区",
						area_code: "Luzhou",
						area_parent_id: 710800
					},
					"710815": {
						id: 710815,
						area_name: "五股区",
						area_code: "Wugu",
						area_parent_id: 710800
					},
					"710816": {
						id: 710816,
						area_name: "泰山区",
						area_code: "Taishan",
						area_parent_id: 710800
					},
					"710817": {
						id: 710817,
						area_name: "林口区",
						area_code: "Linkou",
						area_parent_id: 710800
					},
					"710818": {
						id: 710818,
						area_name: "深坑区",
						area_code: "Shenkeng",
						area_parent_id: 710800
					},
					"710819": {
						id: 710819,
						area_name: "石碇区",
						area_code: "Shiding",
						area_parent_id: 710800
					},
					"710820": {
						id: 710820,
						area_name: "坪林区",
						area_code: "Pinglin",
						area_parent_id: 710800
					},
					"710821": {
						id: 710821,
						area_name: "三芝区",
						area_code: "Sanzhi",
						area_parent_id: 710800
					},
					"710822": {
						id: 710822,
						area_name: "石门区",
						area_code: "Shimen",
						area_parent_id: 710800
					},
					"710823": {
						id: 710823,
						area_name: "八里区",
						area_code: "Bali",
						area_parent_id: 710800
					},
					"710824": {
						id: 710824,
						area_name: "平溪区",
						area_code: "Pingxi",
						area_parent_id: 710800
					},
					"710825": {
						id: 710825,
						area_name: "双溪区",
						area_code: "Shuangxi",
						area_parent_id: 710800
					},
					"710826": {
						id: 710826,
						area_name: "贡寮区",
						area_code: "Gongliao",
						area_parent_id: 710800
					},
					"710827": {
						id: 710827,
						area_name: "金山区",
						area_code: "Jinshan",
						area_parent_id: 710800
					},
					"710828": {
						id: 710828,
						area_name: "万里区",
						area_code: "Wanli",
						area_parent_id: 710800
					},
					"710829": {
						id: 710829,
						area_name: "乌来区",
						area_code: "Wulai",
						area_parent_id: 710800
					}
				}
			},
			"712200": {
				id: 712200,
				area_name: "宜兰县",
				area_code: "Yilan",
				area_parent_id: 710000,
				child: {
					"712201": {
						id: 712201,
						area_name: "宜兰市",
						area_code: "Yilan",
						area_parent_id: 712200
					},
					"712221": {
						id: 712221,
						area_name: "罗东镇",
						area_code: "Luodong",
						area_parent_id: 712200
					},
					"712222": {
						id: 712222,
						area_name: "苏澳镇",
						area_code: "Suao",
						area_parent_id: 712200
					},
					"712223": {
						id: 712223,
						area_name: "头城镇",
						area_code: "Toucheng",
						area_parent_id: 712200
					},
					"712224": {
						id: 712224,
						area_name: "礁溪乡",
						area_code: "Jiaoxi",
						area_parent_id: 712200
					},
					"712225": {
						id: 712225,
						area_name: "壮围乡",
						area_code: "Zhuangwei",
						area_parent_id: 712200
					},
					"712226": {
						id: 712226,
						area_name: "员山乡",
						area_code: "Yuanshan",
						area_parent_id: 712200
					},
					"712227": {
						id: 712227,
						area_name: "冬山乡",
						area_code: "Dongshan",
						area_parent_id: 712200
					},
					"712228": {
						id: 712228,
						area_name: "五结乡",
						area_code: "Wujie",
						area_parent_id: 712200
					},
					"712229": {
						id: 712229,
						area_name: "三星乡",
						area_code: "Sanxing",
						area_parent_id: 712200
					},
					"712230": {
						id: 712230,
						area_name: "大同乡",
						area_code: "Datong",
						area_parent_id: 712200
					},
					"712231": {
						id: 712231,
						area_name: "南澳乡",
						area_code: "Nanao",
						area_parent_id: 712200
					}
				}
			},
			"712300": {
				id: 712300,
				area_name: "桃园县",
				area_code: "Taoyuan",
				area_parent_id: 710000,
				child: {
					"712301": {
						id: 712301,
						area_name: "桃园市",
						area_code: "Taoyuan",
						area_parent_id: 712300
					},
					"712302": {
						id: 712302,
						area_name: "中坜市",
						area_code: "Zhongli",
						area_parent_id: 712300
					},
					"712303": {
						id: 712303,
						area_name: "平镇市",
						area_code: "Pingzhen",
						area_parent_id: 712300
					},
					"712304": {
						id: 712304,
						area_name: "八德市",
						area_code: "Bade",
						area_parent_id: 712300
					},
					"712305": {
						id: 712305,
						area_name: "杨梅市",
						area_code: "Yangmei",
						area_parent_id: 712300
					},
					"712306": {
						id: 712306,
						area_name: "芦竹市",
						area_code: "Luzhu",
						area_parent_id: 712300
					},
					"712321": {
						id: 712321,
						area_name: "大溪镇",
						area_code: "Daxi",
						area_parent_id: 712300
					},
					"712324": {
						id: 712324,
						area_name: "大园乡",
						area_code: "Dayuan",
						area_parent_id: 712300
					},
					"712325": {
						id: 712325,
						area_name: "龟山乡",
						area_code: "Guishan",
						area_parent_id: 712300
					},
					"712327": {
						id: 712327,
						area_name: "龙潭乡",
						area_code: "Longtan",
						area_parent_id: 712300
					},
					"712329": {
						id: 712329,
						area_name: "新屋乡",
						area_code: "Xinwu",
						area_parent_id: 712300
					},
					"712330": {
						id: 712330,
						area_name: "观音乡",
						area_code: "Guanyin",
						area_parent_id: 712300
					},
					"712331": {
						id: 712331,
						area_name: "复兴乡",
						area_code: "Fuxing",
						area_parent_id: 712300
					}
				}
			},
			"712400": {
				id: 712400,
				area_name: "新竹县",
				area_code: "Hsinchu",
				area_parent_id: 710000,
				child: {
					"712401": {
						id: 712401,
						area_name: "竹北市",
						area_code: "Zhubei",
						area_parent_id: 712400
					},
					"712421": {
						id: 712421,
						area_name: "竹东镇",
						area_code: "Zhudong",
						area_parent_id: 712400
					},
					"712422": {
						id: 712422,
						area_name: "新埔镇",
						area_code: "Xinpu",
						area_parent_id: 712400
					},
					"712423": {
						id: 712423,
						area_name: "关西镇",
						area_code: "Guanxi",
						area_parent_id: 712400
					},
					"712424": {
						id: 712424,
						area_name: "湖口乡",
						area_code: "Hukou",
						area_parent_id: 712400
					},
					"712425": {
						id: 712425,
						area_name: "新丰乡",
						area_code: "Xinfeng",
						area_parent_id: 712400
					},
					"712426": {
						id: 712426,
						area_name: "芎林乡",
						area_code: "Xionglin",
						area_parent_id: 712400
					},
					"712427": {
						id: 712427,
						area_name: "横山乡",
						area_code: "Hengshan",
						area_parent_id: 712400
					},
					"712428": {
						id: 712428,
						area_name: "北埔乡",
						area_code: "Beipu",
						area_parent_id: 712400
					},
					"712429": {
						id: 712429,
						area_name: "宝山乡",
						area_code: "Baoshan",
						area_parent_id: 712400
					},
					"712430": {
						id: 712430,
						area_name: "峨眉乡",
						area_code: "Emei",
						area_parent_id: 712400
					},
					"712431": {
						id: 712431,
						area_name: "尖石乡",
						area_code: "Jianshi",
						area_parent_id: 712400
					},
					"712432": {
						id: 712432,
						area_name: "五峰乡",
						area_code: "Wufeng",
						area_parent_id: 712400
					}
				}
			},
			"712500": {
				id: 712500,
				area_name: "苗栗县",
				area_code: "Miaoli",
				area_parent_id: 710000,
				child: {
					"712501": {
						id: 712501,
						area_name: "苗栗市",
						area_code: "Miaoli",
						area_parent_id: 712500
					},
					"712521": {
						id: 712521,
						area_name: "苑里镇",
						area_code: "Yuanli",
						area_parent_id: 712500
					},
					"712522": {
						id: 712522,
						area_name: "通霄镇",
						area_code: "Tongxiao",
						area_parent_id: 712500
					},
					"712523": {
						id: 712523,
						area_name: "竹南镇",
						area_code: "Zhunan",
						area_parent_id: 712500
					},
					"712524": {
						id: 712524,
						area_name: "头份镇",
						area_code: "Toufen",
						area_parent_id: 712500
					},
					"712525": {
						id: 712525,
						area_name: "后龙镇",
						area_code: "Houlong",
						area_parent_id: 712500
					},
					"712526": {
						id: 712526,
						area_name: "卓兰镇",
						area_code: "Zhuolan",
						area_parent_id: 712500
					},
					"712527": {
						id: 712527,
						area_name: "大湖乡",
						area_code: "Dahu",
						area_parent_id: 712500
					},
					"712528": {
						id: 712528,
						area_name: "公馆乡",
						area_code: "Gongguan",
						area_parent_id: 712500
					},
					"712529": {
						id: 712529,
						area_name: "铜锣乡",
						area_code: "Tongluo",
						area_parent_id: 712500
					},
					"712530": {
						id: 712530,
						area_name: "南庄乡",
						area_code: "Nanzhuang",
						area_parent_id: 712500
					},
					"712531": {
						id: 712531,
						area_name: "头屋乡",
						area_code: "Touwu",
						area_parent_id: 712500
					},
					"712532": {
						id: 712532,
						area_name: "三义乡",
						area_code: "Sanyi",
						area_parent_id: 712500
					},
					"712533": {
						id: 712533,
						area_name: "西湖乡",
						area_code: "Xihu",
						area_parent_id: 712500
					},
					"712534": {
						id: 712534,
						area_name: "造桥乡",
						area_code: "Zaoqiao",
						area_parent_id: 712500
					},
					"712535": {
						id: 712535,
						area_name: "三湾乡",
						area_code: "Sanwan",
						area_parent_id: 712500
					},
					"712536": {
						id: 712536,
						area_name: "狮潭乡",
						area_code: "Shitan",
						area_parent_id: 712500
					},
					"712537": {
						id: 712537,
						area_name: "泰安乡",
						area_code: "Tai'an",
						area_parent_id: 712500
					}
				}
			},
			"712700": {
				id: 712700,
				area_name: "彰化县",
				area_code: "Changhua",
				area_parent_id: 710000,
				child: {
					"712701": {
						id: 712701,
						area_name: "彰化市",
						area_code: "Zhanghuashi",
						area_parent_id: 712700
					},
					"712721": {
						id: 712721,
						area_name: "鹿港镇",
						area_code: "Lugang",
						area_parent_id: 712700
					},
					"712722": {
						id: 712722,
						area_name: "和美镇",
						area_code: "Hemei",
						area_parent_id: 712700
					},
					"712723": {
						id: 712723,
						area_name: "线西乡",
						area_code: "Xianxi",
						area_parent_id: 712700
					},
					"712724": {
						id: 712724,
						area_name: "伸港乡",
						area_code: "Shengang",
						area_parent_id: 712700
					},
					"712725": {
						id: 712725,
						area_name: "福兴乡",
						area_code: "Fuxing",
						area_parent_id: 712700
					},
					"712726": {
						id: 712726,
						area_name: "秀水乡",
						area_code: "Xiushui",
						area_parent_id: 712700
					},
					"712727": {
						id: 712727,
						area_name: "花坛乡",
						area_code: "Huatan",
						area_parent_id: 712700
					},
					"712728": {
						id: 712728,
						area_name: "芬园乡",
						area_code: "Fenyuan",
						area_parent_id: 712700
					},
					"712729": {
						id: 712729,
						area_name: "员林镇",
						area_code: "Yuanlin",
						area_parent_id: 712700
					},
					"712730": {
						id: 712730,
						area_name: "溪湖镇",
						area_code: "Xihu",
						area_parent_id: 712700
					},
					"712731": {
						id: 712731,
						area_name: "田中镇",
						area_code: "Tianzhong",
						area_parent_id: 712700
					},
					"712732": {
						id: 712732,
						area_name: "大村乡",
						area_code: "Dacun",
						area_parent_id: 712700
					},
					"712733": {
						id: 712733,
						area_name: "埔盐乡",
						area_code: "Puyan",
						area_parent_id: 712700
					},
					"712734": {
						id: 712734,
						area_name: "埔心乡",
						area_code: "Puxin",
						area_parent_id: 712700
					},
					"712735": {
						id: 712735,
						area_name: "永靖乡",
						area_code: "Yongjing",
						area_parent_id: 712700
					},
					"712736": {
						id: 712736,
						area_name: "社头乡",
						area_code: "Shetou",
						area_parent_id: 712700
					},
					"712737": {
						id: 712737,
						area_name: "二水乡",
						area_code: "Ershui",
						area_parent_id: 712700
					},
					"712738": {
						id: 712738,
						area_name: "北斗镇",
						area_code: "Beidou",
						area_parent_id: 712700
					},
					"712739": {
						id: 712739,
						area_name: "二林镇",
						area_code: "Erlin",
						area_parent_id: 712700
					},
					"712740": {
						id: 712740,
						area_name: "田尾乡",
						area_code: "Tianwei",
						area_parent_id: 712700
					},
					"712741": {
						id: 712741,
						area_name: "埤头乡",
						area_code: "Pitou",
						area_parent_id: 712700
					},
					"712742": {
						id: 712742,
						area_name: "芳苑乡",
						area_code: "Fangyuan",
						area_parent_id: 712700
					},
					"712743": {
						id: 712743,
						area_name: "大城乡",
						area_code: "Dacheng",
						area_parent_id: 712700
					},
					"712744": {
						id: 712744,
						area_name: "竹塘乡",
						area_code: "Zhutang",
						area_parent_id: 712700
					},
					"712745": {
						id: 712745,
						area_name: "溪州乡",
						area_code: "Xizhou",
						area_parent_id: 712700
					}
				}
			},
			"712800": {
				id: 712800,
				area_name: "南投县",
				area_code: "Nantou",
				area_parent_id: 710000,
				child: {
					"712801": {
						id: 712801,
						area_name: "南投市",
						area_code: "Nantoushi",
						area_parent_id: 712800
					},
					"712821": {
						id: 712821,
						area_name: "埔里镇",
						area_code: "Puli",
						area_parent_id: 712800
					},
					"712822": {
						id: 712822,
						area_name: "草屯镇",
						area_code: "Caotun",
						area_parent_id: 712800
					},
					"712823": {
						id: 712823,
						area_name: "竹山镇",
						area_code: "Zhushan",
						area_parent_id: 712800
					},
					"712824": {
						id: 712824,
						area_name: "集集镇",
						area_code: "Jiji",
						area_parent_id: 712800
					},
					"712825": {
						id: 712825,
						area_name: "名间乡",
						area_code: "Mingjian",
						area_parent_id: 712800
					},
					"712826": {
						id: 712826,
						area_name: "鹿谷乡",
						area_code: "Lugu",
						area_parent_id: 712800
					},
					"712827": {
						id: 712827,
						area_name: "中寮乡",
						area_code: "Zhongliao",
						area_parent_id: 712800
					},
					"712828": {
						id: 712828,
						area_name: "鱼池乡",
						area_code: "Yuchi",
						area_parent_id: 712800
					},
					"712829": {
						id: 712829,
						area_name: "国姓乡",
						area_code: "Guoxing",
						area_parent_id: 712800
					},
					"712830": {
						id: 712830,
						area_name: "水里乡",
						area_code: "Shuili",
						area_parent_id: 712800
					},
					"712831": {
						id: 712831,
						area_name: "信义乡",
						area_code: "Xinyi",
						area_parent_id: 712800
					},
					"712832": {
						id: 712832,
						area_name: "仁爱乡",
						area_code: "Renai",
						area_parent_id: 712800
					}
				}
			},
			"712900": {
				id: 712900,
				area_name: "云林县",
				area_code: "Yunlin",
				area_parent_id: 710000,
				child: {
					"712901": {
						id: 712901,
						area_name: "斗六市",
						area_code: "Douliu",
						area_parent_id: 712900
					},
					"712921": {
						id: 712921,
						area_name: "斗南镇",
						area_code: "Dounan",
						area_parent_id: 712900
					},
					"712922": {
						id: 712922,
						area_name: "虎尾镇",
						area_code: "Huwei",
						area_parent_id: 712900
					},
					"712923": {
						id: 712923,
						area_name: "西螺镇",
						area_code: "Xiluo",
						area_parent_id: 712900
					},
					"712924": {
						id: 712924,
						area_name: "土库镇",
						area_code: "Tuku",
						area_parent_id: 712900
					},
					"712925": {
						id: 712925,
						area_name: "北港镇",
						area_code: "Beigang",
						area_parent_id: 712900
					},
					"712926": {
						id: 712926,
						area_name: "古坑乡",
						area_code: "Gukeng",
						area_parent_id: 712900
					},
					"712927": {
						id: 712927,
						area_name: "大埤乡",
						area_code: "Dapi",
						area_parent_id: 712900
					},
					"712928": {
						id: 712928,
						area_name: "莿桐乡",
						area_code: "Citong",
						area_parent_id: 712900
					},
					"712929": {
						id: 712929,
						area_name: "林内乡",
						area_code: "Linna",
						area_parent_id: 712900
					},
					"712930": {
						id: 712930,
						area_name: "二仑乡",
						area_code: "Erlun",
						area_parent_id: 712900
					},
					"712931": {
						id: 712931,
						area_name: "仑背乡",
						area_code: "Lunbei",
						area_parent_id: 712900
					},
					"712932": {
						id: 712932,
						area_name: "麦寮乡",
						area_code: "Mailiao",
						area_parent_id: 712900
					},
					"712933": {
						id: 712933,
						area_name: "东势乡",
						area_code: "Dongshi",
						area_parent_id: 712900
					},
					"712934": {
						id: 712934,
						area_name: "褒忠乡",
						area_code: "Baozhong",
						area_parent_id: 712900
					},
					"712935": {
						id: 712935,
						area_name: "台西乡",
						area_code: "Taixi",
						area_parent_id: 712900
					},
					"712936": {
						id: 712936,
						area_name: "元长乡",
						area_code: "Yuanchang",
						area_parent_id: 712900
					},
					"712937": {
						id: 712937,
						area_name: "四湖乡",
						area_code: "Sihu",
						area_parent_id: 712900
					},
					"712938": {
						id: 712938,
						area_name: "口湖乡",
						area_code: "Kouhu",
						area_parent_id: 712900
					},
					"712939": {
						id: 712939,
						area_name: "水林乡",
						area_code: "Shuilin",
						area_parent_id: 712900
					}
				}
			},
			"713000": {
				id: 713000,
				area_name: "嘉义县",
				area_code: "Chiayi",
				area_parent_id: 710000,
				child: {
					"713001": {
						id: 713001,
						area_name: "太保市",
						area_code: "Taibao",
						area_parent_id: 713000
					},
					"713002": {
						id: 713002,
						area_name: "朴子市",
						area_code: "Puzi",
						area_parent_id: 713000
					},
					"713023": {
						id: 713023,
						area_name: "布袋镇",
						area_code: "Budai",
						area_parent_id: 713000
					},
					"713024": {
						id: 713024,
						area_name: "大林镇",
						area_code: "Dalin",
						area_parent_id: 713000
					},
					"713025": {
						id: 713025,
						area_name: "民雄乡",
						area_code: "Minxiong",
						area_parent_id: 713000
					},
					"713026": {
						id: 713026,
						area_name: "溪口乡",
						area_code: "Xikou",
						area_parent_id: 713000
					},
					"713027": {
						id: 713027,
						area_name: "新港乡",
						area_code: "Xingang",
						area_parent_id: 713000
					},
					"713028": {
						id: 713028,
						area_name: "六脚乡",
						area_code: "Liujiao",
						area_parent_id: 713000
					},
					"713029": {
						id: 713029,
						area_name: "东石乡",
						area_code: "Dongshi",
						area_parent_id: 713000
					},
					"713030": {
						id: 713030,
						area_name: "义竹乡",
						area_code: "Yizhu",
						area_parent_id: 713000
					},
					"713031": {
						id: 713031,
						area_name: "鹿草乡",
						area_code: "Lucao",
						area_parent_id: 713000
					},
					"713032": {
						id: 713032,
						area_name: "水上乡",
						area_code: "Shuishang",
						area_parent_id: 713000
					},
					"713033": {
						id: 713033,
						area_name: "中埔乡",
						area_code: "Zhongpu",
						area_parent_id: 713000
					},
					"713034": {
						id: 713034,
						area_name: "竹崎乡",
						area_code: "Zhuqi",
						area_parent_id: 713000
					},
					"713035": {
						id: 713035,
						area_name: "梅山乡",
						area_code: "Meishan",
						area_parent_id: 713000
					},
					"713036": {
						id: 713036,
						area_name: "番路乡",
						area_code: "Fanlu",
						area_parent_id: 713000
					},
					"713037": {
						id: 713037,
						area_name: "大埔乡",
						area_code: "Dapu",
						area_parent_id: 713000
					},
					"713038": {
						id: 713038,
						area_name: "阿里山乡",
						area_code: "Alishan",
						area_parent_id: 713000
					}
				}
			},
			"713300": {
				id: 713300,
				area_name: "屏东县",
				area_code: "Pingtung",
				area_parent_id: 710000,
				child: {
					"713301": {
						id: 713301,
						area_name: "屏东市",
						area_code: "Pingdong",
						area_parent_id: 713300
					},
					"713321": {
						id: 713321,
						area_name: "潮州镇",
						area_code: "Chaozhou",
						area_parent_id: 713300
					},
					"713322": {
						id: 713322,
						area_name: "东港镇",
						area_code: "Donggang",
						area_parent_id: 713300
					},
					"713323": {
						id: 713323,
						area_name: "恒春镇",
						area_code: "Hengchun",
						area_parent_id: 713300
					},
					"713324": {
						id: 713324,
						area_name: "万丹乡",
						area_code: "Wandan",
						area_parent_id: 713300
					},
					"713325": {
						id: 713325,
						area_name: "长治乡",
						area_code: "Changzhi",
						area_parent_id: 713300
					},
					"713326": {
						id: 713326,
						area_name: "麟洛乡",
						area_code: "Linluo",
						area_parent_id: 713300
					},
					"713327": {
						id: 713327,
						area_name: "九如乡",
						area_code: "Jiuru",
						area_parent_id: 713300
					},
					"713328": {
						id: 713328,
						area_name: "里港乡",
						area_code: "Ligang",
						area_parent_id: 713300
					},
					"713329": {
						id: 713329,
						area_name: "盐埔乡",
						area_code: "Yanpu",
						area_parent_id: 713300
					},
					"713330": {
						id: 713330,
						area_name: "高树乡",
						area_code: "Gaoshu",
						area_parent_id: 713300
					},
					"713331": {
						id: 713331,
						area_name: "万峦乡",
						area_code: "Wanluan",
						area_parent_id: 713300
					},
					"713332": {
						id: 713332,
						area_name: "内埔乡",
						area_code: "Napu",
						area_parent_id: 713300
					},
					"713333": {
						id: 713333,
						area_name: "竹田乡",
						area_code: "Zhutian",
						area_parent_id: 713300
					},
					"713334": {
						id: 713334,
						area_name: "新埤乡",
						area_code: "Xinpi",
						area_parent_id: 713300
					},
					"713335": {
						id: 713335,
						area_name: "枋寮乡",
						area_code: "Fangliao",
						area_parent_id: 713300
					},
					"713336": {
						id: 713336,
						area_name: "新园乡",
						area_code: "Xinyuan",
						area_parent_id: 713300
					},
					"713337": {
						id: 713337,
						area_name: "崁顶乡",
						area_code: "Kanding",
						area_parent_id: 713300
					},
					"713338": {
						id: 713338,
						area_name: "林边乡",
						area_code: "Linbian",
						area_parent_id: 713300
					},
					"713339": {
						id: 713339,
						area_name: "南州乡",
						area_code: "Nanzhou",
						area_parent_id: 713300
					},
					"713340": {
						id: 713340,
						area_name: "佳冬乡",
						area_code: "Jiadong",
						area_parent_id: 713300
					},
					"713341": {
						id: 713341,
						area_name: "琉球乡",
						area_code: "Liuqiu",
						area_parent_id: 713300
					},
					"713342": {
						id: 713342,
						area_name: "车城乡",
						area_code: "Checheng",
						area_parent_id: 713300
					},
					"713343": {
						id: 713343,
						area_name: "满州乡",
						area_code: "Manzhou",
						area_parent_id: 713300
					},
					"713344": {
						id: 713344,
						area_name: "枋山乡",
						area_code: "Fangshan",
						area_parent_id: 713300
					},
					"713345": {
						id: 713345,
						area_name: "三地门乡",
						area_code: "Sandimen",
						area_parent_id: 713300
					},
					"713346": {
						id: 713346,
						area_name: "雾台乡",
						area_code: "Wutai",
						area_parent_id: 713300
					},
					"713347": {
						id: 713347,
						area_name: "玛家乡",
						area_code: "Majia",
						area_parent_id: 713300
					},
					"713348": {
						id: 713348,
						area_name: "泰武乡",
						area_code: "Taiwu",
						area_parent_id: 713300
					},
					"713349": {
						id: 713349,
						area_name: "来义乡",
						area_code: "Laiyi",
						area_parent_id: 713300
					},
					"713350": {
						id: 713350,
						area_name: "春日乡",
						area_code: "Chunri",
						area_parent_id: 713300
					},
					"713351": {
						id: 713351,
						area_name: "狮子乡",
						area_code: "Shizi",
						area_parent_id: 713300
					},
					"713352": {
						id: 713352,
						area_name: "牡丹乡",
						area_code: "Mudan",
						area_parent_id: 713300
					}
				}
			},
			"713400": {
				id: 713400,
				area_name: "台东县",
				area_code: "Taitung",
				area_parent_id: 710000,
				child: {
					"713401": {
						id: 713401,
						area_name: "台东市",
						area_code: "Taidong",
						area_parent_id: 713400
					},
					"713421": {
						id: 713421,
						area_name: "成功镇",
						area_code: "Chenggong",
						area_parent_id: 713400
					},
					"713422": {
						id: 713422,
						area_name: "关山镇",
						area_code: "Guanshan",
						area_parent_id: 713400
					},
					"713423": {
						id: 713423,
						area_name: "卑南乡",
						area_code: "Beinan",
						area_parent_id: 713400
					},
					"713424": {
						id: 713424,
						area_name: "鹿野乡",
						area_code: "Luye",
						area_parent_id: 713400
					},
					"713425": {
						id: 713425,
						area_name: "池上乡",
						area_code: "Chishang",
						area_parent_id: 713400
					},
					"713426": {
						id: 713426,
						area_name: "东河乡",
						area_code: "Donghe",
						area_parent_id: 713400
					},
					"713427": {
						id: 713427,
						area_name: "长滨乡",
						area_code: "Changbin",
						area_parent_id: 713400
					},
					"713428": {
						id: 713428,
						area_name: "太麻里乡",
						area_code: "Taimali",
						area_parent_id: 713400
					},
					"713429": {
						id: 713429,
						area_name: "大武乡",
						area_code: "Dawu",
						area_parent_id: 713400
					},
					"713430": {
						id: 713430,
						area_name: "绿岛乡",
						area_code: "Lvdao",
						area_parent_id: 713400
					},
					"713431": {
						id: 713431,
						area_name: "海端乡",
						area_code: "Haiduan",
						area_parent_id: 713400
					},
					"713432": {
						id: 713432,
						area_name: "延平乡",
						area_code: "Yanping",
						area_parent_id: 713400
					},
					"713433": {
						id: 713433,
						area_name: "金峰乡",
						area_code: "Jinfeng",
						area_parent_id: 713400
					},
					"713434": {
						id: 713434,
						area_name: "达仁乡",
						area_code: "Daren",
						area_parent_id: 713400
					},
					"713435": {
						id: 713435,
						area_name: "兰屿乡",
						area_code: "Lanyu",
						area_parent_id: 713400
					}
				}
			},
			"713500": {
				id: 713500,
				area_name: "花莲县",
				area_code: "Hualien",
				area_parent_id: 710000,
				child: {
					"713501": {
						id: 713501,
						area_name: "花莲市",
						area_code: "Hualian",
						area_parent_id: 713500
					},
					"713521": {
						id: 713521,
						area_name: "凤林镇",
						area_code: "Fenglin",
						area_parent_id: 713500
					},
					"713522": {
						id: 713522,
						area_name: "玉里镇",
						area_code: "Yuli",
						area_parent_id: 713500
					},
					"713523": {
						id: 713523,
						area_name: "新城乡",
						area_code: "Xincheng",
						area_parent_id: 713500
					},
					"713524": {
						id: 713524,
						area_name: "吉安乡",
						area_code: "Ji'an",
						area_parent_id: 713500
					},
					"713525": {
						id: 713525,
						area_name: "寿丰乡",
						area_code: "Shoufeng",
						area_parent_id: 713500
					},
					"713526": {
						id: 713526,
						area_name: "光复乡",
						area_code: "Guangfu",
						area_parent_id: 713500
					},
					"713527": {
						id: 713527,
						area_name: "丰滨乡",
						area_code: "Fengbin",
						area_parent_id: 713500
					},
					"713528": {
						id: 713528,
						area_name: "瑞穗乡",
						area_code: "Ruisui",
						area_parent_id: 713500
					},
					"713529": {
						id: 713529,
						area_name: "富里乡",
						area_code: "Fuli",
						area_parent_id: 713500
					},
					"713530": {
						id: 713530,
						area_name: "秀林乡",
						area_code: "Xiulin",
						area_parent_id: 713500
					},
					"713531": {
						id: 713531,
						area_name: "万荣乡",
						area_code: "Wanrong",
						area_parent_id: 713500
					},
					"713532": {
						id: 713532,
						area_name: "卓溪乡",
						area_code: "Zhuoxi",
						area_parent_id: 713500
					}
				}
			},
			"713600": {
				id: 713600,
				area_name: "澎湖县",
				area_code: "Penghu",
				area_parent_id: 710000,
				child: {
					"713601": {
						id: 713601,
						area_name: "马公市",
						area_code: "Magong",
						area_parent_id: 713600
					},
					"713621": {
						id: 713621,
						area_name: "湖西乡",
						area_code: "Huxi",
						area_parent_id: 713600
					},
					"713622": {
						id: 713622,
						area_name: "白沙乡",
						area_code: "Baisha",
						area_parent_id: 713600
					},
					"713623": {
						id: 713623,
						area_name: "西屿乡",
						area_code: "Xiyu",
						area_parent_id: 713600
					},
					"713624": {
						id: 713624,
						area_name: "望安乡",
						area_code: "Wang'an",
						area_parent_id: 713600
					},
					"713625": {
						id: 713625,
						area_name: "七美乡",
						area_code: "Qimei",
						area_parent_id: 713600
					}
				}
			},
			"713700": {
				id: 713700,
				area_name: "金门县",
				area_code: "Jinmen",
				area_parent_id: 710000,
				child: {
					"713701": {
						id: 713701,
						area_name: "金城镇",
						area_code: "Jincheng",
						area_parent_id: 713700
					},
					"713702": {
						id: 713702,
						area_name: "金湖镇",
						area_code: "Jinhu",
						area_parent_id: 713700
					},
					"713703": {
						id: 713703,
						area_name: "金沙镇",
						area_code: "Jinsha",
						area_parent_id: 713700
					},
					"713704": {
						id: 713704,
						area_name: "金宁乡",
						area_code: "Jinning",
						area_parent_id: 713700
					},
					"713705": {
						id: 713705,
						area_name: "烈屿乡",
						area_code: "Lieyu",
						area_parent_id: 713700
					},
					"713706": {
						id: 713706,
						area_name: "乌丘乡",
						area_code: "Wuqiu",
						area_parent_id: 713700
					}
				}
			},
			"713800": {
				id: 713800,
				area_name: "连江县",
				area_code: "Lienchiang",
				area_parent_id: 710000,
				child: {
					"713801": {
						id: 713801,
						area_name: "南竿乡",
						area_code: "Nangan",
						area_parent_id: 713800
					},
					"713802": {
						id: 713802,
						area_name: "北竿乡",
						area_code: "Beigan",
						area_parent_id: 713800
					},
					"713803": {
						id: 713803,
						area_name: "莒光乡",
						area_code: "Juguang",
						area_parent_id: 713800
					},
					"713804": {
						id: 713804,
						area_name: "东引乡",
						area_code: "Dongyin",
						area_parent_id: 713800
					}
				}
			}
		}
	},
	"810000": {
		id: 810000,
		area_name: "香港特别行政区",
		area_code: "Hong Kong",
		area_parent_id: 0,
		child: {
			"810100": {
				id: 810100,
				area_name: "香港岛",
				area_code: "Hong Kong Island",
				area_parent_id: 810000,
				child: {
					"810101": {
						id: 810101,
						area_name: "中西区",
						area_code: "Central and Western District",
						area_parent_id: 810100
					},
					"810102": {
						id: 810102,
						area_name: "湾仔区",
						area_code: "Wan Chai District",
						area_parent_id: 810100
					},
					"810103": {
						id: 810103,
						area_name: "东区",
						area_code: "Eastern District",
						area_parent_id: 810100
					},
					"810104": {
						id: 810104,
						area_name: "南区",
						area_code: "Southern District",
						area_parent_id: 810100
					}
				}
			},
			"810200": {
				id: 810200,
				area_name: "九龙",
				area_code: "Kowloon",
				area_parent_id: 810000,
				child: {
					"810201": {
						id: 810201,
						area_name: "油尖旺区",
						area_code: "Yau Tsim Mong",
						area_parent_id: 810200
					},
					"810202": {
						id: 810202,
						area_name: "深水埗区",
						area_code: "Sham Shui Po",
						area_parent_id: 810200
					},
					"810203": {
						id: 810203,
						area_name: "九龙城区",
						area_code: "Jiulongcheng",
						area_parent_id: 810200
					},
					"810204": {
						id: 810204,
						area_name: "黄大仙区",
						area_code: "Wong Tai Sin",
						area_parent_id: 810200
					},
					"810205": {
						id: 810205,
						area_name: "观塘区",
						area_code: "Kwun Tong",
						area_parent_id: 810200
					}
				}
			},
			"810300": {
				id: 810300,
				area_name: "新界",
				area_code: "New Territories",
				area_parent_id: 810000,
				child: {
					"810301": {
						id: 810301,
						area_name: "荃湾区",
						area_code: "Tsuen Wan",
						area_parent_id: 810300
					},
					"810302": {
						id: 810302,
						area_name: "屯门区",
						area_code: "Tuen Mun",
						area_parent_id: 810300
					},
					"810303": {
						id: 810303,
						area_name: "元朗区",
						area_code: "Yuen Long",
						area_parent_id: 810300
					},
					"810304": {
						id: 810304,
						area_name: "北区",
						area_code: "North District",
						area_parent_id: 810300
					},
					"810305": {
						id: 810305,
						area_name: "大埔区",
						area_code: "Tai Po",
						area_parent_id: 810300
					},
					"810306": {
						id: 810306,
						area_name: "西贡区",
						area_code: "Sai Kung",
						area_parent_id: 810300
					},
					"810307": {
						id: 810307,
						area_name: "沙田区",
						area_code: "Sha Tin",
						area_parent_id: 810300
					},
					"810308": {
						id: 810308,
						area_name: "葵青区",
						area_code: "Kwai Tsing",
						area_parent_id: 810300
					},
					"810309": {
						id: 810309,
						area_name: "离岛区",
						area_code: "Outlying Islands",
						area_parent_id: 810300
					}
				}
			}
		}
	},
	"820000": {
		id: 820000,
		area_name: "澳门特别行政区",
		area_code: "Macau",
		area_parent_id: 0,
		child: {
			"820100": {
				id: 820100,
				area_name: "澳门半岛",
				area_code: "MacauPeninsula",
				area_parent_id: 820000,
				child: {
					"820101": {
						id: 820101,
						area_name: "花地玛堂区",
						area_code: "Nossa Senhora de Fatima",
						area_parent_id: 820100
					},
					"820102": {
						id: 820102,
						area_name: "圣安多尼堂区",
						area_code: "Santo Antonio",
						area_parent_id: 820100
					},
					"820103": {
						id: 820103,
						area_name: "大堂区",
						area_code: "Sé",
						area_parent_id: 820100
					},
					"820104": {
						id: 820104,
						area_name: "望德堂区",
						area_code: "Sao Lazaro",
						area_parent_id: 820100
					},
					"820105": {
						id: 820105,
						area_name: "风顺堂区",
						area_code: "Sao Lourenco",
						area_parent_id: 820100
					}
				}
			},
			"820200": {
				id: 820200,
				area_name: "氹仔岛",
				area_code: "Taipa",
				area_parent_id: 820000,
				child: {
					"820201": {
						id: 820201,
						area_name: "嘉模堂区",
						area_code: "Our Lady Of Carmel's Parish",
						area_parent_id: 820200
					}
				}
			},
			"820300": {
				id: 820300,
				area_name: "路环岛",
				area_code: "Coloane",
				area_parent_id: 820000,
				child: {
					"820301": {
						id: 820301,
						area_name: "圣方济各堂区",
						area_code: "St Francis Xavier's Parish",
						area_parent_id: 820300
					}
				}
			}
		}
	},
	"900000": {
		id: 900000,
		area_name: "钓鱼岛",
		area_code: "DiaoyuDao",
		area_parent_id: 0
	}
};



// WEBPACK FOOTER //
// ./src/data.js